import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _bigint: any;
  _bytea: any;
  _citext: any;
  _float8: any;
  _jsonb: any;
  _timestamp: any;
  _timestamptz: any;
  _uuid: any;
  bigint: any;
  bytea: any;
  citext: any;
  date: any;
  float8: any;
  json: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars["Boolean"]>;
  _gt?: InputMaybe<Scalars["Boolean"]>;
  _gte?: InputMaybe<Scalars["Boolean"]>;
  _in?: InputMaybe<Array<Scalars["Boolean"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Boolean"]>;
  _lte?: InputMaybe<Scalars["Boolean"]>;
  _neq?: InputMaybe<Scalars["Boolean"]>;
  _nin?: InputMaybe<Array<Scalars["Boolean"]>>;
};

/** Boolean expression to filter rows from the table "COMPANY". All fields are combined with a logical 'AND'. */
export type COMPANY_bool_exp_remote_rel_crm_revtron_indexesto_revtron_company =
  {
    CITY?: InputMaybe<_String_comparison_exp>;
    COMPANYTYPE?: InputMaybe<_String_comparison_exp>;
    COUNTRY?: InputMaybe<_String_comparison_exp>;
    COUNTRYCODE?: InputMaybe<_String_comparison_exp>;
    CRUNCHBASE?: InputMaybe<_String_comparison_exp>;
    DATE_OF_RAISE?: InputMaybe<_String_comparison_exp>;
    DESCRIPTION?: InputMaybe<_String_comparison_exp>;
    DOMAIN?: InputMaybe<_String_comparison_exp>;
    FACEBOOK?: InputMaybe<_String_comparison_exp>;
    FOUNDINGYEAR?: InputMaybe<_float8_comparison_exp>;
    ID?: InputMaybe<bigint_comparison_exp_remote_rel_crm_revtron_indexesto_revtron_company>;
    INFORMALNAME?: InputMaybe<_String_comparison_exp>;
    LINKEDIN?: InputMaybe<_String_comparison_exp>;
    LOADDATE?: InputMaybe<_String_comparison_exp>;
    MODIFIEDDATE?: InputMaybe<_String_comparison_exp>;
    MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<_float8_comparison_exp>;
    NAME?: InputMaybe<_String_comparison_exp>;
    NOLONGERINBUSINESS?: InputMaybe<_Boolean_comparison_exp>;
    NOLONGERINBUSINESSDATE?: InputMaybe<_String_comparison_exp>;
    NOLONGERINBUSINESSREASON?: InputMaybe<_float8_comparison_exp>;
    PARENTCOMPANY?: InputMaybe<_String_comparison_exp>;
    PARENTID?: InputMaybe<_float8_comparison_exp>;
    PHONENUMBER?: InputMaybe<_String_comparison_exp>;
    POSTALCODE?: InputMaybe<_String_comparison_exp>;
    RAISE_AMOUNT?: InputMaybe<_float8_comparison_exp>;
    RAISE_ROUND?: InputMaybe<_float8_comparison_exp>;
    RAISE_TRANSACTION_TYPE?: InputMaybe<_float8_comparison_exp>;
    RAISE_VALUATION?: InputMaybe<_float8_comparison_exp>;
    SOURCECITED?: InputMaybe<_String_comparison_exp>;
    SPECIALTIES?: InputMaybe<_String_comparison_exp>;
    STATE?: InputMaybe<_String_comparison_exp>;
    STATECODE?: InputMaybe<_String_comparison_exp>;
    SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<_String_comparison_exp>;
    TOTALAMOUNTINVESTED?: InputMaybe<_float8_comparison_exp>;
    TWITTER?: InputMaybe<_String_comparison_exp>;
    WEBSITE?: InputMaybe<_String_comparison_exp>;
    _and?: InputMaybe<Array<_COMPANY_bool_exp>>;
    _not?: InputMaybe<_COMPANY_bool_exp>;
    _or?: InputMaybe<Array<_COMPANY_bool_exp>>;
    index?: InputMaybe<_bigint_comparison_exp>;
  };

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: InputMaybe<Scalars["Int"]>;
  _gt?: InputMaybe<Scalars["Int"]>;
  _gte?: InputMaybe<Scalars["Int"]>;
  _in?: InputMaybe<Array<Scalars["Int"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Int"]>;
  _lte?: InputMaybe<Scalars["Int"]>;
  _neq?: InputMaybe<Scalars["Int"]>;
  _nin?: InputMaybe<Array<Scalars["Int"]>>;
};

export type Opportunity_aggregate_bool_exp = {
  avg?: InputMaybe<Opportunity_aggregate_bool_exp_avg>;
  bool_and?: InputMaybe<Opportunity_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<Opportunity_aggregate_bool_exp_bool_or>;
  corr?: InputMaybe<Opportunity_aggregate_bool_exp_corr>;
  count?: InputMaybe<Opportunity_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<Opportunity_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<Opportunity_aggregate_bool_exp_max>;
  min?: InputMaybe<Opportunity_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<Opportunity_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<Opportunity_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<Opportunity_aggregate_bool_exp_var_samp>;
};

export type Opportunity_aggregate_bool_exp_avg = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_bool_and = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_bool_or = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_corr = {
  arguments: Opportunity_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_corr_arguments = {
  X: Opportunity_select_column_Opportunity_aggregate_bool_exp_corr_arguments_columns;
  Y: Opportunity_select_column_Opportunity_aggregate_bool_exp_corr_arguments_columns;
};

export type Opportunity_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Opportunity_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: Int_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_covar_samp = {
  arguments: Opportunity_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_covar_samp_arguments = {
  X: Opportunity_select_column_Opportunity_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: Opportunity_select_column_Opportunity_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type Opportunity_aggregate_bool_exp_max = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_min = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_stddev_samp = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_sum = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

export type Opportunity_aggregate_bool_exp_var_samp = {
  arguments: Opportunity_select_column_Opportunity_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Opportunity_bool_exp>;
  predicate: float8_comparison_exp;
};

/** order by aggregate values of table "Opportunity" */
export type Opportunity_aggregate_order_by = {
  avg?: InputMaybe<Opportunity_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Opportunity_max_order_by>;
  min?: InputMaybe<Opportunity_min_order_by>;
  stddev?: InputMaybe<Opportunity_stddev_order_by>;
  stddev_pop?: InputMaybe<Opportunity_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Opportunity_stddev_samp_order_by>;
  sum?: InputMaybe<Opportunity_sum_order_by>;
  var_pop?: InputMaybe<Opportunity_var_pop_order_by>;
  var_samp?: InputMaybe<Opportunity_var_samp_order_by>;
  variance?: InputMaybe<Opportunity_variance_order_by>;
};

/** input type for inserting array relation for remote table "Opportunity" */
export type Opportunity_arr_rel_insert_input = {
  data: Array<Opportunity_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Opportunity_on_conflict>;
};

/** order by avg() on columns of table "Opportunity" */
export type Opportunity_avg_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Opportunity". All fields are combined with a logical 'AND'. */
export type Opportunity_bool_exp = {
  AE_Notes__c?: InputMaybe<String_comparison_exp>;
  AccountId?: InputMaybe<String_comparison_exp>;
  Account_Contact_Name__c?: InputMaybe<String_comparison_exp>;
  Account_Contact_Phone__c?: InputMaybe<String_comparison_exp>;
  Account_Contact__c?: InputMaybe<String_comparison_exp>;
  Acquisition_Program__c?: InputMaybe<String_comparison_exp>;
  Active_Employees__c?: InputMaybe<String_comparison_exp>;
  Address__c?: InputMaybe<String_comparison_exp>;
  Agreement_ID__c?: InputMaybe<String_comparison_exp>;
  Amount?: InputMaybe<float8_comparison_exp>;
  Amount_?: InputMaybe<float8_comparison_exp>;
  Annual_Contract_Value__c?: InputMaybe<float8_comparison_exp>;
  Anticipated_Go_Live__c?: InputMaybe<date_comparison_exp>;
  Attachments_Count__c?: InputMaybe<float8_comparison_exp>;
  Auto_Renew__c?: InputMaybe<Boolean_comparison_exp>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Employee_Management__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Interviewer_System__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Onboarding__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Payroll_System__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Scheduler_System__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Texting__c?: InputMaybe<String_comparison_exp>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<String_comparison_exp>;
  BackLog_Opportunity__c?: InputMaybe<Boolean_comparison_exp>;
  Barakat_2__c?: InputMaybe<Boolean_comparison_exp>;
  Best_Case_Stalled__c?: InputMaybe<Boolean_comparison_exp>;
  Billing_Terms__c?: InputMaybe<String_comparison_exp>;
  Booked_By__c?: InputMaybe<String_comparison_exp>;
  CMRR_With_Currency__c?: InputMaybe<String_comparison_exp>;
  CMRR__c?: InputMaybe<String_comparison_exp>;
  CampaignId?: InputMaybe<String_comparison_exp>;
  Can_edit_the_close_date__c?: InputMaybe<Boolean_comparison_exp>;
  Champion__c?: InputMaybe<String_comparison_exp>;
  Churned_CMRR__c?: InputMaybe<float8_comparison_exp>;
  Churned_Date__c?: InputMaybe<date_comparison_exp>;
  Churned_Opportunity__c?: InputMaybe<Boolean_comparison_exp>;
  City__c?: InputMaybe<String_comparison_exp>;
  Classification__c?: InputMaybe<String_comparison_exp>;
  CloseDate?: InputMaybe<date_comparison_exp>;
  Coach__c?: InputMaybe<String_comparison_exp>;
  Coming_from_Dealhub__c?: InputMaybe<Boolean_comparison_exp>;
  Commit_Stalled__c?: InputMaybe<Boolean_comparison_exp>;
  Company__c?: InputMaybe<String_comparison_exp>;
  Competition__c?: InputMaybe<String_comparison_exp>;
  Compliance_CMRR__c?: InputMaybe<float8_comparison_exp>;
  Compliance_OTF_Formatted__c?: InputMaybe<String_comparison_exp>;
  Compliance_OTF__c?: InputMaybe<float8_comparison_exp>;
  ContactID__c?: InputMaybe<String_comparison_exp>;
  ContactId?: InputMaybe<String_comparison_exp>;
  Contact_Email__c?: InputMaybe<String_comparison_exp>;
  Contact_ID_Related_Oppt__c?: InputMaybe<String_comparison_exp>;
  Contact_Name__c?: InputMaybe<String_comparison_exp>;
  Contact_Phone__c?: InputMaybe<String_comparison_exp>;
  Contact_Title__c?: InputMaybe<String_comparison_exp>;
  Contact__c?: InputMaybe<String_comparison_exp>;
  Contain_Papa_John__c?: InputMaybe<float8_comparison_exp>;
  Contains_Expansion__c?: InputMaybe<float8_comparison_exp>;
  Contains_Subscription__c?: InputMaybe<float8_comparison_exp>;
  Contract_Term__c?: InputMaybe<String_comparison_exp>;
  Corporate_CMRR__c?: InputMaybe<float8_comparison_exp>;
  Count_of_Discounted_Items__c?: InputMaybe<float8_comparison_exp>;
  CreatedById?: InputMaybe<String_comparison_exp>;
  CreatedDate?: InputMaybe<timestamp_comparison_exp>;
  Created_By_Role_Name__c?: InputMaybe<String_comparison_exp>;
  Created_Unit_Level_User_Logins__c?: InputMaybe<Boolean_comparison_exp>;
  Custom_Close_Date__c?: InputMaybe<date_comparison_exp>;
  Custom_Documents__c?: InputMaybe<String_comparison_exp>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<float8_comparison_exp>;
  Custom_Product_Quantity__c?: InputMaybe<float8_comparison_exp>;
  DH_Overall_MRR__c?: InputMaybe<float8_comparison_exp>;
  Data_Quality_Description__c?: InputMaybe<String_comparison_exp>;
  Data_Quality_Score__c?: InputMaybe<float8_comparison_exp>;
  Date_Demo_Held__c?: InputMaybe<date_comparison_exp>;
  Date_Discovery_Held__c?: InputMaybe<date_comparison_exp>;
  Date_Entered_Backlog__c?: InputMaybe<timestamp_comparison_exp>;
  Date_Left_Backlog__c?: InputMaybe<timestamp_comparison_exp>;
  Date_Payment_Processed__c?: InputMaybe<date_comparison_exp>;
  Date_Payment_Received__c?: InputMaybe<date_comparison_exp>;
  Date_Time__c?: InputMaybe<timestamp_comparison_exp>;
  DealHub_Create_Subscription__c?: InputMaybe<Boolean_comparison_exp>;
  Deal_Health__c?: InputMaybe<String_comparison_exp>;
  Deal_Room_URL__c?: InputMaybe<String_comparison_exp>;
  Dealhub_Quote_Status__c?: InputMaybe<String_comparison_exp>;
  Dealhub_URL__c?: InputMaybe<String_comparison_exp>;
  Decision_Criteria__c?: InputMaybe<String_comparison_exp>;
  Decision_Process__c?: InputMaybe<String_comparison_exp>;
  Demo_Held__c?: InputMaybe<Boolean_comparison_exp>;
  Description?: InputMaybe<String_comparison_exp>;
  Description__c?: InputMaybe<String_comparison_exp>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<float8_comparison_exp>;
  Discount_Approval_Status__c?: InputMaybe<String_comparison_exp>;
  Discovery_Held__c?: InputMaybe<Boolean_comparison_exp>;
  Dont_update_reg__c?: InputMaybe<Boolean_comparison_exp>;
  Economic_Buyer__c?: InputMaybe<String_comparison_exp>;
  Effective_Date__c?: InputMaybe<date_comparison_exp>;
  Email_Sent__c?: InputMaybe<String_comparison_exp>;
  Email__c?: InputMaybe<String_comparison_exp>;
  Employees__c?: InputMaybe<float8_comparison_exp>;
  End_Date__c?: InputMaybe<date_comparison_exp>;
  Expansion_MRR__c?: InputMaybe<float8_comparison_exp>;
  Feature__c?: InputMaybe<String_comparison_exp>;
  Financial_Notes__c?: InputMaybe<String_comparison_exp>;
  Firm_Committed__c?: InputMaybe<Boolean_comparison_exp>;
  First_Quote_Synced_Date__c?: InputMaybe<timestamp_comparison_exp>;
  Fiscal?: InputMaybe<String_comparison_exp>;
  FiscalQuarter?: InputMaybe<Int_comparison_exp>;
  FiscalYear?: InputMaybe<Int_comparison_exp>;
  ForceCreateHarriProjects__c?: InputMaybe<Boolean_comparison_exp>;
  ForecastCategory?: InputMaybe<String_comparison_exp>;
  ForecastCategoryName?: InputMaybe<String_comparison_exp>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<float8_comparison_exp>;
  Franchise_Sign_Up__c?: InputMaybe<Boolean_comparison_exp>;
  Franchisee_Sign_Up__c?: InputMaybe<String_comparison_exp>;
  Franshisees_CMRR__c?: InputMaybe<float8_comparison_exp>;
  GI_Opportunity_Region__c?: InputMaybe<String_comparison_exp>;
  Gong__CurrentGenerators__c?: InputMaybe<String_comparison_exp>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<String_comparison_exp>;
  Gong__Gong_Count__c?: InputMaybe<float8_comparison_exp>;
  Gong__MainCompetitors__c?: InputMaybe<String_comparison_exp>;
  Gong__OrderNumber__c?: InputMaybe<String_comparison_exp>;
  Gong__TrackingNumber__c?: InputMaybe<String_comparison_exp>;
  Harri_API_Enabled__c?: InputMaybe<Boolean_comparison_exp>;
  Harri_Profile_Created__c?: InputMaybe<Boolean_comparison_exp>;
  Harri_Project__c?: InputMaybe<String_comparison_exp>;
  HasOpenActivity?: InputMaybe<Boolean_comparison_exp>;
  HasOpportunityLineItem?: InputMaybe<Boolean_comparison_exp>;
  HasOverdueTask?: InputMaybe<Boolean_comparison_exp>;
  Hiring_Urgency__c?: InputMaybe<String_comparison_exp>;
  ID_18_digit__c?: InputMaybe<String_comparison_exp>;
  Id?: InputMaybe<String_comparison_exp>;
  Identified_Pain__c?: InputMaybe<String_comparison_exp>;
  Implementation_Notes__c?: InputMaybe<String_comparison_exp>;
  IqScore?: InputMaybe<Int_comparison_exp>;
  IsClosed?: InputMaybe<Boolean_comparison_exp>;
  IsDeleted?: InputMaybe<Boolean_comparison_exp>;
  IsExcludedFromTerritory2Filter?: InputMaybe<Boolean_comparison_exp>;
  IsSplit?: InputMaybe<Boolean_comparison_exp>;
  IsSyncNeeded__c?: InputMaybe<Boolean_comparison_exp>;
  IsWon?: InputMaybe<Boolean_comparison_exp>;
  Is_Commit__c?: InputMaybe<Boolean_comparison_exp>;
  Job_Templates__c?: InputMaybe<String_comparison_exp>;
  LID__CurrentGenerators__c?: InputMaybe<String_comparison_exp>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<String_comparison_exp>;
  LID__Is_Influenced__c?: InputMaybe<Boolean_comparison_exp>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<String_comparison_exp>;
  LID__MainCompetitors__c?: InputMaybe<String_comparison_exp>;
  LID__My_DateTime__c?: InputMaybe<timestamp_comparison_exp>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<float8_comparison_exp>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<float8_comparison_exp>;
  LID__My_Geolocation__c?: InputMaybe<json_comparison_exp>;
  LID__OrderNumber__c?: InputMaybe<String_comparison_exp>;
  LID__TrackingNumber__c?: InputMaybe<String_comparison_exp>;
  LastActivityDate?: InputMaybe<date_comparison_exp>;
  LastAmountChangedHistoryId?: InputMaybe<String_comparison_exp>;
  LastCloseDateChangedHistoryId?: InputMaybe<String_comparison_exp>;
  LastModifiedById?: InputMaybe<String_comparison_exp>;
  LastModifiedDate?: InputMaybe<timestamp_comparison_exp>;
  LastReferencedDate?: InputMaybe<timestamp_comparison_exp>;
  LastStageChangeDate?: InputMaybe<timestamp_comparison_exp>;
  LastViewedDate?: InputMaybe<timestamp_comparison_exp>;
  Last_Quote_Synced_Date__c?: InputMaybe<timestamp_comparison_exp>;
  LeadSource?: InputMaybe<String_comparison_exp>;
  Lead_Source_Detail__c?: InputMaybe<String_comparison_exp>;
  Leadership_Focus__c?: InputMaybe<Boolean_comparison_exp>;
  Less_than_current_month__c?: InputMaybe<Boolean_comparison_exp>;
  Locations__c?: InputMaybe<float8_comparison_exp>;
  Lost_Reason__c?: InputMaybe<String_comparison_exp>;
  MKTG_Harri_Partnership__c?: InputMaybe<String_comparison_exp>;
  MRR_In_GBP__c?: InputMaybe<float8_comparison_exp>;
  MRR__c?: InputMaybe<float8_comparison_exp>;
  MSA_Signed_Off_On__c?: InputMaybe<String_comparison_exp>;
  MSA_What_s_Needed__c?: InputMaybe<String_comparison_exp>;
  MSA__c?: InputMaybe<String_comparison_exp>;
  Max_of_OTF__c?: InputMaybe<float8_comparison_exp>;
  Max_of_non_OTF__c?: InputMaybe<float8_comparison_exp>;
  Metrics__c?: InputMaybe<String_comparison_exp>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<date_comparison_exp>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<String_comparison_exp>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<String_comparison_exp>;
  Most_Recent_Lead_Source__c?: InputMaybe<String_comparison_exp>;
  Name?: InputMaybe<String_comparison_exp>;
  NextStep?: InputMaybe<String_comparison_exp>;
  Next_Step_Date__c?: InputMaybe<date_comparison_exp>;
  Next_Steps__c?: InputMaybe<String_comparison_exp>;
  No_Decision__c?: InputMaybe<String_comparison_exp>;
  No_Of_Quotes__c?: InputMaybe<float8_comparison_exp>;
  No_of_Employees__c?: InputMaybe<float8_comparison_exp>;
  None_OTF_Count__c?: InputMaybe<float8_comparison_exp>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<float8_comparison_exp>;
  Number_of_Won_Reason__c?: InputMaybe<float8_comparison_exp>;
  OTF_Effective_Date__c?: InputMaybe<date_comparison_exp>;
  OTF_With_Currency__c?: InputMaybe<String_comparison_exp>;
  One_Call_Close__c?: InputMaybe<Boolean_comparison_exp>;
  Operating_Structure__c?: InputMaybe<String_comparison_exp>;
  Opportunity_Currency__c?: InputMaybe<String_comparison_exp>;
  Opportunity_Franchise_Name__c?: InputMaybe<String_comparison_exp>;
  Opportunity_From_Lead__c?: InputMaybe<Boolean_comparison_exp>;
  Opportunity_Name_Formatted__c?: InputMaybe<String_comparison_exp>;
  Opportunity_Owner_Prediction__c?: InputMaybe<String_comparison_exp>;
  Opportunity_Region__c?: InputMaybe<String_comparison_exp>;
  Orientation_Conducted_By__c?: InputMaybe<String_comparison_exp>;
  Orientation_Contact__c?: InputMaybe<String_comparison_exp>;
  Orientation_Date__c?: InputMaybe<timestamp_comparison_exp>;
  Orientation_Missed__c?: InputMaybe<Boolean_comparison_exp>;
  Orientation_Notes__c?: InputMaybe<String_comparison_exp>;
  Original_Payment_Amount__c?: InputMaybe<float8_comparison_exp>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<String_comparison_exp>;
  Outreach_First_Primary_Contact__c?: InputMaybe<String_comparison_exp>;
  Over_All_CMRR__c?: InputMaybe<float8_comparison_exp>;
  Overall_CMRR_for_renewal__c?: InputMaybe<float8_comparison_exp>;
  Overall_CMRR_new__c?: InputMaybe<float8_comparison_exp>;
  OwnerId?: InputMaybe<String_comparison_exp>;
  Owner_Role__c?: InputMaybe<String_comparison_exp>;
  PAPER_PROCESS__c?: InputMaybe<String_comparison_exp>;
  PB_Locked__c?: InputMaybe<Boolean_comparison_exp>;
  Papa_Johns_Camp__c?: InputMaybe<Boolean_comparison_exp>;
  Papa_Johns_total__c?: InputMaybe<float8_comparison_exp>;
  PatchDealhub__c?: InputMaybe<Boolean_comparison_exp>;
  Payment_Amount__c?: InputMaybe<float8_comparison_exp>;
  Payment_Method__c?: InputMaybe<String_comparison_exp>;
  Payment_Schedule__c?: InputMaybe<String_comparison_exp>;
  Payroll_Integration__c?: InputMaybe<String_comparison_exp>;
  Potential_Hurdles__c?: InputMaybe<String_comparison_exp>;
  PreSale__c?: InputMaybe<String_comparison_exp>;
  Pricebook2Id?: InputMaybe<String_comparison_exp>;
  Pricebook_Name__c?: InputMaybe<String_comparison_exp>;
  Probability?: InputMaybe<float8_comparison_exp>;
  Product_Customizations__c?: InputMaybe<String_comparison_exp>;
  Product_Development_needed__c?: InputMaybe<Boolean_comparison_exp>;
  Product_Quantity__c?: InputMaybe<float8_comparison_exp>;
  Product_Sold__c?: InputMaybe<String_comparison_exp>;
  Product_Team_Reviewing_Status__c?: InputMaybe<String_comparison_exp>;
  Product_analyst_review__c?: InputMaybe<String_comparison_exp>;
  Products_OTF__c?: InputMaybe<float8_comparison_exp>;
  Products_not_equal__c?: InputMaybe<Boolean_comparison_exp>;
  Project_Notes__c?: InputMaybe<String_comparison_exp>;
  Proposal_CMRR_Discount__c?: InputMaybe<float8_comparison_exp>;
  Proposal_Customer_Address__c?: InputMaybe<String_comparison_exp>;
  Proposal_OTF_Discount__c?: InputMaybe<float8_comparison_exp>;
  Proposal_Status__c?: InputMaybe<String_comparison_exp>;
  PushCount?: InputMaybe<Int_comparison_exp>;
  Reason_stalled__c?: InputMaybe<String_comparison_exp>;
  RecordTypeId?: InputMaybe<String_comparison_exp>;
  Referred_By_Who__c?: InputMaybe<String_comparison_exp>;
  Rejected_Reason__c?: InputMaybe<String_comparison_exp>;
  Rejected__c?: InputMaybe<Boolean_comparison_exp>;
  Renewal_Date__c?: InputMaybe<date_comparison_exp>;
  Renewal_Uptick__c?: InputMaybe<float8_comparison_exp>;
  RevOps_Notes__c?: InputMaybe<String_comparison_exp>;
  SDR_Owner__c?: InputMaybe<String_comparison_exp>;
  SOW_What_s_Needed__c?: InputMaybe<String_comparison_exp>;
  ST_cleaned__c?: InputMaybe<String_comparison_exp>;
  Sales_Channel__c?: InputMaybe<String_comparison_exp>;
  Segment__c?: InputMaybe<String_comparison_exp>;
  Signed_Contracts_Count__c?: InputMaybe<float8_comparison_exp>;
  SoW_Form_Id__c?: InputMaybe<String_comparison_exp>;
  SoW_Signed_Off_on__c?: InputMaybe<String_comparison_exp>;
  SoW__c?: InputMaybe<String_comparison_exp>;
  Solution_Consultant_Owner__c?: InputMaybe<String_comparison_exp>;
  Source__c?: InputMaybe<String_comparison_exp>;
  Special_Terms__c?: InputMaybe<String_comparison_exp>;
  Special_Terms_approved__c?: InputMaybe<Boolean_comparison_exp>;
  StageName?: InputMaybe<String_comparison_exp>;
  Stalled_COVID19__c?: InputMaybe<Boolean_comparison_exp>;
  Standard_Documents__c?: InputMaybe<String_comparison_exp>;
  State__c?: InputMaybe<String_comparison_exp>;
  Status__c?: InputMaybe<String_comparison_exp>;
  Subscription_End_Date__c?: InputMaybe<date_comparison_exp>;
  Subscription_Start_Date__c?: InputMaybe<date_comparison_exp>;
  Subway_Onboarding__c?: InputMaybe<String_comparison_exp>;
  Sum_of_Sub_Opp__c?: InputMaybe<float8_comparison_exp>;
  SyncedQuoteId?: InputMaybe<String_comparison_exp>;
  SystemModstamp?: InputMaybe<timestamp_comparison_exp>;
  Term_Length_Months__c?: InputMaybe<String_comparison_exp>;
  Territory2Id?: InputMaybe<String_comparison_exp>;
  Test__c?: InputMaybe<String_comparison_exp>;
  TotalOpportunityQuantity?: InputMaybe<float8_comparison_exp>;
  Total_Amount__c?: InputMaybe<float8_comparison_exp>;
  Total_CMRR_Discount__c?: InputMaybe<float8_comparison_exp>;
  Total_CMRR_Formatted__c?: InputMaybe<String_comparison_exp>;
  Total_OTF_Discount__c?: InputMaybe<float8_comparison_exp>;
  Total_OTF_Formatted__c?: InputMaybe<String_comparison_exp>;
  Total_OTF__c?: InputMaybe<float8_comparison_exp>;
  Total_Opportunity_Amount__c?: InputMaybe<float8_comparison_exp>;
  Total_Opportunity_Discount__c?: InputMaybe<float8_comparison_exp>;
  Trial__c?: InputMaybe<String_comparison_exp>;
  Type?: InputMaybe<String_comparison_exp>;
  Type_?: InputMaybe<String_comparison_exp>;
  UK_Historical_CMRR__c?: InputMaybe<float8_comparison_exp>;
  URL__c?: InputMaybe<String_comparison_exp>;
  Updated__c?: InputMaybe<timestamp_comparison_exp>;
  Uptick_MRR__c?: InputMaybe<float8_comparison_exp>;
  VisibleCompetitorType__c?: InputMaybe<String_comparison_exp>;
  Weighted_CMRR__c?: InputMaybe<float8_comparison_exp>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<String_comparison_exp>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<String_comparison_exp>;
  Who_s_working_on_Sow__c?: InputMaybe<String_comparison_exp>;
  Whos_Working_on_MSA__c?: InputMaybe<String_comparison_exp>;
  Why_Buy_Harri__c?: InputMaybe<String_comparison_exp>;
  Why_Buy_Now__c?: InputMaybe<String_comparison_exp>;
  Why_buy__c?: InputMaybe<String_comparison_exp>;
  Why_no_commit__c?: InputMaybe<String_comparison_exp>;
  Won_against__c?: InputMaybe<String_comparison_exp>;
  Wrong_Contract_Term__c?: InputMaybe<Boolean_comparison_exp>;
  X00_Archived_Date__c?: InputMaybe<date_comparison_exp>;
  X00_Close_Lost_Date__c?: InputMaybe<date_comparison_exp>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<date_comparison_exp>;
  X00_New_Date__c?: InputMaybe<date_comparison_exp>;
  X00_SQL_List__c?: InputMaybe<date_comparison_exp>;
  X00_Unqualified_Date__c?: InputMaybe<date_comparison_exp>;
  X01_Discovery__c?: InputMaybe<date_comparison_exp>;
  X01_Identified_Date__c?: InputMaybe<date_comparison_exp>;
  X02_Analysis__c?: InputMaybe<date_comparison_exp>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<date_comparison_exp>;
  X03_Evaluating_Date__c?: InputMaybe<date_comparison_exp>;
  X03_Presentation__c?: InputMaybe<date_comparison_exp>;
  X04_Competing_Date__c?: InputMaybe<date_comparison_exp>;
  X04_Proposal__c?: InputMaybe<date_comparison_exp>;
  X05_Negotiating_Date__c?: InputMaybe<date_comparison_exp>;
  X06_Signature_Pending_Date__c?: InputMaybe<date_comparison_exp>;
  X07_Close_Won_Date__c?: InputMaybe<date_comparison_exp>;
  _and?: InputMaybe<Array<Opportunity_bool_exp>>;
  _not?: InputMaybe<Opportunity_bool_exp>;
  _or?: InputMaybe<Array<Opportunity_bool_exp>>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<String_comparison_exp>;
  intuit_apps__invoiceAmount__c?: InputMaybe<float8_comparison_exp>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<timestamp_comparison_exp>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<date_comparison_exp>;
  intuit_apps__invoiceId__c?: InputMaybe<String_comparison_exp>;
  intuit_apps__invoiceNumber__c?: InputMaybe<String_comparison_exp>;
  of_Resource_Request__c?: InputMaybe<float8_comparison_exp>;
  posted_time__c?: InputMaybe<timestamp_comparison_exp>;
  power_of_1__c?: InputMaybe<float8_comparison_exp>;
  push_date__c?: InputMaybe<date_comparison_exp>;
  scheduled_demo_date__c?: InputMaybe<timestamp_comparison_exp>;
  scheduled_discovery_call_date__c?: InputMaybe<timestamp_comparison_exp>;
  source_url__c?: InputMaybe<String_comparison_exp>;
  sum_price_after_the_discount__c?: InputMaybe<float8_comparison_exp>;
  sum_price_before_the_discount__c?: InputMaybe<float8_comparison_exp>;
  term_in_months__c?: InputMaybe<float8_comparison_exp>;
  vy_report__Opp_count__c?: InputMaybe<float8_comparison_exp>;
  vy_report__Vidyard_Count__c?: InputMaybe<float8_comparison_exp>;
  weighted_Value__c?: InputMaybe<float8_comparison_exp>;
  what_product_development_is_needed__c?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "Opportunity" */
export enum Opportunity_constraint {
  /** unique or primary key constraint on columns "Id" */
  Opportunity_pkey = "Opportunity_pkey",
}

/** input type for incrementing numeric columns in table "Opportunity" */
export type Opportunity_inc_input = {
  Amount?: InputMaybe<Scalars["float8"]>;
  Amount_?: InputMaybe<Scalars["float8"]>;
  Annual_Contract_Value__c?: InputMaybe<Scalars["float8"]>;
  Attachments_Count__c?: InputMaybe<Scalars["float8"]>;
  Churned_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Compliance_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Compliance_OTF__c?: InputMaybe<Scalars["float8"]>;
  Contain_Papa_John__c?: InputMaybe<Scalars["float8"]>;
  Contains_Expansion__c?: InputMaybe<Scalars["float8"]>;
  Contains_Subscription__c?: InputMaybe<Scalars["float8"]>;
  Corporate_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Count_of_Discounted_Items__c?: InputMaybe<Scalars["float8"]>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<Scalars["float8"]>;
  Custom_Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  DH_Overall_MRR__c?: InputMaybe<Scalars["float8"]>;
  Data_Quality_Score__c?: InputMaybe<Scalars["float8"]>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<Scalars["float8"]>;
  Employees__c?: InputMaybe<Scalars["float8"]>;
  Expansion_MRR__c?: InputMaybe<Scalars["float8"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Franshisees_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Gong__Gong_Count__c?: InputMaybe<Scalars["float8"]>;
  IqScore?: InputMaybe<Scalars["Int"]>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<Scalars["float8"]>;
  Locations__c?: InputMaybe<Scalars["float8"]>;
  MRR_In_GBP__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  Max_of_OTF__c?: InputMaybe<Scalars["float8"]>;
  Max_of_non_OTF__c?: InputMaybe<Scalars["float8"]>;
  No_Of_Quotes__c?: InputMaybe<Scalars["float8"]>;
  No_of_Employees__c?: InputMaybe<Scalars["float8"]>;
  None_OTF_Count__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Won_Reason__c?: InputMaybe<Scalars["float8"]>;
  Original_Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Over_All_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_for_renewal__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_new__c?: InputMaybe<Scalars["float8"]>;
  Papa_Johns_total__c?: InputMaybe<Scalars["float8"]>;
  Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  Products_OTF__c?: InputMaybe<Scalars["float8"]>;
  Proposal_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  Renewal_Uptick__c?: InputMaybe<Scalars["float8"]>;
  Signed_Contracts_Count__c?: InputMaybe<Scalars["float8"]>;
  Sum_of_Sub_Opp__c?: InputMaybe<Scalars["float8"]>;
  TotalOpportunityQuantity?: InputMaybe<Scalars["float8"]>;
  Total_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_OTF__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Discount__c?: InputMaybe<Scalars["float8"]>;
  UK_Historical_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Uptick_MRR__c?: InputMaybe<Scalars["float8"]>;
  Weighted_CMRR__c?: InputMaybe<Scalars["float8"]>;
  intuit_apps__invoiceAmount__c?: InputMaybe<Scalars["float8"]>;
  of_Resource_Request__c?: InputMaybe<Scalars["float8"]>;
  power_of_1__c?: InputMaybe<Scalars["float8"]>;
  sum_price_after_the_discount__c?: InputMaybe<Scalars["float8"]>;
  sum_price_before_the_discount__c?: InputMaybe<Scalars["float8"]>;
  term_in_months__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Opp_count__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Vidyard_Count__c?: InputMaybe<Scalars["float8"]>;
  weighted_Value__c?: InputMaybe<Scalars["float8"]>;
};

/** input type for inserting data into table "Opportunity" */
export type Opportunity_insert_input = {
  AE_Notes__c?: InputMaybe<Scalars["String"]>;
  AccountId?: InputMaybe<Scalars["String"]>;
  Account_Contact_Name__c?: InputMaybe<Scalars["String"]>;
  Account_Contact_Phone__c?: InputMaybe<Scalars["String"]>;
  Account_Contact__c?: InputMaybe<Scalars["String"]>;
  Acquisition_Program__c?: InputMaybe<Scalars["String"]>;
  Active_Employees__c?: InputMaybe<Scalars["String"]>;
  Address__c?: InputMaybe<Scalars["String"]>;
  Agreement_ID__c?: InputMaybe<Scalars["String"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  Amount_?: InputMaybe<Scalars["float8"]>;
  Annual_Contract_Value__c?: InputMaybe<Scalars["float8"]>;
  Anticipated_Go_Live__c?: InputMaybe<Scalars["date"]>;
  Attachments_Count__c?: InputMaybe<Scalars["float8"]>;
  Auto_Renew__c?: InputMaybe<Scalars["Boolean"]>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Employee_Management__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Interviewer_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Onboarding__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Payroll_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Scheduler_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Texting__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<Scalars["String"]>;
  BackLog_Opportunity__c?: InputMaybe<Scalars["Boolean"]>;
  Barakat_2__c?: InputMaybe<Scalars["Boolean"]>;
  Best_Case_Stalled__c?: InputMaybe<Scalars["Boolean"]>;
  Billing_Terms__c?: InputMaybe<Scalars["String"]>;
  Booked_By__c?: InputMaybe<Scalars["String"]>;
  CMRR_With_Currency__c?: InputMaybe<Scalars["String"]>;
  CMRR__c?: InputMaybe<Scalars["String"]>;
  CampaignId?: InputMaybe<Scalars["String"]>;
  Can_edit_the_close_date__c?: InputMaybe<Scalars["Boolean"]>;
  Champion__c?: InputMaybe<Scalars["String"]>;
  Churned_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Churned_Date__c?: InputMaybe<Scalars["date"]>;
  Churned_Opportunity__c?: InputMaybe<Scalars["Boolean"]>;
  City__c?: InputMaybe<Scalars["String"]>;
  Classification__c?: InputMaybe<Scalars["String"]>;
  CloseDate?: InputMaybe<Scalars["date"]>;
  Coach__c?: InputMaybe<Scalars["String"]>;
  Coming_from_Dealhub__c?: InputMaybe<Scalars["Boolean"]>;
  Commit_Stalled__c?: InputMaybe<Scalars["Boolean"]>;
  Company__c?: InputMaybe<Scalars["String"]>;
  Competition__c?: InputMaybe<Scalars["String"]>;
  Compliance_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Compliance_OTF_Formatted__c?: InputMaybe<Scalars["String"]>;
  Compliance_OTF__c?: InputMaybe<Scalars["float8"]>;
  ContactID__c?: InputMaybe<Scalars["String"]>;
  ContactId?: InputMaybe<Scalars["String"]>;
  Contact_Email__c?: InputMaybe<Scalars["String"]>;
  Contact_ID_Related_Oppt__c?: InputMaybe<Scalars["String"]>;
  Contact_Name__c?: InputMaybe<Scalars["String"]>;
  Contact_Phone__c?: InputMaybe<Scalars["String"]>;
  Contact_Title__c?: InputMaybe<Scalars["String"]>;
  Contact__c?: InputMaybe<Scalars["String"]>;
  Contain_Papa_John__c?: InputMaybe<Scalars["float8"]>;
  Contains_Expansion__c?: InputMaybe<Scalars["float8"]>;
  Contains_Subscription__c?: InputMaybe<Scalars["float8"]>;
  Contract_Term__c?: InputMaybe<Scalars["String"]>;
  Corporate_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Count_of_Discounted_Items__c?: InputMaybe<Scalars["float8"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Created_By_Role_Name__c?: InputMaybe<Scalars["String"]>;
  Created_Unit_Level_User_Logins__c?: InputMaybe<Scalars["Boolean"]>;
  Custom_Close_Date__c?: InputMaybe<Scalars["date"]>;
  Custom_Documents__c?: InputMaybe<Scalars["String"]>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<Scalars["float8"]>;
  Custom_Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  DH_Overall_MRR__c?: InputMaybe<Scalars["float8"]>;
  Data_Quality_Description__c?: InputMaybe<Scalars["String"]>;
  Data_Quality_Score__c?: InputMaybe<Scalars["float8"]>;
  Date_Demo_Held__c?: InputMaybe<Scalars["date"]>;
  Date_Discovery_Held__c?: InputMaybe<Scalars["date"]>;
  Date_Entered_Backlog__c?: InputMaybe<Scalars["timestamp"]>;
  Date_Left_Backlog__c?: InputMaybe<Scalars["timestamp"]>;
  Date_Payment_Processed__c?: InputMaybe<Scalars["date"]>;
  Date_Payment_Received__c?: InputMaybe<Scalars["date"]>;
  Date_Time__c?: InputMaybe<Scalars["timestamp"]>;
  DealHub_Create_Subscription__c?: InputMaybe<Scalars["Boolean"]>;
  Deal_Health__c?: InputMaybe<Scalars["String"]>;
  Deal_Room_URL__c?: InputMaybe<Scalars["String"]>;
  Dealhub_Quote_Status__c?: InputMaybe<Scalars["String"]>;
  Dealhub_URL__c?: InputMaybe<Scalars["String"]>;
  Decision_Criteria__c?: InputMaybe<Scalars["String"]>;
  Decision_Process__c?: InputMaybe<Scalars["String"]>;
  Demo_Held__c?: InputMaybe<Scalars["Boolean"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Description__c?: InputMaybe<Scalars["String"]>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<Scalars["float8"]>;
  Discount_Approval_Status__c?: InputMaybe<Scalars["String"]>;
  Discovery_Held__c?: InputMaybe<Scalars["Boolean"]>;
  Dont_update_reg__c?: InputMaybe<Scalars["Boolean"]>;
  Economic_Buyer__c?: InputMaybe<Scalars["String"]>;
  Effective_Date__c?: InputMaybe<Scalars["date"]>;
  Email_Sent__c?: InputMaybe<Scalars["String"]>;
  Email__c?: InputMaybe<Scalars["String"]>;
  Employees__c?: InputMaybe<Scalars["float8"]>;
  End_Date__c?: InputMaybe<Scalars["date"]>;
  Expansion_MRR__c?: InputMaybe<Scalars["float8"]>;
  Feature__c?: InputMaybe<Scalars["String"]>;
  Financial_Notes__c?: InputMaybe<Scalars["String"]>;
  Firm_Committed__c?: InputMaybe<Scalars["Boolean"]>;
  First_Quote_Synced_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Fiscal?: InputMaybe<Scalars["String"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  ForceCreateHarriProjects__c?: InputMaybe<Scalars["Boolean"]>;
  ForecastCategory?: InputMaybe<Scalars["String"]>;
  ForecastCategoryName?: InputMaybe<Scalars["String"]>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Franchise_Sign_Up__c?: InputMaybe<Scalars["Boolean"]>;
  Franchisee_Sign_Up__c?: InputMaybe<Scalars["String"]>;
  Franshisees_CMRR__c?: InputMaybe<Scalars["float8"]>;
  GI_Opportunity_Region__c?: InputMaybe<Scalars["String"]>;
  Gong__CurrentGenerators__c?: InputMaybe<Scalars["String"]>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<Scalars["String"]>;
  Gong__Gong_Count__c?: InputMaybe<Scalars["float8"]>;
  Gong__MainCompetitors__c?: InputMaybe<Scalars["String"]>;
  Gong__OrderNumber__c?: InputMaybe<Scalars["String"]>;
  Gong__TrackingNumber__c?: InputMaybe<Scalars["String"]>;
  Harri_API_Enabled__c?: InputMaybe<Scalars["Boolean"]>;
  Harri_Profile_Created__c?: InputMaybe<Scalars["Boolean"]>;
  Harri_Project__c?: InputMaybe<Scalars["String"]>;
  HasOpenActivity?: InputMaybe<Scalars["Boolean"]>;
  HasOpportunityLineItem?: InputMaybe<Scalars["Boolean"]>;
  HasOverdueTask?: InputMaybe<Scalars["Boolean"]>;
  Hiring_Urgency__c?: InputMaybe<Scalars["String"]>;
  ID_18_digit__c?: InputMaybe<Scalars["String"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Identified_Pain__c?: InputMaybe<Scalars["String"]>;
  Implementation_Notes__c?: InputMaybe<Scalars["String"]>;
  IqScore?: InputMaybe<Scalars["Int"]>;
  IsClosed?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsExcludedFromTerritory2Filter?: InputMaybe<Scalars["Boolean"]>;
  IsSplit?: InputMaybe<Scalars["Boolean"]>;
  IsSyncNeeded__c?: InputMaybe<Scalars["Boolean"]>;
  IsWon?: InputMaybe<Scalars["Boolean"]>;
  Is_Commit__c?: InputMaybe<Scalars["Boolean"]>;
  Job_Templates__c?: InputMaybe<Scalars["String"]>;
  LID__CurrentGenerators__c?: InputMaybe<Scalars["String"]>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<Scalars["String"]>;
  LID__Is_Influenced__c?: InputMaybe<Scalars["Boolean"]>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<Scalars["String"]>;
  LID__MainCompetitors__c?: InputMaybe<Scalars["String"]>;
  LID__My_DateTime__c?: InputMaybe<Scalars["timestamp"]>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__c?: InputMaybe<Scalars["json"]>;
  LID__OrderNumber__c?: InputMaybe<Scalars["String"]>;
  LID__TrackingNumber__c?: InputMaybe<Scalars["String"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastAmountChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastCloseDateChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastStageChangeDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  Last_Quote_Synced_Date__c?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Lead_Source_Detail__c?: InputMaybe<Scalars["String"]>;
  Leadership_Focus__c?: InputMaybe<Scalars["Boolean"]>;
  Less_than_current_month__c?: InputMaybe<Scalars["Boolean"]>;
  Locations__c?: InputMaybe<Scalars["float8"]>;
  Lost_Reason__c?: InputMaybe<Scalars["String"]>;
  MKTG_Harri_Partnership__c?: InputMaybe<Scalars["String"]>;
  MRR_In_GBP__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  MSA_Signed_Off_On__c?: InputMaybe<Scalars["String"]>;
  MSA_What_s_Needed__c?: InputMaybe<Scalars["String"]>;
  MSA__c?: InputMaybe<Scalars["String"]>;
  Max_of_OTF__c?: InputMaybe<Scalars["float8"]>;
  Max_of_non_OTF__c?: InputMaybe<Scalars["float8"]>;
  Metrics__c?: InputMaybe<Scalars["String"]>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<Scalars["date"]>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<Scalars["String"]>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<Scalars["String"]>;
  Most_Recent_Lead_Source__c?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NextStep?: InputMaybe<Scalars["String"]>;
  Next_Step_Date__c?: InputMaybe<Scalars["date"]>;
  Next_Steps__c?: InputMaybe<Scalars["String"]>;
  No_Decision__c?: InputMaybe<Scalars["String"]>;
  No_Of_Quotes__c?: InputMaybe<Scalars["float8"]>;
  No_of_Employees__c?: InputMaybe<Scalars["float8"]>;
  None_OTF_Count__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Won_Reason__c?: InputMaybe<Scalars["float8"]>;
  OTF_Effective_Date__c?: InputMaybe<Scalars["date"]>;
  OTF_With_Currency__c?: InputMaybe<Scalars["String"]>;
  One_Call_Close__c?: InputMaybe<Scalars["Boolean"]>;
  Operating_Structure__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Currency__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Franchise_Name__c?: InputMaybe<Scalars["String"]>;
  Opportunity_From_Lead__c?: InputMaybe<Scalars["Boolean"]>;
  Opportunity_Name_Formatted__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Owner_Prediction__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Region__c?: InputMaybe<Scalars["String"]>;
  Orientation_Conducted_By__c?: InputMaybe<Scalars["String"]>;
  Orientation_Contact__c?: InputMaybe<Scalars["String"]>;
  Orientation_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Orientation_Missed__c?: InputMaybe<Scalars["Boolean"]>;
  Orientation_Notes__c?: InputMaybe<Scalars["String"]>;
  Original_Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<Scalars["String"]>;
  Outreach_First_Primary_Contact__c?: InputMaybe<Scalars["String"]>;
  Over_All_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_for_renewal__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_new__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  Owner_Role__c?: InputMaybe<Scalars["String"]>;
  PAPER_PROCESS__c?: InputMaybe<Scalars["String"]>;
  PB_Locked__c?: InputMaybe<Scalars["Boolean"]>;
  Papa_Johns_Camp__c?: InputMaybe<Scalars["Boolean"]>;
  Papa_Johns_total__c?: InputMaybe<Scalars["float8"]>;
  PatchDealhub__c?: InputMaybe<Scalars["Boolean"]>;
  Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Payment_Method__c?: InputMaybe<Scalars["String"]>;
  Payment_Schedule__c?: InputMaybe<Scalars["String"]>;
  Payroll_Integration__c?: InputMaybe<Scalars["String"]>;
  Potential_Hurdles__c?: InputMaybe<Scalars["String"]>;
  PreSale__c?: InputMaybe<Scalars["String"]>;
  Pricebook2Id?: InputMaybe<Scalars["String"]>;
  Pricebook_Name__c?: InputMaybe<Scalars["String"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  Product_Customizations__c?: InputMaybe<Scalars["String"]>;
  Product_Development_needed__c?: InputMaybe<Scalars["Boolean"]>;
  Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  Product_Sold__c?: InputMaybe<Scalars["String"]>;
  Product_Team_Reviewing_Status__c?: InputMaybe<Scalars["String"]>;
  Product_analyst_review__c?: InputMaybe<Scalars["String"]>;
  Products_OTF__c?: InputMaybe<Scalars["float8"]>;
  Products_not_equal__c?: InputMaybe<Scalars["Boolean"]>;
  Project_Notes__c?: InputMaybe<Scalars["String"]>;
  Proposal_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_Customer_Address__c?: InputMaybe<Scalars["String"]>;
  Proposal_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_Status__c?: InputMaybe<Scalars["String"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  Reason_stalled__c?: InputMaybe<Scalars["String"]>;
  RecordTypeId?: InputMaybe<Scalars["String"]>;
  Referred_By_Who__c?: InputMaybe<Scalars["String"]>;
  Rejected_Reason__c?: InputMaybe<Scalars["String"]>;
  Rejected__c?: InputMaybe<Scalars["Boolean"]>;
  Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  Renewal_Uptick__c?: InputMaybe<Scalars["float8"]>;
  RevOps_Notes__c?: InputMaybe<Scalars["String"]>;
  SDR_Owner__c?: InputMaybe<Scalars["String"]>;
  SOW_What_s_Needed__c?: InputMaybe<Scalars["String"]>;
  ST_cleaned__c?: InputMaybe<Scalars["String"]>;
  Sales_Channel__c?: InputMaybe<Scalars["String"]>;
  Segment__c?: InputMaybe<Scalars["String"]>;
  Signed_Contracts_Count__c?: InputMaybe<Scalars["float8"]>;
  SoW_Form_Id__c?: InputMaybe<Scalars["String"]>;
  SoW_Signed_Off_on__c?: InputMaybe<Scalars["String"]>;
  SoW__c?: InputMaybe<Scalars["String"]>;
  Solution_Consultant_Owner__c?: InputMaybe<Scalars["String"]>;
  Source__c?: InputMaybe<Scalars["String"]>;
  Special_Terms__c?: InputMaybe<Scalars["String"]>;
  Special_Terms_approved__c?: InputMaybe<Scalars["Boolean"]>;
  StageName?: InputMaybe<Scalars["String"]>;
  Stalled_COVID19__c?: InputMaybe<Scalars["Boolean"]>;
  Standard_Documents__c?: InputMaybe<Scalars["String"]>;
  State__c?: InputMaybe<Scalars["String"]>;
  Status__c?: InputMaybe<Scalars["String"]>;
  Subscription_End_Date__c?: InputMaybe<Scalars["date"]>;
  Subscription_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Subway_Onboarding__c?: InputMaybe<Scalars["String"]>;
  Sum_of_Sub_Opp__c?: InputMaybe<Scalars["float8"]>;
  SyncedQuoteId?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Term_Length_Months__c?: InputMaybe<Scalars["String"]>;
  Territory2Id?: InputMaybe<Scalars["String"]>;
  Test__c?: InputMaybe<Scalars["String"]>;
  TotalOpportunityQuantity?: InputMaybe<Scalars["float8"]>;
  Total_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Formatted__c?: InputMaybe<Scalars["String"]>;
  Total_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_OTF_Formatted__c?: InputMaybe<Scalars["String"]>;
  Total_OTF__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Discount__c?: InputMaybe<Scalars["float8"]>;
  Trial__c?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<Scalars["String"]>;
  Type_?: InputMaybe<Scalars["String"]>;
  UK_Historical_CMRR__c?: InputMaybe<Scalars["float8"]>;
  URL__c?: InputMaybe<Scalars["String"]>;
  Updated__c?: InputMaybe<Scalars["timestamp"]>;
  Uptick_MRR__c?: InputMaybe<Scalars["float8"]>;
  VisibleCompetitorType__c?: InputMaybe<Scalars["String"]>;
  Weighted_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<Scalars["String"]>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<Scalars["String"]>;
  Who_s_working_on_Sow__c?: InputMaybe<Scalars["String"]>;
  Whos_Working_on_MSA__c?: InputMaybe<Scalars["String"]>;
  Why_Buy_Harri__c?: InputMaybe<Scalars["String"]>;
  Why_Buy_Now__c?: InputMaybe<Scalars["String"]>;
  Why_buy__c?: InputMaybe<Scalars["String"]>;
  Why_no_commit__c?: InputMaybe<Scalars["String"]>;
  Won_against__c?: InputMaybe<Scalars["String"]>;
  Wrong_Contract_Term__c?: InputMaybe<Scalars["Boolean"]>;
  X00_Archived_Date__c?: InputMaybe<Scalars["date"]>;
  X00_Close_Lost_Date__c?: InputMaybe<Scalars["date"]>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<Scalars["date"]>;
  X00_New_Date__c?: InputMaybe<Scalars["date"]>;
  X00_SQL_List__c?: InputMaybe<Scalars["date"]>;
  X00_Unqualified_Date__c?: InputMaybe<Scalars["date"]>;
  X01_Discovery__c?: InputMaybe<Scalars["date"]>;
  X01_Identified_Date__c?: InputMaybe<Scalars["date"]>;
  X02_Analysis__c?: InputMaybe<Scalars["date"]>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<Scalars["date"]>;
  X03_Evaluating_Date__c?: InputMaybe<Scalars["date"]>;
  X03_Presentation__c?: InputMaybe<Scalars["date"]>;
  X04_Competing_Date__c?: InputMaybe<Scalars["date"]>;
  X04_Proposal__c?: InputMaybe<Scalars["date"]>;
  X05_Negotiating_Date__c?: InputMaybe<Scalars["date"]>;
  X06_Signature_Pending_Date__c?: InputMaybe<Scalars["date"]>;
  X07_Close_Won_Date__c?: InputMaybe<Scalars["date"]>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<Scalars["String"]>;
  intuit_apps__invoiceAmount__c?: InputMaybe<Scalars["float8"]>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<Scalars["timestamp"]>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<Scalars["date"]>;
  intuit_apps__invoiceId__c?: InputMaybe<Scalars["String"]>;
  intuit_apps__invoiceNumber__c?: InputMaybe<Scalars["String"]>;
  of_Resource_Request__c?: InputMaybe<Scalars["float8"]>;
  posted_time__c?: InputMaybe<Scalars["timestamp"]>;
  power_of_1__c?: InputMaybe<Scalars["float8"]>;
  push_date__c?: InputMaybe<Scalars["date"]>;
  scheduled_demo_date__c?: InputMaybe<Scalars["timestamp"]>;
  scheduled_discovery_call_date__c?: InputMaybe<Scalars["timestamp"]>;
  source_url__c?: InputMaybe<Scalars["String"]>;
  sum_price_after_the_discount__c?: InputMaybe<Scalars["float8"]>;
  sum_price_before_the_discount__c?: InputMaybe<Scalars["float8"]>;
  term_in_months__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Opp_count__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Vidyard_Count__c?: InputMaybe<Scalars["float8"]>;
  weighted_Value__c?: InputMaybe<Scalars["float8"]>;
  what_product_development_is_needed__c?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "Opportunity" */
export type Opportunity_max_order_by = {
  AE_Notes__c?: InputMaybe<order_by>;
  AccountId?: InputMaybe<order_by>;
  Account_Contact_Name__c?: InputMaybe<order_by>;
  Account_Contact_Phone__c?: InputMaybe<order_by>;
  Account_Contact__c?: InputMaybe<order_by>;
  Acquisition_Program__c?: InputMaybe<order_by>;
  Active_Employees__c?: InputMaybe<order_by>;
  Address__c?: InputMaybe<order_by>;
  Agreement_ID__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Anticipated_Go_Live__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<order_by>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<order_by>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<order_by>;
  BIZSYS_Employee_Management__c?: InputMaybe<order_by>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<order_by>;
  BIZSYS_Interviewer_System__c?: InputMaybe<order_by>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<order_by>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<order_by>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<order_by>;
  BIZSYS_Onboarding__c?: InputMaybe<order_by>;
  BIZSYS_Payroll_System__c?: InputMaybe<order_by>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<order_by>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<order_by>;
  BIZSYS_Scheduler_System__c?: InputMaybe<order_by>;
  BIZSYS_Texting__c?: InputMaybe<order_by>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<order_by>;
  Billing_Terms__c?: InputMaybe<order_by>;
  Booked_By__c?: InputMaybe<order_by>;
  CMRR_With_Currency__c?: InputMaybe<order_by>;
  CMRR__c?: InputMaybe<order_by>;
  CampaignId?: InputMaybe<order_by>;
  Champion__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Churned_Date__c?: InputMaybe<order_by>;
  City__c?: InputMaybe<order_by>;
  Classification__c?: InputMaybe<order_by>;
  CloseDate?: InputMaybe<order_by>;
  Coach__c?: InputMaybe<order_by>;
  Company__c?: InputMaybe<order_by>;
  Competition__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF_Formatted__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  ContactID__c?: InputMaybe<order_by>;
  ContactId?: InputMaybe<order_by>;
  Contact_Email__c?: InputMaybe<order_by>;
  Contact_ID_Related_Oppt__c?: InputMaybe<order_by>;
  Contact_Name__c?: InputMaybe<order_by>;
  Contact_Phone__c?: InputMaybe<order_by>;
  Contact_Title__c?: InputMaybe<order_by>;
  Contact__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Contract_Term__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Created_By_Role_Name__c?: InputMaybe<order_by>;
  Custom_Close_Date__c?: InputMaybe<order_by>;
  Custom_Documents__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Description__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Date_Demo_Held__c?: InputMaybe<order_by>;
  Date_Discovery_Held__c?: InputMaybe<order_by>;
  Date_Entered_Backlog__c?: InputMaybe<order_by>;
  Date_Left_Backlog__c?: InputMaybe<order_by>;
  Date_Payment_Processed__c?: InputMaybe<order_by>;
  Date_Payment_Received__c?: InputMaybe<order_by>;
  Date_Time__c?: InputMaybe<order_by>;
  Deal_Health__c?: InputMaybe<order_by>;
  Deal_Room_URL__c?: InputMaybe<order_by>;
  Dealhub_Quote_Status__c?: InputMaybe<order_by>;
  Dealhub_URL__c?: InputMaybe<order_by>;
  Decision_Criteria__c?: InputMaybe<order_by>;
  Decision_Process__c?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Description__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Discount_Approval_Status__c?: InputMaybe<order_by>;
  Economic_Buyer__c?: InputMaybe<order_by>;
  Effective_Date__c?: InputMaybe<order_by>;
  Email_Sent__c?: InputMaybe<order_by>;
  Email__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  End_Date__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  Feature__c?: InputMaybe<order_by>;
  Financial_Notes__c?: InputMaybe<order_by>;
  First_Quote_Synced_Date__c?: InputMaybe<order_by>;
  Fiscal?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  ForecastCategory?: InputMaybe<order_by>;
  ForecastCategoryName?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franchisee_Sign_Up__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  GI_Opportunity_Region__c?: InputMaybe<order_by>;
  Gong__CurrentGenerators__c?: InputMaybe<order_by>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  Gong__MainCompetitors__c?: InputMaybe<order_by>;
  Gong__OrderNumber__c?: InputMaybe<order_by>;
  Gong__TrackingNumber__c?: InputMaybe<order_by>;
  Harri_Project__c?: InputMaybe<order_by>;
  Hiring_Urgency__c?: InputMaybe<order_by>;
  ID_18_digit__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Identified_Pain__c?: InputMaybe<order_by>;
  Implementation_Notes__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  Job_Templates__c?: InputMaybe<order_by>;
  LID__CurrentGenerators__c?: InputMaybe<order_by>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<order_by>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<order_by>;
  LID__MainCompetitors__c?: InputMaybe<order_by>;
  LID__My_DateTime__c?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  LID__OrderNumber__c?: InputMaybe<order_by>;
  LID__TrackingNumber__c?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastAmountChangedHistoryId?: InputMaybe<order_by>;
  LastCloseDateChangedHistoryId?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastStageChangeDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  Last_Quote_Synced_Date__c?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Lead_Source_Detail__c?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  Lost_Reason__c?: InputMaybe<order_by>;
  MKTG_Harri_Partnership__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  MSA_Signed_Off_On__c?: InputMaybe<order_by>;
  MSA_What_s_Needed__c?: InputMaybe<order_by>;
  MSA__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  Metrics__c?: InputMaybe<order_by>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<order_by>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<order_by>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<order_by>;
  Most_Recent_Lead_Source__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NextStep?: InputMaybe<order_by>;
  Next_Step_Date__c?: InputMaybe<order_by>;
  Next_Steps__c?: InputMaybe<order_by>;
  No_Decision__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  OTF_Effective_Date__c?: InputMaybe<order_by>;
  OTF_With_Currency__c?: InputMaybe<order_by>;
  Operating_Structure__c?: InputMaybe<order_by>;
  Opportunity_Currency__c?: InputMaybe<order_by>;
  Opportunity_Franchise_Name__c?: InputMaybe<order_by>;
  Opportunity_Name_Formatted__c?: InputMaybe<order_by>;
  Opportunity_Owner_Prediction__c?: InputMaybe<order_by>;
  Opportunity_Region__c?: InputMaybe<order_by>;
  Orientation_Conducted_By__c?: InputMaybe<order_by>;
  Orientation_Contact__c?: InputMaybe<order_by>;
  Orientation_Date__c?: InputMaybe<order_by>;
  Orientation_Notes__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<order_by>;
  Outreach_First_Primary_Contact__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  Owner_Role__c?: InputMaybe<order_by>;
  PAPER_PROCESS__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Payment_Method__c?: InputMaybe<order_by>;
  Payment_Schedule__c?: InputMaybe<order_by>;
  Payroll_Integration__c?: InputMaybe<order_by>;
  Potential_Hurdles__c?: InputMaybe<order_by>;
  PreSale__c?: InputMaybe<order_by>;
  Pricebook2Id?: InputMaybe<order_by>;
  Pricebook_Name__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Customizations__c?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Product_Sold__c?: InputMaybe<order_by>;
  Product_Team_Reviewing_Status__c?: InputMaybe<order_by>;
  Product_analyst_review__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Project_Notes__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_Customer_Address__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  Proposal_Status__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Reason_stalled__c?: InputMaybe<order_by>;
  RecordTypeId?: InputMaybe<order_by>;
  Referred_By_Who__c?: InputMaybe<order_by>;
  Rejected_Reason__c?: InputMaybe<order_by>;
  Renewal_Date__c?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  RevOps_Notes__c?: InputMaybe<order_by>;
  SDR_Owner__c?: InputMaybe<order_by>;
  SOW_What_s_Needed__c?: InputMaybe<order_by>;
  ST_cleaned__c?: InputMaybe<order_by>;
  Sales_Channel__c?: InputMaybe<order_by>;
  Segment__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  SoW_Form_Id__c?: InputMaybe<order_by>;
  SoW_Signed_Off_on__c?: InputMaybe<order_by>;
  SoW__c?: InputMaybe<order_by>;
  Solution_Consultant_Owner__c?: InputMaybe<order_by>;
  Source__c?: InputMaybe<order_by>;
  Special_Terms__c?: InputMaybe<order_by>;
  StageName?: InputMaybe<order_by>;
  Standard_Documents__c?: InputMaybe<order_by>;
  State__c?: InputMaybe<order_by>;
  Status__c?: InputMaybe<order_by>;
  Subscription_End_Date__c?: InputMaybe<order_by>;
  Subscription_Start_Date__c?: InputMaybe<order_by>;
  Subway_Onboarding__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  SyncedQuoteId?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Term_Length_Months__c?: InputMaybe<order_by>;
  Territory2Id?: InputMaybe<order_by>;
  Test__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_CMRR_Formatted__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Formatted__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  Trial__c?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
  Type_?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  URL__c?: InputMaybe<order_by>;
  Updated__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  VisibleCompetitorType__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<order_by>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<order_by>;
  Who_s_working_on_Sow__c?: InputMaybe<order_by>;
  Whos_Working_on_MSA__c?: InputMaybe<order_by>;
  Why_Buy_Harri__c?: InputMaybe<order_by>;
  Why_Buy_Now__c?: InputMaybe<order_by>;
  Why_buy__c?: InputMaybe<order_by>;
  Why_no_commit__c?: InputMaybe<order_by>;
  Won_against__c?: InputMaybe<order_by>;
  X00_Archived_Date__c?: InputMaybe<order_by>;
  X00_Close_Lost_Date__c?: InputMaybe<order_by>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<order_by>;
  X00_New_Date__c?: InputMaybe<order_by>;
  X00_SQL_List__c?: InputMaybe<order_by>;
  X00_Unqualified_Date__c?: InputMaybe<order_by>;
  X01_Discovery__c?: InputMaybe<order_by>;
  X01_Identified_Date__c?: InputMaybe<order_by>;
  X02_Analysis__c?: InputMaybe<order_by>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<order_by>;
  X03_Evaluating_Date__c?: InputMaybe<order_by>;
  X03_Presentation__c?: InputMaybe<order_by>;
  X04_Competing_Date__c?: InputMaybe<order_by>;
  X04_Proposal__c?: InputMaybe<order_by>;
  X05_Negotiating_Date__c?: InputMaybe<order_by>;
  X06_Signature_Pending_Date__c?: InputMaybe<order_by>;
  X07_Close_Won_Date__c?: InputMaybe<order_by>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<order_by>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<order_by>;
  intuit_apps__invoiceId__c?: InputMaybe<order_by>;
  intuit_apps__invoiceNumber__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  posted_time__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  push_date__c?: InputMaybe<order_by>;
  scheduled_demo_date__c?: InputMaybe<order_by>;
  scheduled_discovery_call_date__c?: InputMaybe<order_by>;
  source_url__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
  what_product_development_is_needed__c?: InputMaybe<order_by>;
};

/** order by min() on columns of table "Opportunity" */
export type Opportunity_min_order_by = {
  AE_Notes__c?: InputMaybe<order_by>;
  AccountId?: InputMaybe<order_by>;
  Account_Contact_Name__c?: InputMaybe<order_by>;
  Account_Contact_Phone__c?: InputMaybe<order_by>;
  Account_Contact__c?: InputMaybe<order_by>;
  Acquisition_Program__c?: InputMaybe<order_by>;
  Active_Employees__c?: InputMaybe<order_by>;
  Address__c?: InputMaybe<order_by>;
  Agreement_ID__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Anticipated_Go_Live__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<order_by>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<order_by>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<order_by>;
  BIZSYS_Employee_Management__c?: InputMaybe<order_by>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<order_by>;
  BIZSYS_Interviewer_System__c?: InputMaybe<order_by>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<order_by>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<order_by>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<order_by>;
  BIZSYS_Onboarding__c?: InputMaybe<order_by>;
  BIZSYS_Payroll_System__c?: InputMaybe<order_by>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<order_by>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<order_by>;
  BIZSYS_Scheduler_System__c?: InputMaybe<order_by>;
  BIZSYS_Texting__c?: InputMaybe<order_by>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<order_by>;
  Billing_Terms__c?: InputMaybe<order_by>;
  Booked_By__c?: InputMaybe<order_by>;
  CMRR_With_Currency__c?: InputMaybe<order_by>;
  CMRR__c?: InputMaybe<order_by>;
  CampaignId?: InputMaybe<order_by>;
  Champion__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Churned_Date__c?: InputMaybe<order_by>;
  City__c?: InputMaybe<order_by>;
  Classification__c?: InputMaybe<order_by>;
  CloseDate?: InputMaybe<order_by>;
  Coach__c?: InputMaybe<order_by>;
  Company__c?: InputMaybe<order_by>;
  Competition__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF_Formatted__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  ContactID__c?: InputMaybe<order_by>;
  ContactId?: InputMaybe<order_by>;
  Contact_Email__c?: InputMaybe<order_by>;
  Contact_ID_Related_Oppt__c?: InputMaybe<order_by>;
  Contact_Name__c?: InputMaybe<order_by>;
  Contact_Phone__c?: InputMaybe<order_by>;
  Contact_Title__c?: InputMaybe<order_by>;
  Contact__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Contract_Term__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Created_By_Role_Name__c?: InputMaybe<order_by>;
  Custom_Close_Date__c?: InputMaybe<order_by>;
  Custom_Documents__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Description__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Date_Demo_Held__c?: InputMaybe<order_by>;
  Date_Discovery_Held__c?: InputMaybe<order_by>;
  Date_Entered_Backlog__c?: InputMaybe<order_by>;
  Date_Left_Backlog__c?: InputMaybe<order_by>;
  Date_Payment_Processed__c?: InputMaybe<order_by>;
  Date_Payment_Received__c?: InputMaybe<order_by>;
  Date_Time__c?: InputMaybe<order_by>;
  Deal_Health__c?: InputMaybe<order_by>;
  Deal_Room_URL__c?: InputMaybe<order_by>;
  Dealhub_Quote_Status__c?: InputMaybe<order_by>;
  Dealhub_URL__c?: InputMaybe<order_by>;
  Decision_Criteria__c?: InputMaybe<order_by>;
  Decision_Process__c?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Description__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Discount_Approval_Status__c?: InputMaybe<order_by>;
  Economic_Buyer__c?: InputMaybe<order_by>;
  Effective_Date__c?: InputMaybe<order_by>;
  Email_Sent__c?: InputMaybe<order_by>;
  Email__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  End_Date__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  Feature__c?: InputMaybe<order_by>;
  Financial_Notes__c?: InputMaybe<order_by>;
  First_Quote_Synced_Date__c?: InputMaybe<order_by>;
  Fiscal?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  ForecastCategory?: InputMaybe<order_by>;
  ForecastCategoryName?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franchisee_Sign_Up__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  GI_Opportunity_Region__c?: InputMaybe<order_by>;
  Gong__CurrentGenerators__c?: InputMaybe<order_by>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  Gong__MainCompetitors__c?: InputMaybe<order_by>;
  Gong__OrderNumber__c?: InputMaybe<order_by>;
  Gong__TrackingNumber__c?: InputMaybe<order_by>;
  Harri_Project__c?: InputMaybe<order_by>;
  Hiring_Urgency__c?: InputMaybe<order_by>;
  ID_18_digit__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Identified_Pain__c?: InputMaybe<order_by>;
  Implementation_Notes__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  Job_Templates__c?: InputMaybe<order_by>;
  LID__CurrentGenerators__c?: InputMaybe<order_by>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<order_by>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<order_by>;
  LID__MainCompetitors__c?: InputMaybe<order_by>;
  LID__My_DateTime__c?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  LID__OrderNumber__c?: InputMaybe<order_by>;
  LID__TrackingNumber__c?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastAmountChangedHistoryId?: InputMaybe<order_by>;
  LastCloseDateChangedHistoryId?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastStageChangeDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  Last_Quote_Synced_Date__c?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Lead_Source_Detail__c?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  Lost_Reason__c?: InputMaybe<order_by>;
  MKTG_Harri_Partnership__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  MSA_Signed_Off_On__c?: InputMaybe<order_by>;
  MSA_What_s_Needed__c?: InputMaybe<order_by>;
  MSA__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  Metrics__c?: InputMaybe<order_by>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<order_by>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<order_by>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<order_by>;
  Most_Recent_Lead_Source__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NextStep?: InputMaybe<order_by>;
  Next_Step_Date__c?: InputMaybe<order_by>;
  Next_Steps__c?: InputMaybe<order_by>;
  No_Decision__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  OTF_Effective_Date__c?: InputMaybe<order_by>;
  OTF_With_Currency__c?: InputMaybe<order_by>;
  Operating_Structure__c?: InputMaybe<order_by>;
  Opportunity_Currency__c?: InputMaybe<order_by>;
  Opportunity_Franchise_Name__c?: InputMaybe<order_by>;
  Opportunity_Name_Formatted__c?: InputMaybe<order_by>;
  Opportunity_Owner_Prediction__c?: InputMaybe<order_by>;
  Opportunity_Region__c?: InputMaybe<order_by>;
  Orientation_Conducted_By__c?: InputMaybe<order_by>;
  Orientation_Contact__c?: InputMaybe<order_by>;
  Orientation_Date__c?: InputMaybe<order_by>;
  Orientation_Notes__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<order_by>;
  Outreach_First_Primary_Contact__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  Owner_Role__c?: InputMaybe<order_by>;
  PAPER_PROCESS__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Payment_Method__c?: InputMaybe<order_by>;
  Payment_Schedule__c?: InputMaybe<order_by>;
  Payroll_Integration__c?: InputMaybe<order_by>;
  Potential_Hurdles__c?: InputMaybe<order_by>;
  PreSale__c?: InputMaybe<order_by>;
  Pricebook2Id?: InputMaybe<order_by>;
  Pricebook_Name__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Customizations__c?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Product_Sold__c?: InputMaybe<order_by>;
  Product_Team_Reviewing_Status__c?: InputMaybe<order_by>;
  Product_analyst_review__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Project_Notes__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_Customer_Address__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  Proposal_Status__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Reason_stalled__c?: InputMaybe<order_by>;
  RecordTypeId?: InputMaybe<order_by>;
  Referred_By_Who__c?: InputMaybe<order_by>;
  Rejected_Reason__c?: InputMaybe<order_by>;
  Renewal_Date__c?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  RevOps_Notes__c?: InputMaybe<order_by>;
  SDR_Owner__c?: InputMaybe<order_by>;
  SOW_What_s_Needed__c?: InputMaybe<order_by>;
  ST_cleaned__c?: InputMaybe<order_by>;
  Sales_Channel__c?: InputMaybe<order_by>;
  Segment__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  SoW_Form_Id__c?: InputMaybe<order_by>;
  SoW_Signed_Off_on__c?: InputMaybe<order_by>;
  SoW__c?: InputMaybe<order_by>;
  Solution_Consultant_Owner__c?: InputMaybe<order_by>;
  Source__c?: InputMaybe<order_by>;
  Special_Terms__c?: InputMaybe<order_by>;
  StageName?: InputMaybe<order_by>;
  Standard_Documents__c?: InputMaybe<order_by>;
  State__c?: InputMaybe<order_by>;
  Status__c?: InputMaybe<order_by>;
  Subscription_End_Date__c?: InputMaybe<order_by>;
  Subscription_Start_Date__c?: InputMaybe<order_by>;
  Subway_Onboarding__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  SyncedQuoteId?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Term_Length_Months__c?: InputMaybe<order_by>;
  Territory2Id?: InputMaybe<order_by>;
  Test__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_CMRR_Formatted__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Formatted__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  Trial__c?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
  Type_?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  URL__c?: InputMaybe<order_by>;
  Updated__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  VisibleCompetitorType__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<order_by>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<order_by>;
  Who_s_working_on_Sow__c?: InputMaybe<order_by>;
  Whos_Working_on_MSA__c?: InputMaybe<order_by>;
  Why_Buy_Harri__c?: InputMaybe<order_by>;
  Why_Buy_Now__c?: InputMaybe<order_by>;
  Why_buy__c?: InputMaybe<order_by>;
  Why_no_commit__c?: InputMaybe<order_by>;
  Won_against__c?: InputMaybe<order_by>;
  X00_Archived_Date__c?: InputMaybe<order_by>;
  X00_Close_Lost_Date__c?: InputMaybe<order_by>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<order_by>;
  X00_New_Date__c?: InputMaybe<order_by>;
  X00_SQL_List__c?: InputMaybe<order_by>;
  X00_Unqualified_Date__c?: InputMaybe<order_by>;
  X01_Discovery__c?: InputMaybe<order_by>;
  X01_Identified_Date__c?: InputMaybe<order_by>;
  X02_Analysis__c?: InputMaybe<order_by>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<order_by>;
  X03_Evaluating_Date__c?: InputMaybe<order_by>;
  X03_Presentation__c?: InputMaybe<order_by>;
  X04_Competing_Date__c?: InputMaybe<order_by>;
  X04_Proposal__c?: InputMaybe<order_by>;
  X05_Negotiating_Date__c?: InputMaybe<order_by>;
  X06_Signature_Pending_Date__c?: InputMaybe<order_by>;
  X07_Close_Won_Date__c?: InputMaybe<order_by>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<order_by>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<order_by>;
  intuit_apps__invoiceId__c?: InputMaybe<order_by>;
  intuit_apps__invoiceNumber__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  posted_time__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  push_date__c?: InputMaybe<order_by>;
  scheduled_demo_date__c?: InputMaybe<order_by>;
  scheduled_discovery_call_date__c?: InputMaybe<order_by>;
  source_url__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
  what_product_development_is_needed__c?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "Opportunity" */
export type Opportunity_on_conflict = {
  constraint: Opportunity_constraint;
  update_columns?: Array<Opportunity_update_column>;
  where?: InputMaybe<Opportunity_bool_exp>;
};

/** Ordering options when selecting data from "Opportunity". */
export type Opportunity_order_by = {
  AE_Notes__c?: InputMaybe<order_by>;
  AccountId?: InputMaybe<order_by>;
  Account_Contact_Name__c?: InputMaybe<order_by>;
  Account_Contact_Phone__c?: InputMaybe<order_by>;
  Account_Contact__c?: InputMaybe<order_by>;
  Acquisition_Program__c?: InputMaybe<order_by>;
  Active_Employees__c?: InputMaybe<order_by>;
  Address__c?: InputMaybe<order_by>;
  Agreement_ID__c?: InputMaybe<order_by>;
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Anticipated_Go_Live__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Auto_Renew__c?: InputMaybe<order_by>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<order_by>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<order_by>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<order_by>;
  BIZSYS_Employee_Management__c?: InputMaybe<order_by>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<order_by>;
  BIZSYS_Interviewer_System__c?: InputMaybe<order_by>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<order_by>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<order_by>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<order_by>;
  BIZSYS_Onboarding__c?: InputMaybe<order_by>;
  BIZSYS_Payroll_System__c?: InputMaybe<order_by>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<order_by>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<order_by>;
  BIZSYS_Scheduler_System__c?: InputMaybe<order_by>;
  BIZSYS_Texting__c?: InputMaybe<order_by>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<order_by>;
  BackLog_Opportunity__c?: InputMaybe<order_by>;
  Barakat_2__c?: InputMaybe<order_by>;
  Best_Case_Stalled__c?: InputMaybe<order_by>;
  Billing_Terms__c?: InputMaybe<order_by>;
  Booked_By__c?: InputMaybe<order_by>;
  CMRR_With_Currency__c?: InputMaybe<order_by>;
  CMRR__c?: InputMaybe<order_by>;
  CampaignId?: InputMaybe<order_by>;
  Can_edit_the_close_date__c?: InputMaybe<order_by>;
  Champion__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Churned_Date__c?: InputMaybe<order_by>;
  Churned_Opportunity__c?: InputMaybe<order_by>;
  City__c?: InputMaybe<order_by>;
  Classification__c?: InputMaybe<order_by>;
  CloseDate?: InputMaybe<order_by>;
  Coach__c?: InputMaybe<order_by>;
  Coming_from_Dealhub__c?: InputMaybe<order_by>;
  Commit_Stalled__c?: InputMaybe<order_by>;
  Company__c?: InputMaybe<order_by>;
  Competition__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF_Formatted__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  ContactID__c?: InputMaybe<order_by>;
  ContactId?: InputMaybe<order_by>;
  Contact_Email__c?: InputMaybe<order_by>;
  Contact_ID_Related_Oppt__c?: InputMaybe<order_by>;
  Contact_Name__c?: InputMaybe<order_by>;
  Contact_Phone__c?: InputMaybe<order_by>;
  Contact_Title__c?: InputMaybe<order_by>;
  Contact__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Contract_Term__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  CreatedById?: InputMaybe<order_by>;
  CreatedDate?: InputMaybe<order_by>;
  Created_By_Role_Name__c?: InputMaybe<order_by>;
  Created_Unit_Level_User_Logins__c?: InputMaybe<order_by>;
  Custom_Close_Date__c?: InputMaybe<order_by>;
  Custom_Documents__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Description__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Date_Demo_Held__c?: InputMaybe<order_by>;
  Date_Discovery_Held__c?: InputMaybe<order_by>;
  Date_Entered_Backlog__c?: InputMaybe<order_by>;
  Date_Left_Backlog__c?: InputMaybe<order_by>;
  Date_Payment_Processed__c?: InputMaybe<order_by>;
  Date_Payment_Received__c?: InputMaybe<order_by>;
  Date_Time__c?: InputMaybe<order_by>;
  DealHub_Create_Subscription__c?: InputMaybe<order_by>;
  Deal_Health__c?: InputMaybe<order_by>;
  Deal_Room_URL__c?: InputMaybe<order_by>;
  Dealhub_Quote_Status__c?: InputMaybe<order_by>;
  Dealhub_URL__c?: InputMaybe<order_by>;
  Decision_Criteria__c?: InputMaybe<order_by>;
  Decision_Process__c?: InputMaybe<order_by>;
  Demo_Held__c?: InputMaybe<order_by>;
  Description?: InputMaybe<order_by>;
  Description__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Discount_Approval_Status__c?: InputMaybe<order_by>;
  Discovery_Held__c?: InputMaybe<order_by>;
  Dont_update_reg__c?: InputMaybe<order_by>;
  Economic_Buyer__c?: InputMaybe<order_by>;
  Effective_Date__c?: InputMaybe<order_by>;
  Email_Sent__c?: InputMaybe<order_by>;
  Email__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  End_Date__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  Feature__c?: InputMaybe<order_by>;
  Financial_Notes__c?: InputMaybe<order_by>;
  Firm_Committed__c?: InputMaybe<order_by>;
  First_Quote_Synced_Date__c?: InputMaybe<order_by>;
  Fiscal?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  ForceCreateHarriProjects__c?: InputMaybe<order_by>;
  ForecastCategory?: InputMaybe<order_by>;
  ForecastCategoryName?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franchise_Sign_Up__c?: InputMaybe<order_by>;
  Franchisee_Sign_Up__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  GI_Opportunity_Region__c?: InputMaybe<order_by>;
  Gong__CurrentGenerators__c?: InputMaybe<order_by>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  Gong__MainCompetitors__c?: InputMaybe<order_by>;
  Gong__OrderNumber__c?: InputMaybe<order_by>;
  Gong__TrackingNumber__c?: InputMaybe<order_by>;
  Harri_API_Enabled__c?: InputMaybe<order_by>;
  Harri_Profile_Created__c?: InputMaybe<order_by>;
  Harri_Project__c?: InputMaybe<order_by>;
  HasOpenActivity?: InputMaybe<order_by>;
  HasOpportunityLineItem?: InputMaybe<order_by>;
  HasOverdueTask?: InputMaybe<order_by>;
  Hiring_Urgency__c?: InputMaybe<order_by>;
  ID_18_digit__c?: InputMaybe<order_by>;
  Id?: InputMaybe<order_by>;
  Identified_Pain__c?: InputMaybe<order_by>;
  Implementation_Notes__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  IsClosed?: InputMaybe<order_by>;
  IsDeleted?: InputMaybe<order_by>;
  IsExcludedFromTerritory2Filter?: InputMaybe<order_by>;
  IsSplit?: InputMaybe<order_by>;
  IsSyncNeeded__c?: InputMaybe<order_by>;
  IsWon?: InputMaybe<order_by>;
  Is_Commit__c?: InputMaybe<order_by>;
  Job_Templates__c?: InputMaybe<order_by>;
  LID__CurrentGenerators__c?: InputMaybe<order_by>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<order_by>;
  LID__Is_Influenced__c?: InputMaybe<order_by>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<order_by>;
  LID__MainCompetitors__c?: InputMaybe<order_by>;
  LID__My_DateTime__c?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__c?: InputMaybe<order_by>;
  LID__OrderNumber__c?: InputMaybe<order_by>;
  LID__TrackingNumber__c?: InputMaybe<order_by>;
  LastActivityDate?: InputMaybe<order_by>;
  LastAmountChangedHistoryId?: InputMaybe<order_by>;
  LastCloseDateChangedHistoryId?: InputMaybe<order_by>;
  LastModifiedById?: InputMaybe<order_by>;
  LastModifiedDate?: InputMaybe<order_by>;
  LastReferencedDate?: InputMaybe<order_by>;
  LastStageChangeDate?: InputMaybe<order_by>;
  LastViewedDate?: InputMaybe<order_by>;
  Last_Quote_Synced_Date__c?: InputMaybe<order_by>;
  LeadSource?: InputMaybe<order_by>;
  Lead_Source_Detail__c?: InputMaybe<order_by>;
  Leadership_Focus__c?: InputMaybe<order_by>;
  Less_than_current_month__c?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  Lost_Reason__c?: InputMaybe<order_by>;
  MKTG_Harri_Partnership__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  MSA_Signed_Off_On__c?: InputMaybe<order_by>;
  MSA_What_s_Needed__c?: InputMaybe<order_by>;
  MSA__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  Metrics__c?: InputMaybe<order_by>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<order_by>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<order_by>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<order_by>;
  Most_Recent_Lead_Source__c?: InputMaybe<order_by>;
  Name?: InputMaybe<order_by>;
  NextStep?: InputMaybe<order_by>;
  Next_Step_Date__c?: InputMaybe<order_by>;
  Next_Steps__c?: InputMaybe<order_by>;
  No_Decision__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  OTF_Effective_Date__c?: InputMaybe<order_by>;
  OTF_With_Currency__c?: InputMaybe<order_by>;
  One_Call_Close__c?: InputMaybe<order_by>;
  Operating_Structure__c?: InputMaybe<order_by>;
  Opportunity_Currency__c?: InputMaybe<order_by>;
  Opportunity_Franchise_Name__c?: InputMaybe<order_by>;
  Opportunity_From_Lead__c?: InputMaybe<order_by>;
  Opportunity_Name_Formatted__c?: InputMaybe<order_by>;
  Opportunity_Owner_Prediction__c?: InputMaybe<order_by>;
  Opportunity_Region__c?: InputMaybe<order_by>;
  Orientation_Conducted_By__c?: InputMaybe<order_by>;
  Orientation_Contact__c?: InputMaybe<order_by>;
  Orientation_Date__c?: InputMaybe<order_by>;
  Orientation_Missed__c?: InputMaybe<order_by>;
  Orientation_Notes__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<order_by>;
  Outreach_First_Primary_Contact__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  OwnerId?: InputMaybe<order_by>;
  Owner_Role__c?: InputMaybe<order_by>;
  PAPER_PROCESS__c?: InputMaybe<order_by>;
  PB_Locked__c?: InputMaybe<order_by>;
  Papa_Johns_Camp__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  PatchDealhub__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Payment_Method__c?: InputMaybe<order_by>;
  Payment_Schedule__c?: InputMaybe<order_by>;
  Payroll_Integration__c?: InputMaybe<order_by>;
  Potential_Hurdles__c?: InputMaybe<order_by>;
  PreSale__c?: InputMaybe<order_by>;
  Pricebook2Id?: InputMaybe<order_by>;
  Pricebook_Name__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Customizations__c?: InputMaybe<order_by>;
  Product_Development_needed__c?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Product_Sold__c?: InputMaybe<order_by>;
  Product_Team_Reviewing_Status__c?: InputMaybe<order_by>;
  Product_analyst_review__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Products_not_equal__c?: InputMaybe<order_by>;
  Project_Notes__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_Customer_Address__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  Proposal_Status__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Reason_stalled__c?: InputMaybe<order_by>;
  RecordTypeId?: InputMaybe<order_by>;
  Referred_By_Who__c?: InputMaybe<order_by>;
  Rejected_Reason__c?: InputMaybe<order_by>;
  Rejected__c?: InputMaybe<order_by>;
  Renewal_Date__c?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  RevOps_Notes__c?: InputMaybe<order_by>;
  SDR_Owner__c?: InputMaybe<order_by>;
  SOW_What_s_Needed__c?: InputMaybe<order_by>;
  ST_cleaned__c?: InputMaybe<order_by>;
  Sales_Channel__c?: InputMaybe<order_by>;
  Segment__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  SoW_Form_Id__c?: InputMaybe<order_by>;
  SoW_Signed_Off_on__c?: InputMaybe<order_by>;
  SoW__c?: InputMaybe<order_by>;
  Solution_Consultant_Owner__c?: InputMaybe<order_by>;
  Source__c?: InputMaybe<order_by>;
  Special_Terms__c?: InputMaybe<order_by>;
  Special_Terms_approved__c?: InputMaybe<order_by>;
  StageName?: InputMaybe<order_by>;
  Stalled_COVID19__c?: InputMaybe<order_by>;
  Standard_Documents__c?: InputMaybe<order_by>;
  State__c?: InputMaybe<order_by>;
  Status__c?: InputMaybe<order_by>;
  Subscription_End_Date__c?: InputMaybe<order_by>;
  Subscription_Start_Date__c?: InputMaybe<order_by>;
  Subway_Onboarding__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  SyncedQuoteId?: InputMaybe<order_by>;
  SystemModstamp?: InputMaybe<order_by>;
  Term_Length_Months__c?: InputMaybe<order_by>;
  Territory2Id?: InputMaybe<order_by>;
  Test__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_CMRR_Formatted__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Formatted__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  Trial__c?: InputMaybe<order_by>;
  Type?: InputMaybe<order_by>;
  Type_?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  URL__c?: InputMaybe<order_by>;
  Updated__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  VisibleCompetitorType__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<order_by>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<order_by>;
  Who_s_working_on_Sow__c?: InputMaybe<order_by>;
  Whos_Working_on_MSA__c?: InputMaybe<order_by>;
  Why_Buy_Harri__c?: InputMaybe<order_by>;
  Why_Buy_Now__c?: InputMaybe<order_by>;
  Why_buy__c?: InputMaybe<order_by>;
  Why_no_commit__c?: InputMaybe<order_by>;
  Won_against__c?: InputMaybe<order_by>;
  Wrong_Contract_Term__c?: InputMaybe<order_by>;
  X00_Archived_Date__c?: InputMaybe<order_by>;
  X00_Close_Lost_Date__c?: InputMaybe<order_by>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<order_by>;
  X00_New_Date__c?: InputMaybe<order_by>;
  X00_SQL_List__c?: InputMaybe<order_by>;
  X00_Unqualified_Date__c?: InputMaybe<order_by>;
  X01_Discovery__c?: InputMaybe<order_by>;
  X01_Identified_Date__c?: InputMaybe<order_by>;
  X02_Analysis__c?: InputMaybe<order_by>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<order_by>;
  X03_Evaluating_Date__c?: InputMaybe<order_by>;
  X03_Presentation__c?: InputMaybe<order_by>;
  X04_Competing_Date__c?: InputMaybe<order_by>;
  X04_Proposal__c?: InputMaybe<order_by>;
  X05_Negotiating_Date__c?: InputMaybe<order_by>;
  X06_Signature_Pending_Date__c?: InputMaybe<order_by>;
  X07_Close_Won_Date__c?: InputMaybe<order_by>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<order_by>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<order_by>;
  intuit_apps__invoiceId__c?: InputMaybe<order_by>;
  intuit_apps__invoiceNumber__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  posted_time__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  push_date__c?: InputMaybe<order_by>;
  scheduled_demo_date__c?: InputMaybe<order_by>;
  scheduled_discovery_call_date__c?: InputMaybe<order_by>;
  source_url__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
  what_product_development_is_needed__c?: InputMaybe<order_by>;
};

/** primary key columns input for table: Opportunity */
export type Opportunity_pk_columns_input = {
  Id: Scalars["String"];
};

/** select columns of table "Opportunity" */
export enum Opportunity_select_column {
  /** column name */
  AE_Notes__c = "AE_Notes__c",
  /** column name */
  AccountId = "AccountId",
  /** column name */
  Account_Contact_Name__c = "Account_Contact_Name__c",
  /** column name */
  Account_Contact_Phone__c = "Account_Contact_Phone__c",
  /** column name */
  Account_Contact__c = "Account_Contact__c",
  /** column name */
  Acquisition_Program__c = "Acquisition_Program__c",
  /** column name */
  Active_Employees__c = "Active_Employees__c",
  /** column name */
  Address__c = "Address__c",
  /** column name */
  Agreement_ID__c = "Agreement_ID__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Anticipated_Go_Live__c = "Anticipated_Go_Live__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Auto_Renew__c = "Auto_Renew__c",
  /** column name */
  BIZSYS_Applicant_Tracking_System__c = "BIZSYS_Applicant_Tracking_System__c",
  /** column name */
  BIZSYS_Applicant_Tracking_Systems__c = "BIZSYS_Applicant_Tracking_Systems__c",
  /** column name */
  BIZSYS_Business_Intelligence__c = "BIZSYS_Business_Intelligence__c",
  /** column name */
  BIZSYS_Employee_Management__c = "BIZSYS_Employee_Management__c",
  /** column name */
  BIZSYS_Enterprise_Solutions__c = "BIZSYS_Enterprise_Solutions__c",
  /** column name */
  BIZSYS_Interviewer_System__c = "BIZSYS_Interviewer_System__c",
  /** column name */
  BIZSYS_Inventory_Invoicing__c = "BIZSYS_Inventory_Invoicing__c",
  /** column name */
  BIZSYS_Job_Board_Listing__c = "BIZSYS_Job_Board_Listing__c",
  /** column name */
  BIZSYS_Learning_Management_System__c = "BIZSYS_Learning_Management_System__c",
  /** column name */
  BIZSYS_Onboarding__c = "BIZSYS_Onboarding__c",
  /** column name */
  BIZSYS_Payroll_System__c = "BIZSYS_Payroll_System__c",
  /** column name */
  BIZSYS_Point_of_Sale_System__c = "BIZSYS_Point_of_Sale_System__c",
  /** column name */
  BIZSYS_Recruitment_Marketing__c = "BIZSYS_Recruitment_Marketing__c",
  /** column name */
  BIZSYS_Scheduler_System__c = "BIZSYS_Scheduler_System__c",
  /** column name */
  BIZSYS_Texting__c = "BIZSYS_Texting__c",
  /** column name */
  BIZSYS_Time_Attendance_System__c = "BIZSYS_Time_Attendance_System__c",
  /** column name */
  BackLog_Opportunity__c = "BackLog_Opportunity__c",
  /** column name */
  Barakat_2__c = "Barakat_2__c",
  /** column name */
  Best_Case_Stalled__c = "Best_Case_Stalled__c",
  /** column name */
  Billing_Terms__c = "Billing_Terms__c",
  /** column name */
  Booked_By__c = "Booked_By__c",
  /** column name */
  CMRR_With_Currency__c = "CMRR_With_Currency__c",
  /** column name */
  CMRR__c = "CMRR__c",
  /** column name */
  CampaignId = "CampaignId",
  /** column name */
  Can_edit_the_close_date__c = "Can_edit_the_close_date__c",
  /** column name */
  Champion__c = "Champion__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Churned_Date__c = "Churned_Date__c",
  /** column name */
  Churned_Opportunity__c = "Churned_Opportunity__c",
  /** column name */
  City__c = "City__c",
  /** column name */
  Classification__c = "Classification__c",
  /** column name */
  CloseDate = "CloseDate",
  /** column name */
  Coach__c = "Coach__c",
  /** column name */
  Coming_from_Dealhub__c = "Coming_from_Dealhub__c",
  /** column name */
  Commit_Stalled__c = "Commit_Stalled__c",
  /** column name */
  Company__c = "Company__c",
  /** column name */
  Competition__c = "Competition__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF_Formatted__c = "Compliance_OTF_Formatted__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  ContactID__c = "ContactID__c",
  /** column name */
  ContactId = "ContactId",
  /** column name */
  Contact_Email__c = "Contact_Email__c",
  /** column name */
  Contact_ID_Related_Oppt__c = "Contact_ID_Related_Oppt__c",
  /** column name */
  Contact_Name__c = "Contact_Name__c",
  /** column name */
  Contact_Phone__c = "Contact_Phone__c",
  /** column name */
  Contact_Title__c = "Contact_Title__c",
  /** column name */
  Contact__c = "Contact__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Contract_Term__c = "Contract_Term__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Created_By_Role_Name__c = "Created_By_Role_Name__c",
  /** column name */
  Created_Unit_Level_User_Logins__c = "Created_Unit_Level_User_Logins__c",
  /** column name */
  Custom_Close_Date__c = "Custom_Close_Date__c",
  /** column name */
  Custom_Documents__c = "Custom_Documents__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Description__c = "Data_Quality_Description__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Date_Demo_Held__c = "Date_Demo_Held__c",
  /** column name */
  Date_Discovery_Held__c = "Date_Discovery_Held__c",
  /** column name */
  Date_Entered_Backlog__c = "Date_Entered_Backlog__c",
  /** column name */
  Date_Left_Backlog__c = "Date_Left_Backlog__c",
  /** column name */
  Date_Payment_Processed__c = "Date_Payment_Processed__c",
  /** column name */
  Date_Payment_Received__c = "Date_Payment_Received__c",
  /** column name */
  Date_Time__c = "Date_Time__c",
  /** column name */
  DealHub_Create_Subscription__c = "DealHub_Create_Subscription__c",
  /** column name */
  Deal_Health__c = "Deal_Health__c",
  /** column name */
  Deal_Room_URL__c = "Deal_Room_URL__c",
  /** column name */
  Dealhub_Quote_Status__c = "Dealhub_Quote_Status__c",
  /** column name */
  Dealhub_URL__c = "Dealhub_URL__c",
  /** column name */
  Decision_Criteria__c = "Decision_Criteria__c",
  /** column name */
  Decision_Process__c = "Decision_Process__c",
  /** column name */
  Demo_Held__c = "Demo_Held__c",
  /** column name */
  Description = "Description",
  /** column name */
  Description__c = "Description__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Discount_Approval_Status__c = "Discount_Approval_Status__c",
  /** column name */
  Discovery_Held__c = "Discovery_Held__c",
  /** column name */
  Dont_update_reg__c = "Dont_update_reg__c",
  /** column name */
  Economic_Buyer__c = "Economic_Buyer__c",
  /** column name */
  Effective_Date__c = "Effective_Date__c",
  /** column name */
  Email_Sent__c = "Email_Sent__c",
  /** column name */
  Email__c = "Email__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  End_Date__c = "End_Date__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Feature__c = "Feature__c",
  /** column name */
  Financial_Notes__c = "Financial_Notes__c",
  /** column name */
  Firm_Committed__c = "Firm_Committed__c",
  /** column name */
  First_Quote_Synced_Date__c = "First_Quote_Synced_Date__c",
  /** column name */
  Fiscal = "Fiscal",
  /** column name */
  FiscalQuarter = "FiscalQuarter",
  /** column name */
  FiscalYear = "FiscalYear",
  /** column name */
  ForceCreateHarriProjects__c = "ForceCreateHarriProjects__c",
  /** column name */
  ForecastCategory = "ForecastCategory",
  /** column name */
  ForecastCategoryName = "ForecastCategoryName",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franchise_Sign_Up__c = "Franchise_Sign_Up__c",
  /** column name */
  Franchisee_Sign_Up__c = "Franchisee_Sign_Up__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  GI_Opportunity_Region__c = "GI_Opportunity_Region__c",
  /** column name */
  Gong__CurrentGenerators__c = "Gong__CurrentGenerators__c",
  /** column name */
  Gong__DeliveryInstallationStatus__c = "Gong__DeliveryInstallationStatus__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  Gong__MainCompetitors__c = "Gong__MainCompetitors__c",
  /** column name */
  Gong__OrderNumber__c = "Gong__OrderNumber__c",
  /** column name */
  Gong__TrackingNumber__c = "Gong__TrackingNumber__c",
  /** column name */
  Harri_API_Enabled__c = "Harri_API_Enabled__c",
  /** column name */
  Harri_Profile_Created__c = "Harri_Profile_Created__c",
  /** column name */
  Harri_Project__c = "Harri_Project__c",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  Hiring_Urgency__c = "Hiring_Urgency__c",
  /** column name */
  ID_18_digit__c = "ID_18_digit__c",
  /** column name */
  Id = "Id",
  /** column name */
  Identified_Pain__c = "Identified_Pain__c",
  /** column name */
  Implementation_Notes__c = "Implementation_Notes__c",
  /** column name */
  IqScore = "IqScore",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsExcludedFromTerritory2Filter = "IsExcludedFromTerritory2Filter",
  /** column name */
  IsSplit = "IsSplit",
  /** column name */
  IsSyncNeeded__c = "IsSyncNeeded__c",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  Is_Commit__c = "Is_Commit__c",
  /** column name */
  Job_Templates__c = "Job_Templates__c",
  /** column name */
  LID__CurrentGenerators__c = "LID__CurrentGenerators__c",
  /** column name */
  LID__DeliveryInstallationStatus__c = "LID__DeliveryInstallationStatus__c",
  /** column name */
  LID__Is_Influenced__c = "LID__Is_Influenced__c",
  /** column name */
  LID__LinkedIn_Company_Id__c = "LID__LinkedIn_Company_Id__c",
  /** column name */
  LID__MainCompetitors__c = "LID__MainCompetitors__c",
  /** column name */
  LID__My_DateTime__c = "LID__My_DateTime__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  LID__My_Geolocation__c = "LID__My_Geolocation__c",
  /** column name */
  LID__OrderNumber__c = "LID__OrderNumber__c",
  /** column name */
  LID__TrackingNumber__c = "LID__TrackingNumber__c",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastAmountChangedHistoryId = "LastAmountChangedHistoryId",
  /** column name */
  LastCloseDateChangedHistoryId = "LastCloseDateChangedHistoryId",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastStageChangeDate = "LastStageChangeDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  Last_Quote_Synced_Date__c = "Last_Quote_Synced_Date__c",
  /** column name */
  LeadSource = "LeadSource",
  /** column name */
  Lead_Source_Detail__c = "Lead_Source_Detail__c",
  /** column name */
  Leadership_Focus__c = "Leadership_Focus__c",
  /** column name */
  Less_than_current_month__c = "Less_than_current_month__c",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  Lost_Reason__c = "Lost_Reason__c",
  /** column name */
  MKTG_Harri_Partnership__c = "MKTG_Harri_Partnership__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  MSA_Signed_Off_On__c = "MSA_Signed_Off_On__c",
  /** column name */
  MSA_What_s_Needed__c = "MSA_What_s_Needed__c",
  /** column name */
  MSA__c = "MSA__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  Metrics__c = "Metrics__c",
  /** column name */
  Missed_Orientation_Follow_Up__c = "Missed_Orientation_Follow_Up__c",
  /** column name */
  Most_Recent_Acquisition_Program__c = "Most_Recent_Acquisition_Program__c",
  /** column name */
  Most_Recent_Lead_Source_Detail__c = "Most_Recent_Lead_Source_Detail__c",
  /** column name */
  Most_Recent_Lead_Source__c = "Most_Recent_Lead_Source__c",
  /** column name */
  Name = "Name",
  /** column name */
  NextStep = "NextStep",
  /** column name */
  Next_Step_Date__c = "Next_Step_Date__c",
  /** column name */
  Next_Steps__c = "Next_Steps__c",
  /** column name */
  No_Decision__c = "No_Decision__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  OTF_Effective_Date__c = "OTF_Effective_Date__c",
  /** column name */
  OTF_With_Currency__c = "OTF_With_Currency__c",
  /** column name */
  One_Call_Close__c = "One_Call_Close__c",
  /** column name */
  Operating_Structure__c = "Operating_Structure__c",
  /** column name */
  Opportunity_Currency__c = "Opportunity_Currency__c",
  /** column name */
  Opportunity_Franchise_Name__c = "Opportunity_Franchise_Name__c",
  /** column name */
  Opportunity_From_Lead__c = "Opportunity_From_Lead__c",
  /** column name */
  Opportunity_Name_Formatted__c = "Opportunity_Name_Formatted__c",
  /** column name */
  Opportunity_Owner_Prediction__c = "Opportunity_Owner_Prediction__c",
  /** column name */
  Opportunity_Region__c = "Opportunity_Region__c",
  /** column name */
  Orientation_Conducted_By__c = "Orientation_Conducted_By__c",
  /** column name */
  Orientation_Contact__c = "Orientation_Contact__c",
  /** column name */
  Orientation_Date__c = "Orientation_Date__c",
  /** column name */
  Orientation_Missed__c = "Orientation_Missed__c",
  /** column name */
  Orientation_Notes__c = "Orientation_Notes__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Outreach_First_Primary_Contact_Sequence__c = "Outreach_First_Primary_Contact_Sequence__c",
  /** column name */
  Outreach_First_Primary_Contact__c = "Outreach_First_Primary_Contact__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  Owner_Role__c = "Owner_Role__c",
  /** column name */
  PAPER_PROCESS__c = "PAPER_PROCESS__c",
  /** column name */
  PB_Locked__c = "PB_Locked__c",
  /** column name */
  Papa_Johns_Camp__c = "Papa_Johns_Camp__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  PatchDealhub__c = "PatchDealhub__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Payment_Method__c = "Payment_Method__c",
  /** column name */
  Payment_Schedule__c = "Payment_Schedule__c",
  /** column name */
  Payroll_Integration__c = "Payroll_Integration__c",
  /** column name */
  Potential_Hurdles__c = "Potential_Hurdles__c",
  /** column name */
  PreSale__c = "PreSale__c",
  /** column name */
  Pricebook2Id = "Pricebook2Id",
  /** column name */
  Pricebook_Name__c = "Pricebook_Name__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Customizations__c = "Product_Customizations__c",
  /** column name */
  Product_Development_needed__c = "Product_Development_needed__c",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Product_Sold__c = "Product_Sold__c",
  /** column name */
  Product_Team_Reviewing_Status__c = "Product_Team_Reviewing_Status__c",
  /** column name */
  Product_analyst_review__c = "Product_analyst_review__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Products_not_equal__c = "Products_not_equal__c",
  /** column name */
  Project_Notes__c = "Project_Notes__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_Customer_Address__c = "Proposal_Customer_Address__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Proposal_Status__c = "Proposal_Status__c",
  /** column name */
  PushCount = "PushCount",
  /** column name */
  Reason_stalled__c = "Reason_stalled__c",
  /** column name */
  RecordTypeId = "RecordTypeId",
  /** column name */
  Referred_By_Who__c = "Referred_By_Who__c",
  /** column name */
  Rejected_Reason__c = "Rejected_Reason__c",
  /** column name */
  Rejected__c = "Rejected__c",
  /** column name */
  Renewal_Date__c = "Renewal_Date__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  RevOps_Notes__c = "RevOps_Notes__c",
  /** column name */
  SDR_Owner__c = "SDR_Owner__c",
  /** column name */
  SOW_What_s_Needed__c = "SOW_What_s_Needed__c",
  /** column name */
  ST_cleaned__c = "ST_cleaned__c",
  /** column name */
  Sales_Channel__c = "Sales_Channel__c",
  /** column name */
  Segment__c = "Segment__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  SoW_Form_Id__c = "SoW_Form_Id__c",
  /** column name */
  SoW_Signed_Off_on__c = "SoW_Signed_Off_on__c",
  /** column name */
  SoW__c = "SoW__c",
  /** column name */
  Solution_Consultant_Owner__c = "Solution_Consultant_Owner__c",
  /** column name */
  Source__c = "Source__c",
  /** column name */
  Special_Terms__c = "Special_Terms__c",
  /** column name */
  Special_Terms_approved__c = "Special_Terms_approved__c",
  /** column name */
  StageName = "StageName",
  /** column name */
  Stalled_COVID19__c = "Stalled_COVID19__c",
  /** column name */
  Standard_Documents__c = "Standard_Documents__c",
  /** column name */
  State__c = "State__c",
  /** column name */
  Status__c = "Status__c",
  /** column name */
  Subscription_End_Date__c = "Subscription_End_Date__c",
  /** column name */
  Subscription_Start_Date__c = "Subscription_Start_Date__c",
  /** column name */
  Subway_Onboarding__c = "Subway_Onboarding__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  SyncedQuoteId = "SyncedQuoteId",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Term_Length_Months__c = "Term_Length_Months__c",
  /** column name */
  Territory2Id = "Territory2Id",
  /** column name */
  Test__c = "Test__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_CMRR_Formatted__c = "Total_CMRR_Formatted__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF_Formatted__c = "Total_OTF_Formatted__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  Trial__c = "Trial__c",
  /** column name */
  Type = "Type",
  /** column name */
  Type_ = "Type_",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  URL__c = "URL__c",
  /** column name */
  Updated__c = "Updated__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  VisibleCompetitorType__c = "VisibleCompetitorType__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  Who_Signed_Off_on_MSA__c = "Who_Signed_Off_on_MSA__c",
  /** column name */
  Who_Signed_Off_on_SOW__c = "Who_Signed_Off_on_SOW__c",
  /** column name */
  Who_s_working_on_Sow__c = "Who_s_working_on_Sow__c",
  /** column name */
  Whos_Working_on_MSA__c = "Whos_Working_on_MSA__c",
  /** column name */
  Why_Buy_Harri__c = "Why_Buy_Harri__c",
  /** column name */
  Why_Buy_Now__c = "Why_Buy_Now__c",
  /** column name */
  Why_buy__c = "Why_buy__c",
  /** column name */
  Why_no_commit__c = "Why_no_commit__c",
  /** column name */
  Won_against__c = "Won_against__c",
  /** column name */
  Wrong_Contract_Term__c = "Wrong_Contract_Term__c",
  /** column name */
  X00_Archived_Date__c = "X00_Archived_Date__c",
  /** column name */
  X00_Close_Lost_Date__c = "X00_Close_Lost_Date__c",
  /** column name */
  X00_Meeting_Did_Not_Hold_Date__c = "X00_Meeting_Did_Not_Hold_Date__c",
  /** column name */
  X00_New_Date__c = "X00_New_Date__c",
  /** column name */
  X00_SQL_List__c = "X00_SQL_List__c",
  /** column name */
  X00_Unqualified_Date__c = "X00_Unqualified_Date__c",
  /** column name */
  X01_Discovery__c = "X01_Discovery__c",
  /** column name */
  X01_Identified_Date__c = "X01_Identified_Date__c",
  /** column name */
  X02_Analysis__c = "X02_Analysis__c",
  /** column name */
  X02_Proof_of_Concept_Date__c = "X02_Proof_of_Concept_Date__c",
  /** column name */
  X03_Evaluating_Date__c = "X03_Evaluating_Date__c",
  /** column name */
  X03_Presentation__c = "X03_Presentation__c",
  /** column name */
  X04_Competing_Date__c = "X04_Competing_Date__c",
  /** column name */
  X04_Proposal__c = "X04_Proposal__c",
  /** column name */
  X05_Negotiating_Date__c = "X05_Negotiating_Date__c",
  /** column name */
  X06_Signature_Pending_Date__c = "X06_Signature_Pending_Date__c",
  /** column name */
  X07_Close_Won_Date__c = "X07_Close_Won_Date__c",
  /** column name */
  intuit_apps__intuitInvoiceStatus__c = "intuit_apps__intuitInvoiceStatus__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  intuit_apps__invoiceCreatedDate__c = "intuit_apps__invoiceCreatedDate__c",
  /** column name */
  intuit_apps__invoiceDueDate__c = "intuit_apps__invoiceDueDate__c",
  /** column name */
  intuit_apps__invoiceId__c = "intuit_apps__invoiceId__c",
  /** column name */
  intuit_apps__invoiceNumber__c = "intuit_apps__invoiceNumber__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  posted_time__c = "posted_time__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  push_date__c = "push_date__c",
  /** column name */
  scheduled_demo_date__c = "scheduled_demo_date__c",
  /** column name */
  scheduled_discovery_call_date__c = "scheduled_discovery_call_date__c",
  /** column name */
  source_url__c = "source_url__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
  /** column name */
  what_product_development_is_needed__c = "what_product_development_is_needed__c",
}

/** select "Opportunity_aggregate_bool_exp_avg_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  Auto_Renew__c = "Auto_Renew__c",
  /** column name */
  BackLog_Opportunity__c = "BackLog_Opportunity__c",
  /** column name */
  Barakat_2__c = "Barakat_2__c",
  /** column name */
  Best_Case_Stalled__c = "Best_Case_Stalled__c",
  /** column name */
  Can_edit_the_close_date__c = "Can_edit_the_close_date__c",
  /** column name */
  Churned_Opportunity__c = "Churned_Opportunity__c",
  /** column name */
  Coming_from_Dealhub__c = "Coming_from_Dealhub__c",
  /** column name */
  Commit_Stalled__c = "Commit_Stalled__c",
  /** column name */
  Created_Unit_Level_User_Logins__c = "Created_Unit_Level_User_Logins__c",
  /** column name */
  DealHub_Create_Subscription__c = "DealHub_Create_Subscription__c",
  /** column name */
  Demo_Held__c = "Demo_Held__c",
  /** column name */
  Discovery_Held__c = "Discovery_Held__c",
  /** column name */
  Dont_update_reg__c = "Dont_update_reg__c",
  /** column name */
  Firm_Committed__c = "Firm_Committed__c",
  /** column name */
  ForceCreateHarriProjects__c = "ForceCreateHarriProjects__c",
  /** column name */
  Franchise_Sign_Up__c = "Franchise_Sign_Up__c",
  /** column name */
  Harri_API_Enabled__c = "Harri_API_Enabled__c",
  /** column name */
  Harri_Profile_Created__c = "Harri_Profile_Created__c",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsExcludedFromTerritory2Filter = "IsExcludedFromTerritory2Filter",
  /** column name */
  IsSplit = "IsSplit",
  /** column name */
  IsSyncNeeded__c = "IsSyncNeeded__c",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  Is_Commit__c = "Is_Commit__c",
  /** column name */
  LID__Is_Influenced__c = "LID__Is_Influenced__c",
  /** column name */
  Leadership_Focus__c = "Leadership_Focus__c",
  /** column name */
  Less_than_current_month__c = "Less_than_current_month__c",
  /** column name */
  One_Call_Close__c = "One_Call_Close__c",
  /** column name */
  Opportunity_From_Lead__c = "Opportunity_From_Lead__c",
  /** column name */
  Orientation_Missed__c = "Orientation_Missed__c",
  /** column name */
  PB_Locked__c = "PB_Locked__c",
  /** column name */
  Papa_Johns_Camp__c = "Papa_Johns_Camp__c",
  /** column name */
  PatchDealhub__c = "PatchDealhub__c",
  /** column name */
  Product_Development_needed__c = "Product_Development_needed__c",
  /** column name */
  Products_not_equal__c = "Products_not_equal__c",
  /** column name */
  Rejected__c = "Rejected__c",
  /** column name */
  Special_Terms_approved__c = "Special_Terms_approved__c",
  /** column name */
  Stalled_COVID19__c = "Stalled_COVID19__c",
  /** column name */
  Wrong_Contract_Term__c = "Wrong_Contract_Term__c",
}

/** select "Opportunity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  Auto_Renew__c = "Auto_Renew__c",
  /** column name */
  BackLog_Opportunity__c = "BackLog_Opportunity__c",
  /** column name */
  Barakat_2__c = "Barakat_2__c",
  /** column name */
  Best_Case_Stalled__c = "Best_Case_Stalled__c",
  /** column name */
  Can_edit_the_close_date__c = "Can_edit_the_close_date__c",
  /** column name */
  Churned_Opportunity__c = "Churned_Opportunity__c",
  /** column name */
  Coming_from_Dealhub__c = "Coming_from_Dealhub__c",
  /** column name */
  Commit_Stalled__c = "Commit_Stalled__c",
  /** column name */
  Created_Unit_Level_User_Logins__c = "Created_Unit_Level_User_Logins__c",
  /** column name */
  DealHub_Create_Subscription__c = "DealHub_Create_Subscription__c",
  /** column name */
  Demo_Held__c = "Demo_Held__c",
  /** column name */
  Discovery_Held__c = "Discovery_Held__c",
  /** column name */
  Dont_update_reg__c = "Dont_update_reg__c",
  /** column name */
  Firm_Committed__c = "Firm_Committed__c",
  /** column name */
  ForceCreateHarriProjects__c = "ForceCreateHarriProjects__c",
  /** column name */
  Franchise_Sign_Up__c = "Franchise_Sign_Up__c",
  /** column name */
  Harri_API_Enabled__c = "Harri_API_Enabled__c",
  /** column name */
  Harri_Profile_Created__c = "Harri_Profile_Created__c",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsExcludedFromTerritory2Filter = "IsExcludedFromTerritory2Filter",
  /** column name */
  IsSplit = "IsSplit",
  /** column name */
  IsSyncNeeded__c = "IsSyncNeeded__c",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  Is_Commit__c = "Is_Commit__c",
  /** column name */
  LID__Is_Influenced__c = "LID__Is_Influenced__c",
  /** column name */
  Leadership_Focus__c = "Leadership_Focus__c",
  /** column name */
  Less_than_current_month__c = "Less_than_current_month__c",
  /** column name */
  One_Call_Close__c = "One_Call_Close__c",
  /** column name */
  Opportunity_From_Lead__c = "Opportunity_From_Lead__c",
  /** column name */
  Orientation_Missed__c = "Orientation_Missed__c",
  /** column name */
  PB_Locked__c = "PB_Locked__c",
  /** column name */
  Papa_Johns_Camp__c = "Papa_Johns_Camp__c",
  /** column name */
  PatchDealhub__c = "PatchDealhub__c",
  /** column name */
  Product_Development_needed__c = "Product_Development_needed__c",
  /** column name */
  Products_not_equal__c = "Products_not_equal__c",
  /** column name */
  Rejected__c = "Rejected__c",
  /** column name */
  Special_Terms_approved__c = "Special_Terms_approved__c",
  /** column name */
  Stalled_COVID19__c = "Stalled_COVID19__c",
  /** column name */
  Wrong_Contract_Term__c = "Wrong_Contract_Term__c",
}

/** select "Opportunity_aggregate_bool_exp_corr_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_max_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_min_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_sum_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** select "Opportunity_aggregate_bool_exp_var_samp_arguments_columns" columns of table "Opportunity" */
export enum Opportunity_select_column_Opportunity_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
}

/** input type for updating data in table "Opportunity" */
export type Opportunity_set_input = {
  AE_Notes__c?: InputMaybe<Scalars["String"]>;
  AccountId?: InputMaybe<Scalars["String"]>;
  Account_Contact_Name__c?: InputMaybe<Scalars["String"]>;
  Account_Contact_Phone__c?: InputMaybe<Scalars["String"]>;
  Account_Contact__c?: InputMaybe<Scalars["String"]>;
  Acquisition_Program__c?: InputMaybe<Scalars["String"]>;
  Active_Employees__c?: InputMaybe<Scalars["String"]>;
  Address__c?: InputMaybe<Scalars["String"]>;
  Agreement_ID__c?: InputMaybe<Scalars["String"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  Amount_?: InputMaybe<Scalars["float8"]>;
  Annual_Contract_Value__c?: InputMaybe<Scalars["float8"]>;
  Anticipated_Go_Live__c?: InputMaybe<Scalars["date"]>;
  Attachments_Count__c?: InputMaybe<Scalars["float8"]>;
  Auto_Renew__c?: InputMaybe<Scalars["Boolean"]>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Employee_Management__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Interviewer_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Onboarding__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Payroll_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Scheduler_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Texting__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<Scalars["String"]>;
  BackLog_Opportunity__c?: InputMaybe<Scalars["Boolean"]>;
  Barakat_2__c?: InputMaybe<Scalars["Boolean"]>;
  Best_Case_Stalled__c?: InputMaybe<Scalars["Boolean"]>;
  Billing_Terms__c?: InputMaybe<Scalars["String"]>;
  Booked_By__c?: InputMaybe<Scalars["String"]>;
  CMRR_With_Currency__c?: InputMaybe<Scalars["String"]>;
  CMRR__c?: InputMaybe<Scalars["String"]>;
  CampaignId?: InputMaybe<Scalars["String"]>;
  Can_edit_the_close_date__c?: InputMaybe<Scalars["Boolean"]>;
  Champion__c?: InputMaybe<Scalars["String"]>;
  Churned_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Churned_Date__c?: InputMaybe<Scalars["date"]>;
  Churned_Opportunity__c?: InputMaybe<Scalars["Boolean"]>;
  City__c?: InputMaybe<Scalars["String"]>;
  Classification__c?: InputMaybe<Scalars["String"]>;
  CloseDate?: InputMaybe<Scalars["date"]>;
  Coach__c?: InputMaybe<Scalars["String"]>;
  Coming_from_Dealhub__c?: InputMaybe<Scalars["Boolean"]>;
  Commit_Stalled__c?: InputMaybe<Scalars["Boolean"]>;
  Company__c?: InputMaybe<Scalars["String"]>;
  Competition__c?: InputMaybe<Scalars["String"]>;
  Compliance_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Compliance_OTF_Formatted__c?: InputMaybe<Scalars["String"]>;
  Compliance_OTF__c?: InputMaybe<Scalars["float8"]>;
  ContactID__c?: InputMaybe<Scalars["String"]>;
  ContactId?: InputMaybe<Scalars["String"]>;
  Contact_Email__c?: InputMaybe<Scalars["String"]>;
  Contact_ID_Related_Oppt__c?: InputMaybe<Scalars["String"]>;
  Contact_Name__c?: InputMaybe<Scalars["String"]>;
  Contact_Phone__c?: InputMaybe<Scalars["String"]>;
  Contact_Title__c?: InputMaybe<Scalars["String"]>;
  Contact__c?: InputMaybe<Scalars["String"]>;
  Contain_Papa_John__c?: InputMaybe<Scalars["float8"]>;
  Contains_Expansion__c?: InputMaybe<Scalars["float8"]>;
  Contains_Subscription__c?: InputMaybe<Scalars["float8"]>;
  Contract_Term__c?: InputMaybe<Scalars["String"]>;
  Corporate_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Count_of_Discounted_Items__c?: InputMaybe<Scalars["float8"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Created_By_Role_Name__c?: InputMaybe<Scalars["String"]>;
  Created_Unit_Level_User_Logins__c?: InputMaybe<Scalars["Boolean"]>;
  Custom_Close_Date__c?: InputMaybe<Scalars["date"]>;
  Custom_Documents__c?: InputMaybe<Scalars["String"]>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<Scalars["float8"]>;
  Custom_Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  DH_Overall_MRR__c?: InputMaybe<Scalars["float8"]>;
  Data_Quality_Description__c?: InputMaybe<Scalars["String"]>;
  Data_Quality_Score__c?: InputMaybe<Scalars["float8"]>;
  Date_Demo_Held__c?: InputMaybe<Scalars["date"]>;
  Date_Discovery_Held__c?: InputMaybe<Scalars["date"]>;
  Date_Entered_Backlog__c?: InputMaybe<Scalars["timestamp"]>;
  Date_Left_Backlog__c?: InputMaybe<Scalars["timestamp"]>;
  Date_Payment_Processed__c?: InputMaybe<Scalars["date"]>;
  Date_Payment_Received__c?: InputMaybe<Scalars["date"]>;
  Date_Time__c?: InputMaybe<Scalars["timestamp"]>;
  DealHub_Create_Subscription__c?: InputMaybe<Scalars["Boolean"]>;
  Deal_Health__c?: InputMaybe<Scalars["String"]>;
  Deal_Room_URL__c?: InputMaybe<Scalars["String"]>;
  Dealhub_Quote_Status__c?: InputMaybe<Scalars["String"]>;
  Dealhub_URL__c?: InputMaybe<Scalars["String"]>;
  Decision_Criteria__c?: InputMaybe<Scalars["String"]>;
  Decision_Process__c?: InputMaybe<Scalars["String"]>;
  Demo_Held__c?: InputMaybe<Scalars["Boolean"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Description__c?: InputMaybe<Scalars["String"]>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<Scalars["float8"]>;
  Discount_Approval_Status__c?: InputMaybe<Scalars["String"]>;
  Discovery_Held__c?: InputMaybe<Scalars["Boolean"]>;
  Dont_update_reg__c?: InputMaybe<Scalars["Boolean"]>;
  Economic_Buyer__c?: InputMaybe<Scalars["String"]>;
  Effective_Date__c?: InputMaybe<Scalars["date"]>;
  Email_Sent__c?: InputMaybe<Scalars["String"]>;
  Email__c?: InputMaybe<Scalars["String"]>;
  Employees__c?: InputMaybe<Scalars["float8"]>;
  End_Date__c?: InputMaybe<Scalars["date"]>;
  Expansion_MRR__c?: InputMaybe<Scalars["float8"]>;
  Feature__c?: InputMaybe<Scalars["String"]>;
  Financial_Notes__c?: InputMaybe<Scalars["String"]>;
  Firm_Committed__c?: InputMaybe<Scalars["Boolean"]>;
  First_Quote_Synced_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Fiscal?: InputMaybe<Scalars["String"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  ForceCreateHarriProjects__c?: InputMaybe<Scalars["Boolean"]>;
  ForecastCategory?: InputMaybe<Scalars["String"]>;
  ForecastCategoryName?: InputMaybe<Scalars["String"]>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Franchise_Sign_Up__c?: InputMaybe<Scalars["Boolean"]>;
  Franchisee_Sign_Up__c?: InputMaybe<Scalars["String"]>;
  Franshisees_CMRR__c?: InputMaybe<Scalars["float8"]>;
  GI_Opportunity_Region__c?: InputMaybe<Scalars["String"]>;
  Gong__CurrentGenerators__c?: InputMaybe<Scalars["String"]>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<Scalars["String"]>;
  Gong__Gong_Count__c?: InputMaybe<Scalars["float8"]>;
  Gong__MainCompetitors__c?: InputMaybe<Scalars["String"]>;
  Gong__OrderNumber__c?: InputMaybe<Scalars["String"]>;
  Gong__TrackingNumber__c?: InputMaybe<Scalars["String"]>;
  Harri_API_Enabled__c?: InputMaybe<Scalars["Boolean"]>;
  Harri_Profile_Created__c?: InputMaybe<Scalars["Boolean"]>;
  Harri_Project__c?: InputMaybe<Scalars["String"]>;
  HasOpenActivity?: InputMaybe<Scalars["Boolean"]>;
  HasOpportunityLineItem?: InputMaybe<Scalars["Boolean"]>;
  HasOverdueTask?: InputMaybe<Scalars["Boolean"]>;
  Hiring_Urgency__c?: InputMaybe<Scalars["String"]>;
  ID_18_digit__c?: InputMaybe<Scalars["String"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Identified_Pain__c?: InputMaybe<Scalars["String"]>;
  Implementation_Notes__c?: InputMaybe<Scalars["String"]>;
  IqScore?: InputMaybe<Scalars["Int"]>;
  IsClosed?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsExcludedFromTerritory2Filter?: InputMaybe<Scalars["Boolean"]>;
  IsSplit?: InputMaybe<Scalars["Boolean"]>;
  IsSyncNeeded__c?: InputMaybe<Scalars["Boolean"]>;
  IsWon?: InputMaybe<Scalars["Boolean"]>;
  Is_Commit__c?: InputMaybe<Scalars["Boolean"]>;
  Job_Templates__c?: InputMaybe<Scalars["String"]>;
  LID__CurrentGenerators__c?: InputMaybe<Scalars["String"]>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<Scalars["String"]>;
  LID__Is_Influenced__c?: InputMaybe<Scalars["Boolean"]>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<Scalars["String"]>;
  LID__MainCompetitors__c?: InputMaybe<Scalars["String"]>;
  LID__My_DateTime__c?: InputMaybe<Scalars["timestamp"]>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__c?: InputMaybe<Scalars["json"]>;
  LID__OrderNumber__c?: InputMaybe<Scalars["String"]>;
  LID__TrackingNumber__c?: InputMaybe<Scalars["String"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastAmountChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastCloseDateChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastStageChangeDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  Last_Quote_Synced_Date__c?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Lead_Source_Detail__c?: InputMaybe<Scalars["String"]>;
  Leadership_Focus__c?: InputMaybe<Scalars["Boolean"]>;
  Less_than_current_month__c?: InputMaybe<Scalars["Boolean"]>;
  Locations__c?: InputMaybe<Scalars["float8"]>;
  Lost_Reason__c?: InputMaybe<Scalars["String"]>;
  MKTG_Harri_Partnership__c?: InputMaybe<Scalars["String"]>;
  MRR_In_GBP__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  MSA_Signed_Off_On__c?: InputMaybe<Scalars["String"]>;
  MSA_What_s_Needed__c?: InputMaybe<Scalars["String"]>;
  MSA__c?: InputMaybe<Scalars["String"]>;
  Max_of_OTF__c?: InputMaybe<Scalars["float8"]>;
  Max_of_non_OTF__c?: InputMaybe<Scalars["float8"]>;
  Metrics__c?: InputMaybe<Scalars["String"]>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<Scalars["date"]>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<Scalars["String"]>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<Scalars["String"]>;
  Most_Recent_Lead_Source__c?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NextStep?: InputMaybe<Scalars["String"]>;
  Next_Step_Date__c?: InputMaybe<Scalars["date"]>;
  Next_Steps__c?: InputMaybe<Scalars["String"]>;
  No_Decision__c?: InputMaybe<Scalars["String"]>;
  No_Of_Quotes__c?: InputMaybe<Scalars["float8"]>;
  No_of_Employees__c?: InputMaybe<Scalars["float8"]>;
  None_OTF_Count__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Won_Reason__c?: InputMaybe<Scalars["float8"]>;
  OTF_Effective_Date__c?: InputMaybe<Scalars["date"]>;
  OTF_With_Currency__c?: InputMaybe<Scalars["String"]>;
  One_Call_Close__c?: InputMaybe<Scalars["Boolean"]>;
  Operating_Structure__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Currency__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Franchise_Name__c?: InputMaybe<Scalars["String"]>;
  Opportunity_From_Lead__c?: InputMaybe<Scalars["Boolean"]>;
  Opportunity_Name_Formatted__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Owner_Prediction__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Region__c?: InputMaybe<Scalars["String"]>;
  Orientation_Conducted_By__c?: InputMaybe<Scalars["String"]>;
  Orientation_Contact__c?: InputMaybe<Scalars["String"]>;
  Orientation_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Orientation_Missed__c?: InputMaybe<Scalars["Boolean"]>;
  Orientation_Notes__c?: InputMaybe<Scalars["String"]>;
  Original_Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<Scalars["String"]>;
  Outreach_First_Primary_Contact__c?: InputMaybe<Scalars["String"]>;
  Over_All_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_for_renewal__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_new__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  Owner_Role__c?: InputMaybe<Scalars["String"]>;
  PAPER_PROCESS__c?: InputMaybe<Scalars["String"]>;
  PB_Locked__c?: InputMaybe<Scalars["Boolean"]>;
  Papa_Johns_Camp__c?: InputMaybe<Scalars["Boolean"]>;
  Papa_Johns_total__c?: InputMaybe<Scalars["float8"]>;
  PatchDealhub__c?: InputMaybe<Scalars["Boolean"]>;
  Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Payment_Method__c?: InputMaybe<Scalars["String"]>;
  Payment_Schedule__c?: InputMaybe<Scalars["String"]>;
  Payroll_Integration__c?: InputMaybe<Scalars["String"]>;
  Potential_Hurdles__c?: InputMaybe<Scalars["String"]>;
  PreSale__c?: InputMaybe<Scalars["String"]>;
  Pricebook2Id?: InputMaybe<Scalars["String"]>;
  Pricebook_Name__c?: InputMaybe<Scalars["String"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  Product_Customizations__c?: InputMaybe<Scalars["String"]>;
  Product_Development_needed__c?: InputMaybe<Scalars["Boolean"]>;
  Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  Product_Sold__c?: InputMaybe<Scalars["String"]>;
  Product_Team_Reviewing_Status__c?: InputMaybe<Scalars["String"]>;
  Product_analyst_review__c?: InputMaybe<Scalars["String"]>;
  Products_OTF__c?: InputMaybe<Scalars["float8"]>;
  Products_not_equal__c?: InputMaybe<Scalars["Boolean"]>;
  Project_Notes__c?: InputMaybe<Scalars["String"]>;
  Proposal_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_Customer_Address__c?: InputMaybe<Scalars["String"]>;
  Proposal_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_Status__c?: InputMaybe<Scalars["String"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  Reason_stalled__c?: InputMaybe<Scalars["String"]>;
  RecordTypeId?: InputMaybe<Scalars["String"]>;
  Referred_By_Who__c?: InputMaybe<Scalars["String"]>;
  Rejected_Reason__c?: InputMaybe<Scalars["String"]>;
  Rejected__c?: InputMaybe<Scalars["Boolean"]>;
  Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  Renewal_Uptick__c?: InputMaybe<Scalars["float8"]>;
  RevOps_Notes__c?: InputMaybe<Scalars["String"]>;
  SDR_Owner__c?: InputMaybe<Scalars["String"]>;
  SOW_What_s_Needed__c?: InputMaybe<Scalars["String"]>;
  ST_cleaned__c?: InputMaybe<Scalars["String"]>;
  Sales_Channel__c?: InputMaybe<Scalars["String"]>;
  Segment__c?: InputMaybe<Scalars["String"]>;
  Signed_Contracts_Count__c?: InputMaybe<Scalars["float8"]>;
  SoW_Form_Id__c?: InputMaybe<Scalars["String"]>;
  SoW_Signed_Off_on__c?: InputMaybe<Scalars["String"]>;
  SoW__c?: InputMaybe<Scalars["String"]>;
  Solution_Consultant_Owner__c?: InputMaybe<Scalars["String"]>;
  Source__c?: InputMaybe<Scalars["String"]>;
  Special_Terms__c?: InputMaybe<Scalars["String"]>;
  Special_Terms_approved__c?: InputMaybe<Scalars["Boolean"]>;
  StageName?: InputMaybe<Scalars["String"]>;
  Stalled_COVID19__c?: InputMaybe<Scalars["Boolean"]>;
  Standard_Documents__c?: InputMaybe<Scalars["String"]>;
  State__c?: InputMaybe<Scalars["String"]>;
  Status__c?: InputMaybe<Scalars["String"]>;
  Subscription_End_Date__c?: InputMaybe<Scalars["date"]>;
  Subscription_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Subway_Onboarding__c?: InputMaybe<Scalars["String"]>;
  Sum_of_Sub_Opp__c?: InputMaybe<Scalars["float8"]>;
  SyncedQuoteId?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Term_Length_Months__c?: InputMaybe<Scalars["String"]>;
  Territory2Id?: InputMaybe<Scalars["String"]>;
  Test__c?: InputMaybe<Scalars["String"]>;
  TotalOpportunityQuantity?: InputMaybe<Scalars["float8"]>;
  Total_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Formatted__c?: InputMaybe<Scalars["String"]>;
  Total_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_OTF_Formatted__c?: InputMaybe<Scalars["String"]>;
  Total_OTF__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Discount__c?: InputMaybe<Scalars["float8"]>;
  Trial__c?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<Scalars["String"]>;
  Type_?: InputMaybe<Scalars["String"]>;
  UK_Historical_CMRR__c?: InputMaybe<Scalars["float8"]>;
  URL__c?: InputMaybe<Scalars["String"]>;
  Updated__c?: InputMaybe<Scalars["timestamp"]>;
  Uptick_MRR__c?: InputMaybe<Scalars["float8"]>;
  VisibleCompetitorType__c?: InputMaybe<Scalars["String"]>;
  Weighted_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<Scalars["String"]>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<Scalars["String"]>;
  Who_s_working_on_Sow__c?: InputMaybe<Scalars["String"]>;
  Whos_Working_on_MSA__c?: InputMaybe<Scalars["String"]>;
  Why_Buy_Harri__c?: InputMaybe<Scalars["String"]>;
  Why_Buy_Now__c?: InputMaybe<Scalars["String"]>;
  Why_buy__c?: InputMaybe<Scalars["String"]>;
  Why_no_commit__c?: InputMaybe<Scalars["String"]>;
  Won_against__c?: InputMaybe<Scalars["String"]>;
  Wrong_Contract_Term__c?: InputMaybe<Scalars["Boolean"]>;
  X00_Archived_Date__c?: InputMaybe<Scalars["date"]>;
  X00_Close_Lost_Date__c?: InputMaybe<Scalars["date"]>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<Scalars["date"]>;
  X00_New_Date__c?: InputMaybe<Scalars["date"]>;
  X00_SQL_List__c?: InputMaybe<Scalars["date"]>;
  X00_Unqualified_Date__c?: InputMaybe<Scalars["date"]>;
  X01_Discovery__c?: InputMaybe<Scalars["date"]>;
  X01_Identified_Date__c?: InputMaybe<Scalars["date"]>;
  X02_Analysis__c?: InputMaybe<Scalars["date"]>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<Scalars["date"]>;
  X03_Evaluating_Date__c?: InputMaybe<Scalars["date"]>;
  X03_Presentation__c?: InputMaybe<Scalars["date"]>;
  X04_Competing_Date__c?: InputMaybe<Scalars["date"]>;
  X04_Proposal__c?: InputMaybe<Scalars["date"]>;
  X05_Negotiating_Date__c?: InputMaybe<Scalars["date"]>;
  X06_Signature_Pending_Date__c?: InputMaybe<Scalars["date"]>;
  X07_Close_Won_Date__c?: InputMaybe<Scalars["date"]>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<Scalars["String"]>;
  intuit_apps__invoiceAmount__c?: InputMaybe<Scalars["float8"]>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<Scalars["timestamp"]>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<Scalars["date"]>;
  intuit_apps__invoiceId__c?: InputMaybe<Scalars["String"]>;
  intuit_apps__invoiceNumber__c?: InputMaybe<Scalars["String"]>;
  of_Resource_Request__c?: InputMaybe<Scalars["float8"]>;
  posted_time__c?: InputMaybe<Scalars["timestamp"]>;
  power_of_1__c?: InputMaybe<Scalars["float8"]>;
  push_date__c?: InputMaybe<Scalars["date"]>;
  scheduled_demo_date__c?: InputMaybe<Scalars["timestamp"]>;
  scheduled_discovery_call_date__c?: InputMaybe<Scalars["timestamp"]>;
  source_url__c?: InputMaybe<Scalars["String"]>;
  sum_price_after_the_discount__c?: InputMaybe<Scalars["float8"]>;
  sum_price_before_the_discount__c?: InputMaybe<Scalars["float8"]>;
  term_in_months__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Opp_count__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Vidyard_Count__c?: InputMaybe<Scalars["float8"]>;
  weighted_Value__c?: InputMaybe<Scalars["float8"]>;
  what_product_development_is_needed__c?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "Opportunity" */
export type Opportunity_stddev_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "Opportunity" */
export type Opportunity_stddev_pop_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "Opportunity" */
export type Opportunity_stddev_samp_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Opportunity" */
export type Opportunity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Opportunity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opportunity_stream_cursor_value_input = {
  AE_Notes__c?: InputMaybe<Scalars["String"]>;
  AccountId?: InputMaybe<Scalars["String"]>;
  Account_Contact_Name__c?: InputMaybe<Scalars["String"]>;
  Account_Contact_Phone__c?: InputMaybe<Scalars["String"]>;
  Account_Contact__c?: InputMaybe<Scalars["String"]>;
  Acquisition_Program__c?: InputMaybe<Scalars["String"]>;
  Active_Employees__c?: InputMaybe<Scalars["String"]>;
  Address__c?: InputMaybe<Scalars["String"]>;
  Agreement_ID__c?: InputMaybe<Scalars["String"]>;
  Amount?: InputMaybe<Scalars["float8"]>;
  Amount_?: InputMaybe<Scalars["float8"]>;
  Annual_Contract_Value__c?: InputMaybe<Scalars["float8"]>;
  Anticipated_Go_Live__c?: InputMaybe<Scalars["date"]>;
  Attachments_Count__c?: InputMaybe<Scalars["float8"]>;
  Auto_Renew__c?: InputMaybe<Scalars["Boolean"]>;
  BIZSYS_Applicant_Tracking_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Applicant_Tracking_Systems__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Business_Intelligence__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Employee_Management__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Enterprise_Solutions__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Interviewer_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Inventory_Invoicing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Job_Board_Listing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Learning_Management_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Onboarding__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Payroll_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Point_of_Sale_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Recruitment_Marketing__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Scheduler_System__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Texting__c?: InputMaybe<Scalars["String"]>;
  BIZSYS_Time_Attendance_System__c?: InputMaybe<Scalars["String"]>;
  BackLog_Opportunity__c?: InputMaybe<Scalars["Boolean"]>;
  Barakat_2__c?: InputMaybe<Scalars["Boolean"]>;
  Best_Case_Stalled__c?: InputMaybe<Scalars["Boolean"]>;
  Billing_Terms__c?: InputMaybe<Scalars["String"]>;
  Booked_By__c?: InputMaybe<Scalars["String"]>;
  CMRR_With_Currency__c?: InputMaybe<Scalars["String"]>;
  CMRR__c?: InputMaybe<Scalars["String"]>;
  CampaignId?: InputMaybe<Scalars["String"]>;
  Can_edit_the_close_date__c?: InputMaybe<Scalars["Boolean"]>;
  Champion__c?: InputMaybe<Scalars["String"]>;
  Churned_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Churned_Date__c?: InputMaybe<Scalars["date"]>;
  Churned_Opportunity__c?: InputMaybe<Scalars["Boolean"]>;
  City__c?: InputMaybe<Scalars["String"]>;
  Classification__c?: InputMaybe<Scalars["String"]>;
  CloseDate?: InputMaybe<Scalars["date"]>;
  Coach__c?: InputMaybe<Scalars["String"]>;
  Coming_from_Dealhub__c?: InputMaybe<Scalars["Boolean"]>;
  Commit_Stalled__c?: InputMaybe<Scalars["Boolean"]>;
  Company__c?: InputMaybe<Scalars["String"]>;
  Competition__c?: InputMaybe<Scalars["String"]>;
  Compliance_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Compliance_OTF_Formatted__c?: InputMaybe<Scalars["String"]>;
  Compliance_OTF__c?: InputMaybe<Scalars["float8"]>;
  ContactID__c?: InputMaybe<Scalars["String"]>;
  ContactId?: InputMaybe<Scalars["String"]>;
  Contact_Email__c?: InputMaybe<Scalars["String"]>;
  Contact_ID_Related_Oppt__c?: InputMaybe<Scalars["String"]>;
  Contact_Name__c?: InputMaybe<Scalars["String"]>;
  Contact_Phone__c?: InputMaybe<Scalars["String"]>;
  Contact_Title__c?: InputMaybe<Scalars["String"]>;
  Contact__c?: InputMaybe<Scalars["String"]>;
  Contain_Papa_John__c?: InputMaybe<Scalars["float8"]>;
  Contains_Expansion__c?: InputMaybe<Scalars["float8"]>;
  Contains_Subscription__c?: InputMaybe<Scalars["float8"]>;
  Contract_Term__c?: InputMaybe<Scalars["String"]>;
  Corporate_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Count_of_Discounted_Items__c?: InputMaybe<Scalars["float8"]>;
  CreatedById?: InputMaybe<Scalars["String"]>;
  CreatedDate?: InputMaybe<Scalars["timestamp"]>;
  Created_By_Role_Name__c?: InputMaybe<Scalars["String"]>;
  Created_Unit_Level_User_Logins__c?: InputMaybe<Scalars["Boolean"]>;
  Custom_Close_Date__c?: InputMaybe<Scalars["date"]>;
  Custom_Documents__c?: InputMaybe<Scalars["String"]>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<Scalars["float8"]>;
  Custom_Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  DH_Overall_MRR__c?: InputMaybe<Scalars["float8"]>;
  Data_Quality_Description__c?: InputMaybe<Scalars["String"]>;
  Data_Quality_Score__c?: InputMaybe<Scalars["float8"]>;
  Date_Demo_Held__c?: InputMaybe<Scalars["date"]>;
  Date_Discovery_Held__c?: InputMaybe<Scalars["date"]>;
  Date_Entered_Backlog__c?: InputMaybe<Scalars["timestamp"]>;
  Date_Left_Backlog__c?: InputMaybe<Scalars["timestamp"]>;
  Date_Payment_Processed__c?: InputMaybe<Scalars["date"]>;
  Date_Payment_Received__c?: InputMaybe<Scalars["date"]>;
  Date_Time__c?: InputMaybe<Scalars["timestamp"]>;
  DealHub_Create_Subscription__c?: InputMaybe<Scalars["Boolean"]>;
  Deal_Health__c?: InputMaybe<Scalars["String"]>;
  Deal_Room_URL__c?: InputMaybe<Scalars["String"]>;
  Dealhub_Quote_Status__c?: InputMaybe<Scalars["String"]>;
  Dealhub_URL__c?: InputMaybe<Scalars["String"]>;
  Decision_Criteria__c?: InputMaybe<Scalars["String"]>;
  Decision_Process__c?: InputMaybe<Scalars["String"]>;
  Demo_Held__c?: InputMaybe<Scalars["Boolean"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Description__c?: InputMaybe<Scalars["String"]>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<Scalars["float8"]>;
  Discount_Approval_Status__c?: InputMaybe<Scalars["String"]>;
  Discovery_Held__c?: InputMaybe<Scalars["Boolean"]>;
  Dont_update_reg__c?: InputMaybe<Scalars["Boolean"]>;
  Economic_Buyer__c?: InputMaybe<Scalars["String"]>;
  Effective_Date__c?: InputMaybe<Scalars["date"]>;
  Email_Sent__c?: InputMaybe<Scalars["String"]>;
  Email__c?: InputMaybe<Scalars["String"]>;
  Employees__c?: InputMaybe<Scalars["float8"]>;
  End_Date__c?: InputMaybe<Scalars["date"]>;
  Expansion_MRR__c?: InputMaybe<Scalars["float8"]>;
  Feature__c?: InputMaybe<Scalars["String"]>;
  Financial_Notes__c?: InputMaybe<Scalars["String"]>;
  Firm_Committed__c?: InputMaybe<Scalars["Boolean"]>;
  First_Quote_Synced_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Fiscal?: InputMaybe<Scalars["String"]>;
  FiscalQuarter?: InputMaybe<Scalars["Int"]>;
  FiscalYear?: InputMaybe<Scalars["Int"]>;
  ForceCreateHarriProjects__c?: InputMaybe<Scalars["Boolean"]>;
  ForecastCategory?: InputMaybe<Scalars["String"]>;
  ForecastCategoryName?: InputMaybe<Scalars["String"]>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Franchise_Sign_Up__c?: InputMaybe<Scalars["Boolean"]>;
  Franchisee_Sign_Up__c?: InputMaybe<Scalars["String"]>;
  Franshisees_CMRR__c?: InputMaybe<Scalars["float8"]>;
  GI_Opportunity_Region__c?: InputMaybe<Scalars["String"]>;
  Gong__CurrentGenerators__c?: InputMaybe<Scalars["String"]>;
  Gong__DeliveryInstallationStatus__c?: InputMaybe<Scalars["String"]>;
  Gong__Gong_Count__c?: InputMaybe<Scalars["float8"]>;
  Gong__MainCompetitors__c?: InputMaybe<Scalars["String"]>;
  Gong__OrderNumber__c?: InputMaybe<Scalars["String"]>;
  Gong__TrackingNumber__c?: InputMaybe<Scalars["String"]>;
  Harri_API_Enabled__c?: InputMaybe<Scalars["Boolean"]>;
  Harri_Profile_Created__c?: InputMaybe<Scalars["Boolean"]>;
  Harri_Project__c?: InputMaybe<Scalars["String"]>;
  HasOpenActivity?: InputMaybe<Scalars["Boolean"]>;
  HasOpportunityLineItem?: InputMaybe<Scalars["Boolean"]>;
  HasOverdueTask?: InputMaybe<Scalars["Boolean"]>;
  Hiring_Urgency__c?: InputMaybe<Scalars["String"]>;
  ID_18_digit__c?: InputMaybe<Scalars["String"]>;
  Id?: InputMaybe<Scalars["String"]>;
  Identified_Pain__c?: InputMaybe<Scalars["String"]>;
  Implementation_Notes__c?: InputMaybe<Scalars["String"]>;
  IqScore?: InputMaybe<Scalars["Int"]>;
  IsClosed?: InputMaybe<Scalars["Boolean"]>;
  IsDeleted?: InputMaybe<Scalars["Boolean"]>;
  IsExcludedFromTerritory2Filter?: InputMaybe<Scalars["Boolean"]>;
  IsSplit?: InputMaybe<Scalars["Boolean"]>;
  IsSyncNeeded__c?: InputMaybe<Scalars["Boolean"]>;
  IsWon?: InputMaybe<Scalars["Boolean"]>;
  Is_Commit__c?: InputMaybe<Scalars["Boolean"]>;
  Job_Templates__c?: InputMaybe<Scalars["String"]>;
  LID__CurrentGenerators__c?: InputMaybe<Scalars["String"]>;
  LID__DeliveryInstallationStatus__c?: InputMaybe<Scalars["String"]>;
  LID__Is_Influenced__c?: InputMaybe<Scalars["Boolean"]>;
  LID__LinkedIn_Company_Id__c?: InputMaybe<Scalars["String"]>;
  LID__MainCompetitors__c?: InputMaybe<Scalars["String"]>;
  LID__My_DateTime__c?: InputMaybe<Scalars["timestamp"]>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<Scalars["float8"]>;
  LID__My_Geolocation__c?: InputMaybe<Scalars["json"]>;
  LID__OrderNumber__c?: InputMaybe<Scalars["String"]>;
  LID__TrackingNumber__c?: InputMaybe<Scalars["String"]>;
  LastActivityDate?: InputMaybe<Scalars["date"]>;
  LastAmountChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastCloseDateChangedHistoryId?: InputMaybe<Scalars["String"]>;
  LastModifiedById?: InputMaybe<Scalars["String"]>;
  LastModifiedDate?: InputMaybe<Scalars["timestamp"]>;
  LastReferencedDate?: InputMaybe<Scalars["timestamp"]>;
  LastStageChangeDate?: InputMaybe<Scalars["timestamp"]>;
  LastViewedDate?: InputMaybe<Scalars["timestamp"]>;
  Last_Quote_Synced_Date__c?: InputMaybe<Scalars["timestamp"]>;
  LeadSource?: InputMaybe<Scalars["String"]>;
  Lead_Source_Detail__c?: InputMaybe<Scalars["String"]>;
  Leadership_Focus__c?: InputMaybe<Scalars["Boolean"]>;
  Less_than_current_month__c?: InputMaybe<Scalars["Boolean"]>;
  Locations__c?: InputMaybe<Scalars["float8"]>;
  Lost_Reason__c?: InputMaybe<Scalars["String"]>;
  MKTG_Harri_Partnership__c?: InputMaybe<Scalars["String"]>;
  MRR_In_GBP__c?: InputMaybe<Scalars["float8"]>;
  MRR__c?: InputMaybe<Scalars["float8"]>;
  MSA_Signed_Off_On__c?: InputMaybe<Scalars["String"]>;
  MSA_What_s_Needed__c?: InputMaybe<Scalars["String"]>;
  MSA__c?: InputMaybe<Scalars["String"]>;
  Max_of_OTF__c?: InputMaybe<Scalars["float8"]>;
  Max_of_non_OTF__c?: InputMaybe<Scalars["float8"]>;
  Metrics__c?: InputMaybe<Scalars["String"]>;
  Missed_Orientation_Follow_Up__c?: InputMaybe<Scalars["date"]>;
  Most_Recent_Acquisition_Program__c?: InputMaybe<Scalars["String"]>;
  Most_Recent_Lead_Source_Detail__c?: InputMaybe<Scalars["String"]>;
  Most_Recent_Lead_Source__c?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NextStep?: InputMaybe<Scalars["String"]>;
  Next_Step_Date__c?: InputMaybe<Scalars["date"]>;
  Next_Steps__c?: InputMaybe<Scalars["String"]>;
  No_Decision__c?: InputMaybe<Scalars["String"]>;
  No_Of_Quotes__c?: InputMaybe<Scalars["float8"]>;
  No_of_Employees__c?: InputMaybe<Scalars["float8"]>;
  None_OTF_Count__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<Scalars["float8"]>;
  Number_of_Won_Reason__c?: InputMaybe<Scalars["float8"]>;
  OTF_Effective_Date__c?: InputMaybe<Scalars["date"]>;
  OTF_With_Currency__c?: InputMaybe<Scalars["String"]>;
  One_Call_Close__c?: InputMaybe<Scalars["Boolean"]>;
  Operating_Structure__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Currency__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Franchise_Name__c?: InputMaybe<Scalars["String"]>;
  Opportunity_From_Lead__c?: InputMaybe<Scalars["Boolean"]>;
  Opportunity_Name_Formatted__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Owner_Prediction__c?: InputMaybe<Scalars["String"]>;
  Opportunity_Region__c?: InputMaybe<Scalars["String"]>;
  Orientation_Conducted_By__c?: InputMaybe<Scalars["String"]>;
  Orientation_Contact__c?: InputMaybe<Scalars["String"]>;
  Orientation_Date__c?: InputMaybe<Scalars["timestamp"]>;
  Orientation_Missed__c?: InputMaybe<Scalars["Boolean"]>;
  Orientation_Notes__c?: InputMaybe<Scalars["String"]>;
  Original_Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Outreach_First_Primary_Contact_Sequence__c?: InputMaybe<Scalars["String"]>;
  Outreach_First_Primary_Contact__c?: InputMaybe<Scalars["String"]>;
  Over_All_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_for_renewal__c?: InputMaybe<Scalars["float8"]>;
  Overall_CMRR_new__c?: InputMaybe<Scalars["float8"]>;
  OwnerId?: InputMaybe<Scalars["String"]>;
  Owner_Role__c?: InputMaybe<Scalars["String"]>;
  PAPER_PROCESS__c?: InputMaybe<Scalars["String"]>;
  PB_Locked__c?: InputMaybe<Scalars["Boolean"]>;
  Papa_Johns_Camp__c?: InputMaybe<Scalars["Boolean"]>;
  Papa_Johns_total__c?: InputMaybe<Scalars["float8"]>;
  PatchDealhub__c?: InputMaybe<Scalars["Boolean"]>;
  Payment_Amount__c?: InputMaybe<Scalars["float8"]>;
  Payment_Method__c?: InputMaybe<Scalars["String"]>;
  Payment_Schedule__c?: InputMaybe<Scalars["String"]>;
  Payroll_Integration__c?: InputMaybe<Scalars["String"]>;
  Potential_Hurdles__c?: InputMaybe<Scalars["String"]>;
  PreSale__c?: InputMaybe<Scalars["String"]>;
  Pricebook2Id?: InputMaybe<Scalars["String"]>;
  Pricebook_Name__c?: InputMaybe<Scalars["String"]>;
  Probability?: InputMaybe<Scalars["float8"]>;
  Product_Customizations__c?: InputMaybe<Scalars["String"]>;
  Product_Development_needed__c?: InputMaybe<Scalars["Boolean"]>;
  Product_Quantity__c?: InputMaybe<Scalars["float8"]>;
  Product_Sold__c?: InputMaybe<Scalars["String"]>;
  Product_Team_Reviewing_Status__c?: InputMaybe<Scalars["String"]>;
  Product_analyst_review__c?: InputMaybe<Scalars["String"]>;
  Products_OTF__c?: InputMaybe<Scalars["float8"]>;
  Products_not_equal__c?: InputMaybe<Scalars["Boolean"]>;
  Project_Notes__c?: InputMaybe<Scalars["String"]>;
  Proposal_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_Customer_Address__c?: InputMaybe<Scalars["String"]>;
  Proposal_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Proposal_Status__c?: InputMaybe<Scalars["String"]>;
  PushCount?: InputMaybe<Scalars["Int"]>;
  Reason_stalled__c?: InputMaybe<Scalars["String"]>;
  RecordTypeId?: InputMaybe<Scalars["String"]>;
  Referred_By_Who__c?: InputMaybe<Scalars["String"]>;
  Rejected_Reason__c?: InputMaybe<Scalars["String"]>;
  Rejected__c?: InputMaybe<Scalars["Boolean"]>;
  Renewal_Date__c?: InputMaybe<Scalars["date"]>;
  Renewal_Uptick__c?: InputMaybe<Scalars["float8"]>;
  RevOps_Notes__c?: InputMaybe<Scalars["String"]>;
  SDR_Owner__c?: InputMaybe<Scalars["String"]>;
  SOW_What_s_Needed__c?: InputMaybe<Scalars["String"]>;
  ST_cleaned__c?: InputMaybe<Scalars["String"]>;
  Sales_Channel__c?: InputMaybe<Scalars["String"]>;
  Segment__c?: InputMaybe<Scalars["String"]>;
  Signed_Contracts_Count__c?: InputMaybe<Scalars["float8"]>;
  SoW_Form_Id__c?: InputMaybe<Scalars["String"]>;
  SoW_Signed_Off_on__c?: InputMaybe<Scalars["String"]>;
  SoW__c?: InputMaybe<Scalars["String"]>;
  Solution_Consultant_Owner__c?: InputMaybe<Scalars["String"]>;
  Source__c?: InputMaybe<Scalars["String"]>;
  Special_Terms__c?: InputMaybe<Scalars["String"]>;
  Special_Terms_approved__c?: InputMaybe<Scalars["Boolean"]>;
  StageName?: InputMaybe<Scalars["String"]>;
  Stalled_COVID19__c?: InputMaybe<Scalars["Boolean"]>;
  Standard_Documents__c?: InputMaybe<Scalars["String"]>;
  State__c?: InputMaybe<Scalars["String"]>;
  Status__c?: InputMaybe<Scalars["String"]>;
  Subscription_End_Date__c?: InputMaybe<Scalars["date"]>;
  Subscription_Start_Date__c?: InputMaybe<Scalars["date"]>;
  Subway_Onboarding__c?: InputMaybe<Scalars["String"]>;
  Sum_of_Sub_Opp__c?: InputMaybe<Scalars["float8"]>;
  SyncedQuoteId?: InputMaybe<Scalars["String"]>;
  SystemModstamp?: InputMaybe<Scalars["timestamp"]>;
  Term_Length_Months__c?: InputMaybe<Scalars["String"]>;
  Territory2Id?: InputMaybe<Scalars["String"]>;
  Test__c?: InputMaybe<Scalars["String"]>;
  TotalOpportunityQuantity?: InputMaybe<Scalars["float8"]>;
  Total_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_CMRR_Formatted__c?: InputMaybe<Scalars["String"]>;
  Total_OTF_Discount__c?: InputMaybe<Scalars["float8"]>;
  Total_OTF_Formatted__c?: InputMaybe<Scalars["String"]>;
  Total_OTF__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Amount__c?: InputMaybe<Scalars["float8"]>;
  Total_Opportunity_Discount__c?: InputMaybe<Scalars["float8"]>;
  Trial__c?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<Scalars["String"]>;
  Type_?: InputMaybe<Scalars["String"]>;
  UK_Historical_CMRR__c?: InputMaybe<Scalars["float8"]>;
  URL__c?: InputMaybe<Scalars["String"]>;
  Updated__c?: InputMaybe<Scalars["timestamp"]>;
  Uptick_MRR__c?: InputMaybe<Scalars["float8"]>;
  VisibleCompetitorType__c?: InputMaybe<Scalars["String"]>;
  Weighted_CMRR__c?: InputMaybe<Scalars["float8"]>;
  Who_Signed_Off_on_MSA__c?: InputMaybe<Scalars["String"]>;
  Who_Signed_Off_on_SOW__c?: InputMaybe<Scalars["String"]>;
  Who_s_working_on_Sow__c?: InputMaybe<Scalars["String"]>;
  Whos_Working_on_MSA__c?: InputMaybe<Scalars["String"]>;
  Why_Buy_Harri__c?: InputMaybe<Scalars["String"]>;
  Why_Buy_Now__c?: InputMaybe<Scalars["String"]>;
  Why_buy__c?: InputMaybe<Scalars["String"]>;
  Why_no_commit__c?: InputMaybe<Scalars["String"]>;
  Won_against__c?: InputMaybe<Scalars["String"]>;
  Wrong_Contract_Term__c?: InputMaybe<Scalars["Boolean"]>;
  X00_Archived_Date__c?: InputMaybe<Scalars["date"]>;
  X00_Close_Lost_Date__c?: InputMaybe<Scalars["date"]>;
  X00_Meeting_Did_Not_Hold_Date__c?: InputMaybe<Scalars["date"]>;
  X00_New_Date__c?: InputMaybe<Scalars["date"]>;
  X00_SQL_List__c?: InputMaybe<Scalars["date"]>;
  X00_Unqualified_Date__c?: InputMaybe<Scalars["date"]>;
  X01_Discovery__c?: InputMaybe<Scalars["date"]>;
  X01_Identified_Date__c?: InputMaybe<Scalars["date"]>;
  X02_Analysis__c?: InputMaybe<Scalars["date"]>;
  X02_Proof_of_Concept_Date__c?: InputMaybe<Scalars["date"]>;
  X03_Evaluating_Date__c?: InputMaybe<Scalars["date"]>;
  X03_Presentation__c?: InputMaybe<Scalars["date"]>;
  X04_Competing_Date__c?: InputMaybe<Scalars["date"]>;
  X04_Proposal__c?: InputMaybe<Scalars["date"]>;
  X05_Negotiating_Date__c?: InputMaybe<Scalars["date"]>;
  X06_Signature_Pending_Date__c?: InputMaybe<Scalars["date"]>;
  X07_Close_Won_Date__c?: InputMaybe<Scalars["date"]>;
  intuit_apps__intuitInvoiceStatus__c?: InputMaybe<Scalars["String"]>;
  intuit_apps__invoiceAmount__c?: InputMaybe<Scalars["float8"]>;
  intuit_apps__invoiceCreatedDate__c?: InputMaybe<Scalars["timestamp"]>;
  intuit_apps__invoiceDueDate__c?: InputMaybe<Scalars["date"]>;
  intuit_apps__invoiceId__c?: InputMaybe<Scalars["String"]>;
  intuit_apps__invoiceNumber__c?: InputMaybe<Scalars["String"]>;
  of_Resource_Request__c?: InputMaybe<Scalars["float8"]>;
  posted_time__c?: InputMaybe<Scalars["timestamp"]>;
  power_of_1__c?: InputMaybe<Scalars["float8"]>;
  push_date__c?: InputMaybe<Scalars["date"]>;
  scheduled_demo_date__c?: InputMaybe<Scalars["timestamp"]>;
  scheduled_discovery_call_date__c?: InputMaybe<Scalars["timestamp"]>;
  source_url__c?: InputMaybe<Scalars["String"]>;
  sum_price_after_the_discount__c?: InputMaybe<Scalars["float8"]>;
  sum_price_before_the_discount__c?: InputMaybe<Scalars["float8"]>;
  term_in_months__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Opp_count__c?: InputMaybe<Scalars["float8"]>;
  vy_report__Vidyard_Count__c?: InputMaybe<Scalars["float8"]>;
  weighted_Value__c?: InputMaybe<Scalars["float8"]>;
  what_product_development_is_needed__c?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "Opportunity" */
export type Opportunity_sum_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** update columns of table "Opportunity" */
export enum Opportunity_update_column {
  /** column name */
  AE_Notes__c = "AE_Notes__c",
  /** column name */
  AccountId = "AccountId",
  /** column name */
  Account_Contact_Name__c = "Account_Contact_Name__c",
  /** column name */
  Account_Contact_Phone__c = "Account_Contact_Phone__c",
  /** column name */
  Account_Contact__c = "Account_Contact__c",
  /** column name */
  Acquisition_Program__c = "Acquisition_Program__c",
  /** column name */
  Active_Employees__c = "Active_Employees__c",
  /** column name */
  Address__c = "Address__c",
  /** column name */
  Agreement_ID__c = "Agreement_ID__c",
  /** column name */
  Amount = "Amount",
  /** column name */
  Amount_ = "Amount_",
  /** column name */
  Annual_Contract_Value__c = "Annual_Contract_Value__c",
  /** column name */
  Anticipated_Go_Live__c = "Anticipated_Go_Live__c",
  /** column name */
  Attachments_Count__c = "Attachments_Count__c",
  /** column name */
  Auto_Renew__c = "Auto_Renew__c",
  /** column name */
  BIZSYS_Applicant_Tracking_System__c = "BIZSYS_Applicant_Tracking_System__c",
  /** column name */
  BIZSYS_Applicant_Tracking_Systems__c = "BIZSYS_Applicant_Tracking_Systems__c",
  /** column name */
  BIZSYS_Business_Intelligence__c = "BIZSYS_Business_Intelligence__c",
  /** column name */
  BIZSYS_Employee_Management__c = "BIZSYS_Employee_Management__c",
  /** column name */
  BIZSYS_Enterprise_Solutions__c = "BIZSYS_Enterprise_Solutions__c",
  /** column name */
  BIZSYS_Interviewer_System__c = "BIZSYS_Interviewer_System__c",
  /** column name */
  BIZSYS_Inventory_Invoicing__c = "BIZSYS_Inventory_Invoicing__c",
  /** column name */
  BIZSYS_Job_Board_Listing__c = "BIZSYS_Job_Board_Listing__c",
  /** column name */
  BIZSYS_Learning_Management_System__c = "BIZSYS_Learning_Management_System__c",
  /** column name */
  BIZSYS_Onboarding__c = "BIZSYS_Onboarding__c",
  /** column name */
  BIZSYS_Payroll_System__c = "BIZSYS_Payroll_System__c",
  /** column name */
  BIZSYS_Point_of_Sale_System__c = "BIZSYS_Point_of_Sale_System__c",
  /** column name */
  BIZSYS_Recruitment_Marketing__c = "BIZSYS_Recruitment_Marketing__c",
  /** column name */
  BIZSYS_Scheduler_System__c = "BIZSYS_Scheduler_System__c",
  /** column name */
  BIZSYS_Texting__c = "BIZSYS_Texting__c",
  /** column name */
  BIZSYS_Time_Attendance_System__c = "BIZSYS_Time_Attendance_System__c",
  /** column name */
  BackLog_Opportunity__c = "BackLog_Opportunity__c",
  /** column name */
  Barakat_2__c = "Barakat_2__c",
  /** column name */
  Best_Case_Stalled__c = "Best_Case_Stalled__c",
  /** column name */
  Billing_Terms__c = "Billing_Terms__c",
  /** column name */
  Booked_By__c = "Booked_By__c",
  /** column name */
  CMRR_With_Currency__c = "CMRR_With_Currency__c",
  /** column name */
  CMRR__c = "CMRR__c",
  /** column name */
  CampaignId = "CampaignId",
  /** column name */
  Can_edit_the_close_date__c = "Can_edit_the_close_date__c",
  /** column name */
  Champion__c = "Champion__c",
  /** column name */
  Churned_CMRR__c = "Churned_CMRR__c",
  /** column name */
  Churned_Date__c = "Churned_Date__c",
  /** column name */
  Churned_Opportunity__c = "Churned_Opportunity__c",
  /** column name */
  City__c = "City__c",
  /** column name */
  Classification__c = "Classification__c",
  /** column name */
  CloseDate = "CloseDate",
  /** column name */
  Coach__c = "Coach__c",
  /** column name */
  Coming_from_Dealhub__c = "Coming_from_Dealhub__c",
  /** column name */
  Commit_Stalled__c = "Commit_Stalled__c",
  /** column name */
  Company__c = "Company__c",
  /** column name */
  Competition__c = "Competition__c",
  /** column name */
  Compliance_CMRR__c = "Compliance_CMRR__c",
  /** column name */
  Compliance_OTF_Formatted__c = "Compliance_OTF_Formatted__c",
  /** column name */
  Compliance_OTF__c = "Compliance_OTF__c",
  /** column name */
  ContactID__c = "ContactID__c",
  /** column name */
  ContactId = "ContactId",
  /** column name */
  Contact_Email__c = "Contact_Email__c",
  /** column name */
  Contact_ID_Related_Oppt__c = "Contact_ID_Related_Oppt__c",
  /** column name */
  Contact_Name__c = "Contact_Name__c",
  /** column name */
  Contact_Phone__c = "Contact_Phone__c",
  /** column name */
  Contact_Title__c = "Contact_Title__c",
  /** column name */
  Contact__c = "Contact__c",
  /** column name */
  Contain_Papa_John__c = "Contain_Papa_John__c",
  /** column name */
  Contains_Expansion__c = "Contains_Expansion__c",
  /** column name */
  Contains_Subscription__c = "Contains_Subscription__c",
  /** column name */
  Contract_Term__c = "Contract_Term__c",
  /** column name */
  Corporate_CMRR__c = "Corporate_CMRR__c",
  /** column name */
  Count_of_Discounted_Items__c = "Count_of_Discounted_Items__c",
  /** column name */
  CreatedById = "CreatedById",
  /** column name */
  CreatedDate = "CreatedDate",
  /** column name */
  Created_By_Role_Name__c = "Created_By_Role_Name__c",
  /** column name */
  Created_Unit_Level_User_Logins__c = "Created_Unit_Level_User_Logins__c",
  /** column name */
  Custom_Close_Date__c = "Custom_Close_Date__c",
  /** column name */
  Custom_Documents__c = "Custom_Documents__c",
  /** column name */
  Custom_Opportunity_Products_Approvals__c = "Custom_Opportunity_Products_Approvals__c",
  /** column name */
  Custom_Product_Quantity__c = "Custom_Product_Quantity__c",
  /** column name */
  DH_Overall_MRR__c = "DH_Overall_MRR__c",
  /** column name */
  Data_Quality_Description__c = "Data_Quality_Description__c",
  /** column name */
  Data_Quality_Score__c = "Data_Quality_Score__c",
  /** column name */
  Date_Demo_Held__c = "Date_Demo_Held__c",
  /** column name */
  Date_Discovery_Held__c = "Date_Discovery_Held__c",
  /** column name */
  Date_Entered_Backlog__c = "Date_Entered_Backlog__c",
  /** column name */
  Date_Left_Backlog__c = "Date_Left_Backlog__c",
  /** column name */
  Date_Payment_Processed__c = "Date_Payment_Processed__c",
  /** column name */
  Date_Payment_Received__c = "Date_Payment_Received__c",
  /** column name */
  Date_Time__c = "Date_Time__c",
  /** column name */
  DealHub_Create_Subscription__c = "DealHub_Create_Subscription__c",
  /** column name */
  Deal_Health__c = "Deal_Health__c",
  /** column name */
  Deal_Room_URL__c = "Deal_Room_URL__c",
  /** column name */
  Dealhub_Quote_Status__c = "Dealhub_Quote_Status__c",
  /** column name */
  Dealhub_URL__c = "Dealhub_URL__c",
  /** column name */
  Decision_Criteria__c = "Decision_Criteria__c",
  /** column name */
  Decision_Process__c = "Decision_Process__c",
  /** column name */
  Demo_Held__c = "Demo_Held__c",
  /** column name */
  Description = "Description",
  /** column name */
  Description__c = "Description__c",
  /** column name */
  Difference_between_Close_Date_and_Today__c = "Difference_between_Close_Date_and_Today__c",
  /** column name */
  Discount_Approval_Status__c = "Discount_Approval_Status__c",
  /** column name */
  Discovery_Held__c = "Discovery_Held__c",
  /** column name */
  Dont_update_reg__c = "Dont_update_reg__c",
  /** column name */
  Economic_Buyer__c = "Economic_Buyer__c",
  /** column name */
  Effective_Date__c = "Effective_Date__c",
  /** column name */
  Email_Sent__c = "Email_Sent__c",
  /** column name */
  Email__c = "Email__c",
  /** column name */
  Employees__c = "Employees__c",
  /** column name */
  End_Date__c = "End_Date__c",
  /** column name */
  Expansion_MRR__c = "Expansion_MRR__c",
  /** column name */
  Feature__c = "Feature__c",
  /** column name */
  Financial_Notes__c = "Financial_Notes__c",
  /** column name */
  Firm_Committed__c = "Firm_Committed__c",
  /** column name */
  First_Quote_Synced_Date__c = "First_Quote_Synced_Date__c",
  /** column name */
  Fiscal = "Fiscal",
  /** column name */
  FiscalQuarter = "FiscalQuarter",
  /** column name */
  FiscalYear = "FiscalYear",
  /** column name */
  ForceCreateHarriProjects__c = "ForceCreateHarriProjects__c",
  /** column name */
  ForecastCategory = "ForecastCategory",
  /** column name */
  ForecastCategoryName = "ForecastCategoryName",
  /** column name */
  Forecasted_TOFU_CMRR__c = "Forecasted_TOFU_CMRR__c",
  /** column name */
  Franchise_Sign_Up__c = "Franchise_Sign_Up__c",
  /** column name */
  Franchisee_Sign_Up__c = "Franchisee_Sign_Up__c",
  /** column name */
  Franshisees_CMRR__c = "Franshisees_CMRR__c",
  /** column name */
  GI_Opportunity_Region__c = "GI_Opportunity_Region__c",
  /** column name */
  Gong__CurrentGenerators__c = "Gong__CurrentGenerators__c",
  /** column name */
  Gong__DeliveryInstallationStatus__c = "Gong__DeliveryInstallationStatus__c",
  /** column name */
  Gong__Gong_Count__c = "Gong__Gong_Count__c",
  /** column name */
  Gong__MainCompetitors__c = "Gong__MainCompetitors__c",
  /** column name */
  Gong__OrderNumber__c = "Gong__OrderNumber__c",
  /** column name */
  Gong__TrackingNumber__c = "Gong__TrackingNumber__c",
  /** column name */
  Harri_API_Enabled__c = "Harri_API_Enabled__c",
  /** column name */
  Harri_Profile_Created__c = "Harri_Profile_Created__c",
  /** column name */
  Harri_Project__c = "Harri_Project__c",
  /** column name */
  HasOpenActivity = "HasOpenActivity",
  /** column name */
  HasOpportunityLineItem = "HasOpportunityLineItem",
  /** column name */
  HasOverdueTask = "HasOverdueTask",
  /** column name */
  Hiring_Urgency__c = "Hiring_Urgency__c",
  /** column name */
  ID_18_digit__c = "ID_18_digit__c",
  /** column name */
  Id = "Id",
  /** column name */
  Identified_Pain__c = "Identified_Pain__c",
  /** column name */
  Implementation_Notes__c = "Implementation_Notes__c",
  /** column name */
  IqScore = "IqScore",
  /** column name */
  IsClosed = "IsClosed",
  /** column name */
  IsDeleted = "IsDeleted",
  /** column name */
  IsExcludedFromTerritory2Filter = "IsExcludedFromTerritory2Filter",
  /** column name */
  IsSplit = "IsSplit",
  /** column name */
  IsSyncNeeded__c = "IsSyncNeeded__c",
  /** column name */
  IsWon = "IsWon",
  /** column name */
  Is_Commit__c = "Is_Commit__c",
  /** column name */
  Job_Templates__c = "Job_Templates__c",
  /** column name */
  LID__CurrentGenerators__c = "LID__CurrentGenerators__c",
  /** column name */
  LID__DeliveryInstallationStatus__c = "LID__DeliveryInstallationStatus__c",
  /** column name */
  LID__Is_Influenced__c = "LID__Is_Influenced__c",
  /** column name */
  LID__LinkedIn_Company_Id__c = "LID__LinkedIn_Company_Id__c",
  /** column name */
  LID__MainCompetitors__c = "LID__MainCompetitors__c",
  /** column name */
  LID__My_DateTime__c = "LID__My_DateTime__c",
  /** column name */
  LID__My_Geolocation__Latitude__s = "LID__My_Geolocation__Latitude__s",
  /** column name */
  LID__My_Geolocation__Longitude__s = "LID__My_Geolocation__Longitude__s",
  /** column name */
  LID__My_Geolocation__c = "LID__My_Geolocation__c",
  /** column name */
  LID__OrderNumber__c = "LID__OrderNumber__c",
  /** column name */
  LID__TrackingNumber__c = "LID__TrackingNumber__c",
  /** column name */
  LastActivityDate = "LastActivityDate",
  /** column name */
  LastAmountChangedHistoryId = "LastAmountChangedHistoryId",
  /** column name */
  LastCloseDateChangedHistoryId = "LastCloseDateChangedHistoryId",
  /** column name */
  LastModifiedById = "LastModifiedById",
  /** column name */
  LastModifiedDate = "LastModifiedDate",
  /** column name */
  LastReferencedDate = "LastReferencedDate",
  /** column name */
  LastStageChangeDate = "LastStageChangeDate",
  /** column name */
  LastViewedDate = "LastViewedDate",
  /** column name */
  Last_Quote_Synced_Date__c = "Last_Quote_Synced_Date__c",
  /** column name */
  LeadSource = "LeadSource",
  /** column name */
  Lead_Source_Detail__c = "Lead_Source_Detail__c",
  /** column name */
  Leadership_Focus__c = "Leadership_Focus__c",
  /** column name */
  Less_than_current_month__c = "Less_than_current_month__c",
  /** column name */
  Locations__c = "Locations__c",
  /** column name */
  Lost_Reason__c = "Lost_Reason__c",
  /** column name */
  MKTG_Harri_Partnership__c = "MKTG_Harri_Partnership__c",
  /** column name */
  MRR_In_GBP__c = "MRR_In_GBP__c",
  /** column name */
  MRR__c = "MRR__c",
  /** column name */
  MSA_Signed_Off_On__c = "MSA_Signed_Off_On__c",
  /** column name */
  MSA_What_s_Needed__c = "MSA_What_s_Needed__c",
  /** column name */
  MSA__c = "MSA__c",
  /** column name */
  Max_of_OTF__c = "Max_of_OTF__c",
  /** column name */
  Max_of_non_OTF__c = "Max_of_non_OTF__c",
  /** column name */
  Metrics__c = "Metrics__c",
  /** column name */
  Missed_Orientation_Follow_Up__c = "Missed_Orientation_Follow_Up__c",
  /** column name */
  Most_Recent_Acquisition_Program__c = "Most_Recent_Acquisition_Program__c",
  /** column name */
  Most_Recent_Lead_Source_Detail__c = "Most_Recent_Lead_Source_Detail__c",
  /** column name */
  Most_Recent_Lead_Source__c = "Most_Recent_Lead_Source__c",
  /** column name */
  Name = "Name",
  /** column name */
  NextStep = "NextStep",
  /** column name */
  Next_Step_Date__c = "Next_Step_Date__c",
  /** column name */
  Next_Steps__c = "Next_Steps__c",
  /** column name */
  No_Decision__c = "No_Decision__c",
  /** column name */
  No_Of_Quotes__c = "No_Of_Quotes__c",
  /** column name */
  No_of_Employees__c = "No_of_Employees__c",
  /** column name */
  None_OTF_Count__c = "None_OTF_Count__c",
  /** column name */
  Number_of_Sales_to_Implementation__c = "Number_of_Sales_to_Implementation__c",
  /** column name */
  Number_of_Won_Reason__c = "Number_of_Won_Reason__c",
  /** column name */
  OTF_Effective_Date__c = "OTF_Effective_Date__c",
  /** column name */
  OTF_With_Currency__c = "OTF_With_Currency__c",
  /** column name */
  One_Call_Close__c = "One_Call_Close__c",
  /** column name */
  Operating_Structure__c = "Operating_Structure__c",
  /** column name */
  Opportunity_Currency__c = "Opportunity_Currency__c",
  /** column name */
  Opportunity_Franchise_Name__c = "Opportunity_Franchise_Name__c",
  /** column name */
  Opportunity_From_Lead__c = "Opportunity_From_Lead__c",
  /** column name */
  Opportunity_Name_Formatted__c = "Opportunity_Name_Formatted__c",
  /** column name */
  Opportunity_Owner_Prediction__c = "Opportunity_Owner_Prediction__c",
  /** column name */
  Opportunity_Region__c = "Opportunity_Region__c",
  /** column name */
  Orientation_Conducted_By__c = "Orientation_Conducted_By__c",
  /** column name */
  Orientation_Contact__c = "Orientation_Contact__c",
  /** column name */
  Orientation_Date__c = "Orientation_Date__c",
  /** column name */
  Orientation_Missed__c = "Orientation_Missed__c",
  /** column name */
  Orientation_Notes__c = "Orientation_Notes__c",
  /** column name */
  Original_Payment_Amount__c = "Original_Payment_Amount__c",
  /** column name */
  Outreach_First_Primary_Contact_Sequence__c = "Outreach_First_Primary_Contact_Sequence__c",
  /** column name */
  Outreach_First_Primary_Contact__c = "Outreach_First_Primary_Contact__c",
  /** column name */
  Over_All_CMRR__c = "Over_All_CMRR__c",
  /** column name */
  Overall_CMRR_for_renewal__c = "Overall_CMRR_for_renewal__c",
  /** column name */
  Overall_CMRR_new__c = "Overall_CMRR_new__c",
  /** column name */
  OwnerId = "OwnerId",
  /** column name */
  Owner_Role__c = "Owner_Role__c",
  /** column name */
  PAPER_PROCESS__c = "PAPER_PROCESS__c",
  /** column name */
  PB_Locked__c = "PB_Locked__c",
  /** column name */
  Papa_Johns_Camp__c = "Papa_Johns_Camp__c",
  /** column name */
  Papa_Johns_total__c = "Papa_Johns_total__c",
  /** column name */
  PatchDealhub__c = "PatchDealhub__c",
  /** column name */
  Payment_Amount__c = "Payment_Amount__c",
  /** column name */
  Payment_Method__c = "Payment_Method__c",
  /** column name */
  Payment_Schedule__c = "Payment_Schedule__c",
  /** column name */
  Payroll_Integration__c = "Payroll_Integration__c",
  /** column name */
  Potential_Hurdles__c = "Potential_Hurdles__c",
  /** column name */
  PreSale__c = "PreSale__c",
  /** column name */
  Pricebook2Id = "Pricebook2Id",
  /** column name */
  Pricebook_Name__c = "Pricebook_Name__c",
  /** column name */
  Probability = "Probability",
  /** column name */
  Product_Customizations__c = "Product_Customizations__c",
  /** column name */
  Product_Development_needed__c = "Product_Development_needed__c",
  /** column name */
  Product_Quantity__c = "Product_Quantity__c",
  /** column name */
  Product_Sold__c = "Product_Sold__c",
  /** column name */
  Product_Team_Reviewing_Status__c = "Product_Team_Reviewing_Status__c",
  /** column name */
  Product_analyst_review__c = "Product_analyst_review__c",
  /** column name */
  Products_OTF__c = "Products_OTF__c",
  /** column name */
  Products_not_equal__c = "Products_not_equal__c",
  /** column name */
  Project_Notes__c = "Project_Notes__c",
  /** column name */
  Proposal_CMRR_Discount__c = "Proposal_CMRR_Discount__c",
  /** column name */
  Proposal_Customer_Address__c = "Proposal_Customer_Address__c",
  /** column name */
  Proposal_OTF_Discount__c = "Proposal_OTF_Discount__c",
  /** column name */
  Proposal_Status__c = "Proposal_Status__c",
  /** column name */
  PushCount = "PushCount",
  /** column name */
  Reason_stalled__c = "Reason_stalled__c",
  /** column name */
  RecordTypeId = "RecordTypeId",
  /** column name */
  Referred_By_Who__c = "Referred_By_Who__c",
  /** column name */
  Rejected_Reason__c = "Rejected_Reason__c",
  /** column name */
  Rejected__c = "Rejected__c",
  /** column name */
  Renewal_Date__c = "Renewal_Date__c",
  /** column name */
  Renewal_Uptick__c = "Renewal_Uptick__c",
  /** column name */
  RevOps_Notes__c = "RevOps_Notes__c",
  /** column name */
  SDR_Owner__c = "SDR_Owner__c",
  /** column name */
  SOW_What_s_Needed__c = "SOW_What_s_Needed__c",
  /** column name */
  ST_cleaned__c = "ST_cleaned__c",
  /** column name */
  Sales_Channel__c = "Sales_Channel__c",
  /** column name */
  Segment__c = "Segment__c",
  /** column name */
  Signed_Contracts_Count__c = "Signed_Contracts_Count__c",
  /** column name */
  SoW_Form_Id__c = "SoW_Form_Id__c",
  /** column name */
  SoW_Signed_Off_on__c = "SoW_Signed_Off_on__c",
  /** column name */
  SoW__c = "SoW__c",
  /** column name */
  Solution_Consultant_Owner__c = "Solution_Consultant_Owner__c",
  /** column name */
  Source__c = "Source__c",
  /** column name */
  Special_Terms__c = "Special_Terms__c",
  /** column name */
  Special_Terms_approved__c = "Special_Terms_approved__c",
  /** column name */
  StageName = "StageName",
  /** column name */
  Stalled_COVID19__c = "Stalled_COVID19__c",
  /** column name */
  Standard_Documents__c = "Standard_Documents__c",
  /** column name */
  State__c = "State__c",
  /** column name */
  Status__c = "Status__c",
  /** column name */
  Subscription_End_Date__c = "Subscription_End_Date__c",
  /** column name */
  Subscription_Start_Date__c = "Subscription_Start_Date__c",
  /** column name */
  Subway_Onboarding__c = "Subway_Onboarding__c",
  /** column name */
  Sum_of_Sub_Opp__c = "Sum_of_Sub_Opp__c",
  /** column name */
  SyncedQuoteId = "SyncedQuoteId",
  /** column name */
  SystemModstamp = "SystemModstamp",
  /** column name */
  Term_Length_Months__c = "Term_Length_Months__c",
  /** column name */
  Territory2Id = "Territory2Id",
  /** column name */
  Test__c = "Test__c",
  /** column name */
  TotalOpportunityQuantity = "TotalOpportunityQuantity",
  /** column name */
  Total_Amount__c = "Total_Amount__c",
  /** column name */
  Total_CMRR_Discount__c = "Total_CMRR_Discount__c",
  /** column name */
  Total_CMRR_Formatted__c = "Total_CMRR_Formatted__c",
  /** column name */
  Total_OTF_Discount__c = "Total_OTF_Discount__c",
  /** column name */
  Total_OTF_Formatted__c = "Total_OTF_Formatted__c",
  /** column name */
  Total_OTF__c = "Total_OTF__c",
  /** column name */
  Total_Opportunity_Amount__c = "Total_Opportunity_Amount__c",
  /** column name */
  Total_Opportunity_Discount__c = "Total_Opportunity_Discount__c",
  /** column name */
  Trial__c = "Trial__c",
  /** column name */
  Type = "Type",
  /** column name */
  Type_ = "Type_",
  /** column name */
  UK_Historical_CMRR__c = "UK_Historical_CMRR__c",
  /** column name */
  URL__c = "URL__c",
  /** column name */
  Updated__c = "Updated__c",
  /** column name */
  Uptick_MRR__c = "Uptick_MRR__c",
  /** column name */
  VisibleCompetitorType__c = "VisibleCompetitorType__c",
  /** column name */
  Weighted_CMRR__c = "Weighted_CMRR__c",
  /** column name */
  Who_Signed_Off_on_MSA__c = "Who_Signed_Off_on_MSA__c",
  /** column name */
  Who_Signed_Off_on_SOW__c = "Who_Signed_Off_on_SOW__c",
  /** column name */
  Who_s_working_on_Sow__c = "Who_s_working_on_Sow__c",
  /** column name */
  Whos_Working_on_MSA__c = "Whos_Working_on_MSA__c",
  /** column name */
  Why_Buy_Harri__c = "Why_Buy_Harri__c",
  /** column name */
  Why_Buy_Now__c = "Why_Buy_Now__c",
  /** column name */
  Why_buy__c = "Why_buy__c",
  /** column name */
  Why_no_commit__c = "Why_no_commit__c",
  /** column name */
  Won_against__c = "Won_against__c",
  /** column name */
  Wrong_Contract_Term__c = "Wrong_Contract_Term__c",
  /** column name */
  X00_Archived_Date__c = "X00_Archived_Date__c",
  /** column name */
  X00_Close_Lost_Date__c = "X00_Close_Lost_Date__c",
  /** column name */
  X00_Meeting_Did_Not_Hold_Date__c = "X00_Meeting_Did_Not_Hold_Date__c",
  /** column name */
  X00_New_Date__c = "X00_New_Date__c",
  /** column name */
  X00_SQL_List__c = "X00_SQL_List__c",
  /** column name */
  X00_Unqualified_Date__c = "X00_Unqualified_Date__c",
  /** column name */
  X01_Discovery__c = "X01_Discovery__c",
  /** column name */
  X01_Identified_Date__c = "X01_Identified_Date__c",
  /** column name */
  X02_Analysis__c = "X02_Analysis__c",
  /** column name */
  X02_Proof_of_Concept_Date__c = "X02_Proof_of_Concept_Date__c",
  /** column name */
  X03_Evaluating_Date__c = "X03_Evaluating_Date__c",
  /** column name */
  X03_Presentation__c = "X03_Presentation__c",
  /** column name */
  X04_Competing_Date__c = "X04_Competing_Date__c",
  /** column name */
  X04_Proposal__c = "X04_Proposal__c",
  /** column name */
  X05_Negotiating_Date__c = "X05_Negotiating_Date__c",
  /** column name */
  X06_Signature_Pending_Date__c = "X06_Signature_Pending_Date__c",
  /** column name */
  X07_Close_Won_Date__c = "X07_Close_Won_Date__c",
  /** column name */
  intuit_apps__intuitInvoiceStatus__c = "intuit_apps__intuitInvoiceStatus__c",
  /** column name */
  intuit_apps__invoiceAmount__c = "intuit_apps__invoiceAmount__c",
  /** column name */
  intuit_apps__invoiceCreatedDate__c = "intuit_apps__invoiceCreatedDate__c",
  /** column name */
  intuit_apps__invoiceDueDate__c = "intuit_apps__invoiceDueDate__c",
  /** column name */
  intuit_apps__invoiceId__c = "intuit_apps__invoiceId__c",
  /** column name */
  intuit_apps__invoiceNumber__c = "intuit_apps__invoiceNumber__c",
  /** column name */
  of_Resource_Request__c = "of_Resource_Request__c",
  /** column name */
  posted_time__c = "posted_time__c",
  /** column name */
  power_of_1__c = "power_of_1__c",
  /** column name */
  push_date__c = "push_date__c",
  /** column name */
  scheduled_demo_date__c = "scheduled_demo_date__c",
  /** column name */
  scheduled_discovery_call_date__c = "scheduled_discovery_call_date__c",
  /** column name */
  source_url__c = "source_url__c",
  /** column name */
  sum_price_after_the_discount__c = "sum_price_after_the_discount__c",
  /** column name */
  sum_price_before_the_discount__c = "sum_price_before_the_discount__c",
  /** column name */
  term_in_months__c = "term_in_months__c",
  /** column name */
  vy_report__Opp_count__c = "vy_report__Opp_count__c",
  /** column name */
  vy_report__Vidyard_Count__c = "vy_report__Vidyard_Count__c",
  /** column name */
  weighted_Value__c = "weighted_Value__c",
  /** column name */
  what_product_development_is_needed__c = "what_product_development_is_needed__c",
}

export type Opportunity_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Opportunity_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Opportunity_set_input>;
  where: Opportunity_bool_exp;
};

/** order by var_pop() on columns of table "Opportunity" */
export type Opportunity_var_pop_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "Opportunity" */
export type Opportunity_var_samp_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "Opportunity" */
export type Opportunity_variance_order_by = {
  Amount?: InputMaybe<order_by>;
  Amount_?: InputMaybe<order_by>;
  Annual_Contract_Value__c?: InputMaybe<order_by>;
  Attachments_Count__c?: InputMaybe<order_by>;
  Churned_CMRR__c?: InputMaybe<order_by>;
  Compliance_CMRR__c?: InputMaybe<order_by>;
  Compliance_OTF__c?: InputMaybe<order_by>;
  Contain_Papa_John__c?: InputMaybe<order_by>;
  Contains_Expansion__c?: InputMaybe<order_by>;
  Contains_Subscription__c?: InputMaybe<order_by>;
  Corporate_CMRR__c?: InputMaybe<order_by>;
  Count_of_Discounted_Items__c?: InputMaybe<order_by>;
  Custom_Opportunity_Products_Approvals__c?: InputMaybe<order_by>;
  Custom_Product_Quantity__c?: InputMaybe<order_by>;
  DH_Overall_MRR__c?: InputMaybe<order_by>;
  Data_Quality_Score__c?: InputMaybe<order_by>;
  Difference_between_Close_Date_and_Today__c?: InputMaybe<order_by>;
  Employees__c?: InputMaybe<order_by>;
  Expansion_MRR__c?: InputMaybe<order_by>;
  FiscalQuarter?: InputMaybe<order_by>;
  FiscalYear?: InputMaybe<order_by>;
  Forecasted_TOFU_CMRR__c?: InputMaybe<order_by>;
  Franshisees_CMRR__c?: InputMaybe<order_by>;
  Gong__Gong_Count__c?: InputMaybe<order_by>;
  IqScore?: InputMaybe<order_by>;
  LID__My_Geolocation__Latitude__s?: InputMaybe<order_by>;
  LID__My_Geolocation__Longitude__s?: InputMaybe<order_by>;
  Locations__c?: InputMaybe<order_by>;
  MRR_In_GBP__c?: InputMaybe<order_by>;
  MRR__c?: InputMaybe<order_by>;
  Max_of_OTF__c?: InputMaybe<order_by>;
  Max_of_non_OTF__c?: InputMaybe<order_by>;
  No_Of_Quotes__c?: InputMaybe<order_by>;
  No_of_Employees__c?: InputMaybe<order_by>;
  None_OTF_Count__c?: InputMaybe<order_by>;
  Number_of_Sales_to_Implementation__c?: InputMaybe<order_by>;
  Number_of_Won_Reason__c?: InputMaybe<order_by>;
  Original_Payment_Amount__c?: InputMaybe<order_by>;
  Over_All_CMRR__c?: InputMaybe<order_by>;
  Overall_CMRR_for_renewal__c?: InputMaybe<order_by>;
  Overall_CMRR_new__c?: InputMaybe<order_by>;
  Papa_Johns_total__c?: InputMaybe<order_by>;
  Payment_Amount__c?: InputMaybe<order_by>;
  Probability?: InputMaybe<order_by>;
  Product_Quantity__c?: InputMaybe<order_by>;
  Products_OTF__c?: InputMaybe<order_by>;
  Proposal_CMRR_Discount__c?: InputMaybe<order_by>;
  Proposal_OTF_Discount__c?: InputMaybe<order_by>;
  PushCount?: InputMaybe<order_by>;
  Renewal_Uptick__c?: InputMaybe<order_by>;
  Signed_Contracts_Count__c?: InputMaybe<order_by>;
  Sum_of_Sub_Opp__c?: InputMaybe<order_by>;
  TotalOpportunityQuantity?: InputMaybe<order_by>;
  Total_Amount__c?: InputMaybe<order_by>;
  Total_CMRR_Discount__c?: InputMaybe<order_by>;
  Total_OTF_Discount__c?: InputMaybe<order_by>;
  Total_OTF__c?: InputMaybe<order_by>;
  Total_Opportunity_Amount__c?: InputMaybe<order_by>;
  Total_Opportunity_Discount__c?: InputMaybe<order_by>;
  UK_Historical_CMRR__c?: InputMaybe<order_by>;
  Uptick_MRR__c?: InputMaybe<order_by>;
  Weighted_CMRR__c?: InputMaybe<order_by>;
  intuit_apps__invoiceAmount__c?: InputMaybe<order_by>;
  of_Resource_Request__c?: InputMaybe<order_by>;
  power_of_1__c?: InputMaybe<order_by>;
  sum_price_after_the_discount__c?: InputMaybe<order_by>;
  sum_price_before_the_discount__c?: InputMaybe<order_by>;
  term_in_months__c?: InputMaybe<order_by>;
  vy_report__Opp_count__c?: InputMaybe<order_by>;
  vy_report__Vidyard_Count__c?: InputMaybe<order_by>;
  weighted_Value__c?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: InputMaybe<Scalars["String"]>;
  _gt?: InputMaybe<Scalars["String"]>;
  _gte?: InputMaybe<Scalars["String"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["String"]>;
  _in?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["String"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["String"]>;
  _lt?: InputMaybe<Scalars["String"]>;
  _lte?: InputMaybe<Scalars["String"]>;
  _neq?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["String"]>;
  _nin?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["String"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["String"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type _Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars["Boolean"]>;
  _gt?: InputMaybe<Scalars["Boolean"]>;
  _gte?: InputMaybe<Scalars["Boolean"]>;
  _in?: InputMaybe<Array<Scalars["Boolean"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Boolean"]>;
  _lte?: InputMaybe<Scalars["Boolean"]>;
  _neq?: InputMaybe<Scalars["Boolean"]>;
  _nin?: InputMaybe<Array<Scalars["Boolean"]>>;
};

/** Boolean expression to filter rows from the table "COMPANY". All fields are combined with a logical 'AND'. */
export type _COMPANY_bool_exp = {
  CITY?: InputMaybe<_String_comparison_exp>;
  COMPANYTYPE?: InputMaybe<_String_comparison_exp>;
  COUNTRY?: InputMaybe<_String_comparison_exp>;
  COUNTRYCODE?: InputMaybe<_String_comparison_exp>;
  CRUNCHBASE?: InputMaybe<_String_comparison_exp>;
  DATE_OF_RAISE?: InputMaybe<_String_comparison_exp>;
  DESCRIPTION?: InputMaybe<_String_comparison_exp>;
  DOMAIN?: InputMaybe<_String_comparison_exp>;
  FACEBOOK?: InputMaybe<_String_comparison_exp>;
  FOUNDINGYEAR?: InputMaybe<_float8_comparison_exp>;
  ID?: InputMaybe<_bigint_comparison_exp>;
  INFORMALNAME?: InputMaybe<_String_comparison_exp>;
  LINKEDIN?: InputMaybe<_String_comparison_exp>;
  LOADDATE?: InputMaybe<_String_comparison_exp>;
  MODIFIEDDATE?: InputMaybe<_String_comparison_exp>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<_float8_comparison_exp>;
  NAME?: InputMaybe<_String_comparison_exp>;
  NOLONGERINBUSINESS?: InputMaybe<_Boolean_comparison_exp>;
  NOLONGERINBUSINESSDATE?: InputMaybe<_String_comparison_exp>;
  NOLONGERINBUSINESSREASON?: InputMaybe<_float8_comparison_exp>;
  PARENTCOMPANY?: InputMaybe<_String_comparison_exp>;
  PARENTID?: InputMaybe<_float8_comparison_exp>;
  PHONENUMBER?: InputMaybe<_String_comparison_exp>;
  POSTALCODE?: InputMaybe<_String_comparison_exp>;
  RAISE_AMOUNT?: InputMaybe<_float8_comparison_exp>;
  RAISE_ROUND?: InputMaybe<_float8_comparison_exp>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<_float8_comparison_exp>;
  RAISE_VALUATION?: InputMaybe<_float8_comparison_exp>;
  SOURCECITED?: InputMaybe<_String_comparison_exp>;
  SPECIALTIES?: InputMaybe<_String_comparison_exp>;
  STATE?: InputMaybe<_String_comparison_exp>;
  STATECODE?: InputMaybe<_String_comparison_exp>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<_String_comparison_exp>;
  TOTALAMOUNTINVESTED?: InputMaybe<_float8_comparison_exp>;
  TWITTER?: InputMaybe<_String_comparison_exp>;
  WEBSITE?: InputMaybe<_String_comparison_exp>;
  _and?: InputMaybe<Array<_COMPANY_bool_exp>>;
  _not?: InputMaybe<_COMPANY_bool_exp>;
  _or?: InputMaybe<Array<_COMPANY_bool_exp>>;
  index?: InputMaybe<_bigint_comparison_exp>;
};

/** input type for incrementing numeric columns in table "COMPANY" */
export type _COMPANY_inc_input = {
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "COMPANY" */
export type _COMPANY_insert_input = {
  CITY?: InputMaybe<Scalars["String"]>;
  COMPANYTYPE?: InputMaybe<Scalars["String"]>;
  COUNTRY?: InputMaybe<Scalars["String"]>;
  COUNTRYCODE?: InputMaybe<Scalars["String"]>;
  CRUNCHBASE?: InputMaybe<Scalars["String"]>;
  DATE_OF_RAISE?: InputMaybe<Scalars["String"]>;
  DESCRIPTION?: InputMaybe<Scalars["String"]>;
  DOMAIN?: InputMaybe<Scalars["String"]>;
  FACEBOOK?: InputMaybe<Scalars["String"]>;
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  INFORMALNAME?: InputMaybe<Scalars["String"]>;
  LINKEDIN?: InputMaybe<Scalars["String"]>;
  LOADDATE?: InputMaybe<Scalars["String"]>;
  MODIFIEDDATE?: InputMaybe<Scalars["String"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NAME?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESS?: InputMaybe<Scalars["Boolean"]>;
  NOLONGERINBUSINESSDATE?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTCOMPANY?: InputMaybe<Scalars["String"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  PHONENUMBER?: InputMaybe<Scalars["String"]>;
  POSTALCODE?: InputMaybe<Scalars["String"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  SOURCECITED?: InputMaybe<Scalars["String"]>;
  SPECIALTIES?: InputMaybe<Scalars["String"]>;
  STATE?: InputMaybe<Scalars["String"]>;
  STATECODE?: InputMaybe<Scalars["String"]>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<Scalars["String"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  TWITTER?: InputMaybe<Scalars["String"]>;
  WEBSITE?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

/** Ordering options when selecting data from "COMPANY". */
export type _COMPANY_order_by = {
  CITY?: InputMaybe<_order_by>;
  COMPANYTYPE?: InputMaybe<_order_by>;
  COUNTRY?: InputMaybe<_order_by>;
  COUNTRYCODE?: InputMaybe<_order_by>;
  CRUNCHBASE?: InputMaybe<_order_by>;
  DATE_OF_RAISE?: InputMaybe<_order_by>;
  DESCRIPTION?: InputMaybe<_order_by>;
  DOMAIN?: InputMaybe<_order_by>;
  FACEBOOK?: InputMaybe<_order_by>;
  FOUNDINGYEAR?: InputMaybe<_order_by>;
  ID?: InputMaybe<_order_by>;
  INFORMALNAME?: InputMaybe<_order_by>;
  LINKEDIN?: InputMaybe<_order_by>;
  LOADDATE?: InputMaybe<_order_by>;
  MODIFIEDDATE?: InputMaybe<_order_by>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<_order_by>;
  NAME?: InputMaybe<_order_by>;
  NOLONGERINBUSINESS?: InputMaybe<_order_by>;
  NOLONGERINBUSINESSDATE?: InputMaybe<_order_by>;
  NOLONGERINBUSINESSREASON?: InputMaybe<_order_by>;
  PARENTCOMPANY?: InputMaybe<_order_by>;
  PARENTID?: InputMaybe<_order_by>;
  PHONENUMBER?: InputMaybe<_order_by>;
  POSTALCODE?: InputMaybe<_order_by>;
  RAISE_AMOUNT?: InputMaybe<_order_by>;
  RAISE_ROUND?: InputMaybe<_order_by>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<_order_by>;
  RAISE_VALUATION?: InputMaybe<_order_by>;
  SOURCECITED?: InputMaybe<_order_by>;
  SPECIALTIES?: InputMaybe<_order_by>;
  STATE?: InputMaybe<_order_by>;
  STATECODE?: InputMaybe<_order_by>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<_order_by>;
  TOTALAMOUNTINVESTED?: InputMaybe<_order_by>;
  TWITTER?: InputMaybe<_order_by>;
  WEBSITE?: InputMaybe<_order_by>;
  index?: InputMaybe<_order_by>;
};

/** select columns of table "COMPANY" */
export enum _COMPANY_select_column {
  /** column name */
  CITY = "CITY",
  /** column name */
  COMPANYTYPE = "COMPANYTYPE",
  /** column name */
  COUNTRY = "COUNTRY",
  /** column name */
  COUNTRYCODE = "COUNTRYCODE",
  /** column name */
  CRUNCHBASE = "CRUNCHBASE",
  /** column name */
  DATE_OF_RAISE = "DATE_OF_RAISE",
  /** column name */
  DESCRIPTION = "DESCRIPTION",
  /** column name */
  DOMAIN = "DOMAIN",
  /** column name */
  FACEBOOK = "FACEBOOK",
  /** column name */
  FOUNDINGYEAR = "FOUNDINGYEAR",
  /** column name */
  ID = "ID",
  /** column name */
  INFORMALNAME = "INFORMALNAME",
  /** column name */
  LINKEDIN = "LINKEDIN",
  /** column name */
  LOADDATE = "LOADDATE",
  /** column name */
  MODIFIEDDATE = "MODIFIEDDATE",
  /** column name */
  MOST_RECENT_EMPLOYEE_COUNT = "MOST_RECENT_EMPLOYEE_COUNT",
  /** column name */
  NAME = "NAME",
  /** column name */
  NOLONGERINBUSINESS = "NOLONGERINBUSINESS",
  /** column name */
  NOLONGERINBUSINESSDATE = "NOLONGERINBUSINESSDATE",
  /** column name */
  NOLONGERINBUSINESSREASON = "NOLONGERINBUSINESSREASON",
  /** column name */
  PARENTCOMPANY = "PARENTCOMPANY",
  /** column name */
  PARENTID = "PARENTID",
  /** column name */
  PHONENUMBER = "PHONENUMBER",
  /** column name */
  POSTALCODE = "POSTALCODE",
  /** column name */
  RAISE_AMOUNT = "RAISE_AMOUNT",
  /** column name */
  RAISE_ROUND = "RAISE_ROUND",
  /** column name */
  RAISE_TRANSACTION_TYPE = "RAISE_TRANSACTION_TYPE",
  /** column name */
  RAISE_VALUATION = "RAISE_VALUATION",
  /** column name */
  SOURCECITED = "SOURCECITED",
  /** column name */
  SPECIALTIES = "SPECIALTIES",
  /** column name */
  STATE = "STATE",
  /** column name */
  STATECODE = "STATECODE",
  /** column name */
  SUB_INDUSTRY_CATEGORY_NAME = "SUB_INDUSTRY_CATEGORY_NAME",
  /** column name */
  TOTALAMOUNTINVESTED = "TOTALAMOUNTINVESTED",
  /** column name */
  TWITTER = "TWITTER",
  /** column name */
  WEBSITE = "WEBSITE",
  /** column name */
  index = "index",
}

/** input type for updating data in table "COMPANY" */
export type _COMPANY_set_input = {
  CITY?: InputMaybe<Scalars["String"]>;
  COMPANYTYPE?: InputMaybe<Scalars["String"]>;
  COUNTRY?: InputMaybe<Scalars["String"]>;
  COUNTRYCODE?: InputMaybe<Scalars["String"]>;
  CRUNCHBASE?: InputMaybe<Scalars["String"]>;
  DATE_OF_RAISE?: InputMaybe<Scalars["String"]>;
  DESCRIPTION?: InputMaybe<Scalars["String"]>;
  DOMAIN?: InputMaybe<Scalars["String"]>;
  FACEBOOK?: InputMaybe<Scalars["String"]>;
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  INFORMALNAME?: InputMaybe<Scalars["String"]>;
  LINKEDIN?: InputMaybe<Scalars["String"]>;
  LOADDATE?: InputMaybe<Scalars["String"]>;
  MODIFIEDDATE?: InputMaybe<Scalars["String"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NAME?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESS?: InputMaybe<Scalars["Boolean"]>;
  NOLONGERINBUSINESSDATE?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTCOMPANY?: InputMaybe<Scalars["String"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  PHONENUMBER?: InputMaybe<Scalars["String"]>;
  POSTALCODE?: InputMaybe<Scalars["String"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  SOURCECITED?: InputMaybe<Scalars["String"]>;
  SPECIALTIES?: InputMaybe<Scalars["String"]>;
  STATE?: InputMaybe<Scalars["String"]>;
  STATECODE?: InputMaybe<Scalars["String"]>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<Scalars["String"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  TWITTER?: InputMaybe<Scalars["String"]>;
  WEBSITE?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

/** Streaming cursor of the table "COMPANY" */
export type _COMPANY_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _COMPANY_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _COMPANY_stream_cursor_value_input = {
  CITY?: InputMaybe<Scalars["String"]>;
  COMPANYTYPE?: InputMaybe<Scalars["String"]>;
  COUNTRY?: InputMaybe<Scalars["String"]>;
  COUNTRYCODE?: InputMaybe<Scalars["String"]>;
  CRUNCHBASE?: InputMaybe<Scalars["String"]>;
  DATE_OF_RAISE?: InputMaybe<Scalars["String"]>;
  DESCRIPTION?: InputMaybe<Scalars["String"]>;
  DOMAIN?: InputMaybe<Scalars["String"]>;
  FACEBOOK?: InputMaybe<Scalars["String"]>;
  FOUNDINGYEAR?: InputMaybe<Scalars["_float8"]>;
  ID?: InputMaybe<Scalars["_bigint"]>;
  INFORMALNAME?: InputMaybe<Scalars["String"]>;
  LINKEDIN?: InputMaybe<Scalars["String"]>;
  LOADDATE?: InputMaybe<Scalars["String"]>;
  MODIFIEDDATE?: InputMaybe<Scalars["String"]>;
  MOST_RECENT_EMPLOYEE_COUNT?: InputMaybe<Scalars["_float8"]>;
  NAME?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESS?: InputMaybe<Scalars["Boolean"]>;
  NOLONGERINBUSINESSDATE?: InputMaybe<Scalars["String"]>;
  NOLONGERINBUSINESSREASON?: InputMaybe<Scalars["_float8"]>;
  PARENTCOMPANY?: InputMaybe<Scalars["String"]>;
  PARENTID?: InputMaybe<Scalars["_float8"]>;
  PHONENUMBER?: InputMaybe<Scalars["String"]>;
  POSTALCODE?: InputMaybe<Scalars["String"]>;
  RAISE_AMOUNT?: InputMaybe<Scalars["_float8"]>;
  RAISE_ROUND?: InputMaybe<Scalars["_float8"]>;
  RAISE_TRANSACTION_TYPE?: InputMaybe<Scalars["_float8"]>;
  RAISE_VALUATION?: InputMaybe<Scalars["_float8"]>;
  SOURCECITED?: InputMaybe<Scalars["String"]>;
  SPECIALTIES?: InputMaybe<Scalars["String"]>;
  STATE?: InputMaybe<Scalars["String"]>;
  STATECODE?: InputMaybe<Scalars["String"]>;
  SUB_INDUSTRY_CATEGORY_NAME?: InputMaybe<Scalars["String"]>;
  TOTALAMOUNTINVESTED?: InputMaybe<Scalars["_float8"]>;
  TWITTER?: InputMaybe<Scalars["String"]>;
  WEBSITE?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["_bigint"]>;
};

export type _COMPANY_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_COMPANY_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_COMPANY_set_input>;
  where: _COMPANY_bool_exp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type _Int_comparison_exp = {
  _eq?: InputMaybe<Scalars["Int"]>;
  _gt?: InputMaybe<Scalars["Int"]>;
  _gte?: InputMaybe<Scalars["Int"]>;
  _in?: InputMaybe<Array<Scalars["Int"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["Int"]>;
  _lte?: InputMaybe<Scalars["Int"]>;
  _neq?: InputMaybe<Scalars["Int"]>;
  _nin?: InputMaybe<Array<Scalars["Int"]>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type _String_comparison_exp = {
  _eq?: InputMaybe<Scalars["String"]>;
  _gt?: InputMaybe<Scalars["String"]>;
  _gte?: InputMaybe<Scalars["String"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["String"]>;
  _in?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["String"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["String"]>;
  _lt?: InputMaybe<Scalars["String"]>;
  _lte?: InputMaybe<Scalars["String"]>;
  _neq?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["String"]>;
  _nin?: InputMaybe<Array<Scalars["String"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["String"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["String"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["String"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["String"]>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type _authProviderRequests_append_input = {
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type _authProviderRequests_bool_exp = {
  _and?: InputMaybe<Array<_authProviderRequests_bool_exp>>;
  _not?: InputMaybe<_authProviderRequests_bool_exp>;
  _or?: InputMaybe<Array<_authProviderRequests_bool_exp>>;
  id?: InputMaybe<_uuid_comparison_exp>;
  options?: InputMaybe<_jsonb_comparison_exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum _authProviderRequests_constraint {
  /** unique or primary key constraint on columns "id" */
  provider_requests_pkey = "provider_requests_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type _authProviderRequests_delete_at_path_input = {
  options?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type _authProviderRequests_delete_elem_input = {
  options?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type _authProviderRequests_delete_key_input = {
  options?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type _authProviderRequests_insert_input = {
  id?: InputMaybe<Scalars["_uuid"]>;
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type _authProviderRequests_on_conflict = {
  constraint: _authProviderRequests_constraint;
  update_columns?: Array<_authProviderRequests_update_column>;
  where?: InputMaybe<_authProviderRequests_bool_exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type _authProviderRequests_order_by = {
  id?: InputMaybe<_order_by>;
  options?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.provider_requests */
export type _authProviderRequests_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type _authProviderRequests_prepend_input = {
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** select columns of table "auth.provider_requests" */
export enum _authProviderRequests_select_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

/** input type for updating data in table "auth.provider_requests" */
export type _authProviderRequests_set_input = {
  id?: InputMaybe<Scalars["_uuid"]>;
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type _authProviderRequests_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authProviderRequests_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authProviderRequests_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["_uuid"]>;
  options?: InputMaybe<Scalars["_jsonb"]>;
};

/** update columns of table "auth.provider_requests" */
export enum _authProviderRequests_update_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

export type _authProviderRequests_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<_authProviderRequests_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<_authProviderRequests_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<_authProviderRequests_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<_authProviderRequests_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<_authProviderRequests_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authProviderRequests_set_input>;
  where: _authProviderRequests_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type _authProviders_bool_exp = {
  _and?: InputMaybe<Array<_authProviders_bool_exp>>;
  _not?: InputMaybe<_authProviders_bool_exp>;
  _or?: InputMaybe<Array<_authProviders_bool_exp>>;
  id?: InputMaybe<_String_comparison_exp>;
  userProviders?: InputMaybe<_authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum _authProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  providers_pkey = "providers_pkey",
}

/** input type for inserting data into table "auth.providers" */
export type _authProviders_insert_input = {
  id?: InputMaybe<Scalars["String"]>;
  userProviders?: InputMaybe<_authUserProviders_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type _authProviders_obj_rel_insert_input = {
  data: _authProviders_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_authProviders_on_conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type _authProviders_on_conflict = {
  constraint: _authProviders_constraint;
  update_columns?: Array<_authProviders_update_column>;
  where?: InputMaybe<_authProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type _authProviders_order_by = {
  id?: InputMaybe<_order_by>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.providers */
export type _authProviders_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "auth.providers" */
export enum _authProviders_select_column {
  /** column name */
  id = "id",
}

/** input type for updating data in table "auth.providers" */
export type _authProviders_set_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authProviders" */
export type _authProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authProviders_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.providers" */
export enum _authProviders_update_column {
  /** column name */
  id = "id",
}

export type _authProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authProviders_set_input>;
  where: _authProviders_bool_exp;
};

export type _authRefreshTokens_aggregate_bool_exp = {
  count?: InputMaybe<_authRefreshTokens_aggregate_bool_exp_count>;
};

export type _authRefreshTokens_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authRefreshTokens_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authRefreshTokens_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type _authRefreshTokens_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authRefreshTokens_max_order_by>;
  min?: InputMaybe<_authRefreshTokens_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type _authRefreshTokens_arr_rel_insert_input = {
  data: Array<_authRefreshTokens_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authRefreshTokens_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type _authRefreshTokens_bool_exp = {
  _and?: InputMaybe<Array<_authRefreshTokens_bool_exp>>;
  _not?: InputMaybe<_authRefreshTokens_bool_exp>;
  _or?: InputMaybe<Array<_authRefreshTokens_bool_exp>>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  expiresAt?: InputMaybe<_timestamptz_comparison_exp>;
  refreshToken?: InputMaybe<_uuid_comparison_exp>;
  refreshTokenHash?: InputMaybe<_String_comparison_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum _authRefreshTokens_constraint {
  /** unique or primary key constraint on columns "refresh_token" */
  refresh_tokens_pkey = "refresh_tokens_pkey",
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type _authRefreshTokens_insert_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["_uuid"]>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type _authRefreshTokens_max_order_by = {
  createdAt?: InputMaybe<_order_by>;
  expiresAt?: InputMaybe<_order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<_order_by>;
  refreshTokenHash?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type _authRefreshTokens_min_order_by = {
  createdAt?: InputMaybe<_order_by>;
  expiresAt?: InputMaybe<_order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<_order_by>;
  refreshTokenHash?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type _authRefreshTokens_on_conflict = {
  constraint: _authRefreshTokens_constraint;
  update_columns?: Array<_authRefreshTokens_update_column>;
  where?: InputMaybe<_authRefreshTokens_bool_exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type _authRefreshTokens_order_by = {
  createdAt?: InputMaybe<_order_by>;
  expiresAt?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  refreshTokenHash?: InputMaybe<_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type _authRefreshTokens_pk_columns_input = {
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken: Scalars["_uuid"];
};

/** select columns of table "auth.refresh_tokens" */
export enum _authRefreshTokens_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  refreshTokenHash = "refreshTokenHash",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.refresh_tokens" */
export type _authRefreshTokens_set_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["_uuid"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type _authRefreshTokens_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authRefreshTokens_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authRefreshTokens_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["_uuid"]>;
  refreshTokenHash?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** update columns of table "auth.refresh_tokens" */
export enum _authRefreshTokens_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  userId = "userId",
}

export type _authRefreshTokens_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authRefreshTokens_set_input>;
  where: _authRefreshTokens_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type _authRoles_bool_exp = {
  _and?: InputMaybe<Array<_authRoles_bool_exp>>;
  _not?: InputMaybe<_authRoles_bool_exp>;
  _or?: InputMaybe<Array<_authRoles_bool_exp>>;
  role?: InputMaybe<_String_comparison_exp>;
  userRoles?: InputMaybe<_authUserRoles_bool_exp>;
  userRoles_aggregate?: InputMaybe<_authUserRoles_aggregate_bool_exp>;
  usersByDefaultRole?: InputMaybe<_users_bool_exp>;
  usersByDefaultRole_aggregate?: InputMaybe<_users_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum _authRoles_constraint {
  /** unique or primary key constraint on columns "role" */
  roles_pkey = "roles_pkey",
}

/** input type for inserting data into table "auth.roles" */
export type _authRoles_insert_input = {
  role?: InputMaybe<Scalars["String"]>;
  userRoles?: InputMaybe<_authUserRoles_arr_rel_insert_input>;
  usersByDefaultRole?: InputMaybe<_users_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type _authRoles_obj_rel_insert_input = {
  data: _authRoles_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_authRoles_on_conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type _authRoles_on_conflict = {
  constraint: _authRoles_constraint;
  update_columns?: Array<_authRoles_update_column>;
  where?: InputMaybe<_authRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type _authRoles_order_by = {
  role?: InputMaybe<_order_by>;
  userRoles_aggregate?: InputMaybe<_authUserRoles_aggregate_order_by>;
  usersByDefaultRole_aggregate?: InputMaybe<_users_aggregate_order_by>;
};

/** primary key columns input for table: auth.roles */
export type _authRoles_pk_columns_input = {
  role: Scalars["String"];
};

/** select columns of table "auth.roles" */
export enum _authRoles_select_column {
  /** column name */
  role = "role",
}

/** input type for updating data in table "auth.roles" */
export type _authRoles_set_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authRoles" */
export type _authRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authRoles_stream_cursor_value_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.roles" */
export enum _authRoles_update_column {
  /** column name */
  role = "role",
}

export type _authRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authRoles_set_input>;
  where: _authRoles_bool_exp;
};

export type _authUserProviders_aggregate_bool_exp = {
  count?: InputMaybe<_authUserProviders_aggregate_bool_exp_count>;
};

export type _authUserProviders_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authUserProviders_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authUserProviders_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_providers" */
export type _authUserProviders_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authUserProviders_max_order_by>;
  min?: InputMaybe<_authUserProviders_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type _authUserProviders_arr_rel_insert_input = {
  data: Array<_authUserProviders_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authUserProviders_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type _authUserProviders_bool_exp = {
  _and?: InputMaybe<Array<_authUserProviders_bool_exp>>;
  _not?: InputMaybe<_authUserProviders_bool_exp>;
  _or?: InputMaybe<Array<_authUserProviders_bool_exp>>;
  accessToken?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  provider?: InputMaybe<_authProviders_bool_exp>;
  providerId?: InputMaybe<_String_comparison_exp>;
  providerUserId?: InputMaybe<_String_comparison_exp>;
  refreshToken?: InputMaybe<_String_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum _authUserProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  user_providers_pkey = "user_providers_pkey",
  /** unique or primary key constraint on columns "provider_id", "provider_user_id" */
  user_providers_provider_id_provider_user_id_key = "user_providers_provider_id_provider_user_id_key",
  /** unique or primary key constraint on columns "provider_id", "user_id" */
  user_providers_user_id_provider_id_key = "user_providers_user_id_provider_id_key",
}

/** input type for inserting data into table "auth.user_providers" */
export type _authUserProviders_insert_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  provider?: InputMaybe<_authProviders_obj_rel_insert_input>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.user_providers" */
export type _authUserProviders_max_order_by = {
  accessToken?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  providerId?: InputMaybe<_order_by>;
  providerUserId?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.user_providers" */
export type _authUserProviders_min_order_by = {
  accessToken?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  providerId?: InputMaybe<_order_by>;
  providerUserId?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type _authUserProviders_on_conflict = {
  constraint: _authUserProviders_constraint;
  update_columns?: Array<_authUserProviders_update_column>;
  where?: InputMaybe<_authUserProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type _authUserProviders_order_by = {
  accessToken?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  provider?: InputMaybe<_authProviders_order_by>;
  providerId?: InputMaybe<_order_by>;
  providerUserId?: InputMaybe<_order_by>;
  refreshToken?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.user_providers */
export type _authUserProviders_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "auth.user_providers" */
export enum _authUserProviders_select_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_providers" */
export type _authUserProviders_set_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** Streaming cursor of the table "authUserProviders" */
export type _authUserProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authUserProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authUserProviders_stream_cursor_value_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** update columns of table "auth.user_providers" */
export enum _authUserProviders_update_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

export type _authUserProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authUserProviders_set_input>;
  where: _authUserProviders_bool_exp;
};

export type _authUserRoles_aggregate_bool_exp = {
  count?: InputMaybe<_authUserRoles_aggregate_bool_exp_count>;
};

export type _authUserRoles_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authUserRoles_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authUserRoles_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_roles" */
export type _authUserRoles_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authUserRoles_max_order_by>;
  min?: InputMaybe<_authUserRoles_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type _authUserRoles_arr_rel_insert_input = {
  data: Array<_authUserRoles_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authUserRoles_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type _authUserRoles_bool_exp = {
  _and?: InputMaybe<Array<_authUserRoles_bool_exp>>;
  _not?: InputMaybe<_authUserRoles_bool_exp>;
  _or?: InputMaybe<Array<_authUserRoles_bool_exp>>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  role?: InputMaybe<_String_comparison_exp>;
  roleByRole?: InputMaybe<_authRoles_bool_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum _authUserRoles_constraint {
  /** unique or primary key constraint on columns "id" */
  user_roles_pkey = "user_roles_pkey",
  /** unique or primary key constraint on columns "user_id", "role" */
  user_roles_user_id_role_key = "user_roles_user_id_role_key",
}

/** input type for inserting data into table "auth.user_roles" */
export type _authUserRoles_insert_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  roleByRole?: InputMaybe<_authRoles_obj_rel_insert_input>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.user_roles" */
export type _authUserRoles_max_order_by = {
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  role?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.user_roles" */
export type _authUserRoles_min_order_by = {
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  role?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type _authUserRoles_on_conflict = {
  constraint: _authUserRoles_constraint;
  update_columns?: Array<_authUserRoles_update_column>;
  where?: InputMaybe<_authUserRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type _authUserRoles_order_by = {
  createdAt?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  role?: InputMaybe<_order_by>;
  roleByRole?: InputMaybe<_authRoles_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.user_roles */
export type _authUserRoles_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "auth.user_roles" */
export enum _authUserRoles_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_roles" */
export type _authUserRoles_set_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** Streaming cursor of the table "authUserRoles" */
export type _authUserRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authUserRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authUserRoles_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** update columns of table "auth.user_roles" */
export enum _authUserRoles_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

export type _authUserRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authUserRoles_set_input>;
  where: _authUserRoles_bool_exp;
};

export type _authUserSecurityKeys_aggregate_bool_exp = {
  count?: InputMaybe<_authUserSecurityKeys_aggregate_bool_exp_count>;
};

export type _authUserSecurityKeys_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_authUserSecurityKeys_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_authUserSecurityKeys_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type _authUserSecurityKeys_aggregate_order_by = {
  avg?: InputMaybe<_authUserSecurityKeys_avg_order_by>;
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_authUserSecurityKeys_max_order_by>;
  min?: InputMaybe<_authUserSecurityKeys_min_order_by>;
  stddev?: InputMaybe<_authUserSecurityKeys_stddev_order_by>;
  stddev_pop?: InputMaybe<_authUserSecurityKeys_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<_authUserSecurityKeys_stddev_samp_order_by>;
  sum?: InputMaybe<_authUserSecurityKeys_sum_order_by>;
  var_pop?: InputMaybe<_authUserSecurityKeys_var_pop_order_by>;
  var_samp?: InputMaybe<_authUserSecurityKeys_var_samp_order_by>;
  variance?: InputMaybe<_authUserSecurityKeys_variance_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type _authUserSecurityKeys_arr_rel_insert_input = {
  data: Array<_authUserSecurityKeys_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_authUserSecurityKeys_on_conflict>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_avg_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type _authUserSecurityKeys_bool_exp = {
  _and?: InputMaybe<Array<_authUserSecurityKeys_bool_exp>>;
  _not?: InputMaybe<_authUserSecurityKeys_bool_exp>;
  _or?: InputMaybe<Array<_authUserSecurityKeys_bool_exp>>;
  counter?: InputMaybe<_bigint_comparison_exp>;
  credentialId?: InputMaybe<_String_comparison_exp>;
  credentialPublicKey?: InputMaybe<_bytea_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  nickname?: InputMaybe<_String_comparison_exp>;
  transports?: InputMaybe<_String_comparison_exp>;
  user?: InputMaybe<_users_bool_exp>;
  userId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum _authUserSecurityKeys_constraint {
  /** unique or primary key constraint on columns "credential_id" */
  user_security_key_credential_id_key = "user_security_key_credential_id_key",
  /** unique or primary key constraint on columns "id" */
  user_security_keys_pkey = "user_security_keys_pkey",
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type _authUserSecurityKeys_inc_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type _authUserSecurityKeys_insert_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["_bytea"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  user?: InputMaybe<_users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_max_order_by = {
  counter?: InputMaybe<_order_by>;
  credentialId?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  nickname?: InputMaybe<_order_by>;
  transports?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_min_order_by = {
  counter?: InputMaybe<_order_by>;
  credentialId?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  nickname?: InputMaybe<_order_by>;
  transports?: InputMaybe<_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type _authUserSecurityKeys_on_conflict = {
  constraint: _authUserSecurityKeys_constraint;
  update_columns?: Array<_authUserSecurityKeys_update_column>;
  where?: InputMaybe<_authUserSecurityKeys_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type _authUserSecurityKeys_order_by = {
  counter?: InputMaybe<_order_by>;
  credentialId?: InputMaybe<_order_by>;
  credentialPublicKey?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  nickname?: InputMaybe<_order_by>;
  transports?: InputMaybe<_order_by>;
  user?: InputMaybe<_users_order_by>;
  userId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: auth.user_security_keys */
export type _authUserSecurityKeys_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "auth.user_security_keys" */
export enum _authUserSecurityKeys_select_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_security_keys" */
export type _authUserSecurityKeys_set_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["_bytea"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_stddev_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_stddev_pop_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_stddev_samp_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type _authUserSecurityKeys_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _authUserSecurityKeys_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _authUserSecurityKeys_stream_cursor_value_input = {
  counter?: InputMaybe<Scalars["_bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["_bytea"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_sum_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** update columns of table "auth.user_security_keys" */
export enum _authUserSecurityKeys_update_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

export type _authUserSecurityKeys_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_authUserSecurityKeys_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_authUserSecurityKeys_set_input>;
  where: _authUserSecurityKeys_bool_exp;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_var_pop_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_var_samp_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type _authUserSecurityKeys_variance_order_by = {
  counter?: InputMaybe<_order_by>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type _bigint_comparison_exp = {
  _eq?: InputMaybe<Scalars["_bigint"]>;
  _gt?: InputMaybe<Scalars["_bigint"]>;
  _gte?: InputMaybe<Scalars["_bigint"]>;
  _in?: InputMaybe<Array<Scalars["_bigint"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_bigint"]>;
  _lte?: InputMaybe<Scalars["_bigint"]>;
  _neq?: InputMaybe<Scalars["_bigint"]>;
  _nin?: InputMaybe<Array<Scalars["_bigint"]>>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type _buckets_bool_exp = {
  _and?: InputMaybe<Array<_buckets_bool_exp>>;
  _not?: InputMaybe<_buckets_bool_exp>;
  _or?: InputMaybe<Array<_buckets_bool_exp>>;
  cacheControl?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  downloadExpiration?: InputMaybe<_Int_comparison_exp>;
  files?: InputMaybe<_files_bool_exp>;
  files_aggregate?: InputMaybe<_files_aggregate_bool_exp>;
  id?: InputMaybe<_String_comparison_exp>;
  maxUploadFileSize?: InputMaybe<_Int_comparison_exp>;
  minUploadFileSize?: InputMaybe<_Int_comparison_exp>;
  presignedUrlsEnabled?: InputMaybe<_Boolean_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum _buckets_constraint {
  /** unique or primary key constraint on columns "id" */
  buckets_pkey = "buckets_pkey",
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type _buckets_inc_input = {
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.buckets" */
export type _buckets_insert_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  files?: InputMaybe<_files_arr_rel_insert_input>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type _buckets_obj_rel_insert_input = {
  data: _buckets_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_buckets_on_conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type _buckets_on_conflict = {
  constraint: _buckets_constraint;
  update_columns?: Array<_buckets_update_column>;
  where?: InputMaybe<_buckets_bool_exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type _buckets_order_by = {
  cacheControl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  downloadExpiration?: InputMaybe<_order_by>;
  files_aggregate?: InputMaybe<_files_aggregate_order_by>;
  id?: InputMaybe<_order_by>;
  maxUploadFileSize?: InputMaybe<_order_by>;
  minUploadFileSize?: InputMaybe<_order_by>;
  presignedUrlsEnabled?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
};

/** primary key columns input for table: storage.buckets */
export type _buckets_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "storage.buckets" */
export enum _buckets_select_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

/** input type for updating data in table "storage.buckets" */
export type _buckets_set_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** Streaming cursor of the table "buckets" */
export type _buckets_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _buckets_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _buckets_stream_cursor_value_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** update columns of table "storage.buckets" */
export enum _buckets_update_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

export type _buckets_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_buckets_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_buckets_set_input>;
  where: _buckets_bool_exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type _bytea_comparison_exp = {
  _eq?: InputMaybe<Scalars["_bytea"]>;
  _gt?: InputMaybe<Scalars["_bytea"]>;
  _gte?: InputMaybe<Scalars["_bytea"]>;
  _in?: InputMaybe<Array<Scalars["_bytea"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_bytea"]>;
  _lte?: InputMaybe<Scalars["_bytea"]>;
  _neq?: InputMaybe<Scalars["_bytea"]>;
  _nin?: InputMaybe<Array<Scalars["_bytea"]>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type _citext_comparison_exp = {
  _eq?: InputMaybe<Scalars["_citext"]>;
  _gt?: InputMaybe<Scalars["_citext"]>;
  _gte?: InputMaybe<Scalars["_citext"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["_citext"]>;
  _in?: InputMaybe<Array<Scalars["_citext"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["_citext"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["_citext"]>;
  _lt?: InputMaybe<Scalars["_citext"]>;
  _lte?: InputMaybe<Scalars["_citext"]>;
  _neq?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["_citext"]>;
  _nin?: InputMaybe<Array<Scalars["_citext"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["_citext"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["_citext"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["_citext"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["_citext"]>;
};

/** ordering argument of a cursor */
export enum _cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = "ASC",
  /** descending ordering of the cursor */
  DESC = "DESC",
}

export type _files_aggregate_bool_exp = {
  bool_and?: InputMaybe<_files_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<_files_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<_files_aggregate_bool_exp_count>;
};

export type _files_aggregate_bool_exp_bool_and = {
  arguments: _files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_files_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _files_aggregate_bool_exp_bool_or = {
  arguments: _files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_files_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _files_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_files_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_files_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "storage.files" */
export type _files_aggregate_order_by = {
  avg?: InputMaybe<_files_avg_order_by>;
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_files_max_order_by>;
  min?: InputMaybe<_files_min_order_by>;
  stddev?: InputMaybe<_files_stddev_order_by>;
  stddev_pop?: InputMaybe<_files_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<_files_stddev_samp_order_by>;
  sum?: InputMaybe<_files_sum_order_by>;
  var_pop?: InputMaybe<_files_var_pop_order_by>;
  var_samp?: InputMaybe<_files_var_samp_order_by>;
  variance?: InputMaybe<_files_variance_order_by>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type _files_arr_rel_insert_input = {
  data: Array<_files_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_files_on_conflict>;
};

/** order by avg() on columns of table "storage.files" */
export type _files_avg_order_by = {
  size?: InputMaybe<_order_by>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type _files_bool_exp = {
  _and?: InputMaybe<Array<_files_bool_exp>>;
  _not?: InputMaybe<_files_bool_exp>;
  _or?: InputMaybe<Array<_files_bool_exp>>;
  bucket?: InputMaybe<_buckets_bool_exp>;
  bucketId?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  etag?: InputMaybe<_String_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  isUploaded?: InputMaybe<_Boolean_comparison_exp>;
  mimeType?: InputMaybe<_String_comparison_exp>;
  name?: InputMaybe<_String_comparison_exp>;
  size?: InputMaybe<_Int_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
  uploadedByUserId?: InputMaybe<_uuid_comparison_exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum _files_constraint {
  /** unique or primary key constraint on columns "id" */
  files_pkey = "files_pkey",
}

/** input type for incrementing numeric columns in table "storage.files" */
export type _files_inc_input = {
  size?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.files" */
export type _files_insert_input = {
  bucket?: InputMaybe<_buckets_obj_rel_insert_input>;
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by max() on columns of table "storage.files" */
export type _files_max_order_by = {
  bucketId?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  etag?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  mimeType?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  size?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  uploadedByUserId?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "storage.files" */
export type _files_min_order_by = {
  bucketId?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  etag?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  mimeType?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  size?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  uploadedByUserId?: InputMaybe<_order_by>;
};

/** on_conflict condition type for table "storage.files" */
export type _files_on_conflict = {
  constraint: _files_constraint;
  update_columns?: Array<_files_update_column>;
  where?: InputMaybe<_files_bool_exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type _files_order_by = {
  bucket?: InputMaybe<_buckets_order_by>;
  bucketId?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  etag?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  isUploaded?: InputMaybe<_order_by>;
  mimeType?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  size?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  uploadedByUserId?: InputMaybe<_order_by>;
};

/** primary key columns input for table: storage.files */
export type _files_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** select columns of table "storage.files" */
export enum _files_select_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum _files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum _files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** input type for updating data in table "storage.files" */
export type _files_set_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by stddev() on columns of table "storage.files" */
export type _files_stddev_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type _files_stddev_pop_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type _files_stddev_samp_order_by = {
  size?: InputMaybe<_order_by>;
};

/** Streaming cursor of the table "files" */
export type _files_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _files_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _files_stream_cursor_value_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["_uuid"]>;
};

/** order by sum() on columns of table "storage.files" */
export type _files_sum_order_by = {
  size?: InputMaybe<_order_by>;
};

/** update columns of table "storage.files" */
export enum _files_update_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

export type _files_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_files_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_files_set_input>;
  where: _files_bool_exp;
};

/** order by var_pop() on columns of table "storage.files" */
export type _files_var_pop_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by var_samp() on columns of table "storage.files" */
export type _files_var_samp_order_by = {
  size?: InputMaybe<_order_by>;
};

/** order by variance() on columns of table "storage.files" */
export type _files_variance_order_by = {
  size?: InputMaybe<_order_by>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type _float8_comparison_exp = {
  _eq?: InputMaybe<Scalars["_float8"]>;
  _gt?: InputMaybe<Scalars["_float8"]>;
  _gte?: InputMaybe<Scalars["_float8"]>;
  _in?: InputMaybe<Array<Scalars["_float8"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_float8"]>;
  _lte?: InputMaybe<Scalars["_float8"]>;
  _neq?: InputMaybe<Scalars["_float8"]>;
  _nin?: InputMaybe<Array<Scalars["_float8"]>>;
};

export type _jsonb_cast_exp = {
  String?: InputMaybe<_String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type _jsonb_comparison_exp = {
  _cast?: InputMaybe<_jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars["_jsonb"]>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars["_jsonb"]>;
  _eq?: InputMaybe<Scalars["_jsonb"]>;
  _gt?: InputMaybe<Scalars["_jsonb"]>;
  _gte?: InputMaybe<Scalars["_jsonb"]>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars["String"]>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars["String"]>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars["String"]>>;
  _in?: InputMaybe<Array<Scalars["_jsonb"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_jsonb"]>;
  _lte?: InputMaybe<Scalars["_jsonb"]>;
  _neq?: InputMaybe<Scalars["_jsonb"]>;
  _nin?: InputMaybe<Array<Scalars["_jsonb"]>>;
};

/** column ordering options */
export enum _order_by {
  /** in ascending order, nulls last */
  asc = "asc",
  /** in ascending order, nulls first */
  asc_nulls_first = "asc_nulls_first",
  /** in ascending order, nulls last */
  asc_nulls_last = "asc_nulls_last",
  /** in descending order, nulls first */
  desc = "desc",
  /** in descending order, nulls first */
  desc_nulls_first = "desc_nulls_first",
  /** in descending order, nulls last */
  desc_nulls_last = "desc_nulls_last",
}

/** Boolean expression to filter rows from the table "revtron_companies". All fields are combined with a logical 'AND'. */
export type _revtron_companies_bool_exp = {
  _and?: InputMaybe<Array<_revtron_companies_bool_exp>>;
  _not?: InputMaybe<_revtron_companies_bool_exp>;
  _or?: InputMaybe<Array<_revtron_companies_bool_exp>>;
  address?: InputMaybe<_String_comparison_exp>;
  city?: InputMaybe<_String_comparison_exp>;
  country?: InputMaybe<_String_comparison_exp>;
  created_at?: InputMaybe<_timestamp_comparison_exp>;
  employee_counts?: InputMaybe<_bigint_comparison_exp>;
  founded_year?: InputMaybe<_Int_comparison_exp>;
  id?: InputMaybe<_Int_comparison_exp>;
  industry?: InputMaybe<_String_comparison_exp>;
  linkedin?: InputMaybe<_String_comparison_exp>;
  naics?: InputMaybe<_Int_comparison_exp>;
  name?: InputMaybe<_String_comparison_exp>;
  phone?: InputMaybe<_String_comparison_exp>;
  revenue?: InputMaybe<_bigint_comparison_exp>;
  state?: InputMaybe<_String_comparison_exp>;
  sub_industry?: InputMaybe<_String_comparison_exp>;
  ticker?: InputMaybe<_String_comparison_exp>;
  updated_at?: InputMaybe<_timestamp_comparison_exp>;
  website?: InputMaybe<_String_comparison_exp>;
  zip_code?: InputMaybe<_String_comparison_exp>;
};

/** unique or primary key constraints on table "revtron_companies" */
export enum _revtron_companies_constraint {
  /** unique or primary key constraint on columns "id" */
  revtron_account_pkey = "revtron_account_pkey",
  /** unique or primary key constraint on columns "website" */
  revtron_account_website_key = "revtron_account_website_key",
}

/** input type for incrementing numeric columns in table "revtron_companies" */
export type _revtron_companies_inc_input = {
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "revtron_companies" */
export type _revtron_companies_insert_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["_timestamp"]>;
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["_timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** on_conflict condition type for table "revtron_companies" */
export type _revtron_companies_on_conflict = {
  constraint: _revtron_companies_constraint;
  update_columns?: Array<_revtron_companies_update_column>;
  where?: InputMaybe<_revtron_companies_bool_exp>;
};

/** Ordering options when selecting data from "revtron_companies". */
export type _revtron_companies_order_by = {
  address?: InputMaybe<_order_by>;
  city?: InputMaybe<_order_by>;
  country?: InputMaybe<_order_by>;
  created_at?: InputMaybe<_order_by>;
  employee_counts?: InputMaybe<_order_by>;
  founded_year?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  industry?: InputMaybe<_order_by>;
  linkedin?: InputMaybe<_order_by>;
  naics?: InputMaybe<_order_by>;
  name?: InputMaybe<_order_by>;
  phone?: InputMaybe<_order_by>;
  revenue?: InputMaybe<_order_by>;
  state?: InputMaybe<_order_by>;
  sub_industry?: InputMaybe<_order_by>;
  ticker?: InputMaybe<_order_by>;
  updated_at?: InputMaybe<_order_by>;
  website?: InputMaybe<_order_by>;
  zip_code?: InputMaybe<_order_by>;
};

/** primary key columns input for table: revtron_companies */
export type _revtron_companies_pk_columns_input = {
  id: Scalars["Int"];
};

/** select columns of table "revtron_companies" */
export enum _revtron_companies_select_column {
  /** column name */
  address = "address",
  /** column name */
  city = "city",
  /** column name */
  country = "country",
  /** column name */
  created_at = "created_at",
  /** column name */
  employee_counts = "employee_counts",
  /** column name */
  founded_year = "founded_year",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  linkedin = "linkedin",
  /** column name */
  naics = "naics",
  /** column name */
  name = "name",
  /** column name */
  phone = "phone",
  /** column name */
  revenue = "revenue",
  /** column name */
  state = "state",
  /** column name */
  sub_industry = "sub_industry",
  /** column name */
  ticker = "ticker",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  website = "website",
  /** column name */
  zip_code = "zip_code",
}

/** input type for updating data in table "revtron_companies" */
export type _revtron_companies_set_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["_timestamp"]>;
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["_timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "revtron_companies" */
export type _revtron_companies_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _revtron_companies_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _revtron_companies_stream_cursor_value_input = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["_timestamp"]>;
  employee_counts?: InputMaybe<Scalars["_bigint"]>;
  founded_year?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["Int"]>;
  industry?: InputMaybe<Scalars["String"]>;
  linkedin?: InputMaybe<Scalars["String"]>;
  naics?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  revenue?: InputMaybe<Scalars["_bigint"]>;
  state?: InputMaybe<Scalars["String"]>;
  sub_industry?: InputMaybe<Scalars["String"]>;
  ticker?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["_timestamp"]>;
  website?: InputMaybe<Scalars["String"]>;
  zip_code?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "revtron_companies" */
export enum _revtron_companies_update_column {
  /** column name */
  address = "address",
  /** column name */
  city = "city",
  /** column name */
  country = "country",
  /** column name */
  created_at = "created_at",
  /** column name */
  employee_counts = "employee_counts",
  /** column name */
  founded_year = "founded_year",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  linkedin = "linkedin",
  /** column name */
  naics = "naics",
  /** column name */
  name = "name",
  /** column name */
  phone = "phone",
  /** column name */
  revenue = "revenue",
  /** column name */
  state = "state",
  /** column name */
  sub_industry = "sub_industry",
  /** column name */
  ticker = "ticker",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  website = "website",
  /** column name */
  zip_code = "zip_code",
}

export type _revtron_companies_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_revtron_companies_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_revtron_companies_set_input>;
  where: _revtron_companies_bool_exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type _timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars["_timestamp"]>;
  _gt?: InputMaybe<Scalars["_timestamp"]>;
  _gte?: InputMaybe<Scalars["_timestamp"]>;
  _in?: InputMaybe<Array<Scalars["_timestamp"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_timestamp"]>;
  _lte?: InputMaybe<Scalars["_timestamp"]>;
  _neq?: InputMaybe<Scalars["_timestamp"]>;
  _nin?: InputMaybe<Array<Scalars["_timestamp"]>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type _timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars["_timestamptz"]>;
  _gt?: InputMaybe<Scalars["_timestamptz"]>;
  _gte?: InputMaybe<Scalars["_timestamptz"]>;
  _in?: InputMaybe<Array<Scalars["_timestamptz"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_timestamptz"]>;
  _lte?: InputMaybe<Scalars["_timestamptz"]>;
  _neq?: InputMaybe<Scalars["_timestamptz"]>;
  _nin?: InputMaybe<Array<Scalars["_timestamptz"]>>;
};

export type _users_aggregate_bool_exp = {
  bool_and?: InputMaybe<_users_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<_users_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<_users_aggregate_bool_exp_count>;
};

export type _users_aggregate_bool_exp_bool_and = {
  arguments: _users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_users_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _users_aggregate_bool_exp_bool_or = {
  arguments: _users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_users_bool_exp>;
  predicate: _Boolean_comparison_exp;
};

export type _users_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<_users_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<_users_bool_exp>;
  predicate: _Int_comparison_exp;
};

/** order by aggregate values of table "auth.users" */
export type _users_aggregate_order_by = {
  count?: InputMaybe<_order_by>;
  max?: InputMaybe<_users_max_order_by>;
  min?: InputMaybe<_users_min_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type _users_append_input = {
  metadata?: InputMaybe<Scalars["_jsonb"]>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type _users_arr_rel_insert_input = {
  data: Array<_users_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<_users_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type _users_bool_exp = {
  _and?: InputMaybe<Array<_users_bool_exp>>;
  _not?: InputMaybe<_users_bool_exp>;
  _or?: InputMaybe<Array<_users_bool_exp>>;
  activeMfaType?: InputMaybe<_String_comparison_exp>;
  avatarUrl?: InputMaybe<_String_comparison_exp>;
  createdAt?: InputMaybe<_timestamptz_comparison_exp>;
  currentChallenge?: InputMaybe<_String_comparison_exp>;
  defaultRole?: InputMaybe<_String_comparison_exp>;
  defaultRoleByRole?: InputMaybe<_authRoles_bool_exp>;
  disabled?: InputMaybe<_Boolean_comparison_exp>;
  displayName?: InputMaybe<_String_comparison_exp>;
  email?: InputMaybe<_citext_comparison_exp>;
  emailVerified?: InputMaybe<_Boolean_comparison_exp>;
  id?: InputMaybe<_uuid_comparison_exp>;
  isAnonymous?: InputMaybe<_Boolean_comparison_exp>;
  lastSeen?: InputMaybe<_timestamptz_comparison_exp>;
  locale?: InputMaybe<_String_comparison_exp>;
  metadata?: InputMaybe<_jsonb_comparison_exp>;
  newEmail?: InputMaybe<_citext_comparison_exp>;
  otpHash?: InputMaybe<_String_comparison_exp>;
  otpHashExpiresAt?: InputMaybe<_timestamptz_comparison_exp>;
  otpMethodLastUsed?: InputMaybe<_String_comparison_exp>;
  passwordHash?: InputMaybe<_String_comparison_exp>;
  phoneNumber?: InputMaybe<_String_comparison_exp>;
  phoneNumberVerified?: InputMaybe<_Boolean_comparison_exp>;
  refreshTokens?: InputMaybe<_authRefreshTokens_bool_exp>;
  refreshTokens_aggregate?: InputMaybe<_authRefreshTokens_aggregate_bool_exp>;
  roles?: InputMaybe<_authUserRoles_bool_exp>;
  roles_aggregate?: InputMaybe<_authUserRoles_aggregate_bool_exp>;
  securityKeys?: InputMaybe<_authUserSecurityKeys_bool_exp>;
  securityKeys_aggregate?: InputMaybe<_authUserSecurityKeys_aggregate_bool_exp>;
  ticket?: InputMaybe<_String_comparison_exp>;
  ticketExpiresAt?: InputMaybe<_timestamptz_comparison_exp>;
  totpSecret?: InputMaybe<_String_comparison_exp>;
  updatedAt?: InputMaybe<_timestamptz_comparison_exp>;
  userProviders?: InputMaybe<_authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum _users_constraint {
  /** unique or primary key constraint on columns "email" */
  users_email_key = "users_email_key",
  /** unique or primary key constraint on columns "phone_number" */
  users_phone_number_key = "users_phone_number_key",
  /** unique or primary key constraint on columns "id" */
  users_pkey = "users_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type _users_delete_at_path_input = {
  metadata?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type _users_delete_elem_input = {
  metadata?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type _users_delete_key_input = {
  metadata?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.users" */
export type _users_insert_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  defaultRoleByRole?: InputMaybe<_authRoles_obj_rel_insert_input>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["_timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["_jsonb"]>;
  newEmail?: InputMaybe<Scalars["_citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  refreshTokens?: InputMaybe<_authRefreshTokens_arr_rel_insert_input>;
  roles?: InputMaybe<_authUserRoles_arr_rel_insert_input>;
  securityKeys?: InputMaybe<_authUserSecurityKeys_arr_rel_insert_input>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
  userProviders?: InputMaybe<_authUserProviders_arr_rel_insert_input>;
};

/** order by max() on columns of table "auth.users" */
export type _users_max_order_by = {
  activeMfaType?: InputMaybe<_order_by>;
  avatarUrl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  currentChallenge?: InputMaybe<_order_by>;
  defaultRole?: InputMaybe<_order_by>;
  displayName?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  lastSeen?: InputMaybe<_order_by>;
  locale?: InputMaybe<_order_by>;
  newEmail?: InputMaybe<_order_by>;
  otpHash?: InputMaybe<_order_by>;
  otpHashExpiresAt?: InputMaybe<_order_by>;
  otpMethodLastUsed?: InputMaybe<_order_by>;
  passwordHash?: InputMaybe<_order_by>;
  phoneNumber?: InputMaybe<_order_by>;
  ticket?: InputMaybe<_order_by>;
  ticketExpiresAt?: InputMaybe<_order_by>;
  totpSecret?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
};

/** order by min() on columns of table "auth.users" */
export type _users_min_order_by = {
  activeMfaType?: InputMaybe<_order_by>;
  avatarUrl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  currentChallenge?: InputMaybe<_order_by>;
  defaultRole?: InputMaybe<_order_by>;
  displayName?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  lastSeen?: InputMaybe<_order_by>;
  locale?: InputMaybe<_order_by>;
  newEmail?: InputMaybe<_order_by>;
  otpHash?: InputMaybe<_order_by>;
  otpHashExpiresAt?: InputMaybe<_order_by>;
  otpMethodLastUsed?: InputMaybe<_order_by>;
  passwordHash?: InputMaybe<_order_by>;
  phoneNumber?: InputMaybe<_order_by>;
  ticket?: InputMaybe<_order_by>;
  ticketExpiresAt?: InputMaybe<_order_by>;
  totpSecret?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type _users_obj_rel_insert_input = {
  data: _users_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<_users_on_conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type _users_on_conflict = {
  constraint: _users_constraint;
  update_columns?: Array<_users_update_column>;
  where?: InputMaybe<_users_bool_exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type _users_order_by = {
  activeMfaType?: InputMaybe<_order_by>;
  avatarUrl?: InputMaybe<_order_by>;
  createdAt?: InputMaybe<_order_by>;
  currentChallenge?: InputMaybe<_order_by>;
  defaultRole?: InputMaybe<_order_by>;
  defaultRoleByRole?: InputMaybe<_authRoles_order_by>;
  disabled?: InputMaybe<_order_by>;
  displayName?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  emailVerified?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
  isAnonymous?: InputMaybe<_order_by>;
  lastSeen?: InputMaybe<_order_by>;
  locale?: InputMaybe<_order_by>;
  metadata?: InputMaybe<_order_by>;
  newEmail?: InputMaybe<_order_by>;
  otpHash?: InputMaybe<_order_by>;
  otpHashExpiresAt?: InputMaybe<_order_by>;
  otpMethodLastUsed?: InputMaybe<_order_by>;
  passwordHash?: InputMaybe<_order_by>;
  phoneNumber?: InputMaybe<_order_by>;
  phoneNumberVerified?: InputMaybe<_order_by>;
  refreshTokens_aggregate?: InputMaybe<_authRefreshTokens_aggregate_order_by>;
  roles_aggregate?: InputMaybe<_authUserRoles_aggregate_order_by>;
  securityKeys_aggregate?: InputMaybe<_authUserSecurityKeys_aggregate_order_by>;
  ticket?: InputMaybe<_order_by>;
  ticketExpiresAt?: InputMaybe<_order_by>;
  totpSecret?: InputMaybe<_order_by>;
  updatedAt?: InputMaybe<_order_by>;
  userProviders_aggregate?: InputMaybe<_authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.users */
export type _users_pk_columns_input = {
  id: Scalars["_uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type _users_prepend_input = {
  metadata?: InputMaybe<Scalars["_jsonb"]>;
};

/** select columns of table "auth.users" */
export enum _users_select_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum _users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum _users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** input type for updating data in table "auth.users" */
export type _users_set_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["_timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["_jsonb"]>;
  newEmail?: InputMaybe<Scalars["_citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** Streaming cursor of the table "users" */
export type _users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _users_stream_cursor_value_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["_timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["_uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["_timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["_jsonb"]>;
  newEmail?: InputMaybe<Scalars["_citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["_timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["_timestamptz"]>;
};

/** update columns of table "auth.users" */
export enum _users_update_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

export type _users_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<_users_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<_users_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<_users_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<_users_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<_users_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_users_set_input>;
  where: _users_bool_exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type _uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars["_uuid"]>;
  _gt?: InputMaybe<Scalars["_uuid"]>;
  _gte?: InputMaybe<Scalars["_uuid"]>;
  _in?: InputMaybe<Array<Scalars["_uuid"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["_uuid"]>;
  _lte?: InputMaybe<Scalars["_uuid"]>;
  _neq?: InputMaybe<Scalars["_uuid"]>;
  _nin?: InputMaybe<Array<Scalars["_uuid"]>>;
};

/** Boolean expression to filter rows from the table "waitlist". All fields are combined with a logical 'AND'. */
export type _waitlist_bool_exp = {
  _and?: InputMaybe<Array<_waitlist_bool_exp>>;
  _not?: InputMaybe<_waitlist_bool_exp>;
  _or?: InputMaybe<Array<_waitlist_bool_exp>>;
  created_at?: InputMaybe<_timestamptz_comparison_exp>;
  email?: InputMaybe<_citext_comparison_exp>;
  id?: InputMaybe<_bigint_comparison_exp>;
};

/** unique or primary key constraints on table "waitlist" */
export enum _waitlist_constraint {
  /** unique or primary key constraint on columns "id" */
  waitlist_pkey = "waitlist_pkey",
}

/** input type for incrementing numeric columns in table "waitlist" */
export type _waitlist_inc_input = {
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** input type for inserting data into table "waitlist" */
export type _waitlist_insert_input = {
  created_at?: InputMaybe<Scalars["_timestamptz"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** on_conflict condition type for table "waitlist" */
export type _waitlist_on_conflict = {
  constraint: _waitlist_constraint;
  update_columns?: Array<_waitlist_update_column>;
  where?: InputMaybe<_waitlist_bool_exp>;
};

/** Ordering options when selecting data from "waitlist". */
export type _waitlist_order_by = {
  created_at?: InputMaybe<_order_by>;
  email?: InputMaybe<_order_by>;
  id?: InputMaybe<_order_by>;
};

/** primary key columns input for table: waitlist */
export type _waitlist_pk_columns_input = {
  id: Scalars["_bigint"];
};

/** select columns of table "waitlist" */
export enum _waitlist_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  email = "email",
  /** column name */
  id = "id",
}

/** input type for updating data in table "waitlist" */
export type _waitlist_set_input = {
  created_at?: InputMaybe<Scalars["_timestamptz"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** Streaming cursor of the table "waitlist" */
export type _waitlist_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: _waitlist_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<_cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _waitlist_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["_timestamptz"]>;
  email?: InputMaybe<Scalars["_citext"]>;
  id?: InputMaybe<Scalars["_bigint"]>;
};

/** update columns of table "waitlist" */
export enum _waitlist_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  email = "email",
  /** column name */
  id = "id",
}

export type _waitlist_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<_waitlist_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_waitlist_set_input>;
  where: _waitlist_bool_exp;
};

/** Boolean expression to filter rows from the table "account__c". All fields are combined with a logical 'AND'. */
export type account__c_bool_exp = {
  _and?: InputMaybe<Array<account__c_bool_exp>>;
  _not?: InputMaybe<account__c_bool_exp>;
  _or?: InputMaybe<Array<account__c_bool_exp>>;
  account_id__c?: InputMaybe<String_comparison_exp>;
  account_power_of_1__c?: InputMaybe<numeric_comparison_exp>;
  account_region__c?: InputMaybe<String_comparison_exp>;
  account_status_auto__c?: InputMaybe<String_comparison_exp>;
  account_type__c?: InputMaybe<String_comparison_exp>;
  accountnamelength__c?: InputMaybe<numeric_comparison_exp>;
  active__c?: InputMaybe<Boolean_comparison_exp>;
  active_accounts_14_days__c?: InputMaybe<numeric_comparison_exp>;
  active_employees__c?: InputMaybe<String_comparison_exp>;
  active_users__c?: InputMaybe<numeric_comparison_exp>;
  alternative_contact_email__c?: InputMaybe<String_comparison_exp>;
  alternative_contact_first_name__c?: InputMaybe<String_comparison_exp>;
  alternative_contact_last_name__c?: InputMaybe<String_comparison_exp>;
  alternative_contact_phone__c?: InputMaybe<String_comparison_exp>;
  alternative_email__c?: InputMaybe<String_comparison_exp>;
  alternative_mobile__c?: InputMaybe<String_comparison_exp>;
  alternative_phone__c?: InputMaybe<String_comparison_exp>;
  arr1__c?: InputMaybe<numeric_comparison_exp>;
  billing_deferral_date_updated__c?: InputMaybe<timestamp_comparison_exp>;
  billing_status__c?: InputMaybe<String_comparison_exp>;
  billing_trading_notes__c?: InputMaybe<String_comparison_exp>;
  bizsys_application_tracking_system__c?: InputMaybe<String_comparison_exp>;
  bizsys_business_intelligence__c?: InputMaybe<String_comparison_exp>;
  bizsys_employee_management__c?: InputMaybe<String_comparison_exp>;
  bizsys_enterprise_solutions__c?: InputMaybe<String_comparison_exp>;
  bizsys_hcm__c?: InputMaybe<String_comparison_exp>;
  bizsys_interviewer_system__c?: InputMaybe<String_comparison_exp>;
  bizsys_inventory_invoicing__c?: InputMaybe<String_comparison_exp>;
  bizsys_job_board_listing__c?: InputMaybe<String_comparison_exp>;
  bizsys_learning_management_system__c?: InputMaybe<String_comparison_exp>;
  bizsys_onboarding__c?: InputMaybe<String_comparison_exp>;
  bizsys_payroll__c?: InputMaybe<String_comparison_exp>;
  bizsys_point_of_sale_system__c?: InputMaybe<String_comparison_exp>;
  bizsys_recruitment_marketing__c?: InputMaybe<String_comparison_exp>;
  bizsys_scheduler_system__c?: InputMaybe<String_comparison_exp>;
  bizsys_texting__c?: InputMaybe<String_comparison_exp>;
  bizsys_time_attendance_system__c?: InputMaybe<String_comparison_exp>;
  bizsys_zoominfo_tech_stack__c?: InputMaybe<String_comparison_exp>;
  brand_id__c?: InputMaybe<numeric_comparison_exp>;
  brand_intel__c?: InputMaybe<String_comparison_exp>;
  bu__c?: InputMaybe<String_comparison_exp>;
  bu_long_name__c?: InputMaybe<String_comparison_exp>;
  bu_short_name__c?: InputMaybe<String_comparison_exp>;
  case_owner__c?: InputMaybe<String_comparison_exp>;
  categorical_priority__c?: InputMaybe<String_comparison_exp>;
  check__c?: InputMaybe<Boolean_comparison_exp>;
  churn_date__c?: InputMaybe<timestamp_comparison_exp>;
  churn_details__c?: InputMaybe<String_comparison_exp>;
  churn_reason__c?: InputMaybe<String_comparison_exp>;
  churn_reason_old__c?: InputMaybe<String_comparison_exp>;
  churn_sub_reason__c?: InputMaybe<String_comparison_exp>;
  churned__c?: InputMaybe<Boolean_comparison_exp>;
  churned_cmrr__c?: InputMaybe<numeric_comparison_exp>;
  churned_to__c?: InputMaybe<String_comparison_exp>;
  city__c?: InputMaybe<String_comparison_exp>;
  commission_rules_of_engagement_exception__c?: InputMaybe<Boolean_comparison_exp>;
  concept_type__c?: InputMaybe<String_comparison_exp>;
  concepts__c?: InputMaybe<String_comparison_exp>;
  contact__c?: InputMaybe<String_comparison_exp>;
  contact_name__c?: InputMaybe<String_comparison_exp>;
  contact_phone__c?: InputMaybe<String_comparison_exp>;
  contracted_services__c?: InputMaybe<String_comparison_exp>;
  contracted_training_sessions__c?: InputMaybe<numeric_comparison_exp>;
  covid__c?: InputMaybe<Boolean_comparison_exp>;
  created_date__c?: InputMaybe<timestamp_comparison_exp>;
  cs_owner__c?: InputMaybe<String_comparison_exp>;
  cs_owner_text__c?: InputMaybe<String_comparison_exp>;
  csat__c?: InputMaybe<String_comparison_exp>;
  csat_last_updated__c?: InputMaybe<timestamp_comparison_exp>;
  current_contracted_employees__c?: InputMaybe<numeric_comparison_exp>;
  current_contracted_locations__c?: InputMaybe<numeric_comparison_exp>;
  custom_status__c?: InputMaybe<String_comparison_exp>;
  customer__c?: InputMaybe<Boolean_comparison_exp>;
  customer_health_rating__c?: InputMaybe<String_comparison_exp>;
  customer_health_ryg__c?: InputMaybe<String_comparison_exp>;
  customer_lifecycle_status__c?: InputMaybe<String_comparison_exp>;
  customer_satisfaction_ryg__c?: InputMaybe<String_comparison_exp>;
  customer_status__c?: InputMaybe<String_comparison_exp>;
  customer_success_owner__c?: InputMaybe<String_comparison_exp>;
  customer_support__c?: InputMaybe<String_comparison_exp>;
  customization__c?: InputMaybe<String_comparison_exp>;
  data_quality_description__c?: InputMaybe<String_comparison_exp>;
  data_quality_score__c?: InputMaybe<numeric_comparison_exp>;
  date_of_last_check_in__c?: InputMaybe<timestamp_comparison_exp>;
  date_of_next_account_review__c?: InputMaybe<timestamp_comparison_exp>;
  different__c?: InputMaybe<Boolean_comparison_exp>;
  different_ids__c?: InputMaybe<Boolean_comparison_exp>;
  doors__c?: InputMaybe<numeric_comparison_exp>;
  dozisf__zoominfo_enrich_status__c?: InputMaybe<String_comparison_exp>;
  dozisf__zoominfo_first_updated__c?: InputMaybe<timestamp_comparison_exp>;
  dozisf__zoominfo_id__c?: InputMaybe<String_comparison_exp>;
  dozisf__zoominfo_last_updated__c?: InputMaybe<timestamp_comparison_exp>;
  email__c?: InputMaybe<String_comparison_exp>;
  employer_location_id__c?: InputMaybe<numeric_comparison_exp>;
  end_date__c?: InputMaybe<timestamp_comparison_exp>;
  estimated_contract_value__c?: InputMaybe<numeric_comparison_exp>;
  fair_workweek__c?: InputMaybe<Boolean_comparison_exp>;
  field_office__c?: InputMaybe<String_comparison_exp>;
  fin_fortune_1000_rank__c?: InputMaybe<numeric_comparison_exp>;
  fin_location_size__c?: InputMaybe<numeric_comparison_exp>;
  fin_location_size_accuracy__c?: InputMaybe<String_comparison_exp>;
  fin_location_size_unit_of_measure__c?: InputMaybe<String_comparison_exp>;
  fin_prior_year_revenue__c?: InputMaybe<numeric_comparison_exp>;
  fin_prior_yr_employees__c?: InputMaybe<numeric_comparison_exp>;
  fin_s_p_500__c?: InputMaybe<String_comparison_exp>;
  focus_accounts__c?: InputMaybe<Boolean_comparison_exp>;
  focus_accounts_open_opps__c?: InputMaybe<String_comparison_exp>;
  for_finance__c?: InputMaybe<Boolean_comparison_exp>;
  franchise_brands__c?: InputMaybe<String_comparison_exp>;
  franchise_name__c?: InputMaybe<String_comparison_exp>;
  franchisee__c?: InputMaybe<Boolean_comparison_exp>;
  franchisor__c?: InputMaybe<Boolean_comparison_exp>;
  franshisee__c?: InputMaybe<Boolean_comparison_exp>;
  frozen__c?: InputMaybe<Boolean_comparison_exp>;
  generated_address__c?: InputMaybe<String_comparison_exp>;
  gong__gong_count__c?: InputMaybe<numeric_comparison_exp>;
  google_analytics_campaign__c?: InputMaybe<String_comparison_exp>;
  google_analytics_content__c?: InputMaybe<String_comparison_exp>;
  google_analytics_medium__c?: InputMaybe<String_comparison_exp>;
  google_analytics_source__c?: InputMaybe<String_comparison_exp>;
  google_analytics_term__c?: InputMaybe<String_comparison_exp>;
  group_id__c?: InputMaybe<String_comparison_exp>;
  harri_api_enabled__c?: InputMaybe<Boolean_comparison_exp>;
  harri_brand_type__c?: InputMaybe<String_comparison_exp>;
  harri_client_id__c?: InputMaybe<numeric_comparison_exp>;
  harri_employees_per_brand__c?: InputMaybe<numeric_comparison_exp>;
  harri_locations_count__c?: InputMaybe<numeric_comparison_exp>;
  harri_profile_created__c?: InputMaybe<Boolean_comparison_exp>;
  harri_strategic_sponsor_name__c?: InputMaybe<String_comparison_exp>;
  harri_subscription_status__c?: InputMaybe<String_comparison_exp>;
  harri_user_id__c?: InputMaybe<numeric_comparison_exp>;
  hecs_brands_type__c?: InputMaybe<String_comparison_exp>;
  hecs_category__c?: InputMaybe<String_comparison_exp>;
  hecs_owner_type__c?: InputMaybe<String_comparison_exp>;
  hot_button_feature__c?: InputMaybe<String_comparison_exp>;
  house_account__c?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  ignore__c?: InputMaybe<String_comparison_exp>;
  include__c?: InputMaybe<Boolean_comparison_exp>;
  industry__c?: InputMaybe<String_comparison_exp>;
  industry_category__c?: InputMaybe<String_comparison_exp>;
  inserted_from_system__c?: InputMaybe<String_comparison_exp>;
  is_yesterday__c?: InputMaybe<Boolean_comparison_exp>;
  job_distributor__c?: InputMaybe<String_comparison_exp>;
  job_distributor_details__c?: InputMaybe<String_comparison_exp>;
  job_post__c?: InputMaybe<String_comparison_exp>;
  kick_start__c?: InputMaybe<Boolean_comparison_exp>;
  last_activity__c?: InputMaybe<timestamp_comparison_exp>;
  last_check_in_comments__c?: InputMaybe<String_comparison_exp>;
  last_job_post_date__c?: InputMaybe<timestamp_comparison_exp>;
  last_new_sale_close_date__c?: InputMaybe<timestamp_comparison_exp>;
  last_new_sale_subscription_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  last_scheduled_publish_date__c?: InputMaybe<timestamp_comparison_exp>;
  latest_csat_nps_overall_experience__c?: InputMaybe<numeric_comparison_exp>;
  latest_csat_overall_nps_rating__c?: InputMaybe<String_comparison_exp>;
  latest_customer_satisfaction_rating__c?: InputMaybe<String_comparison_exp>;
  latest_customer_satisfaction_survey__c?: InputMaybe<numeric_comparison_exp>;
  latest_fran__c?: InputMaybe<String_comparison_exp>;
  legacy_id__c?: InputMaybe<String_comparison_exp>;
  legacy_parent_id__c?: InputMaybe<String_comparison_exp>;
  lid__linkedin_company_id__c?: InputMaybe<String_comparison_exp>;
  link_to_sim_form__c?: InputMaybe<String_comparison_exp>;
  live_services__c?: InputMaybe<String_comparison_exp>;
  locations__c?: InputMaybe<numeric_comparison_exp>;
  locations_billed__c?: InputMaybe<numeric_comparison_exp>;
  locations_in_harri__c?: InputMaybe<numeric_comparison_exp>;
  luke_vip__c?: InputMaybe<Boolean_comparison_exp>;
  macro_text__c?: InputMaybe<String_comparison_exp>;
  macro_themes__c?: InputMaybe<String_comparison_exp>;
  mainfranchiserhq__c?: InputMaybe<Boolean_comparison_exp>;
  mcd_operator_name__c?: InputMaybe<String_comparison_exp>;
  mcdonald_s_governance__c?: InputMaybe<Boolean_comparison_exp>;
  micro_text__c?: InputMaybe<String_comparison_exp>;
  micro_themes__c?: InputMaybe<String_comparison_exp>;
  missed_orientation__c?: InputMaybe<Boolean_comparison_exp>;
  mktg_harri_partnership__c?: InputMaybe<String_comparison_exp>;
  mktg_harri_partnership_adp_q1__c?: InputMaybe<String_comparison_exp>;
  mktg_harri_partnership_adp_q2__c?: InputMaybe<String_comparison_exp>;
  mktg_sales_channel__c?: InputMaybe<String_comparison_exp>;
  mktg_time_zone__c?: InputMaybe<String_comparison_exp>;
  most_recent_close_date_for_renewal_opp__c?: InputMaybe<timestamp_comparison_exp>;
  mrr_from_gl_12_19__c?: InputMaybe<numeric_comparison_exp>;
  multi_type__c?: InputMaybe<String_comparison_exp>;
  naive_bayes__c?: InputMaybe<numeric_comparison_exp>;
  net_promoter_comment__c?: InputMaybe<String_comparison_exp>;
  new_mrr_2020__c?: InputMaybe<numeric_comparison_exp>;
  no_of_closed_opp__c?: InputMaybe<numeric_comparison_exp>;
  no_of_open_opp__c?: InputMaybe<numeric_comparison_exp>;
  no_of_opportunities__c?: InputMaybe<numeric_comparison_exp>;
  no_outbound__c?: InputMaybe<Boolean_comparison_exp>;
  notes__c?: InputMaybe<String_comparison_exp>;
  november_2021_current_invoice__c?: InputMaybe<numeric_comparison_exp>;
  nps__c?: InputMaybe<String_comparison_exp>;
  nps_last_updated__c?: InputMaybe<timestamp_comparison_exp>;
  num_closed_opps__c?: InputMaybe<numeric_comparison_exp>;
  number_of_job_postings__c?: InputMaybe<numeric_comparison_exp>;
  number_of_valid_end_dates__c?: InputMaybe<numeric_comparison_exp>;
  of_won_opp__c?: InputMaybe<numeric_comparison_exp>;
  omis_account_id__c?: InputMaybe<String_comparison_exp>;
  omis_door_id__c?: InputMaybe<String_comparison_exp>;
  omis_rating__c?: InputMaybe<String_comparison_exp>;
  omis_score__c?: InputMaybe<String_comparison_exp>;
  onboarding__c?: InputMaybe<Boolean_comparison_exp>;
  open_opportunity_tag__c?: InputMaybe<Boolean_comparison_exp>;
  operating_structure_2__c?: InputMaybe<String_comparison_exp>;
  operational_structure__c?: InputMaybe<String_comparison_exp>;
  orientation_conducted_by__c?: InputMaybe<String_comparison_exp>;
  orientation_contact__c?: InputMaybe<String_comparison_exp>;
  orientation_date__c?: InputMaybe<timestamp_comparison_exp>;
  other_credentials__c?: InputMaybe<String_comparison_exp>;
  outreach_url__c?: InputMaybe<String_comparison_exp>;
  overall_customer_health__c?: InputMaybe<String_comparison_exp>;
  papa_johns__c?: InputMaybe<Boolean_comparison_exp>;
  parent_id__c?: InputMaybe<numeric_comparison_exp>;
  partner_type__c?: InputMaybe<String_comparison_exp>;
  payroll_integration__c?: InputMaybe<String_comparison_exp>;
  payroll_owner__c?: InputMaybe<String_comparison_exp>;
  payroll_owner_text__c?: InputMaybe<String_comparison_exp>;
  payroll_owner_uk_payroll__c?: InputMaybe<String_comparison_exp>;
  payroll_vendor__c?: InputMaybe<String_comparison_exp>;
  pe_influence__c?: InputMaybe<String_comparison_exp>;
  percent_franchised__c?: InputMaybe<String_comparison_exp>;
  pos__c?: InputMaybe<String_comparison_exp>;
  pos_vendor__c?: InputMaybe<String_comparison_exp>;
  predict_proba__c?: InputMaybe<numeric_comparison_exp>;
  primarycontact2__c?: InputMaybe<String_comparison_exp>;
  product_bucket__c?: InputMaybe<String_comparison_exp>;
  prospect_or_customer__c?: InputMaybe<String_comparison_exp>;
  publiccorp__c?: InputMaybe<Boolean_comparison_exp>;
  purchasing_power__c?: InputMaybe<String_comparison_exp>;
  quickbooks_last_invoice__c?: InputMaybe<numeric_comparison_exp>;
  quickbooks_last_invoice_date__c?: InputMaybe<timestamp_comparison_exp>;
  quickbooks_total_balance__c?: InputMaybe<numeric_comparison_exp>;
  random_forest__c?: InputMaybe<numeric_comparison_exp>;
  reference_1__c?: InputMaybe<String_comparison_exp>;
  reference_2__c?: InputMaybe<String_comparison_exp>;
  reference__c?: InputMaybe<String_comparison_exp>;
  root_brand_id__c?: InputMaybe<String_comparison_exp>;
  root_brand_type__c?: InputMaybe<String_comparison_exp>;
  rootid__c?: InputMaybe<String_comparison_exp>;
  ropackage__acctupdateindex__c?: InputMaybe<String_comparison_exp>;
  ropackage__createdbyrestaurantology__c?: InputMaybe<Boolean_comparison_exp>;
  ropackage__known_for__c?: InputMaybe<String_comparison_exp>;
  ropackage__latest_restaurantology_tech_data__c?: InputMaybe<String_comparison_exp>;
  ropackage__parent_restaurantology_internal_id__c?: InputMaybe<String_comparison_exp>;
  ropackage__reconnlogindex__c?: InputMaybe<String_comparison_exp>;
  ropackage__restaurantology_internal_id__c?: InputMaybe<String_comparison_exp>;
  ropackage__roalphaname__c?: InputMaybe<String_comparison_exp>;
  ropackage__rocleaneddomain__c?: InputMaybe<String_comparison_exp>;
  ropackage__service_type__c?: InputMaybe<String_comparison_exp>;
  ropackage__total_locations_overall__c?: InputMaybe<numeric_comparison_exp>;
  sales_priority_tier__c?: InputMaybe<String_comparison_exp>;
  sales_territory__c?: InputMaybe<String_comparison_exp>;
  sdr_owner__c?: InputMaybe<String_comparison_exp>;
  secondary_customer_success_manager__c?: InputMaybe<String_comparison_exp>;
  segment__c?: InputMaybe<String_comparison_exp>;
  service_type__c?: InputMaybe<String_comparison_exp>;
  sim_form_ready__c?: InputMaybe<String_comparison_exp>;
  sim_form_ready_date__c?: InputMaybe<timestamp_comparison_exp>;
  sim_form_start_date__c?: InputMaybe<timestamp_comparison_exp>;
  sim_form_team_member__c?: InputMaybe<String_comparison_exp>;
  size__c?: InputMaybe<String_comparison_exp>;
  slug__c?: InputMaybe<String_comparison_exp>;
  social_facebook_company_profile__c?: InputMaybe<String_comparison_exp>;
  social_instagram_company_profile__c?: InputMaybe<String_comparison_exp>;
  social_linkedin_company_profile__c?: InputMaybe<String_comparison_exp>;
  social_pinterest_company_profile__c?: InputMaybe<String_comparison_exp>;
  social_tripadvisor_company_profile__c?: InputMaybe<String_comparison_exp>;
  social_twitter_company_profile__c?: InputMaybe<String_comparison_exp>;
  social_yelp_company_profile__c?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  standard_documents__c?: InputMaybe<String_comparison_exp>;
  strategic_account__c?: InputMaybe<Boolean_comparison_exp>;
  stripe_ids__c?: InputMaybe<String_comparison_exp>;
  structure_file__c?: InputMaybe<String_comparison_exp>;
  su_training_date__c?: InputMaybe<timestamp_comparison_exp>;
  sub_industry__c?: InputMaybe<String_comparison_exp>;
  systemstructurelookup__c?: InputMaybe<String_comparison_exp>;
  target_status__c?: InputMaybe<String_comparison_exp>;
  target_tier__c?: InputMaybe<String_comparison_exp>;
  total_cmrr_all_opportunities__c?: InputMaybe<numeric_comparison_exp>;
  total_cmrr_won_opportunities__c?: InputMaybe<numeric_comparison_exp>;
  total_current_cmrr__c?: InputMaybe<numeric_comparison_exp>;
  trading_states__c?: InputMaybe<String_comparison_exp>;
  trading_status__c?: InputMaybe<String_comparison_exp>;
  training_sessions_complete__c?: InputMaybe<numeric_comparison_exp>;
  type2__c?: InputMaybe<String_comparison_exp>;
  type_of_business__c?: InputMaybe<String_comparison_exp>;
  uniquebrandco__c?: InputMaybe<Boolean_comparison_exp>;
  uniqueid__c?: InputMaybe<String_comparison_exp>;
  unit_intel__c?: InputMaybe<String_comparison_exp>;
  up__district__c?: InputMaybe<String_comparison_exp>;
  up__region__c?: InputMaybe<String_comparison_exp>;
  up__territory__c?: InputMaybe<String_comparison_exp>;
  upsell_items__c?: InputMaybe<String_comparison_exp>;
  upsell_notes__c?: InputMaybe<String_comparison_exp>;
  upsell_potential__c?: InputMaybe<String_comparison_exp>;
  url__c?: InputMaybe<String_comparison_exp>;
  url_of_account_review_notes__c?: InputMaybe<String_comparison_exp>;
  users__c?: InputMaybe<numeric_comparison_exp>;
  web_client_only__c?: InputMaybe<Boolean_comparison_exp>;
  workpop_lead__c?: InputMaybe<Boolean_comparison_exp>;
  yelp__c?: InputMaybe<String_comparison_exp>;
  zendesk_id__c?: InputMaybe<String_comparison_exp>;
  zisf__company_id__c?: InputMaybe<String_comparison_exp>;
  zisf__zoom_clean_status__c?: InputMaybe<String_comparison_exp>;
  zisf__zoom_id__c?: InputMaybe<String_comparison_exp>;
  zisf__zoom_lastupdated__c?: InputMaybe<timestamp_comparison_exp>;
  zisf__zoominfo_complete_status__c?: InputMaybe<String_comparison_exp>;
  zisf__zoominfo_industry__c?: InputMaybe<String_comparison_exp>;
  zisf__zoominfo_last_clean_run__c?: InputMaybe<timestamp_comparison_exp>;
};

/** input type for incrementing numeric columns in table "account__c" */
export type account__c_inc_input = {
  account_power_of_1__c?: InputMaybe<Scalars["numeric"]>;
  accountnamelength__c?: InputMaybe<Scalars["numeric"]>;
  active_accounts_14_days__c?: InputMaybe<Scalars["numeric"]>;
  active_users__c?: InputMaybe<Scalars["numeric"]>;
  arr1__c?: InputMaybe<Scalars["numeric"]>;
  brand_id__c?: InputMaybe<Scalars["numeric"]>;
  churned_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  contracted_training_sessions__c?: InputMaybe<Scalars["numeric"]>;
  current_contracted_employees__c?: InputMaybe<Scalars["numeric"]>;
  current_contracted_locations__c?: InputMaybe<Scalars["numeric"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  doors__c?: InputMaybe<Scalars["numeric"]>;
  employer_location_id__c?: InputMaybe<Scalars["numeric"]>;
  estimated_contract_value__c?: InputMaybe<Scalars["numeric"]>;
  fin_fortune_1000_rank__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size__c?: InputMaybe<Scalars["numeric"]>;
  fin_prior_year_revenue__c?: InputMaybe<Scalars["numeric"]>;
  fin_prior_yr_employees__c?: InputMaybe<Scalars["numeric"]>;
  gong__gong_count__c?: InputMaybe<Scalars["numeric"]>;
  harri_client_id__c?: InputMaybe<Scalars["numeric"]>;
  harri_employees_per_brand__c?: InputMaybe<Scalars["numeric"]>;
  harri_locations_count__c?: InputMaybe<Scalars["numeric"]>;
  harri_user_id__c?: InputMaybe<Scalars["numeric"]>;
  latest_csat_nps_overall_experience__c?: InputMaybe<Scalars["numeric"]>;
  latest_customer_satisfaction_survey__c?: InputMaybe<Scalars["numeric"]>;
  locations__c?: InputMaybe<Scalars["numeric"]>;
  locations_billed__c?: InputMaybe<Scalars["numeric"]>;
  locations_in_harri__c?: InputMaybe<Scalars["numeric"]>;
  mrr_from_gl_12_19__c?: InputMaybe<Scalars["numeric"]>;
  naive_bayes__c?: InputMaybe<Scalars["numeric"]>;
  new_mrr_2020__c?: InputMaybe<Scalars["numeric"]>;
  no_of_closed_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_open_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  november_2021_current_invoice__c?: InputMaybe<Scalars["numeric"]>;
  num_closed_opps__c?: InputMaybe<Scalars["numeric"]>;
  number_of_job_postings__c?: InputMaybe<Scalars["numeric"]>;
  number_of_valid_end_dates__c?: InputMaybe<Scalars["numeric"]>;
  of_won_opp__c?: InputMaybe<Scalars["numeric"]>;
  parent_id__c?: InputMaybe<Scalars["numeric"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  quickbooks_last_invoice__c?: InputMaybe<Scalars["numeric"]>;
  quickbooks_total_balance__c?: InputMaybe<Scalars["numeric"]>;
  random_forest__c?: InputMaybe<Scalars["numeric"]>;
  ropackage__total_locations_overall__c?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  total_cmrr_all_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_cmrr_won_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_current_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  training_sessions_complete__c?: InputMaybe<Scalars["numeric"]>;
  users__c?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "account__c" */
export type account__c_insert_input = {
  account_id__c?: InputMaybe<Scalars["String"]>;
  account_power_of_1__c?: InputMaybe<Scalars["numeric"]>;
  account_region__c?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  account_type__c?: InputMaybe<Scalars["String"]>;
  accountnamelength__c?: InputMaybe<Scalars["numeric"]>;
  active__c?: InputMaybe<Scalars["Boolean"]>;
  active_accounts_14_days__c?: InputMaybe<Scalars["numeric"]>;
  active_employees__c?: InputMaybe<Scalars["String"]>;
  active_users__c?: InputMaybe<Scalars["numeric"]>;
  alternative_contact_email__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_first_name__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_last_name__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_phone__c?: InputMaybe<Scalars["String"]>;
  alternative_email__c?: InputMaybe<Scalars["String"]>;
  alternative_mobile__c?: InputMaybe<Scalars["String"]>;
  alternative_phone__c?: InputMaybe<Scalars["String"]>;
  arr1__c?: InputMaybe<Scalars["numeric"]>;
  billing_deferral_date_updated__c?: InputMaybe<Scalars["timestamp"]>;
  billing_status__c?: InputMaybe<Scalars["String"]>;
  billing_trading_notes__c?: InputMaybe<Scalars["String"]>;
  bizsys_application_tracking_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_business_intelligence__c?: InputMaybe<Scalars["String"]>;
  bizsys_employee_management__c?: InputMaybe<Scalars["String"]>;
  bizsys_enterprise_solutions__c?: InputMaybe<Scalars["String"]>;
  bizsys_hcm__c?: InputMaybe<Scalars["String"]>;
  bizsys_interviewer_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_inventory_invoicing__c?: InputMaybe<Scalars["String"]>;
  bizsys_job_board_listing__c?: InputMaybe<Scalars["String"]>;
  bizsys_learning_management_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_onboarding__c?: InputMaybe<Scalars["String"]>;
  bizsys_payroll__c?: InputMaybe<Scalars["String"]>;
  bizsys_point_of_sale_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_recruitment_marketing__c?: InputMaybe<Scalars["String"]>;
  bizsys_scheduler_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_texting__c?: InputMaybe<Scalars["String"]>;
  bizsys_time_attendance_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_zoominfo_tech_stack__c?: InputMaybe<Scalars["String"]>;
  brand_id__c?: InputMaybe<Scalars["numeric"]>;
  brand_intel__c?: InputMaybe<Scalars["String"]>;
  bu__c?: InputMaybe<Scalars["String"]>;
  bu_long_name__c?: InputMaybe<Scalars["String"]>;
  bu_short_name__c?: InputMaybe<Scalars["String"]>;
  case_owner__c?: InputMaybe<Scalars["String"]>;
  categorical_priority__c?: InputMaybe<Scalars["String"]>;
  check__c?: InputMaybe<Scalars["Boolean"]>;
  churn_date__c?: InputMaybe<Scalars["timestamp"]>;
  churn_details__c?: InputMaybe<Scalars["String"]>;
  churn_reason__c?: InputMaybe<Scalars["String"]>;
  churn_reason_old__c?: InputMaybe<Scalars["String"]>;
  churn_sub_reason__c?: InputMaybe<Scalars["String"]>;
  churned__c?: InputMaybe<Scalars["Boolean"]>;
  churned_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  churned_to__c?: InputMaybe<Scalars["String"]>;
  city__c?: InputMaybe<Scalars["String"]>;
  commission_rules_of_engagement_exception__c?: InputMaybe<Scalars["Boolean"]>;
  concept_type__c?: InputMaybe<Scalars["String"]>;
  concepts__c?: InputMaybe<Scalars["String"]>;
  contact__c?: InputMaybe<Scalars["String"]>;
  contact_name__c?: InputMaybe<Scalars["String"]>;
  contact_phone__c?: InputMaybe<Scalars["String"]>;
  contracted_services__c?: InputMaybe<Scalars["String"]>;
  contracted_training_sessions__c?: InputMaybe<Scalars["numeric"]>;
  covid__c?: InputMaybe<Scalars["Boolean"]>;
  created_date__c?: InputMaybe<Scalars["timestamp"]>;
  cs_owner__c?: InputMaybe<Scalars["String"]>;
  cs_owner_text__c?: InputMaybe<Scalars["String"]>;
  csat__c?: InputMaybe<Scalars["String"]>;
  csat_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  current_contracted_employees__c?: InputMaybe<Scalars["numeric"]>;
  current_contracted_locations__c?: InputMaybe<Scalars["numeric"]>;
  custom_status__c?: InputMaybe<Scalars["String"]>;
  customer__c?: InputMaybe<Scalars["Boolean"]>;
  customer_health_rating__c?: InputMaybe<Scalars["String"]>;
  customer_health_ryg__c?: InputMaybe<Scalars["String"]>;
  customer_lifecycle_status__c?: InputMaybe<Scalars["String"]>;
  customer_satisfaction_ryg__c?: InputMaybe<Scalars["String"]>;
  customer_status__c?: InputMaybe<Scalars["String"]>;
  customer_success_owner__c?: InputMaybe<Scalars["String"]>;
  customer_support__c?: InputMaybe<Scalars["String"]>;
  customization__c?: InputMaybe<Scalars["String"]>;
  data_quality_description__c?: InputMaybe<Scalars["String"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  date_of_last_check_in__c?: InputMaybe<Scalars["timestamp"]>;
  date_of_next_account_review__c?: InputMaybe<Scalars["timestamp"]>;
  different__c?: InputMaybe<Scalars["Boolean"]>;
  different_ids__c?: InputMaybe<Scalars["Boolean"]>;
  doors__c?: InputMaybe<Scalars["numeric"]>;
  dozisf__zoominfo_enrich_status__c?: InputMaybe<Scalars["String"]>;
  dozisf__zoominfo_first_updated__c?: InputMaybe<Scalars["timestamp"]>;
  dozisf__zoominfo_id__c?: InputMaybe<Scalars["String"]>;
  dozisf__zoominfo_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  email__c?: InputMaybe<Scalars["String"]>;
  employer_location_id__c?: InputMaybe<Scalars["numeric"]>;
  end_date__c?: InputMaybe<Scalars["timestamp"]>;
  estimated_contract_value__c?: InputMaybe<Scalars["numeric"]>;
  fair_workweek__c?: InputMaybe<Scalars["Boolean"]>;
  field_office__c?: InputMaybe<Scalars["String"]>;
  fin_fortune_1000_rank__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size_accuracy__c?: InputMaybe<Scalars["String"]>;
  fin_location_size_unit_of_measure__c?: InputMaybe<Scalars["String"]>;
  fin_prior_year_revenue__c?: InputMaybe<Scalars["numeric"]>;
  fin_prior_yr_employees__c?: InputMaybe<Scalars["numeric"]>;
  fin_s_p_500__c?: InputMaybe<Scalars["String"]>;
  focus_accounts__c?: InputMaybe<Scalars["Boolean"]>;
  focus_accounts_open_opps__c?: InputMaybe<Scalars["String"]>;
  for_finance__c?: InputMaybe<Scalars["Boolean"]>;
  franchise_brands__c?: InputMaybe<Scalars["String"]>;
  franchise_name__c?: InputMaybe<Scalars["String"]>;
  franchisee__c?: InputMaybe<Scalars["Boolean"]>;
  franchisor__c?: InputMaybe<Scalars["Boolean"]>;
  franshisee__c?: InputMaybe<Scalars["Boolean"]>;
  frozen__c?: InputMaybe<Scalars["Boolean"]>;
  generated_address__c?: InputMaybe<Scalars["String"]>;
  gong__gong_count__c?: InputMaybe<Scalars["numeric"]>;
  google_analytics_campaign__c?: InputMaybe<Scalars["String"]>;
  google_analytics_content__c?: InputMaybe<Scalars["String"]>;
  google_analytics_medium__c?: InputMaybe<Scalars["String"]>;
  google_analytics_source__c?: InputMaybe<Scalars["String"]>;
  google_analytics_term__c?: InputMaybe<Scalars["String"]>;
  group_id__c?: InputMaybe<Scalars["String"]>;
  harri_api_enabled__c?: InputMaybe<Scalars["Boolean"]>;
  harri_brand_type__c?: InputMaybe<Scalars["String"]>;
  harri_client_id__c?: InputMaybe<Scalars["numeric"]>;
  harri_employees_per_brand__c?: InputMaybe<Scalars["numeric"]>;
  harri_locations_count__c?: InputMaybe<Scalars["numeric"]>;
  harri_profile_created__c?: InputMaybe<Scalars["Boolean"]>;
  harri_strategic_sponsor_name__c?: InputMaybe<Scalars["String"]>;
  harri_subscription_status__c?: InputMaybe<Scalars["String"]>;
  harri_user_id__c?: InputMaybe<Scalars["numeric"]>;
  hecs_brands_type__c?: InputMaybe<Scalars["String"]>;
  hecs_category__c?: InputMaybe<Scalars["String"]>;
  hecs_owner_type__c?: InputMaybe<Scalars["String"]>;
  hot_button_feature__c?: InputMaybe<Scalars["String"]>;
  house_account__c?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  ignore__c?: InputMaybe<Scalars["String"]>;
  include__c?: InputMaybe<Scalars["Boolean"]>;
  industry__c?: InputMaybe<Scalars["String"]>;
  industry_category__c?: InputMaybe<Scalars["String"]>;
  inserted_from_system__c?: InputMaybe<Scalars["String"]>;
  is_yesterday__c?: InputMaybe<Scalars["Boolean"]>;
  job_distributor__c?: InputMaybe<Scalars["String"]>;
  job_distributor_details__c?: InputMaybe<Scalars["String"]>;
  job_post__c?: InputMaybe<Scalars["String"]>;
  kick_start__c?: InputMaybe<Scalars["Boolean"]>;
  last_activity__c?: InputMaybe<Scalars["timestamp"]>;
  last_check_in_comments__c?: InputMaybe<Scalars["String"]>;
  last_job_post_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_new_sale_close_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_new_sale_subscription_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_scheduled_publish_date__c?: InputMaybe<Scalars["timestamp"]>;
  latest_csat_nps_overall_experience__c?: InputMaybe<Scalars["numeric"]>;
  latest_csat_overall_nps_rating__c?: InputMaybe<Scalars["String"]>;
  latest_customer_satisfaction_rating__c?: InputMaybe<Scalars["String"]>;
  latest_customer_satisfaction_survey__c?: InputMaybe<Scalars["numeric"]>;
  latest_fran__c?: InputMaybe<Scalars["String"]>;
  legacy_id__c?: InputMaybe<Scalars["String"]>;
  legacy_parent_id__c?: InputMaybe<Scalars["String"]>;
  lid__linkedin_company_id__c?: InputMaybe<Scalars["String"]>;
  link_to_sim_form__c?: InputMaybe<Scalars["String"]>;
  live_services__c?: InputMaybe<Scalars["String"]>;
  locations__c?: InputMaybe<Scalars["numeric"]>;
  locations_billed__c?: InputMaybe<Scalars["numeric"]>;
  locations_in_harri__c?: InputMaybe<Scalars["numeric"]>;
  luke_vip__c?: InputMaybe<Scalars["Boolean"]>;
  macro_text__c?: InputMaybe<Scalars["String"]>;
  macro_themes__c?: InputMaybe<Scalars["String"]>;
  mainfranchiserhq__c?: InputMaybe<Scalars["Boolean"]>;
  mcd_operator_name__c?: InputMaybe<Scalars["String"]>;
  mcdonald_s_governance__c?: InputMaybe<Scalars["Boolean"]>;
  micro_text__c?: InputMaybe<Scalars["String"]>;
  micro_themes__c?: InputMaybe<Scalars["String"]>;
  missed_orientation__c?: InputMaybe<Scalars["Boolean"]>;
  mktg_harri_partnership__c?: InputMaybe<Scalars["String"]>;
  mktg_harri_partnership_adp_q1__c?: InputMaybe<Scalars["String"]>;
  mktg_harri_partnership_adp_q2__c?: InputMaybe<Scalars["String"]>;
  mktg_sales_channel__c?: InputMaybe<Scalars["String"]>;
  mktg_time_zone__c?: InputMaybe<Scalars["String"]>;
  most_recent_close_date_for_renewal_opp__c?: InputMaybe<Scalars["timestamp"]>;
  mrr_from_gl_12_19__c?: InputMaybe<Scalars["numeric"]>;
  multi_type__c?: InputMaybe<Scalars["String"]>;
  naive_bayes__c?: InputMaybe<Scalars["numeric"]>;
  net_promoter_comment__c?: InputMaybe<Scalars["String"]>;
  new_mrr_2020__c?: InputMaybe<Scalars["numeric"]>;
  no_of_closed_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_open_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  no_outbound__c?: InputMaybe<Scalars["Boolean"]>;
  notes__c?: InputMaybe<Scalars["String"]>;
  november_2021_current_invoice__c?: InputMaybe<Scalars["numeric"]>;
  nps__c?: InputMaybe<Scalars["String"]>;
  nps_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  num_closed_opps__c?: InputMaybe<Scalars["numeric"]>;
  number_of_job_postings__c?: InputMaybe<Scalars["numeric"]>;
  number_of_valid_end_dates__c?: InputMaybe<Scalars["numeric"]>;
  of_won_opp__c?: InputMaybe<Scalars["numeric"]>;
  omis_account_id__c?: InputMaybe<Scalars["String"]>;
  omis_door_id__c?: InputMaybe<Scalars["String"]>;
  omis_rating__c?: InputMaybe<Scalars["String"]>;
  omis_score__c?: InputMaybe<Scalars["String"]>;
  onboarding__c?: InputMaybe<Scalars["Boolean"]>;
  open_opportunity_tag__c?: InputMaybe<Scalars["Boolean"]>;
  operating_structure_2__c?: InputMaybe<Scalars["String"]>;
  operational_structure__c?: InputMaybe<Scalars["String"]>;
  orientation_conducted_by__c?: InputMaybe<Scalars["String"]>;
  orientation_contact__c?: InputMaybe<Scalars["String"]>;
  orientation_date__c?: InputMaybe<Scalars["timestamp"]>;
  other_credentials__c?: InputMaybe<Scalars["String"]>;
  outreach_url__c?: InputMaybe<Scalars["String"]>;
  overall_customer_health__c?: InputMaybe<Scalars["String"]>;
  papa_johns__c?: InputMaybe<Scalars["Boolean"]>;
  parent_id__c?: InputMaybe<Scalars["numeric"]>;
  partner_type__c?: InputMaybe<Scalars["String"]>;
  payroll_integration__c?: InputMaybe<Scalars["String"]>;
  payroll_owner__c?: InputMaybe<Scalars["String"]>;
  payroll_owner_text__c?: InputMaybe<Scalars["String"]>;
  payroll_owner_uk_payroll__c?: InputMaybe<Scalars["String"]>;
  payroll_vendor__c?: InputMaybe<Scalars["String"]>;
  pe_influence__c?: InputMaybe<Scalars["String"]>;
  percent_franchised__c?: InputMaybe<Scalars["String"]>;
  pos__c?: InputMaybe<Scalars["String"]>;
  pos_vendor__c?: InputMaybe<Scalars["String"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  primarycontact2__c?: InputMaybe<Scalars["String"]>;
  product_bucket__c?: InputMaybe<Scalars["String"]>;
  prospect_or_customer__c?: InputMaybe<Scalars["String"]>;
  publiccorp__c?: InputMaybe<Scalars["Boolean"]>;
  purchasing_power__c?: InputMaybe<Scalars["String"]>;
  quickbooks_last_invoice__c?: InputMaybe<Scalars["numeric"]>;
  quickbooks_last_invoice_date__c?: InputMaybe<Scalars["timestamp"]>;
  quickbooks_total_balance__c?: InputMaybe<Scalars["numeric"]>;
  random_forest__c?: InputMaybe<Scalars["numeric"]>;
  reference_1__c?: InputMaybe<Scalars["String"]>;
  reference_2__c?: InputMaybe<Scalars["String"]>;
  reference__c?: InputMaybe<Scalars["String"]>;
  root_brand_id__c?: InputMaybe<Scalars["String"]>;
  root_brand_type__c?: InputMaybe<Scalars["String"]>;
  rootid__c?: InputMaybe<Scalars["String"]>;
  ropackage__acctupdateindex__c?: InputMaybe<Scalars["String"]>;
  ropackage__createdbyrestaurantology__c?: InputMaybe<Scalars["Boolean"]>;
  ropackage__known_for__c?: InputMaybe<Scalars["String"]>;
  ropackage__latest_restaurantology_tech_data__c?: InputMaybe<
    Scalars["String"]
  >;
  ropackage__parent_restaurantology_internal_id__c?: InputMaybe<
    Scalars["String"]
  >;
  ropackage__reconnlogindex__c?: InputMaybe<Scalars["String"]>;
  ropackage__restaurantology_internal_id__c?: InputMaybe<Scalars["String"]>;
  ropackage__roalphaname__c?: InputMaybe<Scalars["String"]>;
  ropackage__rocleaneddomain__c?: InputMaybe<Scalars["String"]>;
  ropackage__service_type__c?: InputMaybe<Scalars["String"]>;
  ropackage__total_locations_overall__c?: InputMaybe<Scalars["numeric"]>;
  sales_priority_tier__c?: InputMaybe<Scalars["String"]>;
  sales_territory__c?: InputMaybe<Scalars["String"]>;
  sdr_owner__c?: InputMaybe<Scalars["String"]>;
  secondary_customer_success_manager__c?: InputMaybe<Scalars["String"]>;
  segment__c?: InputMaybe<Scalars["String"]>;
  service_type__c?: InputMaybe<Scalars["String"]>;
  sim_form_ready__c?: InputMaybe<Scalars["String"]>;
  sim_form_ready_date__c?: InputMaybe<Scalars["timestamp"]>;
  sim_form_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  sim_form_team_member__c?: InputMaybe<Scalars["String"]>;
  size__c?: InputMaybe<Scalars["String"]>;
  slug__c?: InputMaybe<Scalars["String"]>;
  social_facebook_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_instagram_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_linkedin_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_pinterest_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_tripadvisor_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_twitter_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_yelp_company_profile__c?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  standard_documents__c?: InputMaybe<Scalars["String"]>;
  strategic_account__c?: InputMaybe<Scalars["Boolean"]>;
  stripe_ids__c?: InputMaybe<Scalars["String"]>;
  structure_file__c?: InputMaybe<Scalars["String"]>;
  su_training_date__c?: InputMaybe<Scalars["timestamp"]>;
  sub_industry__c?: InputMaybe<Scalars["String"]>;
  systemstructurelookup__c?: InputMaybe<Scalars["String"]>;
  target_status__c?: InputMaybe<Scalars["String"]>;
  target_tier__c?: InputMaybe<Scalars["String"]>;
  total_cmrr_all_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_cmrr_won_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_current_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  trading_states__c?: InputMaybe<Scalars["String"]>;
  trading_status__c?: InputMaybe<Scalars["String"]>;
  training_sessions_complete__c?: InputMaybe<Scalars["numeric"]>;
  type2__c?: InputMaybe<Scalars["String"]>;
  type_of_business__c?: InputMaybe<Scalars["String"]>;
  uniquebrandco__c?: InputMaybe<Scalars["Boolean"]>;
  uniqueid__c?: InputMaybe<Scalars["String"]>;
  unit_intel__c?: InputMaybe<Scalars["String"]>;
  up__district__c?: InputMaybe<Scalars["String"]>;
  up__region__c?: InputMaybe<Scalars["String"]>;
  up__territory__c?: InputMaybe<Scalars["String"]>;
  upsell_items__c?: InputMaybe<Scalars["String"]>;
  upsell_notes__c?: InputMaybe<Scalars["String"]>;
  upsell_potential__c?: InputMaybe<Scalars["String"]>;
  url__c?: InputMaybe<Scalars["String"]>;
  url_of_account_review_notes__c?: InputMaybe<Scalars["String"]>;
  users__c?: InputMaybe<Scalars["numeric"]>;
  web_client_only__c?: InputMaybe<Scalars["Boolean"]>;
  workpop_lead__c?: InputMaybe<Scalars["Boolean"]>;
  yelp__c?: InputMaybe<Scalars["String"]>;
  zendesk_id__c?: InputMaybe<Scalars["String"]>;
  zisf__company_id__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_clean_status__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_id__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_lastupdated__c?: InputMaybe<Scalars["timestamp"]>;
  zisf__zoominfo_complete_status__c?: InputMaybe<Scalars["String"]>;
  zisf__zoominfo_industry__c?: InputMaybe<Scalars["String"]>;
  zisf__zoominfo_last_clean_run__c?: InputMaybe<Scalars["timestamp"]>;
};

/** input type for inserting object relation for remote table "account__c" */
export type account__c_obj_rel_insert_input = {
  data: account__c_insert_input;
};

/** Ordering options when selecting data from "account__c". */
export type account__c_order_by = {
  account_id__c?: InputMaybe<order_by>;
  account_power_of_1__c?: InputMaybe<order_by>;
  account_region__c?: InputMaybe<order_by>;
  account_status_auto__c?: InputMaybe<order_by>;
  account_type__c?: InputMaybe<order_by>;
  accountnamelength__c?: InputMaybe<order_by>;
  active__c?: InputMaybe<order_by>;
  active_accounts_14_days__c?: InputMaybe<order_by>;
  active_employees__c?: InputMaybe<order_by>;
  active_users__c?: InputMaybe<order_by>;
  alternative_contact_email__c?: InputMaybe<order_by>;
  alternative_contact_first_name__c?: InputMaybe<order_by>;
  alternative_contact_last_name__c?: InputMaybe<order_by>;
  alternative_contact_phone__c?: InputMaybe<order_by>;
  alternative_email__c?: InputMaybe<order_by>;
  alternative_mobile__c?: InputMaybe<order_by>;
  alternative_phone__c?: InputMaybe<order_by>;
  arr1__c?: InputMaybe<order_by>;
  billing_deferral_date_updated__c?: InputMaybe<order_by>;
  billing_status__c?: InputMaybe<order_by>;
  billing_trading_notes__c?: InputMaybe<order_by>;
  bizsys_application_tracking_system__c?: InputMaybe<order_by>;
  bizsys_business_intelligence__c?: InputMaybe<order_by>;
  bizsys_employee_management__c?: InputMaybe<order_by>;
  bizsys_enterprise_solutions__c?: InputMaybe<order_by>;
  bizsys_hcm__c?: InputMaybe<order_by>;
  bizsys_interviewer_system__c?: InputMaybe<order_by>;
  bizsys_inventory_invoicing__c?: InputMaybe<order_by>;
  bizsys_job_board_listing__c?: InputMaybe<order_by>;
  bizsys_learning_management_system__c?: InputMaybe<order_by>;
  bizsys_onboarding__c?: InputMaybe<order_by>;
  bizsys_payroll__c?: InputMaybe<order_by>;
  bizsys_point_of_sale_system__c?: InputMaybe<order_by>;
  bizsys_recruitment_marketing__c?: InputMaybe<order_by>;
  bizsys_scheduler_system__c?: InputMaybe<order_by>;
  bizsys_texting__c?: InputMaybe<order_by>;
  bizsys_time_attendance_system__c?: InputMaybe<order_by>;
  bizsys_zoominfo_tech_stack__c?: InputMaybe<order_by>;
  brand_id__c?: InputMaybe<order_by>;
  brand_intel__c?: InputMaybe<order_by>;
  bu__c?: InputMaybe<order_by>;
  bu_long_name__c?: InputMaybe<order_by>;
  bu_short_name__c?: InputMaybe<order_by>;
  case_owner__c?: InputMaybe<order_by>;
  categorical_priority__c?: InputMaybe<order_by>;
  check__c?: InputMaybe<order_by>;
  churn_date__c?: InputMaybe<order_by>;
  churn_details__c?: InputMaybe<order_by>;
  churn_reason__c?: InputMaybe<order_by>;
  churn_reason_old__c?: InputMaybe<order_by>;
  churn_sub_reason__c?: InputMaybe<order_by>;
  churned__c?: InputMaybe<order_by>;
  churned_cmrr__c?: InputMaybe<order_by>;
  churned_to__c?: InputMaybe<order_by>;
  city__c?: InputMaybe<order_by>;
  commission_rules_of_engagement_exception__c?: InputMaybe<order_by>;
  concept_type__c?: InputMaybe<order_by>;
  concepts__c?: InputMaybe<order_by>;
  contact__c?: InputMaybe<order_by>;
  contact_name__c?: InputMaybe<order_by>;
  contact_phone__c?: InputMaybe<order_by>;
  contracted_services__c?: InputMaybe<order_by>;
  contracted_training_sessions__c?: InputMaybe<order_by>;
  covid__c?: InputMaybe<order_by>;
  created_date__c?: InputMaybe<order_by>;
  cs_owner__c?: InputMaybe<order_by>;
  cs_owner_text__c?: InputMaybe<order_by>;
  csat__c?: InputMaybe<order_by>;
  csat_last_updated__c?: InputMaybe<order_by>;
  current_contracted_employees__c?: InputMaybe<order_by>;
  current_contracted_locations__c?: InputMaybe<order_by>;
  custom_status__c?: InputMaybe<order_by>;
  customer__c?: InputMaybe<order_by>;
  customer_health_rating__c?: InputMaybe<order_by>;
  customer_health_ryg__c?: InputMaybe<order_by>;
  customer_lifecycle_status__c?: InputMaybe<order_by>;
  customer_satisfaction_ryg__c?: InputMaybe<order_by>;
  customer_status__c?: InputMaybe<order_by>;
  customer_success_owner__c?: InputMaybe<order_by>;
  customer_support__c?: InputMaybe<order_by>;
  customization__c?: InputMaybe<order_by>;
  data_quality_description__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  date_of_last_check_in__c?: InputMaybe<order_by>;
  date_of_next_account_review__c?: InputMaybe<order_by>;
  different__c?: InputMaybe<order_by>;
  different_ids__c?: InputMaybe<order_by>;
  doors__c?: InputMaybe<order_by>;
  dozisf__zoominfo_enrich_status__c?: InputMaybe<order_by>;
  dozisf__zoominfo_first_updated__c?: InputMaybe<order_by>;
  dozisf__zoominfo_id__c?: InputMaybe<order_by>;
  dozisf__zoominfo_last_updated__c?: InputMaybe<order_by>;
  email__c?: InputMaybe<order_by>;
  employer_location_id__c?: InputMaybe<order_by>;
  end_date__c?: InputMaybe<order_by>;
  estimated_contract_value__c?: InputMaybe<order_by>;
  fair_workweek__c?: InputMaybe<order_by>;
  field_office__c?: InputMaybe<order_by>;
  fin_fortune_1000_rank__c?: InputMaybe<order_by>;
  fin_location_size__c?: InputMaybe<order_by>;
  fin_location_size_accuracy__c?: InputMaybe<order_by>;
  fin_location_size_unit_of_measure__c?: InputMaybe<order_by>;
  fin_prior_year_revenue__c?: InputMaybe<order_by>;
  fin_prior_yr_employees__c?: InputMaybe<order_by>;
  fin_s_p_500__c?: InputMaybe<order_by>;
  focus_accounts__c?: InputMaybe<order_by>;
  focus_accounts_open_opps__c?: InputMaybe<order_by>;
  for_finance__c?: InputMaybe<order_by>;
  franchise_brands__c?: InputMaybe<order_by>;
  franchise_name__c?: InputMaybe<order_by>;
  franchisee__c?: InputMaybe<order_by>;
  franchisor__c?: InputMaybe<order_by>;
  franshisee__c?: InputMaybe<order_by>;
  frozen__c?: InputMaybe<order_by>;
  generated_address__c?: InputMaybe<order_by>;
  gong__gong_count__c?: InputMaybe<order_by>;
  google_analytics_campaign__c?: InputMaybe<order_by>;
  google_analytics_content__c?: InputMaybe<order_by>;
  google_analytics_medium__c?: InputMaybe<order_by>;
  google_analytics_source__c?: InputMaybe<order_by>;
  google_analytics_term__c?: InputMaybe<order_by>;
  group_id__c?: InputMaybe<order_by>;
  harri_api_enabled__c?: InputMaybe<order_by>;
  harri_brand_type__c?: InputMaybe<order_by>;
  harri_client_id__c?: InputMaybe<order_by>;
  harri_employees_per_brand__c?: InputMaybe<order_by>;
  harri_locations_count__c?: InputMaybe<order_by>;
  harri_profile_created__c?: InputMaybe<order_by>;
  harri_strategic_sponsor_name__c?: InputMaybe<order_by>;
  harri_subscription_status__c?: InputMaybe<order_by>;
  harri_user_id__c?: InputMaybe<order_by>;
  hecs_brands_type__c?: InputMaybe<order_by>;
  hecs_category__c?: InputMaybe<order_by>;
  hecs_owner_type__c?: InputMaybe<order_by>;
  hot_button_feature__c?: InputMaybe<order_by>;
  house_account__c?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  ignore__c?: InputMaybe<order_by>;
  include__c?: InputMaybe<order_by>;
  industry__c?: InputMaybe<order_by>;
  industry_category__c?: InputMaybe<order_by>;
  inserted_from_system__c?: InputMaybe<order_by>;
  is_yesterday__c?: InputMaybe<order_by>;
  job_distributor__c?: InputMaybe<order_by>;
  job_distributor_details__c?: InputMaybe<order_by>;
  job_post__c?: InputMaybe<order_by>;
  kick_start__c?: InputMaybe<order_by>;
  last_activity__c?: InputMaybe<order_by>;
  last_check_in_comments__c?: InputMaybe<order_by>;
  last_job_post_date__c?: InputMaybe<order_by>;
  last_new_sale_close_date__c?: InputMaybe<order_by>;
  last_new_sale_subscription_start_date__c?: InputMaybe<order_by>;
  last_scheduled_publish_date__c?: InputMaybe<order_by>;
  latest_csat_nps_overall_experience__c?: InputMaybe<order_by>;
  latest_csat_overall_nps_rating__c?: InputMaybe<order_by>;
  latest_customer_satisfaction_rating__c?: InputMaybe<order_by>;
  latest_customer_satisfaction_survey__c?: InputMaybe<order_by>;
  latest_fran__c?: InputMaybe<order_by>;
  legacy_id__c?: InputMaybe<order_by>;
  legacy_parent_id__c?: InputMaybe<order_by>;
  lid__linkedin_company_id__c?: InputMaybe<order_by>;
  link_to_sim_form__c?: InputMaybe<order_by>;
  live_services__c?: InputMaybe<order_by>;
  locations__c?: InputMaybe<order_by>;
  locations_billed__c?: InputMaybe<order_by>;
  locations_in_harri__c?: InputMaybe<order_by>;
  luke_vip__c?: InputMaybe<order_by>;
  macro_text__c?: InputMaybe<order_by>;
  macro_themes__c?: InputMaybe<order_by>;
  mainfranchiserhq__c?: InputMaybe<order_by>;
  mcd_operator_name__c?: InputMaybe<order_by>;
  mcdonald_s_governance__c?: InputMaybe<order_by>;
  micro_text__c?: InputMaybe<order_by>;
  micro_themes__c?: InputMaybe<order_by>;
  missed_orientation__c?: InputMaybe<order_by>;
  mktg_harri_partnership__c?: InputMaybe<order_by>;
  mktg_harri_partnership_adp_q1__c?: InputMaybe<order_by>;
  mktg_harri_partnership_adp_q2__c?: InputMaybe<order_by>;
  mktg_sales_channel__c?: InputMaybe<order_by>;
  mktg_time_zone__c?: InputMaybe<order_by>;
  most_recent_close_date_for_renewal_opp__c?: InputMaybe<order_by>;
  mrr_from_gl_12_19__c?: InputMaybe<order_by>;
  multi_type__c?: InputMaybe<order_by>;
  naive_bayes__c?: InputMaybe<order_by>;
  net_promoter_comment__c?: InputMaybe<order_by>;
  new_mrr_2020__c?: InputMaybe<order_by>;
  no_of_closed_opp__c?: InputMaybe<order_by>;
  no_of_open_opp__c?: InputMaybe<order_by>;
  no_of_opportunities__c?: InputMaybe<order_by>;
  no_outbound__c?: InputMaybe<order_by>;
  notes__c?: InputMaybe<order_by>;
  november_2021_current_invoice__c?: InputMaybe<order_by>;
  nps__c?: InputMaybe<order_by>;
  nps_last_updated__c?: InputMaybe<order_by>;
  num_closed_opps__c?: InputMaybe<order_by>;
  number_of_job_postings__c?: InputMaybe<order_by>;
  number_of_valid_end_dates__c?: InputMaybe<order_by>;
  of_won_opp__c?: InputMaybe<order_by>;
  omis_account_id__c?: InputMaybe<order_by>;
  omis_door_id__c?: InputMaybe<order_by>;
  omis_rating__c?: InputMaybe<order_by>;
  omis_score__c?: InputMaybe<order_by>;
  onboarding__c?: InputMaybe<order_by>;
  open_opportunity_tag__c?: InputMaybe<order_by>;
  operating_structure_2__c?: InputMaybe<order_by>;
  operational_structure__c?: InputMaybe<order_by>;
  orientation_conducted_by__c?: InputMaybe<order_by>;
  orientation_contact__c?: InputMaybe<order_by>;
  orientation_date__c?: InputMaybe<order_by>;
  other_credentials__c?: InputMaybe<order_by>;
  outreach_url__c?: InputMaybe<order_by>;
  overall_customer_health__c?: InputMaybe<order_by>;
  papa_johns__c?: InputMaybe<order_by>;
  parent_id__c?: InputMaybe<order_by>;
  partner_type__c?: InputMaybe<order_by>;
  payroll_integration__c?: InputMaybe<order_by>;
  payroll_owner__c?: InputMaybe<order_by>;
  payroll_owner_text__c?: InputMaybe<order_by>;
  payroll_owner_uk_payroll__c?: InputMaybe<order_by>;
  payroll_vendor__c?: InputMaybe<order_by>;
  pe_influence__c?: InputMaybe<order_by>;
  percent_franchised__c?: InputMaybe<order_by>;
  pos__c?: InputMaybe<order_by>;
  pos_vendor__c?: InputMaybe<order_by>;
  predict_proba__c?: InputMaybe<order_by>;
  primarycontact2__c?: InputMaybe<order_by>;
  product_bucket__c?: InputMaybe<order_by>;
  prospect_or_customer__c?: InputMaybe<order_by>;
  publiccorp__c?: InputMaybe<order_by>;
  purchasing_power__c?: InputMaybe<order_by>;
  quickbooks_last_invoice__c?: InputMaybe<order_by>;
  quickbooks_last_invoice_date__c?: InputMaybe<order_by>;
  quickbooks_total_balance__c?: InputMaybe<order_by>;
  random_forest__c?: InputMaybe<order_by>;
  reference_1__c?: InputMaybe<order_by>;
  reference_2__c?: InputMaybe<order_by>;
  reference__c?: InputMaybe<order_by>;
  root_brand_id__c?: InputMaybe<order_by>;
  root_brand_type__c?: InputMaybe<order_by>;
  rootid__c?: InputMaybe<order_by>;
  ropackage__acctupdateindex__c?: InputMaybe<order_by>;
  ropackage__createdbyrestaurantology__c?: InputMaybe<order_by>;
  ropackage__known_for__c?: InputMaybe<order_by>;
  ropackage__latest_restaurantology_tech_data__c?: InputMaybe<order_by>;
  ropackage__parent_restaurantology_internal_id__c?: InputMaybe<order_by>;
  ropackage__reconnlogindex__c?: InputMaybe<order_by>;
  ropackage__restaurantology_internal_id__c?: InputMaybe<order_by>;
  ropackage__roalphaname__c?: InputMaybe<order_by>;
  ropackage__rocleaneddomain__c?: InputMaybe<order_by>;
  ropackage__service_type__c?: InputMaybe<order_by>;
  ropackage__total_locations_overall__c?: InputMaybe<order_by>;
  sales_priority_tier__c?: InputMaybe<order_by>;
  sales_territory__c?: InputMaybe<order_by>;
  sdr_owner__c?: InputMaybe<order_by>;
  secondary_customer_success_manager__c?: InputMaybe<order_by>;
  segment__c?: InputMaybe<order_by>;
  service_type__c?: InputMaybe<order_by>;
  sim_form_ready__c?: InputMaybe<order_by>;
  sim_form_ready_date__c?: InputMaybe<order_by>;
  sim_form_start_date__c?: InputMaybe<order_by>;
  sim_form_team_member__c?: InputMaybe<order_by>;
  size__c?: InputMaybe<order_by>;
  slug__c?: InputMaybe<order_by>;
  social_facebook_company_profile__c?: InputMaybe<order_by>;
  social_instagram_company_profile__c?: InputMaybe<order_by>;
  social_linkedin_company_profile__c?: InputMaybe<order_by>;
  social_pinterest_company_profile__c?: InputMaybe<order_by>;
  social_tripadvisor_company_profile__c?: InputMaybe<order_by>;
  social_twitter_company_profile__c?: InputMaybe<order_by>;
  social_yelp_company_profile__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  standard_documents__c?: InputMaybe<order_by>;
  strategic_account__c?: InputMaybe<order_by>;
  stripe_ids__c?: InputMaybe<order_by>;
  structure_file__c?: InputMaybe<order_by>;
  su_training_date__c?: InputMaybe<order_by>;
  sub_industry__c?: InputMaybe<order_by>;
  systemstructurelookup__c?: InputMaybe<order_by>;
  target_status__c?: InputMaybe<order_by>;
  target_tier__c?: InputMaybe<order_by>;
  total_cmrr_all_opportunities__c?: InputMaybe<order_by>;
  total_cmrr_won_opportunities__c?: InputMaybe<order_by>;
  total_current_cmrr__c?: InputMaybe<order_by>;
  trading_states__c?: InputMaybe<order_by>;
  trading_status__c?: InputMaybe<order_by>;
  training_sessions_complete__c?: InputMaybe<order_by>;
  type2__c?: InputMaybe<order_by>;
  type_of_business__c?: InputMaybe<order_by>;
  uniquebrandco__c?: InputMaybe<order_by>;
  uniqueid__c?: InputMaybe<order_by>;
  unit_intel__c?: InputMaybe<order_by>;
  up__district__c?: InputMaybe<order_by>;
  up__region__c?: InputMaybe<order_by>;
  up__territory__c?: InputMaybe<order_by>;
  upsell_items__c?: InputMaybe<order_by>;
  upsell_notes__c?: InputMaybe<order_by>;
  upsell_potential__c?: InputMaybe<order_by>;
  url__c?: InputMaybe<order_by>;
  url_of_account_review_notes__c?: InputMaybe<order_by>;
  users__c?: InputMaybe<order_by>;
  web_client_only__c?: InputMaybe<order_by>;
  workpop_lead__c?: InputMaybe<order_by>;
  yelp__c?: InputMaybe<order_by>;
  zendesk_id__c?: InputMaybe<order_by>;
  zisf__company_id__c?: InputMaybe<order_by>;
  zisf__zoom_clean_status__c?: InputMaybe<order_by>;
  zisf__zoom_id__c?: InputMaybe<order_by>;
  zisf__zoom_lastupdated__c?: InputMaybe<order_by>;
  zisf__zoominfo_complete_status__c?: InputMaybe<order_by>;
  zisf__zoominfo_industry__c?: InputMaybe<order_by>;
  zisf__zoominfo_last_clean_run__c?: InputMaybe<order_by>;
};

/** select columns of table "account__c" */
export enum account__c_select_column {
  /** column name */
  account_id__c = "account_id__c",
  /** column name */
  account_power_of_1__c = "account_power_of_1__c",
  /** column name */
  account_region__c = "account_region__c",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  account_type__c = "account_type__c",
  /** column name */
  accountnamelength__c = "accountnamelength__c",
  /** column name */
  active__c = "active__c",
  /** column name */
  active_accounts_14_days__c = "active_accounts_14_days__c",
  /** column name */
  active_employees__c = "active_employees__c",
  /** column name */
  active_users__c = "active_users__c",
  /** column name */
  alternative_contact_email__c = "alternative_contact_email__c",
  /** column name */
  alternative_contact_first_name__c = "alternative_contact_first_name__c",
  /** column name */
  alternative_contact_last_name__c = "alternative_contact_last_name__c",
  /** column name */
  alternative_contact_phone__c = "alternative_contact_phone__c",
  /** column name */
  alternative_email__c = "alternative_email__c",
  /** column name */
  alternative_mobile__c = "alternative_mobile__c",
  /** column name */
  alternative_phone__c = "alternative_phone__c",
  /** column name */
  arr1__c = "arr1__c",
  /** column name */
  billing_deferral_date_updated__c = "billing_deferral_date_updated__c",
  /** column name */
  billing_status__c = "billing_status__c",
  /** column name */
  billing_trading_notes__c = "billing_trading_notes__c",
  /** column name */
  bizsys_application_tracking_system__c = "bizsys_application_tracking_system__c",
  /** column name */
  bizsys_business_intelligence__c = "bizsys_business_intelligence__c",
  /** column name */
  bizsys_employee_management__c = "bizsys_employee_management__c",
  /** column name */
  bizsys_enterprise_solutions__c = "bizsys_enterprise_solutions__c",
  /** column name */
  bizsys_hcm__c = "bizsys_hcm__c",
  /** column name */
  bizsys_interviewer_system__c = "bizsys_interviewer_system__c",
  /** column name */
  bizsys_inventory_invoicing__c = "bizsys_inventory_invoicing__c",
  /** column name */
  bizsys_job_board_listing__c = "bizsys_job_board_listing__c",
  /** column name */
  bizsys_learning_management_system__c = "bizsys_learning_management_system__c",
  /** column name */
  bizsys_onboarding__c = "bizsys_onboarding__c",
  /** column name */
  bizsys_payroll__c = "bizsys_payroll__c",
  /** column name */
  bizsys_point_of_sale_system__c = "bizsys_point_of_sale_system__c",
  /** column name */
  bizsys_recruitment_marketing__c = "bizsys_recruitment_marketing__c",
  /** column name */
  bizsys_scheduler_system__c = "bizsys_scheduler_system__c",
  /** column name */
  bizsys_texting__c = "bizsys_texting__c",
  /** column name */
  bizsys_time_attendance_system__c = "bizsys_time_attendance_system__c",
  /** column name */
  bizsys_zoominfo_tech_stack__c = "bizsys_zoominfo_tech_stack__c",
  /** column name */
  brand_id__c = "brand_id__c",
  /** column name */
  brand_intel__c = "brand_intel__c",
  /** column name */
  bu__c = "bu__c",
  /** column name */
  bu_long_name__c = "bu_long_name__c",
  /** column name */
  bu_short_name__c = "bu_short_name__c",
  /** column name */
  case_owner__c = "case_owner__c",
  /** column name */
  categorical_priority__c = "categorical_priority__c",
  /** column name */
  check__c = "check__c",
  /** column name */
  churn_date__c = "churn_date__c",
  /** column name */
  churn_details__c = "churn_details__c",
  /** column name */
  churn_reason__c = "churn_reason__c",
  /** column name */
  churn_reason_old__c = "churn_reason_old__c",
  /** column name */
  churn_sub_reason__c = "churn_sub_reason__c",
  /** column name */
  churned__c = "churned__c",
  /** column name */
  churned_cmrr__c = "churned_cmrr__c",
  /** column name */
  churned_to__c = "churned_to__c",
  /** column name */
  city__c = "city__c",
  /** column name */
  commission_rules_of_engagement_exception__c = "commission_rules_of_engagement_exception__c",
  /** column name */
  concept_type__c = "concept_type__c",
  /** column name */
  concepts__c = "concepts__c",
  /** column name */
  contact__c = "contact__c",
  /** column name */
  contact_name__c = "contact_name__c",
  /** column name */
  contact_phone__c = "contact_phone__c",
  /** column name */
  contracted_services__c = "contracted_services__c",
  /** column name */
  contracted_training_sessions__c = "contracted_training_sessions__c",
  /** column name */
  covid__c = "covid__c",
  /** column name */
  created_date__c = "created_date__c",
  /** column name */
  cs_owner__c = "cs_owner__c",
  /** column name */
  cs_owner_text__c = "cs_owner_text__c",
  /** column name */
  csat__c = "csat__c",
  /** column name */
  csat_last_updated__c = "csat_last_updated__c",
  /** column name */
  current_contracted_employees__c = "current_contracted_employees__c",
  /** column name */
  current_contracted_locations__c = "current_contracted_locations__c",
  /** column name */
  custom_status__c = "custom_status__c",
  /** column name */
  customer__c = "customer__c",
  /** column name */
  customer_health_rating__c = "customer_health_rating__c",
  /** column name */
  customer_health_ryg__c = "customer_health_ryg__c",
  /** column name */
  customer_lifecycle_status__c = "customer_lifecycle_status__c",
  /** column name */
  customer_satisfaction_ryg__c = "customer_satisfaction_ryg__c",
  /** column name */
  customer_status__c = "customer_status__c",
  /** column name */
  customer_success_owner__c = "customer_success_owner__c",
  /** column name */
  customer_support__c = "customer_support__c",
  /** column name */
  customization__c = "customization__c",
  /** column name */
  data_quality_description__c = "data_quality_description__c",
  /** column name */
  data_quality_score__c = "data_quality_score__c",
  /** column name */
  date_of_last_check_in__c = "date_of_last_check_in__c",
  /** column name */
  date_of_next_account_review__c = "date_of_next_account_review__c",
  /** column name */
  different__c = "different__c",
  /** column name */
  different_ids__c = "different_ids__c",
  /** column name */
  doors__c = "doors__c",
  /** column name */
  dozisf__zoominfo_enrich_status__c = "dozisf__zoominfo_enrich_status__c",
  /** column name */
  dozisf__zoominfo_first_updated__c = "dozisf__zoominfo_first_updated__c",
  /** column name */
  dozisf__zoominfo_id__c = "dozisf__zoominfo_id__c",
  /** column name */
  dozisf__zoominfo_last_updated__c = "dozisf__zoominfo_last_updated__c",
  /** column name */
  email__c = "email__c",
  /** column name */
  employer_location_id__c = "employer_location_id__c",
  /** column name */
  end_date__c = "end_date__c",
  /** column name */
  estimated_contract_value__c = "estimated_contract_value__c",
  /** column name */
  fair_workweek__c = "fair_workweek__c",
  /** column name */
  field_office__c = "field_office__c",
  /** column name */
  fin_fortune_1000_rank__c = "fin_fortune_1000_rank__c",
  /** column name */
  fin_location_size__c = "fin_location_size__c",
  /** column name */
  fin_location_size_accuracy__c = "fin_location_size_accuracy__c",
  /** column name */
  fin_location_size_unit_of_measure__c = "fin_location_size_unit_of_measure__c",
  /** column name */
  fin_prior_year_revenue__c = "fin_prior_year_revenue__c",
  /** column name */
  fin_prior_yr_employees__c = "fin_prior_yr_employees__c",
  /** column name */
  fin_s_p_500__c = "fin_s_p_500__c",
  /** column name */
  focus_accounts__c = "focus_accounts__c",
  /** column name */
  focus_accounts_open_opps__c = "focus_accounts_open_opps__c",
  /** column name */
  for_finance__c = "for_finance__c",
  /** column name */
  franchise_brands__c = "franchise_brands__c",
  /** column name */
  franchise_name__c = "franchise_name__c",
  /** column name */
  franchisee__c = "franchisee__c",
  /** column name */
  franchisor__c = "franchisor__c",
  /** column name */
  franshisee__c = "franshisee__c",
  /** column name */
  frozen__c = "frozen__c",
  /** column name */
  generated_address__c = "generated_address__c",
  /** column name */
  gong__gong_count__c = "gong__gong_count__c",
  /** column name */
  google_analytics_campaign__c = "google_analytics_campaign__c",
  /** column name */
  google_analytics_content__c = "google_analytics_content__c",
  /** column name */
  google_analytics_medium__c = "google_analytics_medium__c",
  /** column name */
  google_analytics_source__c = "google_analytics_source__c",
  /** column name */
  google_analytics_term__c = "google_analytics_term__c",
  /** column name */
  group_id__c = "group_id__c",
  /** column name */
  harri_api_enabled__c = "harri_api_enabled__c",
  /** column name */
  harri_brand_type__c = "harri_brand_type__c",
  /** column name */
  harri_client_id__c = "harri_client_id__c",
  /** column name */
  harri_employees_per_brand__c = "harri_employees_per_brand__c",
  /** column name */
  harri_locations_count__c = "harri_locations_count__c",
  /** column name */
  harri_profile_created__c = "harri_profile_created__c",
  /** column name */
  harri_strategic_sponsor_name__c = "harri_strategic_sponsor_name__c",
  /** column name */
  harri_subscription_status__c = "harri_subscription_status__c",
  /** column name */
  harri_user_id__c = "harri_user_id__c",
  /** column name */
  hecs_brands_type__c = "hecs_brands_type__c",
  /** column name */
  hecs_category__c = "hecs_category__c",
  /** column name */
  hecs_owner_type__c = "hecs_owner_type__c",
  /** column name */
  hot_button_feature__c = "hot_button_feature__c",
  /** column name */
  house_account__c = "house_account__c",
  /** column name */
  id = "id",
  /** column name */
  ignore__c = "ignore__c",
  /** column name */
  include__c = "include__c",
  /** column name */
  industry__c = "industry__c",
  /** column name */
  industry_category__c = "industry_category__c",
  /** column name */
  inserted_from_system__c = "inserted_from_system__c",
  /** column name */
  is_yesterday__c = "is_yesterday__c",
  /** column name */
  job_distributor__c = "job_distributor__c",
  /** column name */
  job_distributor_details__c = "job_distributor_details__c",
  /** column name */
  job_post__c = "job_post__c",
  /** column name */
  kick_start__c = "kick_start__c",
  /** column name */
  last_activity__c = "last_activity__c",
  /** column name */
  last_check_in_comments__c = "last_check_in_comments__c",
  /** column name */
  last_job_post_date__c = "last_job_post_date__c",
  /** column name */
  last_new_sale_close_date__c = "last_new_sale_close_date__c",
  /** column name */
  last_new_sale_subscription_start_date__c = "last_new_sale_subscription_start_date__c",
  /** column name */
  last_scheduled_publish_date__c = "last_scheduled_publish_date__c",
  /** column name */
  latest_csat_nps_overall_experience__c = "latest_csat_nps_overall_experience__c",
  /** column name */
  latest_csat_overall_nps_rating__c = "latest_csat_overall_nps_rating__c",
  /** column name */
  latest_customer_satisfaction_rating__c = "latest_customer_satisfaction_rating__c",
  /** column name */
  latest_customer_satisfaction_survey__c = "latest_customer_satisfaction_survey__c",
  /** column name */
  latest_fran__c = "latest_fran__c",
  /** column name */
  legacy_id__c = "legacy_id__c",
  /** column name */
  legacy_parent_id__c = "legacy_parent_id__c",
  /** column name */
  lid__linkedin_company_id__c = "lid__linkedin_company_id__c",
  /** column name */
  link_to_sim_form__c = "link_to_sim_form__c",
  /** column name */
  live_services__c = "live_services__c",
  /** column name */
  locations__c = "locations__c",
  /** column name */
  locations_billed__c = "locations_billed__c",
  /** column name */
  locations_in_harri__c = "locations_in_harri__c",
  /** column name */
  luke_vip__c = "luke_vip__c",
  /** column name */
  macro_text__c = "macro_text__c",
  /** column name */
  macro_themes__c = "macro_themes__c",
  /** column name */
  mainfranchiserhq__c = "mainfranchiserhq__c",
  /** column name */
  mcd_operator_name__c = "mcd_operator_name__c",
  /** column name */
  mcdonald_s_governance__c = "mcdonald_s_governance__c",
  /** column name */
  micro_text__c = "micro_text__c",
  /** column name */
  micro_themes__c = "micro_themes__c",
  /** column name */
  missed_orientation__c = "missed_orientation__c",
  /** column name */
  mktg_harri_partnership__c = "mktg_harri_partnership__c",
  /** column name */
  mktg_harri_partnership_adp_q1__c = "mktg_harri_partnership_adp_q1__c",
  /** column name */
  mktg_harri_partnership_adp_q2__c = "mktg_harri_partnership_adp_q2__c",
  /** column name */
  mktg_sales_channel__c = "mktg_sales_channel__c",
  /** column name */
  mktg_time_zone__c = "mktg_time_zone__c",
  /** column name */
  most_recent_close_date_for_renewal_opp__c = "most_recent_close_date_for_renewal_opp__c",
  /** column name */
  mrr_from_gl_12_19__c = "mrr_from_gl_12_19__c",
  /** column name */
  multi_type__c = "multi_type__c",
  /** column name */
  naive_bayes__c = "naive_bayes__c",
  /** column name */
  net_promoter_comment__c = "net_promoter_comment__c",
  /** column name */
  new_mrr_2020__c = "new_mrr_2020__c",
  /** column name */
  no_of_closed_opp__c = "no_of_closed_opp__c",
  /** column name */
  no_of_open_opp__c = "no_of_open_opp__c",
  /** column name */
  no_of_opportunities__c = "no_of_opportunities__c",
  /** column name */
  no_outbound__c = "no_outbound__c",
  /** column name */
  notes__c = "notes__c",
  /** column name */
  november_2021_current_invoice__c = "november_2021_current_invoice__c",
  /** column name */
  nps__c = "nps__c",
  /** column name */
  nps_last_updated__c = "nps_last_updated__c",
  /** column name */
  num_closed_opps__c = "num_closed_opps__c",
  /** column name */
  number_of_job_postings__c = "number_of_job_postings__c",
  /** column name */
  number_of_valid_end_dates__c = "number_of_valid_end_dates__c",
  /** column name */
  of_won_opp__c = "of_won_opp__c",
  /** column name */
  omis_account_id__c = "omis_account_id__c",
  /** column name */
  omis_door_id__c = "omis_door_id__c",
  /** column name */
  omis_rating__c = "omis_rating__c",
  /** column name */
  omis_score__c = "omis_score__c",
  /** column name */
  onboarding__c = "onboarding__c",
  /** column name */
  open_opportunity_tag__c = "open_opportunity_tag__c",
  /** column name */
  operating_structure_2__c = "operating_structure_2__c",
  /** column name */
  operational_structure__c = "operational_structure__c",
  /** column name */
  orientation_conducted_by__c = "orientation_conducted_by__c",
  /** column name */
  orientation_contact__c = "orientation_contact__c",
  /** column name */
  orientation_date__c = "orientation_date__c",
  /** column name */
  other_credentials__c = "other_credentials__c",
  /** column name */
  outreach_url__c = "outreach_url__c",
  /** column name */
  overall_customer_health__c = "overall_customer_health__c",
  /** column name */
  papa_johns__c = "papa_johns__c",
  /** column name */
  parent_id__c = "parent_id__c",
  /** column name */
  partner_type__c = "partner_type__c",
  /** column name */
  payroll_integration__c = "payroll_integration__c",
  /** column name */
  payroll_owner__c = "payroll_owner__c",
  /** column name */
  payroll_owner_text__c = "payroll_owner_text__c",
  /** column name */
  payroll_owner_uk_payroll__c = "payroll_owner_uk_payroll__c",
  /** column name */
  payroll_vendor__c = "payroll_vendor__c",
  /** column name */
  pe_influence__c = "pe_influence__c",
  /** column name */
  percent_franchised__c = "percent_franchised__c",
  /** column name */
  pos__c = "pos__c",
  /** column name */
  pos_vendor__c = "pos_vendor__c",
  /** column name */
  predict_proba__c = "predict_proba__c",
  /** column name */
  primarycontact2__c = "primarycontact2__c",
  /** column name */
  product_bucket__c = "product_bucket__c",
  /** column name */
  prospect_or_customer__c = "prospect_or_customer__c",
  /** column name */
  publiccorp__c = "publiccorp__c",
  /** column name */
  purchasing_power__c = "purchasing_power__c",
  /** column name */
  quickbooks_last_invoice__c = "quickbooks_last_invoice__c",
  /** column name */
  quickbooks_last_invoice_date__c = "quickbooks_last_invoice_date__c",
  /** column name */
  quickbooks_total_balance__c = "quickbooks_total_balance__c",
  /** column name */
  random_forest__c = "random_forest__c",
  /** column name */
  reference_1__c = "reference_1__c",
  /** column name */
  reference_2__c = "reference_2__c",
  /** column name */
  reference__c = "reference__c",
  /** column name */
  root_brand_id__c = "root_brand_id__c",
  /** column name */
  root_brand_type__c = "root_brand_type__c",
  /** column name */
  rootid__c = "rootid__c",
  /** column name */
  ropackage__acctupdateindex__c = "ropackage__acctupdateindex__c",
  /** column name */
  ropackage__createdbyrestaurantology__c = "ropackage__createdbyrestaurantology__c",
  /** column name */
  ropackage__known_for__c = "ropackage__known_for__c",
  /** column name */
  ropackage__latest_restaurantology_tech_data__c = "ropackage__latest_restaurantology_tech_data__c",
  /** column name */
  ropackage__parent_restaurantology_internal_id__c = "ropackage__parent_restaurantology_internal_id__c",
  /** column name */
  ropackage__reconnlogindex__c = "ropackage__reconnlogindex__c",
  /** column name */
  ropackage__restaurantology_internal_id__c = "ropackage__restaurantology_internal_id__c",
  /** column name */
  ropackage__roalphaname__c = "ropackage__roalphaname__c",
  /** column name */
  ropackage__rocleaneddomain__c = "ropackage__rocleaneddomain__c",
  /** column name */
  ropackage__service_type__c = "ropackage__service_type__c",
  /** column name */
  ropackage__total_locations_overall__c = "ropackage__total_locations_overall__c",
  /** column name */
  sales_priority_tier__c = "sales_priority_tier__c",
  /** column name */
  sales_territory__c = "sales_territory__c",
  /** column name */
  sdr_owner__c = "sdr_owner__c",
  /** column name */
  secondary_customer_success_manager__c = "secondary_customer_success_manager__c",
  /** column name */
  segment__c = "segment__c",
  /** column name */
  service_type__c = "service_type__c",
  /** column name */
  sim_form_ready__c = "sim_form_ready__c",
  /** column name */
  sim_form_ready_date__c = "sim_form_ready_date__c",
  /** column name */
  sim_form_start_date__c = "sim_form_start_date__c",
  /** column name */
  sim_form_team_member__c = "sim_form_team_member__c",
  /** column name */
  size__c = "size__c",
  /** column name */
  slug__c = "slug__c",
  /** column name */
  social_facebook_company_profile__c = "social_facebook_company_profile__c",
  /** column name */
  social_instagram_company_profile__c = "social_instagram_company_profile__c",
  /** column name */
  social_linkedin_company_profile__c = "social_linkedin_company_profile__c",
  /** column name */
  social_pinterest_company_profile__c = "social_pinterest_company_profile__c",
  /** column name */
  social_tripadvisor_company_profile__c = "social_tripadvisor_company_profile__c",
  /** column name */
  social_twitter_company_profile__c = "social_twitter_company_profile__c",
  /** column name */
  social_yelp_company_profile__c = "social_yelp_company_profile__c",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  standard_documents__c = "standard_documents__c",
  /** column name */
  strategic_account__c = "strategic_account__c",
  /** column name */
  stripe_ids__c = "stripe_ids__c",
  /** column name */
  structure_file__c = "structure_file__c",
  /** column name */
  su_training_date__c = "su_training_date__c",
  /** column name */
  sub_industry__c = "sub_industry__c",
  /** column name */
  systemstructurelookup__c = "systemstructurelookup__c",
  /** column name */
  target_status__c = "target_status__c",
  /** column name */
  target_tier__c = "target_tier__c",
  /** column name */
  total_cmrr_all_opportunities__c = "total_cmrr_all_opportunities__c",
  /** column name */
  total_cmrr_won_opportunities__c = "total_cmrr_won_opportunities__c",
  /** column name */
  total_current_cmrr__c = "total_current_cmrr__c",
  /** column name */
  trading_states__c = "trading_states__c",
  /** column name */
  trading_status__c = "trading_status__c",
  /** column name */
  training_sessions_complete__c = "training_sessions_complete__c",
  /** column name */
  type2__c = "type2__c",
  /** column name */
  type_of_business__c = "type_of_business__c",
  /** column name */
  uniquebrandco__c = "uniquebrandco__c",
  /** column name */
  uniqueid__c = "uniqueid__c",
  /** column name */
  unit_intel__c = "unit_intel__c",
  /** column name */
  up__district__c = "up__district__c",
  /** column name */
  up__region__c = "up__region__c",
  /** column name */
  up__territory__c = "up__territory__c",
  /** column name */
  upsell_items__c = "upsell_items__c",
  /** column name */
  upsell_notes__c = "upsell_notes__c",
  /** column name */
  upsell_potential__c = "upsell_potential__c",
  /** column name */
  url__c = "url__c",
  /** column name */
  url_of_account_review_notes__c = "url_of_account_review_notes__c",
  /** column name */
  users__c = "users__c",
  /** column name */
  web_client_only__c = "web_client_only__c",
  /** column name */
  workpop_lead__c = "workpop_lead__c",
  /** column name */
  yelp__c = "yelp__c",
  /** column name */
  zendesk_id__c = "zendesk_id__c",
  /** column name */
  zisf__company_id__c = "zisf__company_id__c",
  /** column name */
  zisf__zoom_clean_status__c = "zisf__zoom_clean_status__c",
  /** column name */
  zisf__zoom_id__c = "zisf__zoom_id__c",
  /** column name */
  zisf__zoom_lastupdated__c = "zisf__zoom_lastupdated__c",
  /** column name */
  zisf__zoominfo_complete_status__c = "zisf__zoominfo_complete_status__c",
  /** column name */
  zisf__zoominfo_industry__c = "zisf__zoominfo_industry__c",
  /** column name */
  zisf__zoominfo_last_clean_run__c = "zisf__zoominfo_last_clean_run__c",
}

/** input type for updating data in table "account__c" */
export type account__c_set_input = {
  account_id__c?: InputMaybe<Scalars["String"]>;
  account_power_of_1__c?: InputMaybe<Scalars["numeric"]>;
  account_region__c?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  account_type__c?: InputMaybe<Scalars["String"]>;
  accountnamelength__c?: InputMaybe<Scalars["numeric"]>;
  active__c?: InputMaybe<Scalars["Boolean"]>;
  active_accounts_14_days__c?: InputMaybe<Scalars["numeric"]>;
  active_employees__c?: InputMaybe<Scalars["String"]>;
  active_users__c?: InputMaybe<Scalars["numeric"]>;
  alternative_contact_email__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_first_name__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_last_name__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_phone__c?: InputMaybe<Scalars["String"]>;
  alternative_email__c?: InputMaybe<Scalars["String"]>;
  alternative_mobile__c?: InputMaybe<Scalars["String"]>;
  alternative_phone__c?: InputMaybe<Scalars["String"]>;
  arr1__c?: InputMaybe<Scalars["numeric"]>;
  billing_deferral_date_updated__c?: InputMaybe<Scalars["timestamp"]>;
  billing_status__c?: InputMaybe<Scalars["String"]>;
  billing_trading_notes__c?: InputMaybe<Scalars["String"]>;
  bizsys_application_tracking_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_business_intelligence__c?: InputMaybe<Scalars["String"]>;
  bizsys_employee_management__c?: InputMaybe<Scalars["String"]>;
  bizsys_enterprise_solutions__c?: InputMaybe<Scalars["String"]>;
  bizsys_hcm__c?: InputMaybe<Scalars["String"]>;
  bizsys_interviewer_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_inventory_invoicing__c?: InputMaybe<Scalars["String"]>;
  bizsys_job_board_listing__c?: InputMaybe<Scalars["String"]>;
  bizsys_learning_management_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_onboarding__c?: InputMaybe<Scalars["String"]>;
  bizsys_payroll__c?: InputMaybe<Scalars["String"]>;
  bizsys_point_of_sale_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_recruitment_marketing__c?: InputMaybe<Scalars["String"]>;
  bizsys_scheduler_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_texting__c?: InputMaybe<Scalars["String"]>;
  bizsys_time_attendance_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_zoominfo_tech_stack__c?: InputMaybe<Scalars["String"]>;
  brand_id__c?: InputMaybe<Scalars["numeric"]>;
  brand_intel__c?: InputMaybe<Scalars["String"]>;
  bu__c?: InputMaybe<Scalars["String"]>;
  bu_long_name__c?: InputMaybe<Scalars["String"]>;
  bu_short_name__c?: InputMaybe<Scalars["String"]>;
  case_owner__c?: InputMaybe<Scalars["String"]>;
  categorical_priority__c?: InputMaybe<Scalars["String"]>;
  check__c?: InputMaybe<Scalars["Boolean"]>;
  churn_date__c?: InputMaybe<Scalars["timestamp"]>;
  churn_details__c?: InputMaybe<Scalars["String"]>;
  churn_reason__c?: InputMaybe<Scalars["String"]>;
  churn_reason_old__c?: InputMaybe<Scalars["String"]>;
  churn_sub_reason__c?: InputMaybe<Scalars["String"]>;
  churned__c?: InputMaybe<Scalars["Boolean"]>;
  churned_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  churned_to__c?: InputMaybe<Scalars["String"]>;
  city__c?: InputMaybe<Scalars["String"]>;
  commission_rules_of_engagement_exception__c?: InputMaybe<Scalars["Boolean"]>;
  concept_type__c?: InputMaybe<Scalars["String"]>;
  concepts__c?: InputMaybe<Scalars["String"]>;
  contact__c?: InputMaybe<Scalars["String"]>;
  contact_name__c?: InputMaybe<Scalars["String"]>;
  contact_phone__c?: InputMaybe<Scalars["String"]>;
  contracted_services__c?: InputMaybe<Scalars["String"]>;
  contracted_training_sessions__c?: InputMaybe<Scalars["numeric"]>;
  covid__c?: InputMaybe<Scalars["Boolean"]>;
  created_date__c?: InputMaybe<Scalars["timestamp"]>;
  cs_owner__c?: InputMaybe<Scalars["String"]>;
  cs_owner_text__c?: InputMaybe<Scalars["String"]>;
  csat__c?: InputMaybe<Scalars["String"]>;
  csat_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  current_contracted_employees__c?: InputMaybe<Scalars["numeric"]>;
  current_contracted_locations__c?: InputMaybe<Scalars["numeric"]>;
  custom_status__c?: InputMaybe<Scalars["String"]>;
  customer__c?: InputMaybe<Scalars["Boolean"]>;
  customer_health_rating__c?: InputMaybe<Scalars["String"]>;
  customer_health_ryg__c?: InputMaybe<Scalars["String"]>;
  customer_lifecycle_status__c?: InputMaybe<Scalars["String"]>;
  customer_satisfaction_ryg__c?: InputMaybe<Scalars["String"]>;
  customer_status__c?: InputMaybe<Scalars["String"]>;
  customer_success_owner__c?: InputMaybe<Scalars["String"]>;
  customer_support__c?: InputMaybe<Scalars["String"]>;
  customization__c?: InputMaybe<Scalars["String"]>;
  data_quality_description__c?: InputMaybe<Scalars["String"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  date_of_last_check_in__c?: InputMaybe<Scalars["timestamp"]>;
  date_of_next_account_review__c?: InputMaybe<Scalars["timestamp"]>;
  different__c?: InputMaybe<Scalars["Boolean"]>;
  different_ids__c?: InputMaybe<Scalars["Boolean"]>;
  doors__c?: InputMaybe<Scalars["numeric"]>;
  dozisf__zoominfo_enrich_status__c?: InputMaybe<Scalars["String"]>;
  dozisf__zoominfo_first_updated__c?: InputMaybe<Scalars["timestamp"]>;
  dozisf__zoominfo_id__c?: InputMaybe<Scalars["String"]>;
  dozisf__zoominfo_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  email__c?: InputMaybe<Scalars["String"]>;
  employer_location_id__c?: InputMaybe<Scalars["numeric"]>;
  end_date__c?: InputMaybe<Scalars["timestamp"]>;
  estimated_contract_value__c?: InputMaybe<Scalars["numeric"]>;
  fair_workweek__c?: InputMaybe<Scalars["Boolean"]>;
  field_office__c?: InputMaybe<Scalars["String"]>;
  fin_fortune_1000_rank__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size_accuracy__c?: InputMaybe<Scalars["String"]>;
  fin_location_size_unit_of_measure__c?: InputMaybe<Scalars["String"]>;
  fin_prior_year_revenue__c?: InputMaybe<Scalars["numeric"]>;
  fin_prior_yr_employees__c?: InputMaybe<Scalars["numeric"]>;
  fin_s_p_500__c?: InputMaybe<Scalars["String"]>;
  focus_accounts__c?: InputMaybe<Scalars["Boolean"]>;
  focus_accounts_open_opps__c?: InputMaybe<Scalars["String"]>;
  for_finance__c?: InputMaybe<Scalars["Boolean"]>;
  franchise_brands__c?: InputMaybe<Scalars["String"]>;
  franchise_name__c?: InputMaybe<Scalars["String"]>;
  franchisee__c?: InputMaybe<Scalars["Boolean"]>;
  franchisor__c?: InputMaybe<Scalars["Boolean"]>;
  franshisee__c?: InputMaybe<Scalars["Boolean"]>;
  frozen__c?: InputMaybe<Scalars["Boolean"]>;
  generated_address__c?: InputMaybe<Scalars["String"]>;
  gong__gong_count__c?: InputMaybe<Scalars["numeric"]>;
  google_analytics_campaign__c?: InputMaybe<Scalars["String"]>;
  google_analytics_content__c?: InputMaybe<Scalars["String"]>;
  google_analytics_medium__c?: InputMaybe<Scalars["String"]>;
  google_analytics_source__c?: InputMaybe<Scalars["String"]>;
  google_analytics_term__c?: InputMaybe<Scalars["String"]>;
  group_id__c?: InputMaybe<Scalars["String"]>;
  harri_api_enabled__c?: InputMaybe<Scalars["Boolean"]>;
  harri_brand_type__c?: InputMaybe<Scalars["String"]>;
  harri_client_id__c?: InputMaybe<Scalars["numeric"]>;
  harri_employees_per_brand__c?: InputMaybe<Scalars["numeric"]>;
  harri_locations_count__c?: InputMaybe<Scalars["numeric"]>;
  harri_profile_created__c?: InputMaybe<Scalars["Boolean"]>;
  harri_strategic_sponsor_name__c?: InputMaybe<Scalars["String"]>;
  harri_subscription_status__c?: InputMaybe<Scalars["String"]>;
  harri_user_id__c?: InputMaybe<Scalars["numeric"]>;
  hecs_brands_type__c?: InputMaybe<Scalars["String"]>;
  hecs_category__c?: InputMaybe<Scalars["String"]>;
  hecs_owner_type__c?: InputMaybe<Scalars["String"]>;
  hot_button_feature__c?: InputMaybe<Scalars["String"]>;
  house_account__c?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  ignore__c?: InputMaybe<Scalars["String"]>;
  include__c?: InputMaybe<Scalars["Boolean"]>;
  industry__c?: InputMaybe<Scalars["String"]>;
  industry_category__c?: InputMaybe<Scalars["String"]>;
  inserted_from_system__c?: InputMaybe<Scalars["String"]>;
  is_yesterday__c?: InputMaybe<Scalars["Boolean"]>;
  job_distributor__c?: InputMaybe<Scalars["String"]>;
  job_distributor_details__c?: InputMaybe<Scalars["String"]>;
  job_post__c?: InputMaybe<Scalars["String"]>;
  kick_start__c?: InputMaybe<Scalars["Boolean"]>;
  last_activity__c?: InputMaybe<Scalars["timestamp"]>;
  last_check_in_comments__c?: InputMaybe<Scalars["String"]>;
  last_job_post_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_new_sale_close_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_new_sale_subscription_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_scheduled_publish_date__c?: InputMaybe<Scalars["timestamp"]>;
  latest_csat_nps_overall_experience__c?: InputMaybe<Scalars["numeric"]>;
  latest_csat_overall_nps_rating__c?: InputMaybe<Scalars["String"]>;
  latest_customer_satisfaction_rating__c?: InputMaybe<Scalars["String"]>;
  latest_customer_satisfaction_survey__c?: InputMaybe<Scalars["numeric"]>;
  latest_fran__c?: InputMaybe<Scalars["String"]>;
  legacy_id__c?: InputMaybe<Scalars["String"]>;
  legacy_parent_id__c?: InputMaybe<Scalars["String"]>;
  lid__linkedin_company_id__c?: InputMaybe<Scalars["String"]>;
  link_to_sim_form__c?: InputMaybe<Scalars["String"]>;
  live_services__c?: InputMaybe<Scalars["String"]>;
  locations__c?: InputMaybe<Scalars["numeric"]>;
  locations_billed__c?: InputMaybe<Scalars["numeric"]>;
  locations_in_harri__c?: InputMaybe<Scalars["numeric"]>;
  luke_vip__c?: InputMaybe<Scalars["Boolean"]>;
  macro_text__c?: InputMaybe<Scalars["String"]>;
  macro_themes__c?: InputMaybe<Scalars["String"]>;
  mainfranchiserhq__c?: InputMaybe<Scalars["Boolean"]>;
  mcd_operator_name__c?: InputMaybe<Scalars["String"]>;
  mcdonald_s_governance__c?: InputMaybe<Scalars["Boolean"]>;
  micro_text__c?: InputMaybe<Scalars["String"]>;
  micro_themes__c?: InputMaybe<Scalars["String"]>;
  missed_orientation__c?: InputMaybe<Scalars["Boolean"]>;
  mktg_harri_partnership__c?: InputMaybe<Scalars["String"]>;
  mktg_harri_partnership_adp_q1__c?: InputMaybe<Scalars["String"]>;
  mktg_harri_partnership_adp_q2__c?: InputMaybe<Scalars["String"]>;
  mktg_sales_channel__c?: InputMaybe<Scalars["String"]>;
  mktg_time_zone__c?: InputMaybe<Scalars["String"]>;
  most_recent_close_date_for_renewal_opp__c?: InputMaybe<Scalars["timestamp"]>;
  mrr_from_gl_12_19__c?: InputMaybe<Scalars["numeric"]>;
  multi_type__c?: InputMaybe<Scalars["String"]>;
  naive_bayes__c?: InputMaybe<Scalars["numeric"]>;
  net_promoter_comment__c?: InputMaybe<Scalars["String"]>;
  new_mrr_2020__c?: InputMaybe<Scalars["numeric"]>;
  no_of_closed_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_open_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  no_outbound__c?: InputMaybe<Scalars["Boolean"]>;
  notes__c?: InputMaybe<Scalars["String"]>;
  november_2021_current_invoice__c?: InputMaybe<Scalars["numeric"]>;
  nps__c?: InputMaybe<Scalars["String"]>;
  nps_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  num_closed_opps__c?: InputMaybe<Scalars["numeric"]>;
  number_of_job_postings__c?: InputMaybe<Scalars["numeric"]>;
  number_of_valid_end_dates__c?: InputMaybe<Scalars["numeric"]>;
  of_won_opp__c?: InputMaybe<Scalars["numeric"]>;
  omis_account_id__c?: InputMaybe<Scalars["String"]>;
  omis_door_id__c?: InputMaybe<Scalars["String"]>;
  omis_rating__c?: InputMaybe<Scalars["String"]>;
  omis_score__c?: InputMaybe<Scalars["String"]>;
  onboarding__c?: InputMaybe<Scalars["Boolean"]>;
  open_opportunity_tag__c?: InputMaybe<Scalars["Boolean"]>;
  operating_structure_2__c?: InputMaybe<Scalars["String"]>;
  operational_structure__c?: InputMaybe<Scalars["String"]>;
  orientation_conducted_by__c?: InputMaybe<Scalars["String"]>;
  orientation_contact__c?: InputMaybe<Scalars["String"]>;
  orientation_date__c?: InputMaybe<Scalars["timestamp"]>;
  other_credentials__c?: InputMaybe<Scalars["String"]>;
  outreach_url__c?: InputMaybe<Scalars["String"]>;
  overall_customer_health__c?: InputMaybe<Scalars["String"]>;
  papa_johns__c?: InputMaybe<Scalars["Boolean"]>;
  parent_id__c?: InputMaybe<Scalars["numeric"]>;
  partner_type__c?: InputMaybe<Scalars["String"]>;
  payroll_integration__c?: InputMaybe<Scalars["String"]>;
  payroll_owner__c?: InputMaybe<Scalars["String"]>;
  payroll_owner_text__c?: InputMaybe<Scalars["String"]>;
  payroll_owner_uk_payroll__c?: InputMaybe<Scalars["String"]>;
  payroll_vendor__c?: InputMaybe<Scalars["String"]>;
  pe_influence__c?: InputMaybe<Scalars["String"]>;
  percent_franchised__c?: InputMaybe<Scalars["String"]>;
  pos__c?: InputMaybe<Scalars["String"]>;
  pos_vendor__c?: InputMaybe<Scalars["String"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  primarycontact2__c?: InputMaybe<Scalars["String"]>;
  product_bucket__c?: InputMaybe<Scalars["String"]>;
  prospect_or_customer__c?: InputMaybe<Scalars["String"]>;
  publiccorp__c?: InputMaybe<Scalars["Boolean"]>;
  purchasing_power__c?: InputMaybe<Scalars["String"]>;
  quickbooks_last_invoice__c?: InputMaybe<Scalars["numeric"]>;
  quickbooks_last_invoice_date__c?: InputMaybe<Scalars["timestamp"]>;
  quickbooks_total_balance__c?: InputMaybe<Scalars["numeric"]>;
  random_forest__c?: InputMaybe<Scalars["numeric"]>;
  reference_1__c?: InputMaybe<Scalars["String"]>;
  reference_2__c?: InputMaybe<Scalars["String"]>;
  reference__c?: InputMaybe<Scalars["String"]>;
  root_brand_id__c?: InputMaybe<Scalars["String"]>;
  root_brand_type__c?: InputMaybe<Scalars["String"]>;
  rootid__c?: InputMaybe<Scalars["String"]>;
  ropackage__acctupdateindex__c?: InputMaybe<Scalars["String"]>;
  ropackage__createdbyrestaurantology__c?: InputMaybe<Scalars["Boolean"]>;
  ropackage__known_for__c?: InputMaybe<Scalars["String"]>;
  ropackage__latest_restaurantology_tech_data__c?: InputMaybe<
    Scalars["String"]
  >;
  ropackage__parent_restaurantology_internal_id__c?: InputMaybe<
    Scalars["String"]
  >;
  ropackage__reconnlogindex__c?: InputMaybe<Scalars["String"]>;
  ropackage__restaurantology_internal_id__c?: InputMaybe<Scalars["String"]>;
  ropackage__roalphaname__c?: InputMaybe<Scalars["String"]>;
  ropackage__rocleaneddomain__c?: InputMaybe<Scalars["String"]>;
  ropackage__service_type__c?: InputMaybe<Scalars["String"]>;
  ropackage__total_locations_overall__c?: InputMaybe<Scalars["numeric"]>;
  sales_priority_tier__c?: InputMaybe<Scalars["String"]>;
  sales_territory__c?: InputMaybe<Scalars["String"]>;
  sdr_owner__c?: InputMaybe<Scalars["String"]>;
  secondary_customer_success_manager__c?: InputMaybe<Scalars["String"]>;
  segment__c?: InputMaybe<Scalars["String"]>;
  service_type__c?: InputMaybe<Scalars["String"]>;
  sim_form_ready__c?: InputMaybe<Scalars["String"]>;
  sim_form_ready_date__c?: InputMaybe<Scalars["timestamp"]>;
  sim_form_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  sim_form_team_member__c?: InputMaybe<Scalars["String"]>;
  size__c?: InputMaybe<Scalars["String"]>;
  slug__c?: InputMaybe<Scalars["String"]>;
  social_facebook_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_instagram_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_linkedin_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_pinterest_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_tripadvisor_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_twitter_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_yelp_company_profile__c?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  standard_documents__c?: InputMaybe<Scalars["String"]>;
  strategic_account__c?: InputMaybe<Scalars["Boolean"]>;
  stripe_ids__c?: InputMaybe<Scalars["String"]>;
  structure_file__c?: InputMaybe<Scalars["String"]>;
  su_training_date__c?: InputMaybe<Scalars["timestamp"]>;
  sub_industry__c?: InputMaybe<Scalars["String"]>;
  systemstructurelookup__c?: InputMaybe<Scalars["String"]>;
  target_status__c?: InputMaybe<Scalars["String"]>;
  target_tier__c?: InputMaybe<Scalars["String"]>;
  total_cmrr_all_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_cmrr_won_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_current_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  trading_states__c?: InputMaybe<Scalars["String"]>;
  trading_status__c?: InputMaybe<Scalars["String"]>;
  training_sessions_complete__c?: InputMaybe<Scalars["numeric"]>;
  type2__c?: InputMaybe<Scalars["String"]>;
  type_of_business__c?: InputMaybe<Scalars["String"]>;
  uniquebrandco__c?: InputMaybe<Scalars["Boolean"]>;
  uniqueid__c?: InputMaybe<Scalars["String"]>;
  unit_intel__c?: InputMaybe<Scalars["String"]>;
  up__district__c?: InputMaybe<Scalars["String"]>;
  up__region__c?: InputMaybe<Scalars["String"]>;
  up__territory__c?: InputMaybe<Scalars["String"]>;
  upsell_items__c?: InputMaybe<Scalars["String"]>;
  upsell_notes__c?: InputMaybe<Scalars["String"]>;
  upsell_potential__c?: InputMaybe<Scalars["String"]>;
  url__c?: InputMaybe<Scalars["String"]>;
  url_of_account_review_notes__c?: InputMaybe<Scalars["String"]>;
  users__c?: InputMaybe<Scalars["numeric"]>;
  web_client_only__c?: InputMaybe<Scalars["Boolean"]>;
  workpop_lead__c?: InputMaybe<Scalars["Boolean"]>;
  yelp__c?: InputMaybe<Scalars["String"]>;
  zendesk_id__c?: InputMaybe<Scalars["String"]>;
  zisf__company_id__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_clean_status__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_id__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_lastupdated__c?: InputMaybe<Scalars["timestamp"]>;
  zisf__zoominfo_complete_status__c?: InputMaybe<Scalars["String"]>;
  zisf__zoominfo_industry__c?: InputMaybe<Scalars["String"]>;
  zisf__zoominfo_last_clean_run__c?: InputMaybe<Scalars["timestamp"]>;
};

/** Streaming cursor of the table "account__c" */
export type account__c_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account__c_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account__c_stream_cursor_value_input = {
  account_id__c?: InputMaybe<Scalars["String"]>;
  account_power_of_1__c?: InputMaybe<Scalars["numeric"]>;
  account_region__c?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  account_type__c?: InputMaybe<Scalars["String"]>;
  accountnamelength__c?: InputMaybe<Scalars["numeric"]>;
  active__c?: InputMaybe<Scalars["Boolean"]>;
  active_accounts_14_days__c?: InputMaybe<Scalars["numeric"]>;
  active_employees__c?: InputMaybe<Scalars["String"]>;
  active_users__c?: InputMaybe<Scalars["numeric"]>;
  alternative_contact_email__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_first_name__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_last_name__c?: InputMaybe<Scalars["String"]>;
  alternative_contact_phone__c?: InputMaybe<Scalars["String"]>;
  alternative_email__c?: InputMaybe<Scalars["String"]>;
  alternative_mobile__c?: InputMaybe<Scalars["String"]>;
  alternative_phone__c?: InputMaybe<Scalars["String"]>;
  arr1__c?: InputMaybe<Scalars["numeric"]>;
  billing_deferral_date_updated__c?: InputMaybe<Scalars["timestamp"]>;
  billing_status__c?: InputMaybe<Scalars["String"]>;
  billing_trading_notes__c?: InputMaybe<Scalars["String"]>;
  bizsys_application_tracking_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_business_intelligence__c?: InputMaybe<Scalars["String"]>;
  bizsys_employee_management__c?: InputMaybe<Scalars["String"]>;
  bizsys_enterprise_solutions__c?: InputMaybe<Scalars["String"]>;
  bizsys_hcm__c?: InputMaybe<Scalars["String"]>;
  bizsys_interviewer_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_inventory_invoicing__c?: InputMaybe<Scalars["String"]>;
  bizsys_job_board_listing__c?: InputMaybe<Scalars["String"]>;
  bizsys_learning_management_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_onboarding__c?: InputMaybe<Scalars["String"]>;
  bizsys_payroll__c?: InputMaybe<Scalars["String"]>;
  bizsys_point_of_sale_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_recruitment_marketing__c?: InputMaybe<Scalars["String"]>;
  bizsys_scheduler_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_texting__c?: InputMaybe<Scalars["String"]>;
  bizsys_time_attendance_system__c?: InputMaybe<Scalars["String"]>;
  bizsys_zoominfo_tech_stack__c?: InputMaybe<Scalars["String"]>;
  brand_id__c?: InputMaybe<Scalars["numeric"]>;
  brand_intel__c?: InputMaybe<Scalars["String"]>;
  bu__c?: InputMaybe<Scalars["String"]>;
  bu_long_name__c?: InputMaybe<Scalars["String"]>;
  bu_short_name__c?: InputMaybe<Scalars["String"]>;
  case_owner__c?: InputMaybe<Scalars["String"]>;
  categorical_priority__c?: InputMaybe<Scalars["String"]>;
  check__c?: InputMaybe<Scalars["Boolean"]>;
  churn_date__c?: InputMaybe<Scalars["timestamp"]>;
  churn_details__c?: InputMaybe<Scalars["String"]>;
  churn_reason__c?: InputMaybe<Scalars["String"]>;
  churn_reason_old__c?: InputMaybe<Scalars["String"]>;
  churn_sub_reason__c?: InputMaybe<Scalars["String"]>;
  churned__c?: InputMaybe<Scalars["Boolean"]>;
  churned_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  churned_to__c?: InputMaybe<Scalars["String"]>;
  city__c?: InputMaybe<Scalars["String"]>;
  commission_rules_of_engagement_exception__c?: InputMaybe<Scalars["Boolean"]>;
  concept_type__c?: InputMaybe<Scalars["String"]>;
  concepts__c?: InputMaybe<Scalars["String"]>;
  contact__c?: InputMaybe<Scalars["String"]>;
  contact_name__c?: InputMaybe<Scalars["String"]>;
  contact_phone__c?: InputMaybe<Scalars["String"]>;
  contracted_services__c?: InputMaybe<Scalars["String"]>;
  contracted_training_sessions__c?: InputMaybe<Scalars["numeric"]>;
  covid__c?: InputMaybe<Scalars["Boolean"]>;
  created_date__c?: InputMaybe<Scalars["timestamp"]>;
  cs_owner__c?: InputMaybe<Scalars["String"]>;
  cs_owner_text__c?: InputMaybe<Scalars["String"]>;
  csat__c?: InputMaybe<Scalars["String"]>;
  csat_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  current_contracted_employees__c?: InputMaybe<Scalars["numeric"]>;
  current_contracted_locations__c?: InputMaybe<Scalars["numeric"]>;
  custom_status__c?: InputMaybe<Scalars["String"]>;
  customer__c?: InputMaybe<Scalars["Boolean"]>;
  customer_health_rating__c?: InputMaybe<Scalars["String"]>;
  customer_health_ryg__c?: InputMaybe<Scalars["String"]>;
  customer_lifecycle_status__c?: InputMaybe<Scalars["String"]>;
  customer_satisfaction_ryg__c?: InputMaybe<Scalars["String"]>;
  customer_status__c?: InputMaybe<Scalars["String"]>;
  customer_success_owner__c?: InputMaybe<Scalars["String"]>;
  customer_support__c?: InputMaybe<Scalars["String"]>;
  customization__c?: InputMaybe<Scalars["String"]>;
  data_quality_description__c?: InputMaybe<Scalars["String"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  date_of_last_check_in__c?: InputMaybe<Scalars["timestamp"]>;
  date_of_next_account_review__c?: InputMaybe<Scalars["timestamp"]>;
  different__c?: InputMaybe<Scalars["Boolean"]>;
  different_ids__c?: InputMaybe<Scalars["Boolean"]>;
  doors__c?: InputMaybe<Scalars["numeric"]>;
  dozisf__zoominfo_enrich_status__c?: InputMaybe<Scalars["String"]>;
  dozisf__zoominfo_first_updated__c?: InputMaybe<Scalars["timestamp"]>;
  dozisf__zoominfo_id__c?: InputMaybe<Scalars["String"]>;
  dozisf__zoominfo_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  email__c?: InputMaybe<Scalars["String"]>;
  employer_location_id__c?: InputMaybe<Scalars["numeric"]>;
  end_date__c?: InputMaybe<Scalars["timestamp"]>;
  estimated_contract_value__c?: InputMaybe<Scalars["numeric"]>;
  fair_workweek__c?: InputMaybe<Scalars["Boolean"]>;
  field_office__c?: InputMaybe<Scalars["String"]>;
  fin_fortune_1000_rank__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size__c?: InputMaybe<Scalars["numeric"]>;
  fin_location_size_accuracy__c?: InputMaybe<Scalars["String"]>;
  fin_location_size_unit_of_measure__c?: InputMaybe<Scalars["String"]>;
  fin_prior_year_revenue__c?: InputMaybe<Scalars["numeric"]>;
  fin_prior_yr_employees__c?: InputMaybe<Scalars["numeric"]>;
  fin_s_p_500__c?: InputMaybe<Scalars["String"]>;
  focus_accounts__c?: InputMaybe<Scalars["Boolean"]>;
  focus_accounts_open_opps__c?: InputMaybe<Scalars["String"]>;
  for_finance__c?: InputMaybe<Scalars["Boolean"]>;
  franchise_brands__c?: InputMaybe<Scalars["String"]>;
  franchise_name__c?: InputMaybe<Scalars["String"]>;
  franchisee__c?: InputMaybe<Scalars["Boolean"]>;
  franchisor__c?: InputMaybe<Scalars["Boolean"]>;
  franshisee__c?: InputMaybe<Scalars["Boolean"]>;
  frozen__c?: InputMaybe<Scalars["Boolean"]>;
  generated_address__c?: InputMaybe<Scalars["String"]>;
  gong__gong_count__c?: InputMaybe<Scalars["numeric"]>;
  google_analytics_campaign__c?: InputMaybe<Scalars["String"]>;
  google_analytics_content__c?: InputMaybe<Scalars["String"]>;
  google_analytics_medium__c?: InputMaybe<Scalars["String"]>;
  google_analytics_source__c?: InputMaybe<Scalars["String"]>;
  google_analytics_term__c?: InputMaybe<Scalars["String"]>;
  group_id__c?: InputMaybe<Scalars["String"]>;
  harri_api_enabled__c?: InputMaybe<Scalars["Boolean"]>;
  harri_brand_type__c?: InputMaybe<Scalars["String"]>;
  harri_client_id__c?: InputMaybe<Scalars["numeric"]>;
  harri_employees_per_brand__c?: InputMaybe<Scalars["numeric"]>;
  harri_locations_count__c?: InputMaybe<Scalars["numeric"]>;
  harri_profile_created__c?: InputMaybe<Scalars["Boolean"]>;
  harri_strategic_sponsor_name__c?: InputMaybe<Scalars["String"]>;
  harri_subscription_status__c?: InputMaybe<Scalars["String"]>;
  harri_user_id__c?: InputMaybe<Scalars["numeric"]>;
  hecs_brands_type__c?: InputMaybe<Scalars["String"]>;
  hecs_category__c?: InputMaybe<Scalars["String"]>;
  hecs_owner_type__c?: InputMaybe<Scalars["String"]>;
  hot_button_feature__c?: InputMaybe<Scalars["String"]>;
  house_account__c?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  ignore__c?: InputMaybe<Scalars["String"]>;
  include__c?: InputMaybe<Scalars["Boolean"]>;
  industry__c?: InputMaybe<Scalars["String"]>;
  industry_category__c?: InputMaybe<Scalars["String"]>;
  inserted_from_system__c?: InputMaybe<Scalars["String"]>;
  is_yesterday__c?: InputMaybe<Scalars["Boolean"]>;
  job_distributor__c?: InputMaybe<Scalars["String"]>;
  job_distributor_details__c?: InputMaybe<Scalars["String"]>;
  job_post__c?: InputMaybe<Scalars["String"]>;
  kick_start__c?: InputMaybe<Scalars["Boolean"]>;
  last_activity__c?: InputMaybe<Scalars["timestamp"]>;
  last_check_in_comments__c?: InputMaybe<Scalars["String"]>;
  last_job_post_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_new_sale_close_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_new_sale_subscription_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  last_scheduled_publish_date__c?: InputMaybe<Scalars["timestamp"]>;
  latest_csat_nps_overall_experience__c?: InputMaybe<Scalars["numeric"]>;
  latest_csat_overall_nps_rating__c?: InputMaybe<Scalars["String"]>;
  latest_customer_satisfaction_rating__c?: InputMaybe<Scalars["String"]>;
  latest_customer_satisfaction_survey__c?: InputMaybe<Scalars["numeric"]>;
  latest_fran__c?: InputMaybe<Scalars["String"]>;
  legacy_id__c?: InputMaybe<Scalars["String"]>;
  legacy_parent_id__c?: InputMaybe<Scalars["String"]>;
  lid__linkedin_company_id__c?: InputMaybe<Scalars["String"]>;
  link_to_sim_form__c?: InputMaybe<Scalars["String"]>;
  live_services__c?: InputMaybe<Scalars["String"]>;
  locations__c?: InputMaybe<Scalars["numeric"]>;
  locations_billed__c?: InputMaybe<Scalars["numeric"]>;
  locations_in_harri__c?: InputMaybe<Scalars["numeric"]>;
  luke_vip__c?: InputMaybe<Scalars["Boolean"]>;
  macro_text__c?: InputMaybe<Scalars["String"]>;
  macro_themes__c?: InputMaybe<Scalars["String"]>;
  mainfranchiserhq__c?: InputMaybe<Scalars["Boolean"]>;
  mcd_operator_name__c?: InputMaybe<Scalars["String"]>;
  mcdonald_s_governance__c?: InputMaybe<Scalars["Boolean"]>;
  micro_text__c?: InputMaybe<Scalars["String"]>;
  micro_themes__c?: InputMaybe<Scalars["String"]>;
  missed_orientation__c?: InputMaybe<Scalars["Boolean"]>;
  mktg_harri_partnership__c?: InputMaybe<Scalars["String"]>;
  mktg_harri_partnership_adp_q1__c?: InputMaybe<Scalars["String"]>;
  mktg_harri_partnership_adp_q2__c?: InputMaybe<Scalars["String"]>;
  mktg_sales_channel__c?: InputMaybe<Scalars["String"]>;
  mktg_time_zone__c?: InputMaybe<Scalars["String"]>;
  most_recent_close_date_for_renewal_opp__c?: InputMaybe<Scalars["timestamp"]>;
  mrr_from_gl_12_19__c?: InputMaybe<Scalars["numeric"]>;
  multi_type__c?: InputMaybe<Scalars["String"]>;
  naive_bayes__c?: InputMaybe<Scalars["numeric"]>;
  net_promoter_comment__c?: InputMaybe<Scalars["String"]>;
  new_mrr_2020__c?: InputMaybe<Scalars["numeric"]>;
  no_of_closed_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_open_opp__c?: InputMaybe<Scalars["numeric"]>;
  no_of_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  no_outbound__c?: InputMaybe<Scalars["Boolean"]>;
  notes__c?: InputMaybe<Scalars["String"]>;
  november_2021_current_invoice__c?: InputMaybe<Scalars["numeric"]>;
  nps__c?: InputMaybe<Scalars["String"]>;
  nps_last_updated__c?: InputMaybe<Scalars["timestamp"]>;
  num_closed_opps__c?: InputMaybe<Scalars["numeric"]>;
  number_of_job_postings__c?: InputMaybe<Scalars["numeric"]>;
  number_of_valid_end_dates__c?: InputMaybe<Scalars["numeric"]>;
  of_won_opp__c?: InputMaybe<Scalars["numeric"]>;
  omis_account_id__c?: InputMaybe<Scalars["String"]>;
  omis_door_id__c?: InputMaybe<Scalars["String"]>;
  omis_rating__c?: InputMaybe<Scalars["String"]>;
  omis_score__c?: InputMaybe<Scalars["String"]>;
  onboarding__c?: InputMaybe<Scalars["Boolean"]>;
  open_opportunity_tag__c?: InputMaybe<Scalars["Boolean"]>;
  operating_structure_2__c?: InputMaybe<Scalars["String"]>;
  operational_structure__c?: InputMaybe<Scalars["String"]>;
  orientation_conducted_by__c?: InputMaybe<Scalars["String"]>;
  orientation_contact__c?: InputMaybe<Scalars["String"]>;
  orientation_date__c?: InputMaybe<Scalars["timestamp"]>;
  other_credentials__c?: InputMaybe<Scalars["String"]>;
  outreach_url__c?: InputMaybe<Scalars["String"]>;
  overall_customer_health__c?: InputMaybe<Scalars["String"]>;
  papa_johns__c?: InputMaybe<Scalars["Boolean"]>;
  parent_id__c?: InputMaybe<Scalars["numeric"]>;
  partner_type__c?: InputMaybe<Scalars["String"]>;
  payroll_integration__c?: InputMaybe<Scalars["String"]>;
  payroll_owner__c?: InputMaybe<Scalars["String"]>;
  payroll_owner_text__c?: InputMaybe<Scalars["String"]>;
  payroll_owner_uk_payroll__c?: InputMaybe<Scalars["String"]>;
  payroll_vendor__c?: InputMaybe<Scalars["String"]>;
  pe_influence__c?: InputMaybe<Scalars["String"]>;
  percent_franchised__c?: InputMaybe<Scalars["String"]>;
  pos__c?: InputMaybe<Scalars["String"]>;
  pos_vendor__c?: InputMaybe<Scalars["String"]>;
  predict_proba__c?: InputMaybe<Scalars["numeric"]>;
  primarycontact2__c?: InputMaybe<Scalars["String"]>;
  product_bucket__c?: InputMaybe<Scalars["String"]>;
  prospect_or_customer__c?: InputMaybe<Scalars["String"]>;
  publiccorp__c?: InputMaybe<Scalars["Boolean"]>;
  purchasing_power__c?: InputMaybe<Scalars["String"]>;
  quickbooks_last_invoice__c?: InputMaybe<Scalars["numeric"]>;
  quickbooks_last_invoice_date__c?: InputMaybe<Scalars["timestamp"]>;
  quickbooks_total_balance__c?: InputMaybe<Scalars["numeric"]>;
  random_forest__c?: InputMaybe<Scalars["numeric"]>;
  reference_1__c?: InputMaybe<Scalars["String"]>;
  reference_2__c?: InputMaybe<Scalars["String"]>;
  reference__c?: InputMaybe<Scalars["String"]>;
  root_brand_id__c?: InputMaybe<Scalars["String"]>;
  root_brand_type__c?: InputMaybe<Scalars["String"]>;
  rootid__c?: InputMaybe<Scalars["String"]>;
  ropackage__acctupdateindex__c?: InputMaybe<Scalars["String"]>;
  ropackage__createdbyrestaurantology__c?: InputMaybe<Scalars["Boolean"]>;
  ropackage__known_for__c?: InputMaybe<Scalars["String"]>;
  ropackage__latest_restaurantology_tech_data__c?: InputMaybe<
    Scalars["String"]
  >;
  ropackage__parent_restaurantology_internal_id__c?: InputMaybe<
    Scalars["String"]
  >;
  ropackage__reconnlogindex__c?: InputMaybe<Scalars["String"]>;
  ropackage__restaurantology_internal_id__c?: InputMaybe<Scalars["String"]>;
  ropackage__roalphaname__c?: InputMaybe<Scalars["String"]>;
  ropackage__rocleaneddomain__c?: InputMaybe<Scalars["String"]>;
  ropackage__service_type__c?: InputMaybe<Scalars["String"]>;
  ropackage__total_locations_overall__c?: InputMaybe<Scalars["numeric"]>;
  sales_priority_tier__c?: InputMaybe<Scalars["String"]>;
  sales_territory__c?: InputMaybe<Scalars["String"]>;
  sdr_owner__c?: InputMaybe<Scalars["String"]>;
  secondary_customer_success_manager__c?: InputMaybe<Scalars["String"]>;
  segment__c?: InputMaybe<Scalars["String"]>;
  service_type__c?: InputMaybe<Scalars["String"]>;
  sim_form_ready__c?: InputMaybe<Scalars["String"]>;
  sim_form_ready_date__c?: InputMaybe<Scalars["timestamp"]>;
  sim_form_start_date__c?: InputMaybe<Scalars["timestamp"]>;
  sim_form_team_member__c?: InputMaybe<Scalars["String"]>;
  size__c?: InputMaybe<Scalars["String"]>;
  slug__c?: InputMaybe<Scalars["String"]>;
  social_facebook_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_instagram_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_linkedin_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_pinterest_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_tripadvisor_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_twitter_company_profile__c?: InputMaybe<Scalars["String"]>;
  social_yelp_company_profile__c?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  standard_documents__c?: InputMaybe<Scalars["String"]>;
  strategic_account__c?: InputMaybe<Scalars["Boolean"]>;
  stripe_ids__c?: InputMaybe<Scalars["String"]>;
  structure_file__c?: InputMaybe<Scalars["String"]>;
  su_training_date__c?: InputMaybe<Scalars["timestamp"]>;
  sub_industry__c?: InputMaybe<Scalars["String"]>;
  systemstructurelookup__c?: InputMaybe<Scalars["String"]>;
  target_status__c?: InputMaybe<Scalars["String"]>;
  target_tier__c?: InputMaybe<Scalars["String"]>;
  total_cmrr_all_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_cmrr_won_opportunities__c?: InputMaybe<Scalars["numeric"]>;
  total_current_cmrr__c?: InputMaybe<Scalars["numeric"]>;
  trading_states__c?: InputMaybe<Scalars["String"]>;
  trading_status__c?: InputMaybe<Scalars["String"]>;
  training_sessions_complete__c?: InputMaybe<Scalars["numeric"]>;
  type2__c?: InputMaybe<Scalars["String"]>;
  type_of_business__c?: InputMaybe<Scalars["String"]>;
  uniquebrandco__c?: InputMaybe<Scalars["Boolean"]>;
  uniqueid__c?: InputMaybe<Scalars["String"]>;
  unit_intel__c?: InputMaybe<Scalars["String"]>;
  up__district__c?: InputMaybe<Scalars["String"]>;
  up__region__c?: InputMaybe<Scalars["String"]>;
  up__territory__c?: InputMaybe<Scalars["String"]>;
  upsell_items__c?: InputMaybe<Scalars["String"]>;
  upsell_notes__c?: InputMaybe<Scalars["String"]>;
  upsell_potential__c?: InputMaybe<Scalars["String"]>;
  url__c?: InputMaybe<Scalars["String"]>;
  url_of_account_review_notes__c?: InputMaybe<Scalars["String"]>;
  users__c?: InputMaybe<Scalars["numeric"]>;
  web_client_only__c?: InputMaybe<Scalars["Boolean"]>;
  workpop_lead__c?: InputMaybe<Scalars["Boolean"]>;
  yelp__c?: InputMaybe<Scalars["String"]>;
  zendesk_id__c?: InputMaybe<Scalars["String"]>;
  zisf__company_id__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_clean_status__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_id__c?: InputMaybe<Scalars["String"]>;
  zisf__zoom_lastupdated__c?: InputMaybe<Scalars["timestamp"]>;
  zisf__zoominfo_complete_status__c?: InputMaybe<Scalars["String"]>;
  zisf__zoominfo_industry__c?: InputMaybe<Scalars["String"]>;
  zisf__zoominfo_last_clean_run__c?: InputMaybe<Scalars["timestamp"]>;
};

export type account__c_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account__c_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account__c_set_input>;
  where: account__c_bool_exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type account_append_input = {
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type account_bool_exp = {
  _and?: InputMaybe<Array<account_bool_exp>>;
  _not?: InputMaybe<account_bool_exp>;
  _or?: InputMaybe<Array<account_bool_exp>>;
  account_module_static?: InputMaybe<account_module_static_bool_exp>;
  account_to_custom_account?: InputMaybe<account__c_bool_exp>;
  accountsource?: InputMaybe<String_comparison_exp>;
  annualrevenue?: InputMaybe<numeric_comparison_exp>;
  billingaddress?: InputMaybe<jsonb_comparison_exp>;
  billingcity?: InputMaybe<String_comparison_exp>;
  billingcountry?: InputMaybe<String_comparison_exp>;
  billinggeocodeaccuracy?: InputMaybe<String_comparison_exp>;
  billinglatitude?: InputMaybe<numeric_comparison_exp>;
  billinglongitude?: InputMaybe<numeric_comparison_exp>;
  billingpostalcode?: InputMaybe<String_comparison_exp>;
  billingstate?: InputMaybe<String_comparison_exp>;
  billingstreet?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  fax?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  industry?: InputMaybe<String_comparison_exp>;
  iscustomerportal?: InputMaybe<Boolean_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  jigsaw?: InputMaybe<String_comparison_exp>;
  jigsawcompanyid?: InputMaybe<String_comparison_exp>;
  lastactivitydate?: InputMaybe<timestamp_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  masterrecordid?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  numberofemployees?: InputMaybe<Int_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  parentid?: InputMaybe<String_comparison_exp>;
  phone?: InputMaybe<String_comparison_exp>;
  photourl?: InputMaybe<String_comparison_exp>;
  recordtypeid?: InputMaybe<String_comparison_exp>;
  shippingaddress?: InputMaybe<jsonb_comparison_exp>;
  shippingcity?: InputMaybe<String_comparison_exp>;
  shippingcountry?: InputMaybe<String_comparison_exp>;
  shippinggeocodeaccuracy?: InputMaybe<String_comparison_exp>;
  shippinglatitude?: InputMaybe<numeric_comparison_exp>;
  shippinglongitude?: InputMaybe<numeric_comparison_exp>;
  shippingpostalcode?: InputMaybe<String_comparison_exp>;
  shippingstate?: InputMaybe<String_comparison_exp>;
  shippingstreet?: InputMaybe<String_comparison_exp>;
  sic?: InputMaybe<String_comparison_exp>;
  sicdesc?: InputMaybe<String_comparison_exp>;
  site?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  to_revtron?: InputMaybe<crm_revtron_indexes_bool_exp>;
  type?: InputMaybe<String_comparison_exp>;
  website?: InputMaybe<String_comparison_exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type account_delete_at_path_input = {
  billingaddress?: InputMaybe<Array<Scalars["String"]>>;
  shippingaddress?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type account_delete_elem_input = {
  billingaddress?: InputMaybe<Scalars["Int"]>;
  shippingaddress?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type account_delete_key_input = {
  billingaddress?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "account_effort_engagement_static_gql". All fields are combined with a logical 'AND'. */
export type account_effort_engagement_static_gql_bool_exp = {
  _and?: InputMaybe<Array<account_effort_engagement_static_gql_bool_exp>>;
  _not?: InputMaybe<account_effort_engagement_static_gql_bool_exp>;
  _or?: InputMaybe<Array<account_effort_engagement_static_gql_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
};

/** input type for incrementing numeric columns in table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_inc_input = {
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Ordering options when selecting data from "account_effort_engagement_static_gql". */
export type account_effort_engagement_static_gql_order_by = {
  accountid?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** select columns of table "account_effort_engagement_static_gql" */
export enum account_effort_engagement_static_gql_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
}

/** input type for updating data in table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Streaming cursor of the table "account_effort_engagement_static_gql" */
export type account_effort_engagement_static_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_effort_engagement_static_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_effort_engagement_static_gql_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

export type account_effort_engagement_static_gql_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account_effort_engagement_static_gql_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account_effort_engagement_static_gql_set_input>;
  where: account_effort_engagement_static_gql_bool_exp;
};

/** input type for incrementing numeric columns in table "account" */
export type account_inc_input = {
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "account" */
export type account_insert_input = {
  account_module_static?: InputMaybe<account_module_static_obj_rel_insert_input>;
  account_to_custom_account?: InputMaybe<account__c_obj_rel_insert_input>;
  accountsource?: InputMaybe<Scalars["String"]>;
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  billingpostalcode?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  billingstreet?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  iscustomerportal?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcompanyid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  parentid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  recordtypeid?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingcity?: InputMaybe<Scalars["String"]>;
  shippingcountry?: InputMaybe<Scalars["String"]>;
  shippinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  shippingpostalcode?: InputMaybe<Scalars["String"]>;
  shippingstate?: InputMaybe<Scalars["String"]>;
  shippingstreet?: InputMaybe<Scalars["String"]>;
  sic?: InputMaybe<Scalars["String"]>;
  sicdesc?: InputMaybe<Scalars["String"]>;
  site?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  to_revtron?: InputMaybe<crm_revtron_indexes_obj_rel_insert_input>;
  type?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "account_module_expansion_gql". All fields are combined with a logical 'AND'. */
export type account_module_expansion_gql_bool_exp = {
  _and?: InputMaybe<Array<account_module_expansion_gql_bool_exp>>;
  _not?: InputMaybe<account_module_expansion_gql_bool_exp>;
  _or?: InputMaybe<Array<account_module_expansion_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  daily_engagement?: InputMaybe<daily_effort_engagement_by_account_bool_exp>;
  daily_engagement_aggregate?: InputMaybe<daily_effort_engagement_by_account_aggregate_bool_exp>;
  number_of_contacts?: InputMaybe<bigint_comparison_exp>;
  open_opp_count?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "account_module_expansion_gql". */
export type account_module_expansion_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  daily_engagement_aggregate?: InputMaybe<daily_effort_engagement_by_account_aggregate_order_by>;
  number_of_contacts?: InputMaybe<order_by>;
  open_opp_count?: InputMaybe<order_by>;
};

/** select columns of table "account_module_expansion_gql" */
export enum account_module_expansion_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  number_of_contacts = "number_of_contacts",
  /** column name */
  open_opp_count = "open_opp_count",
}

/** Streaming cursor of the table "account_module_expansion_gql" */
export type account_module_expansion_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_module_expansion_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_module_expansion_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  number_of_contacts?: InputMaybe<Scalars["bigint"]>;
  open_opp_count?: InputMaybe<Scalars["bigint"]>;
};

/** Boolean expression to filter rows from the table "account_module_gql". All fields are combined with a logical 'AND'. */
export type account_module_gql_bool_exp = {
  _and?: InputMaybe<Array<account_module_gql_bool_exp>>;
  _not?: InputMaybe<account_module_gql_bool_exp>;
  _or?: InputMaybe<Array<account_module_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  account_owner?: InputMaybe<String_comparison_exp>;
  account_status_auto__c?: InputMaybe<String_comparison_exp>;
  billingcity?: InputMaybe<String_comparison_exp>;
  billingcountry?: InputMaybe<String_comparison_exp>;
  billingstate?: InputMaybe<String_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
  predct_proba?: InputMaybe<float8_comparison_exp>;
};

/** Ordering options when selecting data from "account_module_gql". */
export type account_module_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  account_owner?: InputMaybe<order_by>;
  account_status_auto__c?: InputMaybe<order_by>;
  billingcity?: InputMaybe<order_by>;
  billingcountry?: InputMaybe<order_by>;
  billingstate?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
  predct_proba?: InputMaybe<order_by>;
};

/** select columns of table "account_module_gql" */
export enum account_module_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  account_owner = "account_owner",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
  /** column name */
  predct_proba = "predct_proba",
}

/** Streaming cursor of the table "account_module_gql" */
export type account_module_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_module_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_module_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["float8"]>;
};

/** Boolean expression to filter rows from the table "account_module_static". All fields are combined with a logical 'AND'. */
export type account_module_static_bool_exp = {
  _and?: InputMaybe<Array<account_module_static_bool_exp>>;
  _not?: InputMaybe<account_module_static_bool_exp>;
  _or?: InputMaybe<Array<account_module_static_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  account_owner?: InputMaybe<String_comparison_exp>;
  account_status_auto__c?: InputMaybe<String_comparison_exp>;
  billingcity?: InputMaybe<String_comparison_exp>;
  billingcountry?: InputMaybe<String_comparison_exp>;
  billingstate?: InputMaybe<String_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
  predct_proba?: InputMaybe<numeric_comparison_exp>;
};

/** unique or primary key constraints on table "account_module_static" */
export enum account_module_static_constraint {
  /** unique or primary key constraint on columns "account_id" */
  account_module_static_pkey = "account_module_static_pkey",
}

/** input type for incrementing numeric columns in table "account_module_static" */
export type account_module_static_inc_input = {
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "account_module_static" */
export type account_module_static_insert_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting object relation for remote table "account_module_static" */
export type account_module_static_obj_rel_insert_input = {
  data: account_module_static_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<account_module_static_on_conflict>;
};

/** on_conflict condition type for table "account_module_static" */
export type account_module_static_on_conflict = {
  constraint: account_module_static_constraint;
  update_columns?: Array<account_module_static_update_column>;
  where?: InputMaybe<account_module_static_bool_exp>;
};

/** Ordering options when selecting data from "account_module_static". */
export type account_module_static_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  account_owner?: InputMaybe<order_by>;
  account_status_auto__c?: InputMaybe<order_by>;
  billingcity?: InputMaybe<order_by>;
  billingcountry?: InputMaybe<order_by>;
  billingstate?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
  predct_proba?: InputMaybe<order_by>;
};

/** primary key columns input for table: account_module_static */
export type account_module_static_pk_columns_input = {
  account_id: Scalars["String"];
};

/** select columns of table "account_module_static" */
export enum account_module_static_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  account_owner = "account_owner",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
  /** column name */
  predct_proba = "predct_proba",
}

/** input type for updating data in table "account_module_static" */
export type account_module_static_set_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** Streaming cursor of the table "account_module_static" */
export type account_module_static_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_module_static_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_module_static_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  account_owner?: InputMaybe<Scalars["String"]>;
  account_status_auto__c?: InputMaybe<Scalars["String"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
  predct_proba?: InputMaybe<Scalars["numeric"]>;
};

/** update columns of table "account_module_static" */
export enum account_module_static_update_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  account_owner = "account_owner",
  /** column name */
  account_status_auto__c = "account_status_auto__c",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
  /** column name */
  predct_proba = "predct_proba",
}

export type account_module_static_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account_module_static_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account_module_static_set_input>;
  where: account_module_static_bool_exp;
};

/** Ordering options when selecting data from "account". */
export type account_order_by = {
  account_module_static?: InputMaybe<account_module_static_order_by>;
  account_to_custom_account?: InputMaybe<account__c_order_by>;
  accountsource?: InputMaybe<order_by>;
  annualrevenue?: InputMaybe<order_by>;
  billingaddress?: InputMaybe<order_by>;
  billingcity?: InputMaybe<order_by>;
  billingcountry?: InputMaybe<order_by>;
  billinggeocodeaccuracy?: InputMaybe<order_by>;
  billinglatitude?: InputMaybe<order_by>;
  billinglongitude?: InputMaybe<order_by>;
  billingpostalcode?: InputMaybe<order_by>;
  billingstate?: InputMaybe<order_by>;
  billingstreet?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fax?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  industry?: InputMaybe<order_by>;
  iscustomerportal?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  jigsaw?: InputMaybe<order_by>;
  jigsawcompanyid?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  masterrecordid?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  numberofemployees?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  parentid?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  photourl?: InputMaybe<order_by>;
  recordtypeid?: InputMaybe<order_by>;
  shippingaddress?: InputMaybe<order_by>;
  shippingcity?: InputMaybe<order_by>;
  shippingcountry?: InputMaybe<order_by>;
  shippinggeocodeaccuracy?: InputMaybe<order_by>;
  shippinglatitude?: InputMaybe<order_by>;
  shippinglongitude?: InputMaybe<order_by>;
  shippingpostalcode?: InputMaybe<order_by>;
  shippingstate?: InputMaybe<order_by>;
  shippingstreet?: InputMaybe<order_by>;
  sic?: InputMaybe<order_by>;
  sicdesc?: InputMaybe<order_by>;
  site?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  to_revtron?: InputMaybe<crm_revtron_indexes_order_by>;
  type?: InputMaybe<order_by>;
  website?: InputMaybe<order_by>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type account_prepend_input = {
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "account" */
export enum account_select_column {
  /** column name */
  accountsource = "accountsource",
  /** column name */
  annualrevenue = "annualrevenue",
  /** column name */
  billingaddress = "billingaddress",
  /** column name */
  billingcity = "billingcity",
  /** column name */
  billingcountry = "billingcountry",
  /** column name */
  billinggeocodeaccuracy = "billinggeocodeaccuracy",
  /** column name */
  billinglatitude = "billinglatitude",
  /** column name */
  billinglongitude = "billinglongitude",
  /** column name */
  billingpostalcode = "billingpostalcode",
  /** column name */
  billingstate = "billingstate",
  /** column name */
  billingstreet = "billingstreet",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  fax = "fax",
  /** column name */
  id = "id",
  /** column name */
  industry = "industry",
  /** column name */
  iscustomerportal = "iscustomerportal",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  jigsaw = "jigsaw",
  /** column name */
  jigsawcompanyid = "jigsawcompanyid",
  /** column name */
  lastactivitydate = "lastactivitydate",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  masterrecordid = "masterrecordid",
  /** column name */
  name = "name",
  /** column name */
  numberofemployees = "numberofemployees",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  parentid = "parentid",
  /** column name */
  phone = "phone",
  /** column name */
  photourl = "photourl",
  /** column name */
  recordtypeid = "recordtypeid",
  /** column name */
  shippingaddress = "shippingaddress",
  /** column name */
  shippingcity = "shippingcity",
  /** column name */
  shippingcountry = "shippingcountry",
  /** column name */
  shippinggeocodeaccuracy = "shippinggeocodeaccuracy",
  /** column name */
  shippinglatitude = "shippinglatitude",
  /** column name */
  shippinglongitude = "shippinglongitude",
  /** column name */
  shippingpostalcode = "shippingpostalcode",
  /** column name */
  shippingstate = "shippingstate",
  /** column name */
  shippingstreet = "shippingstreet",
  /** column name */
  sic = "sic",
  /** column name */
  sicdesc = "sicdesc",
  /** column name */
  site = "site",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  type = "type",
  /** column name */
  website = "website",
}

/** input type for updating data in table "account" */
export type account_set_input = {
  accountsource?: InputMaybe<Scalars["String"]>;
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  billingpostalcode?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  billingstreet?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  iscustomerportal?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcompanyid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  parentid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  recordtypeid?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingcity?: InputMaybe<Scalars["String"]>;
  shippingcountry?: InputMaybe<Scalars["String"]>;
  shippinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  shippingpostalcode?: InputMaybe<Scalars["String"]>;
  shippingstate?: InputMaybe<Scalars["String"]>;
  shippingstreet?: InputMaybe<Scalars["String"]>;
  sic?: InputMaybe<Scalars["String"]>;
  sicdesc?: InputMaybe<Scalars["String"]>;
  site?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "account" */
export type account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type account_stream_cursor_value_input = {
  accountsource?: InputMaybe<Scalars["String"]>;
  annualrevenue?: InputMaybe<Scalars["numeric"]>;
  billingaddress?: InputMaybe<Scalars["jsonb"]>;
  billingcity?: InputMaybe<Scalars["String"]>;
  billingcountry?: InputMaybe<Scalars["String"]>;
  billinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  billinglatitude?: InputMaybe<Scalars["numeric"]>;
  billinglongitude?: InputMaybe<Scalars["numeric"]>;
  billingpostalcode?: InputMaybe<Scalars["String"]>;
  billingstate?: InputMaybe<Scalars["String"]>;
  billingstreet?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  iscustomerportal?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  jigsaw?: InputMaybe<Scalars["String"]>;
  jigsawcompanyid?: InputMaybe<Scalars["String"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  masterrecordid?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberofemployees?: InputMaybe<Scalars["Int"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  parentid?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photourl?: InputMaybe<Scalars["String"]>;
  recordtypeid?: InputMaybe<Scalars["String"]>;
  shippingaddress?: InputMaybe<Scalars["jsonb"]>;
  shippingcity?: InputMaybe<Scalars["String"]>;
  shippingcountry?: InputMaybe<Scalars["String"]>;
  shippinggeocodeaccuracy?: InputMaybe<Scalars["String"]>;
  shippinglatitude?: InputMaybe<Scalars["numeric"]>;
  shippinglongitude?: InputMaybe<Scalars["numeric"]>;
  shippingpostalcode?: InputMaybe<Scalars["String"]>;
  shippingstate?: InputMaybe<Scalars["String"]>;
  shippingstreet?: InputMaybe<Scalars["String"]>;
  sic?: InputMaybe<Scalars["String"]>;
  sicdesc?: InputMaybe<Scalars["String"]>;
  site?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type account_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<account_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<account_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<account_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<account_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<account_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<account_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<account_set_input>;
  where: account_bool_exp;
};

/** Boolean expression to filter rows from the table "actuals_vs_targets_activity". All fields are combined with a logical 'AND'. */
export type actuals_vs_targets_activity_bool_exp = {
  _and?: InputMaybe<Array<actuals_vs_targets_activity_bool_exp>>;
  _not?: InputMaybe<actuals_vs_targets_activity_bool_exp>;
  _or?: InputMaybe<Array<actuals_vs_targets_activity_bool_exp>>;
  calls?: InputMaybe<bigint_comparison_exp>;
  calls_out?: InputMaybe<bigint_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  emails?: InputMaybe<bigint_comparison_exp>;
  emails_sent?: InputMaybe<bigint_comparison_exp>;
  meetings_booked?: InputMaybe<Int_comparison_exp>;
  meetings_scheduled?: InputMaybe<float8_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opportunities?: InputMaybe<float8_comparison_exp>;
  opportunity_create_count?: InputMaybe<bigint_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  social_target?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "actuals_vs_targets_activity". */
export type actuals_vs_targets_activity_order_by = {
  calls?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  meetings_booked?: InputMaybe<order_by>;
  meetings_scheduled?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  opportunities?: InputMaybe<order_by>;
  opportunity_create_count?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  social_target?: InputMaybe<order_by>;
};

/** select columns of table "actuals_vs_targets_activity" */
export enum actuals_vs_targets_activity_select_column {
  /** column name */
  calls = "calls",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  email = "email",
  /** column name */
  emails = "emails",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  meetings_booked = "meetings_booked",
  /** column name */
  meetings_scheduled = "meetings_scheduled",
  /** column name */
  name = "name",
  /** column name */
  opportunities = "opportunities",
  /** column name */
  opportunity_create_count = "opportunity_create_count",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  social = "social",
  /** column name */
  social_target = "social_target",
}

/** Streaming cursor of the table "actuals_vs_targets_activity" */
export type actuals_vs_targets_activity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: actuals_vs_targets_activity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type actuals_vs_targets_activity_stream_cursor_value_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  calls_out?: InputMaybe<Scalars["bigint"]>;
  email?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  emails_sent?: InputMaybe<Scalars["bigint"]>;
  meetings_booked?: InputMaybe<Scalars["Int"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  opportunity_create_count?: InputMaybe<Scalars["bigint"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type authProviderRequests_append_input = {
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type authProviderRequests_bool_exp = {
  _and?: InputMaybe<Array<authProviderRequests_bool_exp>>;
  _not?: InputMaybe<authProviderRequests_bool_exp>;
  _or?: InputMaybe<Array<authProviderRequests_bool_exp>>;
  id?: InputMaybe<uuid_comparison_exp>;
  options?: InputMaybe<jsonb_comparison_exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum authProviderRequests_constraint {
  /** unique or primary key constraint on columns "id" */
  provider_requests_pkey = "provider_requests_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type authProviderRequests_delete_at_path_input = {
  options?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type authProviderRequests_delete_elem_input = {
  options?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type authProviderRequests_delete_key_input = {
  options?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type authProviderRequests_insert_input = {
  id?: InputMaybe<Scalars["uuid"]>;
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type authProviderRequests_on_conflict = {
  constraint: authProviderRequests_constraint;
  update_columns?: Array<authProviderRequests_update_column>;
  where?: InputMaybe<authProviderRequests_bool_exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type authProviderRequests_order_by = {
  id?: InputMaybe<order_by>;
  options?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.provider_requests */
export type authProviderRequests_pk_columns_input = {
  id: Scalars["uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type authProviderRequests_prepend_input = {
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "auth.provider_requests" */
export enum authProviderRequests_select_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

/** input type for updating data in table "auth.provider_requests" */
export type authProviderRequests_set_input = {
  id?: InputMaybe<Scalars["uuid"]>;
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type authProviderRequests_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authProviderRequests_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authProviderRequests_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["uuid"]>;
  options?: InputMaybe<Scalars["jsonb"]>;
};

/** update columns of table "auth.provider_requests" */
export enum authProviderRequests_update_column {
  /** column name */
  id = "id",
  /** column name */
  options = "options",
}

export type authProviderRequests_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<authProviderRequests_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<authProviderRequests_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<authProviderRequests_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<authProviderRequests_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<authProviderRequests_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authProviderRequests_set_input>;
  where: authProviderRequests_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type authProviders_bool_exp = {
  _and?: InputMaybe<Array<authProviders_bool_exp>>;
  _not?: InputMaybe<authProviders_bool_exp>;
  _or?: InputMaybe<Array<authProviders_bool_exp>>;
  id?: InputMaybe<String_comparison_exp>;
  userProviders?: InputMaybe<authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum authProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  providers_pkey = "providers_pkey",
}

/** input type for inserting data into table "auth.providers" */
export type authProviders_insert_input = {
  id?: InputMaybe<Scalars["String"]>;
  userProviders?: InputMaybe<authUserProviders_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type authProviders_obj_rel_insert_input = {
  data: authProviders_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<authProviders_on_conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type authProviders_on_conflict = {
  constraint: authProviders_constraint;
  update_columns?: Array<authProviders_update_column>;
  where?: InputMaybe<authProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type authProviders_order_by = {
  id?: InputMaybe<order_by>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.providers */
export type authProviders_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "auth.providers" */
export enum authProviders_select_column {
  /** column name */
  id = "id",
}

/** input type for updating data in table "auth.providers" */
export type authProviders_set_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authProviders" */
export type authProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authProviders_stream_cursor_value_input = {
  id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.providers" */
export enum authProviders_update_column {
  /** column name */
  id = "id",
}

export type authProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authProviders_set_input>;
  where: authProviders_bool_exp;
};

export type authRefreshTokens_aggregate_bool_exp = {
  count?: InputMaybe<authRefreshTokens_aggregate_bool_exp_count>;
};

export type authRefreshTokens_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authRefreshTokens_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authRefreshTokens_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type authRefreshTokens_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authRefreshTokens_max_order_by>;
  min?: InputMaybe<authRefreshTokens_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type authRefreshTokens_arr_rel_insert_input = {
  data: Array<authRefreshTokens_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authRefreshTokens_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type authRefreshTokens_bool_exp = {
  _and?: InputMaybe<Array<authRefreshTokens_bool_exp>>;
  _not?: InputMaybe<authRefreshTokens_bool_exp>;
  _or?: InputMaybe<Array<authRefreshTokens_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  expiresAt?: InputMaybe<timestamptz_comparison_exp>;
  refreshToken?: InputMaybe<uuid_comparison_exp>;
  refreshTokenHash?: InputMaybe<String_comparison_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum authRefreshTokens_constraint {
  /** unique or primary key constraint on columns "refresh_token" */
  refresh_tokens_pkey = "refresh_tokens_pkey",
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type authRefreshTokens_insert_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["uuid"]>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type authRefreshTokens_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<order_by>;
  refreshTokenHash?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type authRefreshTokens_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<order_by>;
  refreshTokenHash?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type authRefreshTokens_on_conflict = {
  constraint: authRefreshTokens_constraint;
  update_columns?: Array<authRefreshTokens_update_column>;
  where?: InputMaybe<authRefreshTokens_bool_exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type authRefreshTokens_order_by = {
  createdAt?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  refreshTokenHash?: InputMaybe<order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type authRefreshTokens_pk_columns_input = {
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken: Scalars["uuid"];
};

/** select columns of table "auth.refresh_tokens" */
export enum authRefreshTokens_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  refreshTokenHash = "refreshTokenHash",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.refresh_tokens" */
export type authRefreshTokens_set_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["uuid"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type authRefreshTokens_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authRefreshTokens_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authRefreshTokens_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  expiresAt?: InputMaybe<Scalars["timestamptz"]>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: InputMaybe<Scalars["uuid"]>;
  refreshTokenHash?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** update columns of table "auth.refresh_tokens" */
export enum authRefreshTokens_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  expiresAt = "expiresAt",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  userId = "userId",
}

export type authRefreshTokens_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authRefreshTokens_set_input>;
  where: authRefreshTokens_bool_exp;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type authRoles_bool_exp = {
  _and?: InputMaybe<Array<authRoles_bool_exp>>;
  _not?: InputMaybe<authRoles_bool_exp>;
  _or?: InputMaybe<Array<authRoles_bool_exp>>;
  role?: InputMaybe<String_comparison_exp>;
  userRoles?: InputMaybe<authUserRoles_bool_exp>;
  userRoles_aggregate?: InputMaybe<authUserRoles_aggregate_bool_exp>;
  usersByDefaultRole?: InputMaybe<users_bool_exp>;
  usersByDefaultRole_aggregate?: InputMaybe<users_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum authRoles_constraint {
  /** unique or primary key constraint on columns "role" */
  roles_pkey = "roles_pkey",
}

/** input type for inserting data into table "auth.roles" */
export type authRoles_insert_input = {
  role?: InputMaybe<Scalars["String"]>;
  userRoles?: InputMaybe<authUserRoles_arr_rel_insert_input>;
  usersByDefaultRole?: InputMaybe<users_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type authRoles_obj_rel_insert_input = {
  data: authRoles_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<authRoles_on_conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type authRoles_on_conflict = {
  constraint: authRoles_constraint;
  update_columns?: Array<authRoles_update_column>;
  where?: InputMaybe<authRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type authRoles_order_by = {
  role?: InputMaybe<order_by>;
  userRoles_aggregate?: InputMaybe<authUserRoles_aggregate_order_by>;
  usersByDefaultRole_aggregate?: InputMaybe<users_aggregate_order_by>;
};

/** primary key columns input for table: auth.roles */
export type authRoles_pk_columns_input = {
  role: Scalars["String"];
};

/** select columns of table "auth.roles" */
export enum authRoles_select_column {
  /** column name */
  role = "role",
}

/** input type for updating data in table "auth.roles" */
export type authRoles_set_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "authRoles" */
export type authRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authRoles_stream_cursor_value_input = {
  role?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "auth.roles" */
export enum authRoles_update_column {
  /** column name */
  role = "role",
}

export type authRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authRoles_set_input>;
  where: authRoles_bool_exp;
};

export type authUserProviders_aggregate_bool_exp = {
  count?: InputMaybe<authUserProviders_aggregate_bool_exp_count>;
};

export type authUserProviders_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authUserProviders_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authUserProviders_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_providers" */
export type authUserProviders_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authUserProviders_max_order_by>;
  min?: InputMaybe<authUserProviders_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type authUserProviders_arr_rel_insert_input = {
  data: Array<authUserProviders_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authUserProviders_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type authUserProviders_bool_exp = {
  _and?: InputMaybe<Array<authUserProviders_bool_exp>>;
  _not?: InputMaybe<authUserProviders_bool_exp>;
  _or?: InputMaybe<Array<authUserProviders_bool_exp>>;
  accessToken?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  provider?: InputMaybe<authProviders_bool_exp>;
  providerId?: InputMaybe<String_comparison_exp>;
  providerUserId?: InputMaybe<String_comparison_exp>;
  refreshToken?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum authUserProviders_constraint {
  /** unique or primary key constraint on columns "id" */
  user_providers_pkey = "user_providers_pkey",
  /** unique or primary key constraint on columns "provider_id", "provider_user_id" */
  user_providers_provider_id_provider_user_id_key = "user_providers_provider_id_provider_user_id_key",
  /** unique or primary key constraint on columns "provider_id", "user_id" */
  user_providers_user_id_provider_id_key = "user_providers_user_id_provider_id_key",
}

/** input type for inserting data into table "auth.user_providers" */
export type authUserProviders_insert_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  provider?: InputMaybe<authProviders_obj_rel_insert_input>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.user_providers" */
export type authUserProviders_max_order_by = {
  accessToken?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  providerId?: InputMaybe<order_by>;
  providerUserId?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.user_providers" */
export type authUserProviders_min_order_by = {
  accessToken?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  providerId?: InputMaybe<order_by>;
  providerUserId?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type authUserProviders_on_conflict = {
  constraint: authUserProviders_constraint;
  update_columns?: Array<authUserProviders_update_column>;
  where?: InputMaybe<authUserProviders_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type authUserProviders_order_by = {
  accessToken?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  provider?: InputMaybe<authProviders_order_by>;
  providerId?: InputMaybe<order_by>;
  providerUserId?: InputMaybe<order_by>;
  refreshToken?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.user_providers */
export type authUserProviders_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "auth.user_providers" */
export enum authUserProviders_select_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_providers" */
export type authUserProviders_set_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** Streaming cursor of the table "authUserProviders" */
export type authUserProviders_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authUserProviders_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authUserProviders_stream_cursor_value_input = {
  accessToken?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerUserId?: InputMaybe<Scalars["String"]>;
  refreshToken?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** update columns of table "auth.user_providers" */
export enum authUserProviders_update_column {
  /** column name */
  accessToken = "accessToken",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  providerId = "providerId",
  /** column name */
  providerUserId = "providerUserId",
  /** column name */
  refreshToken = "refreshToken",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  userId = "userId",
}

export type authUserProviders_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authUserProviders_set_input>;
  where: authUserProviders_bool_exp;
};

export type authUserRoles_aggregate_bool_exp = {
  count?: InputMaybe<authUserRoles_aggregate_bool_exp_count>;
};

export type authUserRoles_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authUserRoles_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authUserRoles_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_roles" */
export type authUserRoles_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authUserRoles_max_order_by>;
  min?: InputMaybe<authUserRoles_min_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type authUserRoles_arr_rel_insert_input = {
  data: Array<authUserRoles_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authUserRoles_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type authUserRoles_bool_exp = {
  _and?: InputMaybe<Array<authUserRoles_bool_exp>>;
  _not?: InputMaybe<authUserRoles_bool_exp>;
  _or?: InputMaybe<Array<authUserRoles_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  role?: InputMaybe<String_comparison_exp>;
  roleByRole?: InputMaybe<authRoles_bool_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum authUserRoles_constraint {
  /** unique or primary key constraint on columns "id" */
  user_roles_pkey = "user_roles_pkey",
  /** unique or primary key constraint on columns "user_id", "role" */
  user_roles_user_id_role_key = "user_roles_user_id_role_key",
}

/** input type for inserting data into table "auth.user_roles" */
export type authUserRoles_insert_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  roleByRole?: InputMaybe<authRoles_obj_rel_insert_input>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.user_roles" */
export type authUserRoles_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.user_roles" */
export type authUserRoles_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type authUserRoles_on_conflict = {
  constraint: authUserRoles_constraint;
  update_columns?: Array<authUserRoles_update_column>;
  where?: InputMaybe<authUserRoles_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type authUserRoles_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  roleByRole?: InputMaybe<authRoles_order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.user_roles */
export type authUserRoles_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "auth.user_roles" */
export enum authUserRoles_select_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_roles" */
export type authUserRoles_set_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** Streaming cursor of the table "authUserRoles" */
export type authUserRoles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authUserRoles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authUserRoles_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  role?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** update columns of table "auth.user_roles" */
export enum authUserRoles_update_column {
  /** column name */
  createdAt = "createdAt",
  /** column name */
  id = "id",
  /** column name */
  role = "role",
  /** column name */
  userId = "userId",
}

export type authUserRoles_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authUserRoles_set_input>;
  where: authUserRoles_bool_exp;
};

export type authUserSecurityKeys_aggregate_bool_exp = {
  count?: InputMaybe<authUserSecurityKeys_aggregate_bool_exp_count>;
};

export type authUserSecurityKeys_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<authUserSecurityKeys_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<authUserSecurityKeys_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type authUserSecurityKeys_aggregate_order_by = {
  avg?: InputMaybe<authUserSecurityKeys_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<authUserSecurityKeys_max_order_by>;
  min?: InputMaybe<authUserSecurityKeys_min_order_by>;
  stddev?: InputMaybe<authUserSecurityKeys_stddev_order_by>;
  stddev_pop?: InputMaybe<authUserSecurityKeys_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<authUserSecurityKeys_stddev_samp_order_by>;
  sum?: InputMaybe<authUserSecurityKeys_sum_order_by>;
  var_pop?: InputMaybe<authUserSecurityKeys_var_pop_order_by>;
  var_samp?: InputMaybe<authUserSecurityKeys_var_samp_order_by>;
  variance?: InputMaybe<authUserSecurityKeys_variance_order_by>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type authUserSecurityKeys_arr_rel_insert_input = {
  data: Array<authUserSecurityKeys_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<authUserSecurityKeys_on_conflict>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_avg_order_by = {
  counter?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type authUserSecurityKeys_bool_exp = {
  _and?: InputMaybe<Array<authUserSecurityKeys_bool_exp>>;
  _not?: InputMaybe<authUserSecurityKeys_bool_exp>;
  _or?: InputMaybe<Array<authUserSecurityKeys_bool_exp>>;
  counter?: InputMaybe<bigint_comparison_exp>;
  credentialId?: InputMaybe<String_comparison_exp>;
  credentialPublicKey?: InputMaybe<bytea_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  nickname?: InputMaybe<String_comparison_exp>;
  transports?: InputMaybe<String_comparison_exp>;
  user?: InputMaybe<users_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum authUserSecurityKeys_constraint {
  /** unique or primary key constraint on columns "credential_id" */
  user_security_key_credential_id_key = "user_security_key_credential_id_key",
  /** unique or primary key constraint on columns "id" */
  user_security_keys_pkey = "user_security_keys_pkey",
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type authUserSecurityKeys_inc_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type authUserSecurityKeys_insert_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["bytea"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  user?: InputMaybe<users_obj_rel_insert_input>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_max_order_by = {
  counter?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  transports?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_min_order_by = {
  counter?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  transports?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type authUserSecurityKeys_on_conflict = {
  constraint: authUserSecurityKeys_constraint;
  update_columns?: Array<authUserSecurityKeys_update_column>;
  where?: InputMaybe<authUserSecurityKeys_bool_exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type authUserSecurityKeys_order_by = {
  counter?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  credentialPublicKey?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  transports?: InputMaybe<order_by>;
  user?: InputMaybe<users_order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: auth.user_security_keys */
export type authUserSecurityKeys_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "auth.user_security_keys" */
export enum authUserSecurityKeys_select_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

/** input type for updating data in table "auth.user_security_keys" */
export type authUserSecurityKeys_set_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["bytea"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_stddev_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_stddev_pop_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_stddev_samp_order_by = {
  counter?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type authUserSecurityKeys_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: authUserSecurityKeys_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type authUserSecurityKeys_stream_cursor_value_input = {
  counter?: InputMaybe<Scalars["bigint"]>;
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialPublicKey?: InputMaybe<Scalars["bytea"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  nickname?: InputMaybe<Scalars["String"]>;
  transports?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["uuid"]>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_sum_order_by = {
  counter?: InputMaybe<order_by>;
};

/** update columns of table "auth.user_security_keys" */
export enum authUserSecurityKeys_update_column {
  /** column name */
  counter = "counter",
  /** column name */
  credentialId = "credentialId",
  /** column name */
  credentialPublicKey = "credentialPublicKey",
  /** column name */
  id = "id",
  /** column name */
  nickname = "nickname",
  /** column name */
  transports = "transports",
  /** column name */
  userId = "userId",
}

export type authUserSecurityKeys_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<authUserSecurityKeys_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<authUserSecurityKeys_set_input>;
  where: authUserSecurityKeys_bool_exp;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_var_pop_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_var_samp_order_by = {
  counter?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type authUserSecurityKeys_variance_order_by = {
  counter?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp = {
  _eq?: InputMaybe<Scalars["bigint"]>;
  _gt?: InputMaybe<Scalars["bigint"]>;
  _gte?: InputMaybe<Scalars["bigint"]>;
  _in?: InputMaybe<Array<Scalars["bigint"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["bigint"]>;
  _lte?: InputMaybe<Scalars["bigint"]>;
  _neq?: InputMaybe<Scalars["bigint"]>;
  _nin?: InputMaybe<Array<Scalars["bigint"]>>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp_remote_rel_crm_revtron_indexesto_revtron_company =
  {
    _gt?: InputMaybe<Scalars["_bigint"]>;
    _gte?: InputMaybe<Scalars["_bigint"]>;
    _in?: InputMaybe<Array<Scalars["_bigint"]>>;
    _is_null?: InputMaybe<Scalars["Boolean"]>;
    _lt?: InputMaybe<Scalars["_bigint"]>;
    _lte?: InputMaybe<Scalars["_bigint"]>;
    _neq?: InputMaybe<Scalars["_bigint"]>;
    _nin?: InputMaybe<Array<Scalars["_bigint"]>>;
  };

/** Boolean expression to filter rows from the table "bookings_by_owner_gql". All fields are combined with a logical 'AND'. */
export type bookings_by_owner_gql_bool_exp = {
  _and?: InputMaybe<Array<bookings_by_owner_gql_bool_exp>>;
  _not?: InputMaybe<bookings_by_owner_gql_bool_exp>;
  _or?: InputMaybe<Array<bookings_by_owner_gql_bool_exp>>;
  bookings?: InputMaybe<numeric_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  team_member?: InputMaybe<String_comparison_exp>;
  userid?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "bookings_by_owner_gql". */
export type bookings_by_owner_gql_order_by = {
  bookings?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  team_member?: InputMaybe<order_by>;
  userid?: InputMaybe<order_by>;
};

/** select columns of table "bookings_by_owner_gql" */
export enum bookings_by_owner_gql_select_column {
  /** column name */
  bookings = "bookings",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  team_member = "team_member",
  /** column name */
  userid = "userid",
}

/** Streaming cursor of the table "bookings_by_owner_gql" */
export type bookings_by_owner_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: bookings_by_owner_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type bookings_by_owner_gql_stream_cursor_value_input = {
  bookings?: InputMaybe<Scalars["numeric"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  team_member?: InputMaybe<Scalars["String"]>;
  userid?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type buckets_bool_exp = {
  _and?: InputMaybe<Array<buckets_bool_exp>>;
  _not?: InputMaybe<buckets_bool_exp>;
  _or?: InputMaybe<Array<buckets_bool_exp>>;
  cacheControl?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  downloadExpiration?: InputMaybe<Int_comparison_exp>;
  files?: InputMaybe<files_bool_exp>;
  files_aggregate?: InputMaybe<files_aggregate_bool_exp>;
  id?: InputMaybe<String_comparison_exp>;
  maxUploadFileSize?: InputMaybe<Int_comparison_exp>;
  minUploadFileSize?: InputMaybe<Int_comparison_exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum buckets_constraint {
  /** unique or primary key constraint on columns "id" */
  buckets_pkey = "buckets_pkey",
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type buckets_inc_input = {
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.buckets" */
export type buckets_insert_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  files?: InputMaybe<files_arr_rel_insert_input>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type buckets_obj_rel_insert_input = {
  data: buckets_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<buckets_on_conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type buckets_on_conflict = {
  constraint: buckets_constraint;
  update_columns?: Array<buckets_update_column>;
  where?: InputMaybe<buckets_bool_exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type buckets_order_by = {
  cacheControl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  downloadExpiration?: InputMaybe<order_by>;
  files_aggregate?: InputMaybe<files_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  maxUploadFileSize?: InputMaybe<order_by>;
  minUploadFileSize?: InputMaybe<order_by>;
  presignedUrlsEnabled?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: storage.buckets */
export type buckets_pk_columns_input = {
  id: Scalars["String"];
};

/** select columns of table "storage.buckets" */
export enum buckets_select_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

/** input type for updating data in table "storage.buckets" */
export type buckets_set_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "buckets" */
export type buckets_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: buckets_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type buckets_stream_cursor_value_input = {
  cacheControl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  downloadExpiration?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  maxUploadFileSize?: InputMaybe<Scalars["Int"]>;
  minUploadFileSize?: InputMaybe<Scalars["Int"]>;
  presignedUrlsEnabled?: InputMaybe<Scalars["Boolean"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "storage.buckets" */
export enum buckets_update_column {
  /** column name */
  cacheControl = "cacheControl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  downloadExpiration = "downloadExpiration",
  /** column name */
  id = "id",
  /** column name */
  maxUploadFileSize = "maxUploadFileSize",
  /** column name */
  minUploadFileSize = "minUploadFileSize",
  /** column name */
  presignedUrlsEnabled = "presignedUrlsEnabled",
  /** column name */
  updatedAt = "updatedAt",
}

export type buckets_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<buckets_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<buckets_set_input>;
  where: buckets_bool_exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type bytea_comparison_exp = {
  _eq?: InputMaybe<Scalars["bytea"]>;
  _gt?: InputMaybe<Scalars["bytea"]>;
  _gte?: InputMaybe<Scalars["bytea"]>;
  _in?: InputMaybe<Array<Scalars["bytea"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["bytea"]>;
  _lte?: InputMaybe<Scalars["bytea"]>;
  _neq?: InputMaybe<Scalars["bytea"]>;
  _nin?: InputMaybe<Array<Scalars["bytea"]>>;
};

/** Boolean expression to filter rows from the table "calendar_gql_clean". All fields are combined with a logical 'AND'. */
export type calendar_gql_clean_bool_exp = {
  _and?: InputMaybe<Array<calendar_gql_clean_bool_exp>>;
  _not?: InputMaybe<calendar_gql_clean_bool_exp>;
  _or?: InputMaybe<Array<calendar_gql_clean_bool_exp>>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  enddatetime?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  meeting_owner?: InputMaybe<String_comparison_exp>;
  meeting_owner_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
  startdatetime?: InputMaybe<timestamp_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "calendar_gql_clean". */
export type calendar_gql_clean_order_by = {
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  meeting_owner?: InputMaybe<order_by>;
  meeting_owner_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
};

/** select columns of table "calendar_gql_clean" */
export enum calendar_gql_clean_select_column {
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  enddatetime = "enddatetime",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  meeting_owner = "meeting_owner",
  /** column name */
  meeting_owner_id = "meeting_owner_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  probability = "probability",
  /** column name */
  stagename = "stagename",
  /** column name */
  startdatetime = "startdatetime",
  /** column name */
  subject = "subject",
}

/** Streaming cursor of the table "calendar_gql_clean" */
export type calendar_gql_clean_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: calendar_gql_clean_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type calendar_gql_clean_stream_cursor_value_input = {
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  meeting_key?: InputMaybe<Scalars["bigint"]>;
  meeting_owner?: InputMaybe<Scalars["String"]>;
  meeting_owner_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "calendar_meeting_owner_gql". All fields are combined with a logical 'AND'. */
export type calendar_meeting_owner_gql_bool_exp = {
  _and?: InputMaybe<Array<calendar_meeting_owner_gql_bool_exp>>;
  _not?: InputMaybe<calendar_meeting_owner_gql_bool_exp>;
  _or?: InputMaybe<Array<calendar_meeting_owner_gql_bool_exp>>;
  meeting_owner?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "calendar_meeting_owner_gql". */
export type calendar_meeting_owner_gql_order_by = {
  meeting_owner?: InputMaybe<order_by>;
};

/** select columns of table "calendar_meeting_owner_gql" */
export enum calendar_meeting_owner_gql_select_column {
  /** column name */
  meeting_owner = "meeting_owner",
}

/** Streaming cursor of the table "calendar_meeting_owner_gql" */
export type calendar_meeting_owner_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: calendar_meeting_owner_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type calendar_meeting_owner_gql_stream_cursor_value_input = {
  meeting_owner?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "calendar_stagename_gql". All fields are combined with a logical 'AND'. */
export type calendar_stagename_gql_bool_exp = {
  _and?: InputMaybe<Array<calendar_stagename_gql_bool_exp>>;
  _not?: InputMaybe<calendar_stagename_gql_bool_exp>;
  _or?: InputMaybe<Array<calendar_stagename_gql_bool_exp>>;
  stagename?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "calendar_stagename_gql". */
export type calendar_stagename_gql_order_by = {
  stagename?: InputMaybe<order_by>;
};

/** select columns of table "calendar_stagename_gql" */
export enum calendar_stagename_gql_select_column {
  /** column name */
  stagename = "stagename",
}

/** Streaming cursor of the table "calendar_stagename_gql" */
export type calendar_stagename_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: calendar_stagename_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type calendar_stagename_gql_stream_cursor_value_input = {
  stagename?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type citext_comparison_exp = {
  _eq?: InputMaybe<Scalars["citext"]>;
  _gt?: InputMaybe<Scalars["citext"]>;
  _gte?: InputMaybe<Scalars["citext"]>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["citext"]>;
  _in?: InputMaybe<Array<Scalars["citext"]>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["citext"]>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["citext"]>;
  _lt?: InputMaybe<Scalars["citext"]>;
  _lte?: InputMaybe<Scalars["citext"]>;
  _neq?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["citext"]>;
  _nin?: InputMaybe<Array<Scalars["citext"]>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["citext"]>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["citext"]>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["citext"]>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["citext"]>;
};

/** Boolean expression to filter rows from the table "crm_account_mappings". All fields are combined with a logical 'AND'. */
export type crm_account_mappings_bool_exp = {
  _and?: InputMaybe<Array<crm_account_mappings_bool_exp>>;
  _not?: InputMaybe<crm_account_mappings_bool_exp>;
  _or?: InputMaybe<Array<crm_account_mappings_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  crm_field?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  is_active?: InputMaybe<Boolean_comparison_exp>;
  method?: InputMaybe<String_comparison_exp>;
  revtron_field?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "crm_account_mappings" */
export enum crm_account_mappings_constraint {
  /** unique or primary key constraint on columns "crm_field" */
  crm_account_mappings_crm_field_key = "crm_account_mappings_crm_field_key",
  /** unique or primary key constraint on columns "id" */
  crm_account_mappings_pkey = "crm_account_mappings_pkey",
}

/** input type for incrementing numeric columns in table "crm_account_mappings" */
export type crm_account_mappings_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "crm_account_mappings" */
export type crm_account_mappings_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** on_conflict condition type for table "crm_account_mappings" */
export type crm_account_mappings_on_conflict = {
  constraint: crm_account_mappings_constraint;
  update_columns?: Array<crm_account_mappings_update_column>;
  where?: InputMaybe<crm_account_mappings_bool_exp>;
};

/** Ordering options when selecting data from "crm_account_mappings". */
export type crm_account_mappings_order_by = {
  created_at?: InputMaybe<order_by>;
  crm_field?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_active?: InputMaybe<order_by>;
  method?: InputMaybe<order_by>;
  revtron_field?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: crm_account_mappings */
export type crm_account_mappings_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "crm_account_mappings" */
export enum crm_account_mappings_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_field = "crm_field",
  /** column name */
  id = "id",
  /** column name */
  is_active = "is_active",
  /** column name */
  method = "method",
  /** column name */
  revtron_field = "revtron_field",
  /** column name */
  updated_at = "updated_at",
}

/** input type for updating data in table "crm_account_mappings" */
export type crm_account_mappings_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "crm_account_mappings" */
export type crm_account_mappings_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_account_mappings_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_account_mappings_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  crm_field?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_active?: InputMaybe<Scalars["Boolean"]>;
  method?: InputMaybe<Scalars["String"]>;
  revtron_field?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "crm_account_mappings" */
export enum crm_account_mappings_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  crm_field = "crm_field",
  /** column name */
  id = "id",
  /** column name */
  is_active = "is_active",
  /** column name */
  method = "method",
  /** column name */
  revtron_field = "revtron_field",
  /** column name */
  updated_at = "updated_at",
}

export type crm_account_mappings_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<crm_account_mappings_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_account_mappings_set_input>;
  where: crm_account_mappings_bool_exp;
};

/** Boolean expression to filter rows from the table "crm_revtron_indexes". All fields are combined with a logical 'AND'. */
export type crm_revtron_indexes_bool_exp = {
  _and?: InputMaybe<Array<crm_revtron_indexes_bool_exp>>;
  _not?: InputMaybe<crm_revtron_indexes_bool_exp>;
  _or?: InputMaybe<Array<crm_revtron_indexes_bool_exp>>;
  crm_id?: InputMaybe<String_comparison_exp>;
  revtron_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "crm_revtron_indexes" */
export enum crm_revtron_indexes_constraint {
  /** unique or primary key constraint on columns "revtron_id", "crm_id" */
  crm_revtron_indexes_pkey = "crm_revtron_indexes_pkey",
}

/** input type for inserting data into table "crm_revtron_indexes" */
export type crm_revtron_indexes_insert_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting object relation for remote table "crm_revtron_indexes" */
export type crm_revtron_indexes_obj_rel_insert_input = {
  data: crm_revtron_indexes_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<crm_revtron_indexes_on_conflict>;
};

/** on_conflict condition type for table "crm_revtron_indexes" */
export type crm_revtron_indexes_on_conflict = {
  constraint: crm_revtron_indexes_constraint;
  update_columns?: Array<crm_revtron_indexes_update_column>;
  where?: InputMaybe<crm_revtron_indexes_bool_exp>;
};

/** Ordering options when selecting data from "crm_revtron_indexes". */
export type crm_revtron_indexes_order_by = {
  crm_id?: InputMaybe<order_by>;
  revtron_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: crm_revtron_indexes */
export type crm_revtron_indexes_pk_columns_input = {
  crm_id: Scalars["String"];
  revtron_id: Scalars["String"];
};

/** select columns of table "crm_revtron_indexes" */
export enum crm_revtron_indexes_select_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  revtron_id = "revtron_id",
}

/** input type for updating data in table "crm_revtron_indexes" */
export type crm_revtron_indexes_set_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "crm_revtron_indexes" */
export type crm_revtron_indexes_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_revtron_indexes_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_revtron_indexes_stream_cursor_value_input = {
  crm_id?: InputMaybe<Scalars["String"]>;
  revtron_id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "crm_revtron_indexes" */
export enum crm_revtron_indexes_update_column {
  /** column name */
  crm_id = "crm_id",
  /** column name */
  revtron_id = "revtron_id",
}

export type crm_revtron_indexes_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_revtron_indexes_set_input>;
  where: crm_revtron_indexes_bool_exp;
};

/** Boolean expression to filter rows from the table "crm_users". All fields are combined with a logical 'AND'. */
export type crm_users_bool_exp = {
  _and?: InputMaybe<Array<crm_users_bool_exp>>;
  _not?: InputMaybe<crm_users_bool_exp>;
  _or?: InputMaybe<Array<crm_users_bool_exp>>;
  created_date?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  firstname?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  isactive?: InputMaybe<Boolean_comparison_exp>;
  lastname?: InputMaybe<String_comparison_exp>;
  meeting_creation?: InputMaybe<event_bool_exp>;
  meeting_creation_aggregate?: InputMaybe<event_aggregate_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opp_creation?: InputMaybe<opportunity_bool_exp>;
  opp_creation_aggregate?: InputMaybe<opportunity_aggregate_bool_exp>;
  revtron_users?: InputMaybe<users_bool_exp>;
  title?: InputMaybe<String_comparison_exp>;
  to_effort_engagement?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
  to_effort_engagement_aggregate?: InputMaybe<task_effort_engagement_mapping_aggregate_bool_exp>;
  to_opportunity?: InputMaybe<Opportunity_bool_exp>;
  to_opportunity_aggregate?: InputMaybe<Opportunity_aggregate_bool_exp>;
  to_win_rates?: InputMaybe<win_rates_individual_gql_bool_exp>;
  to_win_rates_aggregate?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp>;
  updated_date?: InputMaybe<timestamp_comparison_exp>;
};

/** input type for inserting data into table "crm_users" */
export type crm_users_insert_input = {
  created_date?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  meeting_creation?: InputMaybe<event_arr_rel_insert_input>;
  name?: InputMaybe<Scalars["String"]>;
  opp_creation?: InputMaybe<opportunity_arr_rel_insert_input>;
  revtron_users?: InputMaybe<users_obj_rel_insert_input>;
  title?: InputMaybe<Scalars["String"]>;
  to_effort_engagement?: InputMaybe<task_effort_engagement_mapping_arr_rel_insert_input>;
  to_opportunity?: InputMaybe<Opportunity_arr_rel_insert_input>;
  to_win_rates?: InputMaybe<win_rates_individual_gql_arr_rel_insert_input>;
  updated_date?: InputMaybe<Scalars["timestamp"]>;
};

/** input type for inserting object relation for remote table "crm_users" */
export type crm_users_obj_rel_insert_input = {
  data: crm_users_insert_input;
};

/** Ordering options when selecting data from "crm_users". */
export type crm_users_order_by = {
  created_date?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  firstname?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isactive?: InputMaybe<order_by>;
  lastname?: InputMaybe<order_by>;
  meeting_creation_aggregate?: InputMaybe<event_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  opp_creation_aggregate?: InputMaybe<opportunity_aggregate_order_by>;
  revtron_users?: InputMaybe<users_order_by>;
  title?: InputMaybe<order_by>;
  to_effort_engagement_aggregate?: InputMaybe<task_effort_engagement_mapping_aggregate_order_by>;
  to_opportunity_aggregate?: InputMaybe<Opportunity_aggregate_order_by>;
  to_win_rates_aggregate?: InputMaybe<win_rates_individual_gql_aggregate_order_by>;
  updated_date?: InputMaybe<order_by>;
};

/** select columns of table "crm_users" */
export enum crm_users_select_column {
  /** column name */
  created_date = "created_date",
  /** column name */
  email = "email",
  /** column name */
  firstname = "firstname",
  /** column name */
  id = "id",
  /** column name */
  isactive = "isactive",
  /** column name */
  lastname = "lastname",
  /** column name */
  name = "name",
  /** column name */
  title = "title",
  /** column name */
  updated_date = "updated_date",
}

/** input type for updating data in table "crm_users" */
export type crm_users_set_input = {
  created_date?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  updated_date?: InputMaybe<Scalars["timestamp"]>;
};

/** Streaming cursor of the table "crm_users" */
export type crm_users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: crm_users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type crm_users_stream_cursor_value_input = {
  created_date?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  updated_date?: InputMaybe<Scalars["timestamp"]>;
};

export type crm_users_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crm_users_set_input>;
  where: crm_users_bool_exp;
};

/** ordering argument of a cursor */
export enum cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = "ASC",
  /** descending ordering of the cursor */
  DESC = "DESC",
}

export type daily_effort_engagement_by_account_aggregate_bool_exp = {
  count?: InputMaybe<daily_effort_engagement_by_account_aggregate_bool_exp_count>;
};

export type daily_effort_engagement_by_account_aggregate_bool_exp_count = {
  arguments?: InputMaybe<
    Array<daily_effort_engagement_by_account_select_column>
  >;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<daily_effort_engagement_by_account_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_aggregate_order_by = {
  avg?: InputMaybe<daily_effort_engagement_by_account_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<daily_effort_engagement_by_account_max_order_by>;
  min?: InputMaybe<daily_effort_engagement_by_account_min_order_by>;
  stddev?: InputMaybe<daily_effort_engagement_by_account_stddev_order_by>;
  stddev_pop?: InputMaybe<daily_effort_engagement_by_account_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<daily_effort_engagement_by_account_stddev_samp_order_by>;
  sum?: InputMaybe<daily_effort_engagement_by_account_sum_order_by>;
  var_pop?: InputMaybe<daily_effort_engagement_by_account_var_pop_order_by>;
  var_samp?: InputMaybe<daily_effort_engagement_by_account_var_samp_order_by>;
  variance?: InputMaybe<daily_effort_engagement_by_account_variance_order_by>;
};

/** order by avg() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_avg_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "daily_effort_engagement_by_account". All fields are combined with a logical 'AND'. */
export type daily_effort_engagement_by_account_bool_exp = {
  _and?: InputMaybe<Array<daily_effort_engagement_by_account_bool_exp>>;
  _not?: InputMaybe<daily_effort_engagement_by_account_bool_exp>;
  _or?: InputMaybe<Array<daily_effort_engagement_by_account_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  activity_date?: InputMaybe<timestamp_comparison_exp>;
  effort?: InputMaybe<numeric_comparison_exp>;
  engagement?: InputMaybe<numeric_comparison_exp>;
};

/** order by max() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_max_order_by = {
  accountid?: InputMaybe<order_by>;
  activity_date?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by min() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_min_order_by = {
  accountid?: InputMaybe<order_by>;
  activity_date?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "daily_effort_engagement_by_account". */
export type daily_effort_engagement_by_account_order_by = {
  accountid?: InputMaybe<order_by>;
  activity_date?: InputMaybe<order_by>;
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** select columns of table "daily_effort_engagement_by_account" */
export enum daily_effort_engagement_by_account_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activity_date = "activity_date",
  /** column name */
  effort = "effort",
  /** column name */
  engagement = "engagement",
}

/** order by stddev() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stddev_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stddev_pop_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stddev_samp_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: daily_effort_engagement_by_account_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type daily_effort_engagement_by_account_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activity_date?: InputMaybe<Scalars["timestamp"]>;
  effort?: InputMaybe<Scalars["numeric"]>;
  engagement?: InputMaybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_sum_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_var_pop_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_var_samp_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "daily_effort_engagement_by_account" */
export type daily_effort_engagement_by_account_variance_order_by = {
  effort?: InputMaybe<order_by>;
  engagement?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type date_comparison_exp = {
  _eq?: InputMaybe<Scalars["date"]>;
  _gt?: InputMaybe<Scalars["date"]>;
  _gte?: InputMaybe<Scalars["date"]>;
  _in?: InputMaybe<Array<Scalars["date"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["date"]>;
  _lte?: InputMaybe<Scalars["date"]>;
  _neq?: InputMaybe<Scalars["date"]>;
  _nin?: InputMaybe<Array<Scalars["date"]>>;
};

export type event_aggregate_bool_exp = {
  bool_and?: InputMaybe<event_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<event_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<event_aggregate_bool_exp_count>;
};

export type event_aggregate_bool_exp_bool_and = {
  arguments: event_select_column_event_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<event_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type event_aggregate_bool_exp_bool_or = {
  arguments: event_select_column_event_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<event_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type event_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<event_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<event_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "event" */
export type event_aggregate_order_by = {
  avg?: InputMaybe<event_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<event_max_order_by>;
  min?: InputMaybe<event_min_order_by>;
  stddev?: InputMaybe<event_stddev_order_by>;
  stddev_pop?: InputMaybe<event_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<event_stddev_samp_order_by>;
  sum?: InputMaybe<event_sum_order_by>;
  var_pop?: InputMaybe<event_var_pop_order_by>;
  var_samp?: InputMaybe<event_var_samp_order_by>;
  variance?: InputMaybe<event_variance_order_by>;
};

/** input type for inserting array relation for remote table "event" */
export type event_arr_rel_insert_input = {
  data: Array<event_insert_input>;
};

/** order by avg() on columns of table "event" */
export type event_avg_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "event". All fields are combined with a logical 'AND'. */
export type event_bool_exp = {
  _and?: InputMaybe<Array<event_bool_exp>>;
  _not?: InputMaybe<event_bool_exp>;
  _or?: InputMaybe<Array<event_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  action__c?: InputMaybe<String_comparison_exp>;
  activitydate?: InputMaybe<timestamp_comparison_exp>;
  activitydatetime?: InputMaybe<timestamp_comparison_exp>;
  age__c?: InputMaybe<numeric_comparison_exp>;
  attributable_sequence_name__c?: InputMaybe<String_comparison_exp>;
  bounced_at__c?: InputMaybe<timestamp_comparison_exp>;
  call_disposition2__c?: InputMaybe<String_comparison_exp>;
  call_disposition__c?: InputMaybe<String_comparison_exp>;
  call_outcome__c?: InputMaybe<String_comparison_exp>;
  clearslide_link_clicked__c?: InputMaybe<Boolean_comparison_exp>;
  click_count__c?: InputMaybe<numeric_comparison_exp>;
  clicked_at__c?: InputMaybe<timestamp_comparison_exp>;
  close_task__c?: InputMaybe<Boolean_comparison_exp>;
  connected_count__c?: InputMaybe<numeric_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  data_quality_description__c?: InputMaybe<String_comparison_exp>;
  data_quality_score__c?: InputMaybe<numeric_comparison_exp>;
  delivered_at__c?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  direct_contact__c?: InputMaybe<String_comparison_exp>;
  durationinminutes?: InputMaybe<Int_comparison_exp>;
  effort_score__c?: InputMaybe<numeric_comparison_exp>;
  enddate?: InputMaybe<timestamp_comparison_exp>;
  enddatetime?: InputMaybe<timestamp_comparison_exp>;
  eventsubtype?: InputMaybe<String_comparison_exp>;
  flow_name__c?: InputMaybe<String_comparison_exp>;
  gong__gong_selected_process__c?: InputMaybe<Boolean_comparison_exp>;
  groove_email_sent_at__c?: InputMaybe<timestamp_comparison_exp>;
  groove_inbound_response_time_seconds__c?: InputMaybe<numeric_comparison_exp>;
  groove_sent_from_flow__c?: InputMaybe<Boolean_comparison_exp>;
  groupeventtype?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  id__c?: InputMaybe<String_comparison_exp>;
  inviteeuuid__c?: InputMaybe<String_comparison_exp>;
  isalldayevent?: InputMaybe<Boolean_comparison_exp>;
  isarchived?: InputMaybe<Boolean_comparison_exp>;
  ischild?: InputMaybe<Boolean_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  isgroupevent?: InputMaybe<Boolean_comparison_exp>;
  isprivate?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence2?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence2exception?: InputMaybe<Boolean_comparison_exp>;
  isrecurrence2exclusion?: InputMaybe<Boolean_comparison_exp>;
  isreminderset?: InputMaybe<Boolean_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lid__date_sent__c?: InputMaybe<timestamp_comparison_exp>;
  lid__url__c?: InputMaybe<String_comparison_exp>;
  location?: InputMaybe<String_comparison_exp>;
  mailbox_source_email_address__c?: InputMaybe<String_comparison_exp>;
  marked_as_spam_at__c?: InputMaybe<timestamp_comparison_exp>;
  messageid__c?: InputMaybe<String_comparison_exp>;
  missed_meeting__c?: InputMaybe<Boolean_comparison_exp>;
  missed_meeting_reason__c?: InputMaybe<String_comparison_exp>;
  not_pardot_or_hubspot__c?: InputMaybe<Boolean_comparison_exp>;
  open_count__c?: InputMaybe<numeric_comparison_exp>;
  opened_at__c?: InputMaybe<timestamp_comparison_exp>;
  outreach_task_type__c?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  per_user__c?: InputMaybe<String_comparison_exp>;
  profile_claimed__c?: InputMaybe<Boolean_comparison_exp>;
  recurrence2patternstartdate?: InputMaybe<timestamp_comparison_exp>;
  recurrence2patterntext?: InputMaybe<String_comparison_exp>;
  recurrence2patterntimezone?: InputMaybe<String_comparison_exp>;
  recurrence2patternversion?: InputMaybe<String_comparison_exp>;
  recurrenceactivityid?: InputMaybe<String_comparison_exp>;
  recurrencedayofmonth?: InputMaybe<Int_comparison_exp>;
  recurrencedayofweekmask?: InputMaybe<Int_comparison_exp>;
  recurrenceenddateonly?: InputMaybe<timestamp_comparison_exp>;
  recurrenceinstance?: InputMaybe<String_comparison_exp>;
  recurrenceinterval?: InputMaybe<Int_comparison_exp>;
  recurrencemonthofyear?: InputMaybe<String_comparison_exp>;
  recurrencestartdatetime?: InputMaybe<timestamp_comparison_exp>;
  recurrencetimezonesidkey?: InputMaybe<String_comparison_exp>;
  recurrencetype?: InputMaybe<String_comparison_exp>;
  reminderdatetime?: InputMaybe<timestamp_comparison_exp>;
  ringcentral__call_recording__c?: InputMaybe<String_comparison_exp>;
  ringcentral__recording_information__c?: InputMaybe<String_comparison_exp>;
  salesloft_cadence_id__c?: InputMaybe<String_comparison_exp>;
  salesloft_cadence_name__c?: InputMaybe<String_comparison_exp>;
  salesloft_clicked_count__c?: InputMaybe<numeric_comparison_exp>;
  salesloft_email_template_id__c?: InputMaybe<String_comparison_exp>;
  salesloft_email_template_title__c?: InputMaybe<String_comparison_exp>;
  salesloft_external_identifier__c?: InputMaybe<String_comparison_exp>;
  salesloft_step_day_new__c?: InputMaybe<numeric_comparison_exp>;
  salesloft_step_id__c?: InputMaybe<String_comparison_exp>;
  salesloft_step_name__c?: InputMaybe<String_comparison_exp>;
  salesloft_step_type__c?: InputMaybe<String_comparison_exp>;
  salesloft_viewed_count__c?: InputMaybe<numeric_comparison_exp>;
  salesloftreplycount__c?: InputMaybe<numeric_comparison_exp>;
  score__c?: InputMaybe<numeric_comparison_exp>;
  showas?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  startdatetime?: InputMaybe<timestamp_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  summary__c?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  task_start_time__c?: InputMaybe<timestamp_comparison_exp>;
  template_name__c?: InputMaybe<String_comparison_exp>;
  testsfdc__c?: InputMaybe<String_comparison_exp>;
  time_stamp__c?: InputMaybe<timestamp_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  unique_click_count__c?: InputMaybe<numeric_comparison_exp>;
  unique_reply_count__c?: InputMaybe<numeric_comparison_exp>;
  unique_view_count__c?: InputMaybe<numeric_comparison_exp>;
  user__c?: InputMaybe<String_comparison_exp>;
  voicemail_count__c?: InputMaybe<numeric_comparison_exp>;
  whatid?: InputMaybe<String_comparison_exp>;
  whoid?: InputMaybe<String_comparison_exp>;
  zoom_app__additional_emails__c?: InputMaybe<String_comparison_exp>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<numeric_comparison_exp>;
  zoom_app__customer_start_time__c?: InputMaybe<timestamp_comparison_exp>;
  zoom_app__customer_time_zone__c?: InputMaybe<String_comparison_exp>;
  zoom_app__ics_sequence__c?: InputMaybe<numeric_comparison_exp>;
  zoom_app__join_before_host__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__make_it_zoom_meeting__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__use_personal_zoom_meeting_id__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__zoom_call_log__c?: InputMaybe<String_comparison_exp>;
  zoom_app__zoom_event__c?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "event" */
export type event_inc_input = {
  age__c?: InputMaybe<Scalars["numeric"]>;
  click_count__c?: InputMaybe<Scalars["numeric"]>;
  connected_count__c?: InputMaybe<Scalars["numeric"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  effort_score__c?: InputMaybe<Scalars["numeric"]>;
  groove_inbound_response_time_seconds__c?: InputMaybe<Scalars["numeric"]>;
  open_count__c?: InputMaybe<Scalars["numeric"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  salesloft_clicked_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_step_day_new__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_viewed_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloftreplycount__c?: InputMaybe<Scalars["numeric"]>;
  score__c?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  unique_click_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_reply_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_view_count__c?: InputMaybe<Scalars["numeric"]>;
  voicemail_count__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__ics_sequence__c?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "event" */
export type event_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  action__c?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  activitydatetime?: InputMaybe<Scalars["timestamp"]>;
  age__c?: InputMaybe<Scalars["numeric"]>;
  attributable_sequence_name__c?: InputMaybe<Scalars["String"]>;
  bounced_at__c?: InputMaybe<Scalars["timestamp"]>;
  call_disposition2__c?: InputMaybe<Scalars["String"]>;
  call_disposition__c?: InputMaybe<Scalars["String"]>;
  call_outcome__c?: InputMaybe<Scalars["String"]>;
  clearslide_link_clicked__c?: InputMaybe<Scalars["Boolean"]>;
  click_count__c?: InputMaybe<Scalars["numeric"]>;
  clicked_at__c?: InputMaybe<Scalars["timestamp"]>;
  close_task__c?: InputMaybe<Scalars["Boolean"]>;
  connected_count__c?: InputMaybe<Scalars["numeric"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  data_quality_description__c?: InputMaybe<Scalars["String"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  delivered_at__c?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  direct_contact__c?: InputMaybe<Scalars["String"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  effort_score__c?: InputMaybe<Scalars["numeric"]>;
  enddate?: InputMaybe<Scalars["timestamp"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  eventsubtype?: InputMaybe<Scalars["String"]>;
  flow_name__c?: InputMaybe<Scalars["String"]>;
  gong__gong_selected_process__c?: InputMaybe<Scalars["Boolean"]>;
  groove_email_sent_at__c?: InputMaybe<Scalars["timestamp"]>;
  groove_inbound_response_time_seconds__c?: InputMaybe<Scalars["numeric"]>;
  groove_sent_from_flow__c?: InputMaybe<Scalars["Boolean"]>;
  groupeventtype?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  id__c?: InputMaybe<Scalars["String"]>;
  inviteeuuid__c?: InputMaybe<Scalars["String"]>;
  isalldayevent?: InputMaybe<Scalars["Boolean"]>;
  isarchived?: InputMaybe<Scalars["Boolean"]>;
  ischild?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isgroupevent?: InputMaybe<Scalars["Boolean"]>;
  isprivate?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exception?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exclusion?: InputMaybe<Scalars["Boolean"]>;
  isreminderset?: InputMaybe<Scalars["Boolean"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lid__date_sent__c?: InputMaybe<Scalars["timestamp"]>;
  lid__url__c?: InputMaybe<Scalars["String"]>;
  location?: InputMaybe<Scalars["String"]>;
  mailbox_source_email_address__c?: InputMaybe<Scalars["String"]>;
  marked_as_spam_at__c?: InputMaybe<Scalars["timestamp"]>;
  messageid__c?: InputMaybe<Scalars["String"]>;
  missed_meeting__c?: InputMaybe<Scalars["Boolean"]>;
  missed_meeting_reason__c?: InputMaybe<Scalars["String"]>;
  not_pardot_or_hubspot__c?: InputMaybe<Scalars["Boolean"]>;
  open_count__c?: InputMaybe<Scalars["numeric"]>;
  opened_at__c?: InputMaybe<Scalars["timestamp"]>;
  outreach_task_type__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  per_user__c?: InputMaybe<Scalars["String"]>;
  profile_claimed__c?: InputMaybe<Scalars["Boolean"]>;
  recurrence2patternstartdate?: InputMaybe<Scalars["timestamp"]>;
  recurrence2patterntext?: InputMaybe<Scalars["String"]>;
  recurrence2patterntimezone?: InputMaybe<Scalars["String"]>;
  recurrence2patternversion?: InputMaybe<Scalars["String"]>;
  recurrenceactivityid?: InputMaybe<Scalars["String"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceenddateonly?: InputMaybe<Scalars["timestamp"]>;
  recurrenceinstance?: InputMaybe<Scalars["String"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  recurrencemonthofyear?: InputMaybe<Scalars["String"]>;
  recurrencestartdatetime?: InputMaybe<Scalars["timestamp"]>;
  recurrencetimezonesidkey?: InputMaybe<Scalars["String"]>;
  recurrencetype?: InputMaybe<Scalars["String"]>;
  reminderdatetime?: InputMaybe<Scalars["timestamp"]>;
  ringcentral__call_recording__c?: InputMaybe<Scalars["String"]>;
  ringcentral__recording_information__c?: InputMaybe<Scalars["String"]>;
  salesloft_cadence_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_cadence_name__c?: InputMaybe<Scalars["String"]>;
  salesloft_clicked_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_email_template_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_email_template_title__c?: InputMaybe<Scalars["String"]>;
  salesloft_external_identifier__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_day_new__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_step_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_name__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_type__c?: InputMaybe<Scalars["String"]>;
  salesloft_viewed_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloftreplycount__c?: InputMaybe<Scalars["numeric"]>;
  score__c?: InputMaybe<Scalars["numeric"]>;
  showas?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
  summary__c?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  task_start_time__c?: InputMaybe<Scalars["timestamp"]>;
  template_name__c?: InputMaybe<Scalars["String"]>;
  testsfdc__c?: InputMaybe<Scalars["String"]>;
  time_stamp__c?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  unique_click_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_reply_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_view_count__c?: InputMaybe<Scalars["numeric"]>;
  user__c?: InputMaybe<Scalars["String"]>;
  voicemail_count__c?: InputMaybe<Scalars["numeric"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
  zoom_app__additional_emails__c?: InputMaybe<Scalars["String"]>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__customer_start_time__c?: InputMaybe<Scalars["timestamp"]>;
  zoom_app__customer_time_zone__c?: InputMaybe<Scalars["String"]>;
  zoom_app__ics_sequence__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__join_before_host__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__make_it_zoom_meeting__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__use_personal_zoom_meeting_id__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__zoom_call_log__c?: InputMaybe<Scalars["String"]>;
  zoom_app__zoom_event__c?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "event" */
export type event_max_order_by = {
  accountid?: InputMaybe<order_by>;
  action__c?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  activitydatetime?: InputMaybe<order_by>;
  age__c?: InputMaybe<order_by>;
  attributable_sequence_name__c?: InputMaybe<order_by>;
  bounced_at__c?: InputMaybe<order_by>;
  call_disposition2__c?: InputMaybe<order_by>;
  call_disposition__c?: InputMaybe<order_by>;
  call_outcome__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  clicked_at__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  data_quality_description__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  delivered_at__c?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  direct_contact__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  enddate?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  eventsubtype?: InputMaybe<order_by>;
  flow_name__c?: InputMaybe<order_by>;
  groove_email_sent_at__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  groupeventtype?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  id__c?: InputMaybe<order_by>;
  inviteeuuid__c?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lid__date_sent__c?: InputMaybe<order_by>;
  lid__url__c?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  mailbox_source_email_address__c?: InputMaybe<order_by>;
  marked_as_spam_at__c?: InputMaybe<order_by>;
  messageid__c?: InputMaybe<order_by>;
  missed_meeting_reason__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  opened_at__c?: InputMaybe<order_by>;
  outreach_task_type__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  per_user__c?: InputMaybe<order_by>;
  recurrence2patternstartdate?: InputMaybe<order_by>;
  recurrence2patterntext?: InputMaybe<order_by>;
  recurrence2patterntimezone?: InputMaybe<order_by>;
  recurrence2patternversion?: InputMaybe<order_by>;
  recurrenceactivityid?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceenddateonly?: InputMaybe<order_by>;
  recurrenceinstance?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  recurrencemonthofyear?: InputMaybe<order_by>;
  recurrencestartdatetime?: InputMaybe<order_by>;
  recurrencetimezonesidkey?: InputMaybe<order_by>;
  recurrencetype?: InputMaybe<order_by>;
  reminderdatetime?: InputMaybe<order_by>;
  ringcentral__call_recording__c?: InputMaybe<order_by>;
  ringcentral__recording_information__c?: InputMaybe<order_by>;
  salesloft_cadence_id__c?: InputMaybe<order_by>;
  salesloft_cadence_name__c?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_email_template_id__c?: InputMaybe<order_by>;
  salesloft_email_template_title__c?: InputMaybe<order_by>;
  salesloft_external_identifier__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_step_id__c?: InputMaybe<order_by>;
  salesloft_step_name__c?: InputMaybe<order_by>;
  salesloft_step_type__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  showas?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  summary__c?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  task_start_time__c?: InputMaybe<order_by>;
  template_name__c?: InputMaybe<order_by>;
  testsfdc__c?: InputMaybe<order_by>;
  time_stamp__c?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  user__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
  zoom_app__additional_emails__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__customer_start_time__c?: InputMaybe<order_by>;
  zoom_app__customer_time_zone__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
  zoom_app__zoom_call_log__c?: InputMaybe<order_by>;
  zoom_app__zoom_event__c?: InputMaybe<order_by>;
};

/** order by min() on columns of table "event" */
export type event_min_order_by = {
  accountid?: InputMaybe<order_by>;
  action__c?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  activitydatetime?: InputMaybe<order_by>;
  age__c?: InputMaybe<order_by>;
  attributable_sequence_name__c?: InputMaybe<order_by>;
  bounced_at__c?: InputMaybe<order_by>;
  call_disposition2__c?: InputMaybe<order_by>;
  call_disposition__c?: InputMaybe<order_by>;
  call_outcome__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  clicked_at__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  data_quality_description__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  delivered_at__c?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  direct_contact__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  enddate?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  eventsubtype?: InputMaybe<order_by>;
  flow_name__c?: InputMaybe<order_by>;
  groove_email_sent_at__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  groupeventtype?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  id__c?: InputMaybe<order_by>;
  inviteeuuid__c?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lid__date_sent__c?: InputMaybe<order_by>;
  lid__url__c?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  mailbox_source_email_address__c?: InputMaybe<order_by>;
  marked_as_spam_at__c?: InputMaybe<order_by>;
  messageid__c?: InputMaybe<order_by>;
  missed_meeting_reason__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  opened_at__c?: InputMaybe<order_by>;
  outreach_task_type__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  per_user__c?: InputMaybe<order_by>;
  recurrence2patternstartdate?: InputMaybe<order_by>;
  recurrence2patterntext?: InputMaybe<order_by>;
  recurrence2patterntimezone?: InputMaybe<order_by>;
  recurrence2patternversion?: InputMaybe<order_by>;
  recurrenceactivityid?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceenddateonly?: InputMaybe<order_by>;
  recurrenceinstance?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  recurrencemonthofyear?: InputMaybe<order_by>;
  recurrencestartdatetime?: InputMaybe<order_by>;
  recurrencetimezonesidkey?: InputMaybe<order_by>;
  recurrencetype?: InputMaybe<order_by>;
  reminderdatetime?: InputMaybe<order_by>;
  ringcentral__call_recording__c?: InputMaybe<order_by>;
  ringcentral__recording_information__c?: InputMaybe<order_by>;
  salesloft_cadence_id__c?: InputMaybe<order_by>;
  salesloft_cadence_name__c?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_email_template_id__c?: InputMaybe<order_by>;
  salesloft_email_template_title__c?: InputMaybe<order_by>;
  salesloft_external_identifier__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_step_id__c?: InputMaybe<order_by>;
  salesloft_step_name__c?: InputMaybe<order_by>;
  salesloft_step_type__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  showas?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  summary__c?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  task_start_time__c?: InputMaybe<order_by>;
  template_name__c?: InputMaybe<order_by>;
  testsfdc__c?: InputMaybe<order_by>;
  time_stamp__c?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  user__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
  zoom_app__additional_emails__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__customer_start_time__c?: InputMaybe<order_by>;
  zoom_app__customer_time_zone__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
  zoom_app__zoom_call_log__c?: InputMaybe<order_by>;
  zoom_app__zoom_event__c?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "event". */
export type event_order_by = {
  accountid?: InputMaybe<order_by>;
  action__c?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  activitydatetime?: InputMaybe<order_by>;
  age__c?: InputMaybe<order_by>;
  attributable_sequence_name__c?: InputMaybe<order_by>;
  bounced_at__c?: InputMaybe<order_by>;
  call_disposition2__c?: InputMaybe<order_by>;
  call_disposition__c?: InputMaybe<order_by>;
  call_outcome__c?: InputMaybe<order_by>;
  clearslide_link_clicked__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  clicked_at__c?: InputMaybe<order_by>;
  close_task__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  data_quality_description__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  delivered_at__c?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  direct_contact__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  enddate?: InputMaybe<order_by>;
  enddatetime?: InputMaybe<order_by>;
  eventsubtype?: InputMaybe<order_by>;
  flow_name__c?: InputMaybe<order_by>;
  gong__gong_selected_process__c?: InputMaybe<order_by>;
  groove_email_sent_at__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  groove_sent_from_flow__c?: InputMaybe<order_by>;
  groupeventtype?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  id__c?: InputMaybe<order_by>;
  inviteeuuid__c?: InputMaybe<order_by>;
  isalldayevent?: InputMaybe<order_by>;
  isarchived?: InputMaybe<order_by>;
  ischild?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  isgroupevent?: InputMaybe<order_by>;
  isprivate?: InputMaybe<order_by>;
  isrecurrence?: InputMaybe<order_by>;
  isrecurrence2?: InputMaybe<order_by>;
  isrecurrence2exception?: InputMaybe<order_by>;
  isrecurrence2exclusion?: InputMaybe<order_by>;
  isreminderset?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lid__date_sent__c?: InputMaybe<order_by>;
  lid__url__c?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  mailbox_source_email_address__c?: InputMaybe<order_by>;
  marked_as_spam_at__c?: InputMaybe<order_by>;
  messageid__c?: InputMaybe<order_by>;
  missed_meeting__c?: InputMaybe<order_by>;
  missed_meeting_reason__c?: InputMaybe<order_by>;
  not_pardot_or_hubspot__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  opened_at__c?: InputMaybe<order_by>;
  outreach_task_type__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  per_user__c?: InputMaybe<order_by>;
  profile_claimed__c?: InputMaybe<order_by>;
  recurrence2patternstartdate?: InputMaybe<order_by>;
  recurrence2patterntext?: InputMaybe<order_by>;
  recurrence2patterntimezone?: InputMaybe<order_by>;
  recurrence2patternversion?: InputMaybe<order_by>;
  recurrenceactivityid?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceenddateonly?: InputMaybe<order_by>;
  recurrenceinstance?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  recurrencemonthofyear?: InputMaybe<order_by>;
  recurrencestartdatetime?: InputMaybe<order_by>;
  recurrencetimezonesidkey?: InputMaybe<order_by>;
  recurrencetype?: InputMaybe<order_by>;
  reminderdatetime?: InputMaybe<order_by>;
  ringcentral__call_recording__c?: InputMaybe<order_by>;
  ringcentral__recording_information__c?: InputMaybe<order_by>;
  salesloft_cadence_id__c?: InputMaybe<order_by>;
  salesloft_cadence_name__c?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_email_template_id__c?: InputMaybe<order_by>;
  salesloft_email_template_title__c?: InputMaybe<order_by>;
  salesloft_external_identifier__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_step_id__c?: InputMaybe<order_by>;
  salesloft_step_name__c?: InputMaybe<order_by>;
  salesloft_step_type__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  showas?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  startdatetime?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  summary__c?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  task_start_time__c?: InputMaybe<order_by>;
  template_name__c?: InputMaybe<order_by>;
  testsfdc__c?: InputMaybe<order_by>;
  time_stamp__c?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  user__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
  zoom_app__additional_emails__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__customer_start_time__c?: InputMaybe<order_by>;
  zoom_app__customer_time_zone__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
  zoom_app__join_before_host__c?: InputMaybe<order_by>;
  zoom_app__make_it_zoom_meeting__c?: InputMaybe<order_by>;
  zoom_app__use_personal_zoom_meeting_id__c?: InputMaybe<order_by>;
  zoom_app__zoom_call_log__c?: InputMaybe<order_by>;
  zoom_app__zoom_event__c?: InputMaybe<order_by>;
};

/** select columns of table "event" */
export enum event_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  action__c = "action__c",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  activitydatetime = "activitydatetime",
  /** column name */
  age__c = "age__c",
  /** column name */
  attributable_sequence_name__c = "attributable_sequence_name__c",
  /** column name */
  bounced_at__c = "bounced_at__c",
  /** column name */
  call_disposition2__c = "call_disposition2__c",
  /** column name */
  call_disposition__c = "call_disposition__c",
  /** column name */
  call_outcome__c = "call_outcome__c",
  /** column name */
  clearslide_link_clicked__c = "clearslide_link_clicked__c",
  /** column name */
  click_count__c = "click_count__c",
  /** column name */
  clicked_at__c = "clicked_at__c",
  /** column name */
  close_task__c = "close_task__c",
  /** column name */
  connected_count__c = "connected_count__c",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  data_quality_description__c = "data_quality_description__c",
  /** column name */
  data_quality_score__c = "data_quality_score__c",
  /** column name */
  delivered_at__c = "delivered_at__c",
  /** column name */
  description = "description",
  /** column name */
  direct_contact__c = "direct_contact__c",
  /** column name */
  durationinminutes = "durationinminutes",
  /** column name */
  effort_score__c = "effort_score__c",
  /** column name */
  enddate = "enddate",
  /** column name */
  enddatetime = "enddatetime",
  /** column name */
  eventsubtype = "eventsubtype",
  /** column name */
  flow_name__c = "flow_name__c",
  /** column name */
  gong__gong_selected_process__c = "gong__gong_selected_process__c",
  /** column name */
  groove_email_sent_at__c = "groove_email_sent_at__c",
  /** column name */
  groove_inbound_response_time_seconds__c = "groove_inbound_response_time_seconds__c",
  /** column name */
  groove_sent_from_flow__c = "groove_sent_from_flow__c",
  /** column name */
  groupeventtype = "groupeventtype",
  /** column name */
  id = "id",
  /** column name */
  id__c = "id__c",
  /** column name */
  inviteeuuid__c = "inviteeuuid__c",
  /** column name */
  isalldayevent = "isalldayevent",
  /** column name */
  isarchived = "isarchived",
  /** column name */
  ischild = "ischild",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isgroupevent = "isgroupevent",
  /** column name */
  isprivate = "isprivate",
  /** column name */
  isrecurrence = "isrecurrence",
  /** column name */
  isrecurrence2 = "isrecurrence2",
  /** column name */
  isrecurrence2exception = "isrecurrence2exception",
  /** column name */
  isrecurrence2exclusion = "isrecurrence2exclusion",
  /** column name */
  isreminderset = "isreminderset",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lid__date_sent__c = "lid__date_sent__c",
  /** column name */
  lid__url__c = "lid__url__c",
  /** column name */
  location = "location",
  /** column name */
  mailbox_source_email_address__c = "mailbox_source_email_address__c",
  /** column name */
  marked_as_spam_at__c = "marked_as_spam_at__c",
  /** column name */
  messageid__c = "messageid__c",
  /** column name */
  missed_meeting__c = "missed_meeting__c",
  /** column name */
  missed_meeting_reason__c = "missed_meeting_reason__c",
  /** column name */
  not_pardot_or_hubspot__c = "not_pardot_or_hubspot__c",
  /** column name */
  open_count__c = "open_count__c",
  /** column name */
  opened_at__c = "opened_at__c",
  /** column name */
  outreach_task_type__c = "outreach_task_type__c",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  per_user__c = "per_user__c",
  /** column name */
  profile_claimed__c = "profile_claimed__c",
  /** column name */
  recurrence2patternstartdate = "recurrence2patternstartdate",
  /** column name */
  recurrence2patterntext = "recurrence2patterntext",
  /** column name */
  recurrence2patterntimezone = "recurrence2patterntimezone",
  /** column name */
  recurrence2patternversion = "recurrence2patternversion",
  /** column name */
  recurrenceactivityid = "recurrenceactivityid",
  /** column name */
  recurrencedayofmonth = "recurrencedayofmonth",
  /** column name */
  recurrencedayofweekmask = "recurrencedayofweekmask",
  /** column name */
  recurrenceenddateonly = "recurrenceenddateonly",
  /** column name */
  recurrenceinstance = "recurrenceinstance",
  /** column name */
  recurrenceinterval = "recurrenceinterval",
  /** column name */
  recurrencemonthofyear = "recurrencemonthofyear",
  /** column name */
  recurrencestartdatetime = "recurrencestartdatetime",
  /** column name */
  recurrencetimezonesidkey = "recurrencetimezonesidkey",
  /** column name */
  recurrencetype = "recurrencetype",
  /** column name */
  reminderdatetime = "reminderdatetime",
  /** column name */
  ringcentral__call_recording__c = "ringcentral__call_recording__c",
  /** column name */
  ringcentral__recording_information__c = "ringcentral__recording_information__c",
  /** column name */
  salesloft_cadence_id__c = "salesloft_cadence_id__c",
  /** column name */
  salesloft_cadence_name__c = "salesloft_cadence_name__c",
  /** column name */
  salesloft_clicked_count__c = "salesloft_clicked_count__c",
  /** column name */
  salesloft_email_template_id__c = "salesloft_email_template_id__c",
  /** column name */
  salesloft_email_template_title__c = "salesloft_email_template_title__c",
  /** column name */
  salesloft_external_identifier__c = "salesloft_external_identifier__c",
  /** column name */
  salesloft_step_day_new__c = "salesloft_step_day_new__c",
  /** column name */
  salesloft_step_id__c = "salesloft_step_id__c",
  /** column name */
  salesloft_step_name__c = "salesloft_step_name__c",
  /** column name */
  salesloft_step_type__c = "salesloft_step_type__c",
  /** column name */
  salesloft_viewed_count__c = "salesloft_viewed_count__c",
  /** column name */
  salesloftreplycount__c = "salesloftreplycount__c",
  /** column name */
  score__c = "score__c",
  /** column name */
  showas = "showas",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  startdatetime = "startdatetime",
  /** column name */
  subject = "subject",
  /** column name */
  summary__c = "summary__c",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  task_start_time__c = "task_start_time__c",
  /** column name */
  template_name__c = "template_name__c",
  /** column name */
  testsfdc__c = "testsfdc__c",
  /** column name */
  time_stamp__c = "time_stamp__c",
  /** column name */
  type = "type",
  /** column name */
  unique_click_count__c = "unique_click_count__c",
  /** column name */
  unique_reply_count__c = "unique_reply_count__c",
  /** column name */
  unique_view_count__c = "unique_view_count__c",
  /** column name */
  user__c = "user__c",
  /** column name */
  voicemail_count__c = "voicemail_count__c",
  /** column name */
  whatid = "whatid",
  /** column name */
  whoid = "whoid",
  /** column name */
  zoom_app__additional_emails__c = "zoom_app__additional_emails__c",
  /** column name */
  zoom_app__customer_duration_of_meeting__c = "zoom_app__customer_duration_of_meeting__c",
  /** column name */
  zoom_app__customer_start_time__c = "zoom_app__customer_start_time__c",
  /** column name */
  zoom_app__customer_time_zone__c = "zoom_app__customer_time_zone__c",
  /** column name */
  zoom_app__ics_sequence__c = "zoom_app__ics_sequence__c",
  /** column name */
  zoom_app__join_before_host__c = "zoom_app__join_before_host__c",
  /** column name */
  zoom_app__make_it_zoom_meeting__c = "zoom_app__make_it_zoom_meeting__c",
  /** column name */
  zoom_app__use_personal_zoom_meeting_id__c = "zoom_app__use_personal_zoom_meeting_id__c",
  /** column name */
  zoom_app__zoom_call_log__c = "zoom_app__zoom_call_log__c",
  /** column name */
  zoom_app__zoom_event__c = "zoom_app__zoom_event__c",
}

/** select "event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event" */
export enum event_select_column_event_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  clearslide_link_clicked__c = "clearslide_link_clicked__c",
  /** column name */
  close_task__c = "close_task__c",
  /** column name */
  gong__gong_selected_process__c = "gong__gong_selected_process__c",
  /** column name */
  groove_sent_from_flow__c = "groove_sent_from_flow__c",
  /** column name */
  isalldayevent = "isalldayevent",
  /** column name */
  isarchived = "isarchived",
  /** column name */
  ischild = "ischild",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isgroupevent = "isgroupevent",
  /** column name */
  isprivate = "isprivate",
  /** column name */
  isrecurrence = "isrecurrence",
  /** column name */
  isrecurrence2 = "isrecurrence2",
  /** column name */
  isrecurrence2exception = "isrecurrence2exception",
  /** column name */
  isrecurrence2exclusion = "isrecurrence2exclusion",
  /** column name */
  isreminderset = "isreminderset",
  /** column name */
  missed_meeting__c = "missed_meeting__c",
  /** column name */
  not_pardot_or_hubspot__c = "not_pardot_or_hubspot__c",
  /** column name */
  profile_claimed__c = "profile_claimed__c",
  /** column name */
  zoom_app__join_before_host__c = "zoom_app__join_before_host__c",
  /** column name */
  zoom_app__make_it_zoom_meeting__c = "zoom_app__make_it_zoom_meeting__c",
  /** column name */
  zoom_app__use_personal_zoom_meeting_id__c = "zoom_app__use_personal_zoom_meeting_id__c",
}

/** select "event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event" */
export enum event_select_column_event_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  clearslide_link_clicked__c = "clearslide_link_clicked__c",
  /** column name */
  close_task__c = "close_task__c",
  /** column name */
  gong__gong_selected_process__c = "gong__gong_selected_process__c",
  /** column name */
  groove_sent_from_flow__c = "groove_sent_from_flow__c",
  /** column name */
  isalldayevent = "isalldayevent",
  /** column name */
  isarchived = "isarchived",
  /** column name */
  ischild = "ischild",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isgroupevent = "isgroupevent",
  /** column name */
  isprivate = "isprivate",
  /** column name */
  isrecurrence = "isrecurrence",
  /** column name */
  isrecurrence2 = "isrecurrence2",
  /** column name */
  isrecurrence2exception = "isrecurrence2exception",
  /** column name */
  isrecurrence2exclusion = "isrecurrence2exclusion",
  /** column name */
  isreminderset = "isreminderset",
  /** column name */
  missed_meeting__c = "missed_meeting__c",
  /** column name */
  not_pardot_or_hubspot__c = "not_pardot_or_hubspot__c",
  /** column name */
  profile_claimed__c = "profile_claimed__c",
  /** column name */
  zoom_app__join_before_host__c = "zoom_app__join_before_host__c",
  /** column name */
  zoom_app__make_it_zoom_meeting__c = "zoom_app__make_it_zoom_meeting__c",
  /** column name */
  zoom_app__use_personal_zoom_meeting_id__c = "zoom_app__use_personal_zoom_meeting_id__c",
}

/** input type for updating data in table "event" */
export type event_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  action__c?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  activitydatetime?: InputMaybe<Scalars["timestamp"]>;
  age__c?: InputMaybe<Scalars["numeric"]>;
  attributable_sequence_name__c?: InputMaybe<Scalars["String"]>;
  bounced_at__c?: InputMaybe<Scalars["timestamp"]>;
  call_disposition2__c?: InputMaybe<Scalars["String"]>;
  call_disposition__c?: InputMaybe<Scalars["String"]>;
  call_outcome__c?: InputMaybe<Scalars["String"]>;
  clearslide_link_clicked__c?: InputMaybe<Scalars["Boolean"]>;
  click_count__c?: InputMaybe<Scalars["numeric"]>;
  clicked_at__c?: InputMaybe<Scalars["timestamp"]>;
  close_task__c?: InputMaybe<Scalars["Boolean"]>;
  connected_count__c?: InputMaybe<Scalars["numeric"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  data_quality_description__c?: InputMaybe<Scalars["String"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  delivered_at__c?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  direct_contact__c?: InputMaybe<Scalars["String"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  effort_score__c?: InputMaybe<Scalars["numeric"]>;
  enddate?: InputMaybe<Scalars["timestamp"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  eventsubtype?: InputMaybe<Scalars["String"]>;
  flow_name__c?: InputMaybe<Scalars["String"]>;
  gong__gong_selected_process__c?: InputMaybe<Scalars["Boolean"]>;
  groove_email_sent_at__c?: InputMaybe<Scalars["timestamp"]>;
  groove_inbound_response_time_seconds__c?: InputMaybe<Scalars["numeric"]>;
  groove_sent_from_flow__c?: InputMaybe<Scalars["Boolean"]>;
  groupeventtype?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  id__c?: InputMaybe<Scalars["String"]>;
  inviteeuuid__c?: InputMaybe<Scalars["String"]>;
  isalldayevent?: InputMaybe<Scalars["Boolean"]>;
  isarchived?: InputMaybe<Scalars["Boolean"]>;
  ischild?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isgroupevent?: InputMaybe<Scalars["Boolean"]>;
  isprivate?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exception?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exclusion?: InputMaybe<Scalars["Boolean"]>;
  isreminderset?: InputMaybe<Scalars["Boolean"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lid__date_sent__c?: InputMaybe<Scalars["timestamp"]>;
  lid__url__c?: InputMaybe<Scalars["String"]>;
  location?: InputMaybe<Scalars["String"]>;
  mailbox_source_email_address__c?: InputMaybe<Scalars["String"]>;
  marked_as_spam_at__c?: InputMaybe<Scalars["timestamp"]>;
  messageid__c?: InputMaybe<Scalars["String"]>;
  missed_meeting__c?: InputMaybe<Scalars["Boolean"]>;
  missed_meeting_reason__c?: InputMaybe<Scalars["String"]>;
  not_pardot_or_hubspot__c?: InputMaybe<Scalars["Boolean"]>;
  open_count__c?: InputMaybe<Scalars["numeric"]>;
  opened_at__c?: InputMaybe<Scalars["timestamp"]>;
  outreach_task_type__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  per_user__c?: InputMaybe<Scalars["String"]>;
  profile_claimed__c?: InputMaybe<Scalars["Boolean"]>;
  recurrence2patternstartdate?: InputMaybe<Scalars["timestamp"]>;
  recurrence2patterntext?: InputMaybe<Scalars["String"]>;
  recurrence2patterntimezone?: InputMaybe<Scalars["String"]>;
  recurrence2patternversion?: InputMaybe<Scalars["String"]>;
  recurrenceactivityid?: InputMaybe<Scalars["String"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceenddateonly?: InputMaybe<Scalars["timestamp"]>;
  recurrenceinstance?: InputMaybe<Scalars["String"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  recurrencemonthofyear?: InputMaybe<Scalars["String"]>;
  recurrencestartdatetime?: InputMaybe<Scalars["timestamp"]>;
  recurrencetimezonesidkey?: InputMaybe<Scalars["String"]>;
  recurrencetype?: InputMaybe<Scalars["String"]>;
  reminderdatetime?: InputMaybe<Scalars["timestamp"]>;
  ringcentral__call_recording__c?: InputMaybe<Scalars["String"]>;
  ringcentral__recording_information__c?: InputMaybe<Scalars["String"]>;
  salesloft_cadence_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_cadence_name__c?: InputMaybe<Scalars["String"]>;
  salesloft_clicked_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_email_template_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_email_template_title__c?: InputMaybe<Scalars["String"]>;
  salesloft_external_identifier__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_day_new__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_step_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_name__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_type__c?: InputMaybe<Scalars["String"]>;
  salesloft_viewed_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloftreplycount__c?: InputMaybe<Scalars["numeric"]>;
  score__c?: InputMaybe<Scalars["numeric"]>;
  showas?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
  summary__c?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  task_start_time__c?: InputMaybe<Scalars["timestamp"]>;
  template_name__c?: InputMaybe<Scalars["String"]>;
  testsfdc__c?: InputMaybe<Scalars["String"]>;
  time_stamp__c?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  unique_click_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_reply_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_view_count__c?: InputMaybe<Scalars["numeric"]>;
  user__c?: InputMaybe<Scalars["String"]>;
  voicemail_count__c?: InputMaybe<Scalars["numeric"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
  zoom_app__additional_emails__c?: InputMaybe<Scalars["String"]>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__customer_start_time__c?: InputMaybe<Scalars["timestamp"]>;
  zoom_app__customer_time_zone__c?: InputMaybe<Scalars["String"]>;
  zoom_app__ics_sequence__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__join_before_host__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__make_it_zoom_meeting__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__use_personal_zoom_meeting_id__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__zoom_call_log__c?: InputMaybe<Scalars["String"]>;
  zoom_app__zoom_event__c?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "event" */
export type event_stddev_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "event" */
export type event_stddev_pop_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "event" */
export type event_stddev_samp_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "event" */
export type event_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: event_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type event_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  action__c?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  activitydatetime?: InputMaybe<Scalars["timestamp"]>;
  age__c?: InputMaybe<Scalars["numeric"]>;
  attributable_sequence_name__c?: InputMaybe<Scalars["String"]>;
  bounced_at__c?: InputMaybe<Scalars["timestamp"]>;
  call_disposition2__c?: InputMaybe<Scalars["String"]>;
  call_disposition__c?: InputMaybe<Scalars["String"]>;
  call_outcome__c?: InputMaybe<Scalars["String"]>;
  clearslide_link_clicked__c?: InputMaybe<Scalars["Boolean"]>;
  click_count__c?: InputMaybe<Scalars["numeric"]>;
  clicked_at__c?: InputMaybe<Scalars["timestamp"]>;
  close_task__c?: InputMaybe<Scalars["Boolean"]>;
  connected_count__c?: InputMaybe<Scalars["numeric"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  data_quality_description__c?: InputMaybe<Scalars["String"]>;
  data_quality_score__c?: InputMaybe<Scalars["numeric"]>;
  delivered_at__c?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  direct_contact__c?: InputMaybe<Scalars["String"]>;
  durationinminutes?: InputMaybe<Scalars["Int"]>;
  effort_score__c?: InputMaybe<Scalars["numeric"]>;
  enddate?: InputMaybe<Scalars["timestamp"]>;
  enddatetime?: InputMaybe<Scalars["timestamp"]>;
  eventsubtype?: InputMaybe<Scalars["String"]>;
  flow_name__c?: InputMaybe<Scalars["String"]>;
  gong__gong_selected_process__c?: InputMaybe<Scalars["Boolean"]>;
  groove_email_sent_at__c?: InputMaybe<Scalars["timestamp"]>;
  groove_inbound_response_time_seconds__c?: InputMaybe<Scalars["numeric"]>;
  groove_sent_from_flow__c?: InputMaybe<Scalars["Boolean"]>;
  groupeventtype?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  id__c?: InputMaybe<Scalars["String"]>;
  inviteeuuid__c?: InputMaybe<Scalars["String"]>;
  isalldayevent?: InputMaybe<Scalars["Boolean"]>;
  isarchived?: InputMaybe<Scalars["Boolean"]>;
  ischild?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isgroupevent?: InputMaybe<Scalars["Boolean"]>;
  isprivate?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exception?: InputMaybe<Scalars["Boolean"]>;
  isrecurrence2exclusion?: InputMaybe<Scalars["Boolean"]>;
  isreminderset?: InputMaybe<Scalars["Boolean"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lid__date_sent__c?: InputMaybe<Scalars["timestamp"]>;
  lid__url__c?: InputMaybe<Scalars["String"]>;
  location?: InputMaybe<Scalars["String"]>;
  mailbox_source_email_address__c?: InputMaybe<Scalars["String"]>;
  marked_as_spam_at__c?: InputMaybe<Scalars["timestamp"]>;
  messageid__c?: InputMaybe<Scalars["String"]>;
  missed_meeting__c?: InputMaybe<Scalars["Boolean"]>;
  missed_meeting_reason__c?: InputMaybe<Scalars["String"]>;
  not_pardot_or_hubspot__c?: InputMaybe<Scalars["Boolean"]>;
  open_count__c?: InputMaybe<Scalars["numeric"]>;
  opened_at__c?: InputMaybe<Scalars["timestamp"]>;
  outreach_task_type__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  per_user__c?: InputMaybe<Scalars["String"]>;
  profile_claimed__c?: InputMaybe<Scalars["Boolean"]>;
  recurrence2patternstartdate?: InputMaybe<Scalars["timestamp"]>;
  recurrence2patterntext?: InputMaybe<Scalars["String"]>;
  recurrence2patterntimezone?: InputMaybe<Scalars["String"]>;
  recurrence2patternversion?: InputMaybe<Scalars["String"]>;
  recurrenceactivityid?: InputMaybe<Scalars["String"]>;
  recurrencedayofmonth?: InputMaybe<Scalars["Int"]>;
  recurrencedayofweekmask?: InputMaybe<Scalars["Int"]>;
  recurrenceenddateonly?: InputMaybe<Scalars["timestamp"]>;
  recurrenceinstance?: InputMaybe<Scalars["String"]>;
  recurrenceinterval?: InputMaybe<Scalars["Int"]>;
  recurrencemonthofyear?: InputMaybe<Scalars["String"]>;
  recurrencestartdatetime?: InputMaybe<Scalars["timestamp"]>;
  recurrencetimezonesidkey?: InputMaybe<Scalars["String"]>;
  recurrencetype?: InputMaybe<Scalars["String"]>;
  reminderdatetime?: InputMaybe<Scalars["timestamp"]>;
  ringcentral__call_recording__c?: InputMaybe<Scalars["String"]>;
  ringcentral__recording_information__c?: InputMaybe<Scalars["String"]>;
  salesloft_cadence_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_cadence_name__c?: InputMaybe<Scalars["String"]>;
  salesloft_clicked_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_email_template_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_email_template_title__c?: InputMaybe<Scalars["String"]>;
  salesloft_external_identifier__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_day_new__c?: InputMaybe<Scalars["numeric"]>;
  salesloft_step_id__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_name__c?: InputMaybe<Scalars["String"]>;
  salesloft_step_type__c?: InputMaybe<Scalars["String"]>;
  salesloft_viewed_count__c?: InputMaybe<Scalars["numeric"]>;
  salesloftreplycount__c?: InputMaybe<Scalars["numeric"]>;
  score__c?: InputMaybe<Scalars["numeric"]>;
  showas?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  startdatetime?: InputMaybe<Scalars["timestamp"]>;
  subject?: InputMaybe<Scalars["String"]>;
  summary__c?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  task_start_time__c?: InputMaybe<Scalars["timestamp"]>;
  template_name__c?: InputMaybe<Scalars["String"]>;
  testsfdc__c?: InputMaybe<Scalars["String"]>;
  time_stamp__c?: InputMaybe<Scalars["timestamp"]>;
  type?: InputMaybe<Scalars["String"]>;
  unique_click_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_reply_count__c?: InputMaybe<Scalars["numeric"]>;
  unique_view_count__c?: InputMaybe<Scalars["numeric"]>;
  user__c?: InputMaybe<Scalars["String"]>;
  voicemail_count__c?: InputMaybe<Scalars["numeric"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
  zoom_app__additional_emails__c?: InputMaybe<Scalars["String"]>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__customer_start_time__c?: InputMaybe<Scalars["timestamp"]>;
  zoom_app__customer_time_zone__c?: InputMaybe<Scalars["String"]>;
  zoom_app__ics_sequence__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__join_before_host__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__make_it_zoom_meeting__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__use_personal_zoom_meeting_id__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__zoom_call_log__c?: InputMaybe<Scalars["String"]>;
  zoom_app__zoom_event__c?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "event" */
export type event_sum_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

export type event_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<event_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<event_set_input>;
  where: event_bool_exp;
};

/** order by var_pop() on columns of table "event" */
export type event_var_pop_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "event" */
export type event_var_samp_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "event" */
export type event_variance_order_by = {
  age__c?: InputMaybe<order_by>;
  click_count__c?: InputMaybe<order_by>;
  connected_count__c?: InputMaybe<order_by>;
  data_quality_score__c?: InputMaybe<order_by>;
  durationinminutes?: InputMaybe<order_by>;
  effort_score__c?: InputMaybe<order_by>;
  groove_inbound_response_time_seconds__c?: InputMaybe<order_by>;
  open_count__c?: InputMaybe<order_by>;
  recurrencedayofmonth?: InputMaybe<order_by>;
  recurrencedayofweekmask?: InputMaybe<order_by>;
  recurrenceinterval?: InputMaybe<order_by>;
  salesloft_clicked_count__c?: InputMaybe<order_by>;
  salesloft_step_day_new__c?: InputMaybe<order_by>;
  salesloft_viewed_count__c?: InputMaybe<order_by>;
  salesloftreplycount__c?: InputMaybe<order_by>;
  score__c?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  unique_click_count__c?: InputMaybe<order_by>;
  unique_reply_count__c?: InputMaybe<order_by>;
  unique_view_count__c?: InputMaybe<order_by>;
  voicemail_count__c?: InputMaybe<order_by>;
  zoom_app__customer_duration_of_meeting__c?: InputMaybe<order_by>;
  zoom_app__ics_sequence__c?: InputMaybe<order_by>;
};

export type files_aggregate_bool_exp = {
  bool_and?: InputMaybe<files_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<files_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<files_aggregate_bool_exp_count>;
};

export type files_aggregate_bool_exp_bool_and = {
  arguments: files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<files_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type files_aggregate_bool_exp_bool_or = {
  arguments: files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<files_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type files_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<files_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<files_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "storage.files" */
export type files_aggregate_order_by = {
  avg?: InputMaybe<files_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<files_max_order_by>;
  min?: InputMaybe<files_min_order_by>;
  stddev?: InputMaybe<files_stddev_order_by>;
  stddev_pop?: InputMaybe<files_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<files_stddev_samp_order_by>;
  sum?: InputMaybe<files_sum_order_by>;
  var_pop?: InputMaybe<files_var_pop_order_by>;
  var_samp?: InputMaybe<files_var_samp_order_by>;
  variance?: InputMaybe<files_variance_order_by>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type files_arr_rel_insert_input = {
  data: Array<files_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<files_on_conflict>;
};

/** order by avg() on columns of table "storage.files" */
export type files_avg_order_by = {
  size?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type files_bool_exp = {
  _and?: InputMaybe<Array<files_bool_exp>>;
  _not?: InputMaybe<files_bool_exp>;
  _or?: InputMaybe<Array<files_bool_exp>>;
  bucket?: InputMaybe<buckets_bool_exp>;
  bucketId?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  etag?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  isUploaded?: InputMaybe<Boolean_comparison_exp>;
  mimeType?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  size?: InputMaybe<Int_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  uploadedByUserId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum files_constraint {
  /** unique or primary key constraint on columns "id" */
  files_pkey = "files_pkey",
}

/** input type for incrementing numeric columns in table "storage.files" */
export type files_inc_input = {
  size?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "storage.files" */
export type files_insert_input = {
  bucket?: InputMaybe<buckets_obj_rel_insert_input>;
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "storage.files" */
export type files_max_order_by = {
  bucketId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  etag?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  mimeType?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  size?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** order by min() on columns of table "storage.files" */
export type files_min_order_by = {
  bucketId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  etag?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  mimeType?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  size?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "storage.files" */
export type files_on_conflict = {
  constraint: files_constraint;
  update_columns?: Array<files_update_column>;
  where?: InputMaybe<files_bool_exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type files_order_by = {
  bucket?: InputMaybe<buckets_order_by>;
  bucketId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  etag?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isUploaded?: InputMaybe<order_by>;
  mimeType?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  size?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** primary key columns input for table: storage.files */
export type files_pk_columns_input = {
  id: Scalars["uuid"];
};

/** select columns of table "storage.files" */
export enum files_select_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum files_select_column_files_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum files_select_column_files_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isUploaded = "isUploaded",
}

/** input type for updating data in table "storage.files" */
export type files_set_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["uuid"]>;
};

/** order by stddev() on columns of table "storage.files" */
export type files_stddev_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type files_stddev_pop_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type files_stddev_samp_order_by = {
  size?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "files" */
export type files_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: files_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type files_stream_cursor_value_input = {
  bucketId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  etag?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]>;
  mimeType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  uploadedByUserId?: InputMaybe<Scalars["uuid"]>;
};

/** order by sum() on columns of table "storage.files" */
export type files_sum_order_by = {
  size?: InputMaybe<order_by>;
};

/** update columns of table "storage.files" */
export enum files_update_column {
  /** column name */
  bucketId = "bucketId",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  etag = "etag",
  /** column name */
  id = "id",
  /** column name */
  isUploaded = "isUploaded",
  /** column name */
  mimeType = "mimeType",
  /** column name */
  name = "name",
  /** column name */
  size = "size",
  /** column name */
  updatedAt = "updatedAt",
  /** column name */
  uploadedByUserId = "uploadedByUserId",
}

export type files_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<files_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<files_set_input>;
  where: files_bool_exp;
};

/** order by var_pop() on columns of table "storage.files" */
export type files_var_pop_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "storage.files" */
export type files_var_samp_order_by = {
  size?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "storage.files" */
export type files_variance_order_by = {
  size?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "first_meetings_leads_accounts_gql". All fields are combined with a logical 'AND'. */
export type first_meetings_leads_accounts_gql_bool_exp = {
  _and?: InputMaybe<Array<first_meetings_leads_accounts_gql_bool_exp>>;
  _not?: InputMaybe<first_meetings_leads_accounts_gql_bool_exp>;
  _or?: InputMaybe<Array<first_meetings_leads_accounts_gql_bool_exp>>;
  account_name?: InputMaybe<String_comparison_exp>;
  activitydate?: InputMaybe<timestamp_comparison_exp>;
  contact?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  eventid?: InputMaybe<String_comparison_exp>;
  meeting_owner?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "first_meetings_leads_accounts_gql". */
export type first_meetings_leads_accounts_gql_order_by = {
  account_name?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  contact?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  eventid?: InputMaybe<order_by>;
  meeting_owner?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
};

/** select columns of table "first_meetings_leads_accounts_gql" */
export enum first_meetings_leads_accounts_gql_select_column {
  /** column name */
  account_name = "account_name",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  contact = "contact",
  /** column name */
  createddate = "createddate",
  /** column name */
  eventid = "eventid",
  /** column name */
  meeting_owner = "meeting_owner",
  /** column name */
  subject = "subject",
  /** column name */
  title = "title",
}

/** Streaming cursor of the table "first_meetings_leads_accounts_gql" */
export type first_meetings_leads_accounts_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: first_meetings_leads_accounts_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type first_meetings_leads_accounts_gql_stream_cursor_value_input = {
  account_name?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  contact?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  eventid?: InputMaybe<Scalars["String"]>;
  meeting_owner?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type float8_comparison_exp = {
  _eq?: InputMaybe<Scalars["float8"]>;
  _gt?: InputMaybe<Scalars["float8"]>;
  _gte?: InputMaybe<Scalars["float8"]>;
  _in?: InputMaybe<Array<Scalars["float8"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["float8"]>;
  _lte?: InputMaybe<Scalars["float8"]>;
  _neq?: InputMaybe<Scalars["float8"]>;
  _nin?: InputMaybe<Array<Scalars["float8"]>>;
};

/** Boolean expression to filter rows from the table "invites". All fields are combined with a logical 'AND'. */
export type invites_bool_exp = {
  _and?: InputMaybe<Array<invites_bool_exp>>;
  _not?: InputMaybe<invites_bool_exp>;
  _or?: InputMaybe<Array<invites_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  invitee_email?: InputMaybe<citext_comparison_exp>;
  inviter_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "invites" */
export enum invites_constraint {
  /** unique or primary key constraint on columns "id" */
  invites_pkey = "invites_pkey",
}

/** input type for incrementing numeric columns in table "invites" */
export type invites_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "invites" */
export type invites_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
};

/** on_conflict condition type for table "invites" */
export type invites_on_conflict = {
  constraint: invites_constraint;
  update_columns?: Array<invites_update_column>;
  where?: InputMaybe<invites_bool_exp>;
};

/** Ordering options when selecting data from "invites". */
export type invites_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invitee_email?: InputMaybe<order_by>;
  inviter_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: invites */
export type invites_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "invites" */
export enum invites_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  invitee_email = "invitee_email",
  /** column name */
  inviter_id = "inviter_id",
}

/** input type for updating data in table "invites" */
export type invites_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "invites" */
export type invites_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: invites_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type invites_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  invitee_email?: InputMaybe<Scalars["citext"]>;
  inviter_id?: InputMaybe<Scalars["String"]>;
};

/** update columns of table "invites" */
export enum invites_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  invitee_email = "invitee_email",
  /** column name */
  inviter_id = "inviter_id",
}

export type invites_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<invites_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<invites_set_input>;
  where: invites_bool_exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type json_comparison_exp = {
  _eq?: InputMaybe<Scalars["json"]>;
  _gt?: InputMaybe<Scalars["json"]>;
  _gte?: InputMaybe<Scalars["json"]>;
  _in?: InputMaybe<Array<Scalars["json"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["json"]>;
  _lte?: InputMaybe<Scalars["json"]>;
  _neq?: InputMaybe<Scalars["json"]>;
  _nin?: InputMaybe<Array<Scalars["json"]>>;
};

export type jsonb_cast_exp = {
  String?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: InputMaybe<jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars["jsonb"]>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars["jsonb"]>;
  _eq?: InputMaybe<Scalars["jsonb"]>;
  _gt?: InputMaybe<Scalars["jsonb"]>;
  _gte?: InputMaybe<Scalars["jsonb"]>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars["String"]>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars["String"]>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars["String"]>>;
  _in?: InputMaybe<Array<Scalars["jsonb"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["jsonb"]>;
  _lte?: InputMaybe<Scalars["jsonb"]>;
  _neq?: InputMaybe<Scalars["jsonb"]>;
  _nin?: InputMaybe<Array<Scalars["jsonb"]>>;
};

/** Boolean expression to filter rows from the table "leaderboard_summary_gql". All fields are combined with a logical 'AND'. */
export type leaderboard_summary_gql_bool_exp = {
  _and?: InputMaybe<Array<leaderboard_summary_gql_bool_exp>>;
  _not?: InputMaybe<leaderboard_summary_gql_bool_exp>;
  _or?: InputMaybe<Array<leaderboard_summary_gql_bool_exp>>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  licenses__c?: InputMaybe<numeric_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "leaderboard_summary_gql". */
export type leaderboard_summary_gql_order_by = {
  closedate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  licenses__c?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
};

/** select columns of table "leaderboard_summary_gql" */
export enum leaderboard_summary_gql_select_column {
  /** column name */
  closedate = "closedate",
  /** column name */
  createddate = "createddate",
  /** column name */
  id = "id",
  /** column name */
  licenses__c = "licenses__c",
  /** column name */
  name = "name",
}

/** Streaming cursor of the table "leaderboard_summary_gql" */
export type leaderboard_summary_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: leaderboard_summary_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type leaderboard_summary_gql_stream_cursor_value_input = {
  closedate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  id?: InputMaybe<Scalars["String"]>;
  licenses__c?: InputMaybe<Scalars["numeric"]>;
  name?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "ml_weighted_pipeline_gql". All fields are combined with a logical 'AND'. */
export type ml_weighted_pipeline_gql_bool_exp = {
  _and?: InputMaybe<Array<ml_weighted_pipeline_gql_bool_exp>>;
  _not?: InputMaybe<ml_weighted_pipeline_gql_bool_exp>;
  _or?: InputMaybe<Array<ml_weighted_pipeline_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  ml_probability?: InputMaybe<float8_comparison_exp>;
  ml_scored_date?: InputMaybe<date_comparison_exp>;
  ml_updated_at?: InputMaybe<timestamp_comparison_exp>;
  ml_weighted_arr?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services?: InputMaybe<float8_comparison_exp>;
  opportunity_age?: InputMaybe<Int_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  services_amount?: InputMaybe<numeric_comparison_exp>;
  sf_weighted_arr?: InputMaybe<numeric_comparison_exp>;
  sf_weighted_services?: InputMaybe<numeric_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "ml_weighted_pipeline_gql". */
export type ml_weighted_pipeline_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  ml_probability?: InputMaybe<order_by>;
  ml_scored_date?: InputMaybe<order_by>;
  ml_updated_at?: InputMaybe<order_by>;
  ml_weighted_arr?: InputMaybe<order_by>;
  ml_weighted_services?: InputMaybe<order_by>;
  opportunity_age?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  services_amount?: InputMaybe<order_by>;
  sf_weighted_arr?: InputMaybe<order_by>;
  sf_weighted_services?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
};

/** select columns of table "ml_weighted_pipeline_gql" */
export enum ml_weighted_pipeline_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  createddate = "createddate",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  iswon = "iswon",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  ml_probability = "ml_probability",
  /** column name */
  ml_scored_date = "ml_scored_date",
  /** column name */
  ml_updated_at = "ml_updated_at",
  /** column name */
  ml_weighted_arr = "ml_weighted_arr",
  /** column name */
  ml_weighted_services = "ml_weighted_services",
  /** column name */
  opportunity_age = "opportunity_age",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  probability = "probability",
  /** column name */
  services_amount = "services_amount",
  /** column name */
  sf_weighted_arr = "sf_weighted_arr",
  /** column name */
  sf_weighted_services = "sf_weighted_services",
  /** column name */
  stage = "stage",
}

/** Streaming cursor of the table "ml_weighted_pipeline_gql" */
export type ml_weighted_pipeline_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ml_weighted_pipeline_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ml_weighted_pipeline_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  ml_probability?: InputMaybe<Scalars["float8"]>;
  ml_scored_date?: InputMaybe<Scalars["date"]>;
  ml_updated_at?: InputMaybe<Scalars["timestamp"]>;
  ml_weighted_arr?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services?: InputMaybe<Scalars["float8"]>;
  opportunity_age?: InputMaybe<Scalars["Int"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  services_amount?: InputMaybe<Scalars["numeric"]>;
  sf_weighted_arr?: InputMaybe<Scalars["numeric"]>;
  sf_weighted_services?: InputMaybe<Scalars["numeric"]>;
  stage?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "monthly_bookings_gql". All fields are combined with a logical 'AND'. */
export type monthly_bookings_gql_bool_exp = {
  _and?: InputMaybe<Array<monthly_bookings_gql_bool_exp>>;
  _not?: InputMaybe<monthly_bookings_gql_bool_exp>;
  _or?: InputMaybe<Array<monthly_bookings_gql_bool_exp>>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  sum?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_bookings_gql". */
export type monthly_bookings_gql_order_by = {
  date_trunc?: InputMaybe<order_by>;
  sum?: InputMaybe<order_by>;
};

/** select columns of table "monthly_bookings_gql" */
export enum monthly_bookings_gql_select_column {
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  sum = "sum",
}

/** Streaming cursor of the table "monthly_bookings_gql" */
export type monthly_bookings_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_bookings_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_bookings_gql_stream_cursor_value_input = {
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  sum?: InputMaybe<Scalars["numeric"]>;
};

/** Boolean expression to filter rows from the table "monthly_effort_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type monthly_effort_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<monthly_effort_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<monthly_effort_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<monthly_effort_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_effort_breakdown_overview_gql". */
export type monthly_effort_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "monthly_effort_breakdown_overview_gql" */
export enum monthly_effort_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "monthly_effort_breakdown_overview_gql" */
export type monthly_effort_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_effort_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_effort_breakdown_overview_gql_stream_cursor_value_input = {
  count?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  meeting_key?: InputMaybe<Scalars["bigint"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  type_category?: InputMaybe<Scalars["String"]>;
  type_detail?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "monthly_engagement_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type monthly_engagement_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<monthly_engagement_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<monthly_engagement_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<monthly_engagement_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_engagement_breakdown_overview_gql". */
export type monthly_engagement_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "monthly_engagement_breakdown_overview_gql" */
export enum monthly_engagement_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "monthly_engagement_breakdown_overview_gql" */
export type monthly_engagement_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_engagement_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_engagement_breakdown_overview_gql_stream_cursor_value_input =
  {
    count?: InputMaybe<Scalars["bigint"]>;
    date_trunc?: InputMaybe<Scalars["timestamp"]>;
    meeting_key?: InputMaybe<Scalars["bigint"]>;
    task_categorization?: InputMaybe<Scalars["Int"]>;
    type_category?: InputMaybe<Scalars["String"]>;
    type_detail?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "monthly_pipeline_gql_new". All fields are combined with a logical 'AND'. */
export type monthly_pipeline_gql_new_bool_exp = {
  _and?: InputMaybe<Array<monthly_pipeline_gql_new_bool_exp>>;
  _not?: InputMaybe<monthly_pipeline_gql_new_bool_exp>;
  _or?: InputMaybe<Array<monthly_pipeline_gql_new_bool_exp>>;
  amount?: InputMaybe<numeric_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  lead_source?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  owner_name?: InputMaybe<String_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "monthly_pipeline_gql_new". */
export type monthly_pipeline_gql_new_order_by = {
  amount?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  lead_source?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  owner_name?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
};

/** select columns of table "monthly_pipeline_gql_new" */
export enum monthly_pipeline_gql_new_select_column {
  /** column name */
  amount = "amount",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  lead_source = "lead_source",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  owner_name = "owner_name",
  /** column name */
  stagename = "stagename",
}

/** Streaming cursor of the table "monthly_pipeline_gql_new" */
export type monthly_pipeline_gql_new_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: monthly_pipeline_gql_new_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type monthly_pipeline_gql_new_stream_cursor_value_input = {
  amount?: InputMaybe<Scalars["numeric"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  lead_source?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  owner_name?: InputMaybe<Scalars["String"]>;
  stagename?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type numeric_comparison_exp = {
  _eq?: InputMaybe<Scalars["numeric"]>;
  _gt?: InputMaybe<Scalars["numeric"]>;
  _gte?: InputMaybe<Scalars["numeric"]>;
  _in?: InputMaybe<Array<Scalars["numeric"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["numeric"]>;
  _lte?: InputMaybe<Scalars["numeric"]>;
  _neq?: InputMaybe<Scalars["numeric"]>;
  _nin?: InputMaybe<Array<Scalars["numeric"]>>;
};

/** Boolean expression to filter rows from the table "opp_detail_gql". All fields are combined with a logical 'AND'. */
export type opp_detail_gql_bool_exp = {
  _and?: InputMaybe<Array<opp_detail_gql_bool_exp>>;
  _not?: InputMaybe<opp_detail_gql_bool_exp>;
  _or?: InputMaybe<Array<opp_detail_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  created_by?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "opp_detail_gql". */
export type opp_detail_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  created_by?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
};

/** select columns of table "opp_detail_gql" */
export enum opp_detail_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  created_by = "created_by",
  /** column name */
  createddate = "createddate",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  stage = "stage",
}

/** Streaming cursor of the table "opp_detail_gql" */
export type opp_detail_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: opp_detail_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type opp_detail_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  created_by?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  stage?: InputMaybe<Scalars["String"]>;
};

export type opportunity_aggregate_bool_exp = {
  bool_and?: InputMaybe<opportunity_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<opportunity_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<opportunity_aggregate_bool_exp_count>;
};

export type opportunity_aggregate_bool_exp_bool_and = {
  arguments: opportunity_select_column_opportunity_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type opportunity_aggregate_bool_exp_bool_or = {
  arguments: opportunity_select_column_opportunity_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<opportunity_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type opportunity_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<opportunity_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<opportunity_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "opportunity" */
export type opportunity_aggregate_order_by = {
  avg?: InputMaybe<opportunity_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<opportunity_max_order_by>;
  min?: InputMaybe<opportunity_min_order_by>;
  stddev?: InputMaybe<opportunity_stddev_order_by>;
  stddev_pop?: InputMaybe<opportunity_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<opportunity_stddev_samp_order_by>;
  sum?: InputMaybe<opportunity_sum_order_by>;
  var_pop?: InputMaybe<opportunity_var_pop_order_by>;
  var_samp?: InputMaybe<opportunity_var_samp_order_by>;
  variance?: InputMaybe<opportunity_variance_order_by>;
};

/** input type for inserting array relation for remote table "opportunity" */
export type opportunity_arr_rel_insert_input = {
  data: Array<opportunity_insert_input>;
};

/** order by avg() on columns of table "opportunity" */
export type opportunity_avg_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "opportunity". All fields are combined with a logical 'AND'. */
export type opportunity_bool_exp = {
  _and?: InputMaybe<Array<opportunity_bool_exp>>;
  _not?: InputMaybe<opportunity_bool_exp>;
  _or?: InputMaybe<Array<opportunity_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<numeric_comparison_exp>;
  campaignid?: InputMaybe<String_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  contactid?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  fiscal?: InputMaybe<String_comparison_exp>;
  fiscalquarter?: InputMaybe<Int_comparison_exp>;
  fiscalyear?: InputMaybe<Int_comparison_exp>;
  forecastcategory?: InputMaybe<String_comparison_exp>;
  forecastcategoryname?: InputMaybe<String_comparison_exp>;
  hasopenactivity?: InputMaybe<Boolean_comparison_exp>;
  hasopportunitylineitem?: InputMaybe<Boolean_comparison_exp>;
  hasoverduetask?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  iqscore?: InputMaybe<Int_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  isdeleted?: InputMaybe<Boolean_comparison_exp>;
  isexcludedfromterritory2filter?: InputMaybe<Boolean_comparison_exp>;
  issplit?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  lastactivitydate?: InputMaybe<timestamp_comparison_exp>;
  lastamountchangedhistoryid?: InputMaybe<String_comparison_exp>;
  lastclosedatechangedhistoryid?: InputMaybe<String_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  laststagechangedate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  lid__my_geolocation__latitude__s?: InputMaybe<numeric_comparison_exp>;
  lid__my_geolocation__longitude__s?: InputMaybe<numeric_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  nextstep?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  pricebook2id?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  recordtypeid?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
  syncedquoteid?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  territory2id?: InputMaybe<String_comparison_exp>;
  totalopportunityquantity?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "opportunity" */
export type opportunity_inc_input = {
  amount?: InputMaybe<Scalars["numeric"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  iqscore?: InputMaybe<Scalars["Int"]>;
  lid__my_geolocation__latitude__s?: InputMaybe<Scalars["numeric"]>;
  lid__my_geolocation__longitude__s?: InputMaybe<Scalars["numeric"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  totalopportunityquantity?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "opportunity" */
export type opportunity_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  campaignid?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fiscal?: InputMaybe<Scalars["String"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  forecastcategory?: InputMaybe<Scalars["String"]>;
  forecastcategoryname?: InputMaybe<Scalars["String"]>;
  hasopenactivity?: InputMaybe<Scalars["Boolean"]>;
  hasopportunitylineitem?: InputMaybe<Scalars["Boolean"]>;
  hasoverduetask?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  iqscore?: InputMaybe<Scalars["Int"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isexcludedfromterritory2filter?: InputMaybe<Scalars["Boolean"]>;
  issplit?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastamountchangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastclosedatechangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  laststagechangedate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  lid__my_geolocation__latitude__s?: InputMaybe<Scalars["numeric"]>;
  lid__my_geolocation__longitude__s?: InputMaybe<Scalars["numeric"]>;
  name?: InputMaybe<Scalars["String"]>;
  nextstep?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pricebook2id?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  recordtypeid?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  syncedquoteid?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  territory2id?: InputMaybe<Scalars["String"]>;
  totalopportunityquantity?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "opportunity" */
export type opportunity_max_order_by = {
  accountid?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  campaignid?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fiscal?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  forecastcategory?: InputMaybe<order_by>;
  forecastcategoryname?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastamountchangedhistoryid?: InputMaybe<order_by>;
  lastclosedatechangedhistoryid?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  laststagechangedate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nextstep?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pricebook2id?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  recordtypeid?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  syncedquoteid?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  territory2id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** order by min() on columns of table "opportunity" */
export type opportunity_min_order_by = {
  accountid?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  campaignid?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fiscal?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  forecastcategory?: InputMaybe<order_by>;
  forecastcategoryname?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastamountchangedhistoryid?: InputMaybe<order_by>;
  lastclosedatechangedhistoryid?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  laststagechangedate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nextstep?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pricebook2id?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  recordtypeid?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  syncedquoteid?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  territory2id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "opportunity". */
export type opportunity_order_by = {
  accountid?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  campaignid?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  fiscal?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  forecastcategory?: InputMaybe<order_by>;
  forecastcategoryname?: InputMaybe<order_by>;
  hasopenactivity?: InputMaybe<order_by>;
  hasopportunitylineitem?: InputMaybe<order_by>;
  hasoverduetask?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  isdeleted?: InputMaybe<order_by>;
  isexcludedfromterritory2filter?: InputMaybe<order_by>;
  issplit?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  lastactivitydate?: InputMaybe<order_by>;
  lastamountchangedhistoryid?: InputMaybe<order_by>;
  lastclosedatechangedhistoryid?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  laststagechangedate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nextstep?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pricebook2id?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  recordtypeid?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
  syncedquoteid?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  territory2id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "opportunity" */
export enum opportunity_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  amount = "amount",
  /** column name */
  campaignid = "campaignid",
  /** column name */
  closedate = "closedate",
  /** column name */
  contactid = "contactid",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  fiscal = "fiscal",
  /** column name */
  fiscalquarter = "fiscalquarter",
  /** column name */
  fiscalyear = "fiscalyear",
  /** column name */
  forecastcategory = "forecastcategory",
  /** column name */
  forecastcategoryname = "forecastcategoryname",
  /** column name */
  hasopenactivity = "hasopenactivity",
  /** column name */
  hasopportunitylineitem = "hasopportunitylineitem",
  /** column name */
  hasoverduetask = "hasoverduetask",
  /** column name */
  id = "id",
  /** column name */
  iqscore = "iqscore",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isexcludedfromterritory2filter = "isexcludedfromterritory2filter",
  /** column name */
  issplit = "issplit",
  /** column name */
  iswon = "iswon",
  /** column name */
  lastactivitydate = "lastactivitydate",
  /** column name */
  lastamountchangedhistoryid = "lastamountchangedhistoryid",
  /** column name */
  lastclosedatechangedhistoryid = "lastclosedatechangedhistoryid",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  laststagechangedate = "laststagechangedate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  lid__my_geolocation__latitude__s = "lid__my_geolocation__latitude__s",
  /** column name */
  lid__my_geolocation__longitude__s = "lid__my_geolocation__longitude__s",
  /** column name */
  name = "name",
  /** column name */
  nextstep = "nextstep",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  pricebook2id = "pricebook2id",
  /** column name */
  probability = "probability",
  /** column name */
  recordtypeid = "recordtypeid",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  stagename = "stagename",
  /** column name */
  syncedquoteid = "syncedquoteid",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  territory2id = "territory2id",
  /** column name */
  totalopportunityquantity = "totalopportunityquantity",
  /** column name */
  type = "type",
}

/** select "opportunity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "opportunity" */
export enum opportunity_select_column_opportunity_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  hasopenactivity = "hasopenactivity",
  /** column name */
  hasopportunitylineitem = "hasopportunitylineitem",
  /** column name */
  hasoverduetask = "hasoverduetask",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isexcludedfromterritory2filter = "isexcludedfromterritory2filter",
  /** column name */
  issplit = "issplit",
  /** column name */
  iswon = "iswon",
}

/** select "opportunity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "opportunity" */
export enum opportunity_select_column_opportunity_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  hasopenactivity = "hasopenactivity",
  /** column name */
  hasopportunitylineitem = "hasopportunitylineitem",
  /** column name */
  hasoverduetask = "hasoverduetask",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  isdeleted = "isdeleted",
  /** column name */
  isexcludedfromterritory2filter = "isexcludedfromterritory2filter",
  /** column name */
  issplit = "issplit",
  /** column name */
  iswon = "iswon",
}

/** input type for updating data in table "opportunity" */
export type opportunity_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  campaignid?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fiscal?: InputMaybe<Scalars["String"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  forecastcategory?: InputMaybe<Scalars["String"]>;
  forecastcategoryname?: InputMaybe<Scalars["String"]>;
  hasopenactivity?: InputMaybe<Scalars["Boolean"]>;
  hasopportunitylineitem?: InputMaybe<Scalars["Boolean"]>;
  hasoverduetask?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  iqscore?: InputMaybe<Scalars["Int"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isexcludedfromterritory2filter?: InputMaybe<Scalars["Boolean"]>;
  issplit?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastamountchangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastclosedatechangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  laststagechangedate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  lid__my_geolocation__latitude__s?: InputMaybe<Scalars["numeric"]>;
  lid__my_geolocation__longitude__s?: InputMaybe<Scalars["numeric"]>;
  name?: InputMaybe<Scalars["String"]>;
  nextstep?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pricebook2id?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  recordtypeid?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  syncedquoteid?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  territory2id?: InputMaybe<Scalars["String"]>;
  totalopportunityquantity?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "opportunity" */
export type opportunity_stddev_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "opportunity" */
export type opportunity_stddev_pop_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "opportunity" */
export type opportunity_stddev_samp_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "opportunity" */
export type opportunity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: opportunity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type opportunity_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["numeric"]>;
  campaignid?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  fiscal?: InputMaybe<Scalars["String"]>;
  fiscalquarter?: InputMaybe<Scalars["Int"]>;
  fiscalyear?: InputMaybe<Scalars["Int"]>;
  forecastcategory?: InputMaybe<Scalars["String"]>;
  forecastcategoryname?: InputMaybe<Scalars["String"]>;
  hasopenactivity?: InputMaybe<Scalars["Boolean"]>;
  hasopportunitylineitem?: InputMaybe<Scalars["Boolean"]>;
  hasoverduetask?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  iqscore?: InputMaybe<Scalars["Int"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  isdeleted?: InputMaybe<Scalars["Boolean"]>;
  isexcludedfromterritory2filter?: InputMaybe<Scalars["Boolean"]>;
  issplit?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  lastactivitydate?: InputMaybe<Scalars["timestamp"]>;
  lastamountchangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastclosedatechangedhistoryid?: InputMaybe<Scalars["String"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  laststagechangedate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  lid__my_geolocation__latitude__s?: InputMaybe<Scalars["numeric"]>;
  lid__my_geolocation__longitude__s?: InputMaybe<Scalars["numeric"]>;
  name?: InputMaybe<Scalars["String"]>;
  nextstep?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pricebook2id?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  recordtypeid?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  stagename?: InputMaybe<Scalars["String"]>;
  syncedquoteid?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  territory2id?: InputMaybe<Scalars["String"]>;
  totalopportunityquantity?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "opportunity" */
export type opportunity_sum_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

export type opportunity_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<opportunity_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<opportunity_set_input>;
  where: opportunity_bool_exp;
};

/** order by var_pop() on columns of table "opportunity" */
export type opportunity_var_pop_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "opportunity" */
export type opportunity_var_samp_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "opportunity" */
export type opportunity_variance_order_by = {
  amount?: InputMaybe<order_by>;
  fiscalquarter?: InputMaybe<order_by>;
  fiscalyear?: InputMaybe<order_by>;
  iqscore?: InputMaybe<order_by>;
  lid__my_geolocation__latitude__s?: InputMaybe<order_by>;
  lid__my_geolocation__longitude__s?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  totalopportunityquantity?: InputMaybe<order_by>;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = "asc",
  /** in ascending order, nulls first */
  asc_nulls_first = "asc_nulls_first",
  /** in ascending order, nulls last */
  asc_nulls_last = "asc_nulls_last",
  /** in descending order, nulls first */
  desc = "desc",
  /** in descending order, nulls first */
  desc_nulls_first = "desc_nulls_first",
  /** in descending order, nulls last */
  desc_nulls_last = "desc_nulls_last",
}

/** Boolean expression to filter rows from the table "pipeline_activity_drill_down_gql". All fields are combined with a logical 'AND'. */
export type pipeline_activity_drill_down_gql_bool_exp = {
  _and?: InputMaybe<Array<pipeline_activity_drill_down_gql_bool_exp>>;
  _not?: InputMaybe<pipeline_activity_drill_down_gql_bool_exp>;
  _or?: InputMaybe<Array<pipeline_activity_drill_down_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  contact_id?: InputMaybe<String_comparison_exp>;
  contact_name?: InputMaybe<String_comparison_exp>;
  contact_title?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  task_id?: InputMaybe<String_comparison_exp>;
  tasksubtype?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  user_name?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "pipeline_activity_drill_down_gql". */
export type pipeline_activity_drill_down_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  contact_id?: InputMaybe<order_by>;
  contact_name?: InputMaybe<order_by>;
  contact_title?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  tasksubtype?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  user_name?: InputMaybe<order_by>;
};

/** select columns of table "pipeline_activity_drill_down_gql" */
export enum pipeline_activity_drill_down_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  contact_id = "contact_id",
  /** column name */
  contact_name = "contact_name",
  /** column name */
  contact_title = "contact_title",
  /** column name */
  createddate = "createddate",
  /** column name */
  description = "description",
  /** column name */
  subject = "subject",
  /** column name */
  task_id = "task_id",
  /** column name */
  tasksubtype = "tasksubtype",
  /** column name */
  type = "type",
  /** column name */
  user_name = "user_name",
}

/** Streaming cursor of the table "pipeline_activity_drill_down_gql" */
export type pipeline_activity_drill_down_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pipeline_activity_drill_down_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pipeline_activity_drill_down_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  contact_id?: InputMaybe<Scalars["String"]>;
  contact_name?: InputMaybe<Scalars["String"]>;
  contact_title?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  description?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  tasksubtype?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  user_name?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "pipeline_opp_detail_gql". All fields are combined with a logical 'AND'. */
export type pipeline_opp_detail_gql_bool_exp = {
  _and?: InputMaybe<Array<pipeline_opp_detail_gql_bool_exp>>;
  _not?: InputMaybe<pipeline_opp_detail_gql_bool_exp>;
  _or?: InputMaybe<Array<pipeline_opp_detail_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<float8_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_link?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  opportunity_type__c?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  services_amount?: InputMaybe<numeric_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "pipeline_opp_detail_gql". */
export type pipeline_opp_detail_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_link?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  opportunity_type__c?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  services_amount?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
};

/** select columns of table "pipeline_opp_detail_gql" */
export enum pipeline_opp_detail_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  createddate = "createddate",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  iswon = "iswon",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_link = "opportunity_link",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  opportunity_type__c = "opportunity_type__c",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  probability = "probability",
  /** column name */
  services_amount = "services_amount",
  /** column name */
  stage = "stage",
}

/** Streaming cursor of the table "pipeline_opp_detail_gql" */
export type pipeline_opp_detail_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pipeline_opp_detail_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pipeline_opp_detail_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["float8"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_link?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  opportunity_type__c?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  services_amount?: InputMaybe<Scalars["numeric"]>;
  stage?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "pipeline_opp_detail_ml_gql". All fields are combined with a logical 'AND'. */
export type pipeline_opp_detail_ml_gql_bool_exp = {
  _and?: InputMaybe<Array<pipeline_opp_detail_ml_gql_bool_exp>>;
  _not?: InputMaybe<pipeline_opp_detail_ml_gql_bool_exp>;
  _or?: InputMaybe<Array<pipeline_opp_detail_ml_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  account_key?: InputMaybe<bigint_comparison_exp>;
  account_name?: InputMaybe<String_comparison_exp>;
  amount?: InputMaybe<float8_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  coalesce?: InputMaybe<float8_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  custom_filter_1?: InputMaybe<String_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  isclosed?: InputMaybe<Boolean_comparison_exp>;
  iswon?: InputMaybe<Boolean_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  ml_last_scored_at?: InputMaybe<timestamp_comparison_exp>;
  ml_probability?: InputMaybe<float8_comparison_exp>;
  ml_weighted_arr?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services?: InputMaybe<float8_comparison_exp>;
  opportunity_age?: InputMaybe<float8_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_link?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  probability?: InputMaybe<numeric_comparison_exp>;
  region?: InputMaybe<String_comparison_exp>;
  services_amount?: InputMaybe<numeric_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "pipeline_opp_detail_ml_gql". */
export type pipeline_opp_detail_ml_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  account_key?: InputMaybe<order_by>;
  account_name?: InputMaybe<order_by>;
  amount?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  coalesce?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  custom_filter_1?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  isclosed?: InputMaybe<order_by>;
  iswon?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  ml_last_scored_at?: InputMaybe<order_by>;
  ml_probability?: InputMaybe<order_by>;
  ml_weighted_arr?: InputMaybe<order_by>;
  ml_weighted_services?: InputMaybe<order_by>;
  opportunity_age?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_link?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  probability?: InputMaybe<order_by>;
  region?: InputMaybe<order_by>;
  services_amount?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "pipeline_opp_detail_ml_gql" */
export enum pipeline_opp_detail_ml_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  account_key = "account_key",
  /** column name */
  account_name = "account_name",
  /** column name */
  amount = "amount",
  /** column name */
  closedate = "closedate",
  /** column name */
  coalesce = "coalesce",
  /** column name */
  createddate = "createddate",
  /** column name */
  custom_filter_1 = "custom_filter_1",
  /** column name */
  email = "email",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  isclosed = "isclosed",
  /** column name */
  iswon = "iswon",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  ml_last_scored_at = "ml_last_scored_at",
  /** column name */
  ml_probability = "ml_probability",
  /** column name */
  ml_weighted_arr = "ml_weighted_arr",
  /** column name */
  ml_weighted_services = "ml_weighted_services",
  /** column name */
  opportunity_age = "opportunity_age",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_link = "opportunity_link",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  probability = "probability",
  /** column name */
  region = "region",
  /** column name */
  services_amount = "services_amount",
  /** column name */
  stage = "stage",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "pipeline_opp_detail_ml_gql" */
export type pipeline_opp_detail_ml_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: pipeline_opp_detail_ml_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type pipeline_opp_detail_ml_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  account_key?: InputMaybe<Scalars["bigint"]>;
  account_name?: InputMaybe<Scalars["String"]>;
  amount?: InputMaybe<Scalars["float8"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  coalesce?: InputMaybe<Scalars["float8"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  custom_filter_1?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  isclosed?: InputMaybe<Scalars["Boolean"]>;
  iswon?: InputMaybe<Scalars["Boolean"]>;
  leadsource?: InputMaybe<Scalars["String"]>;
  ml_last_scored_at?: InputMaybe<Scalars["timestamp"]>;
  ml_probability?: InputMaybe<Scalars["float8"]>;
  ml_weighted_arr?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services?: InputMaybe<Scalars["float8"]>;
  opportunity_age?: InputMaybe<Scalars["float8"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_link?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  probability?: InputMaybe<Scalars["numeric"]>;
  region?: InputMaybe<Scalars["String"]>;
  services_amount?: InputMaybe<Scalars["numeric"]>;
  stage?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_bookings_by_channel_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_bookings_by_channel_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_bookings_by_channel_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_bookings_by_channel_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_bookings_by_channel_gql_bool_exp>>;
  avg_cycle_times_wins?: InputMaybe<float8_comparison_exp>;
  avg_deal_size_wins?: InputMaybe<numeric_comparison_exp>;
  lead_channel?: InputMaybe<String_comparison_exp>;
  losses?: InputMaybe<bigint_comparison_exp>;
  total_opps?: InputMaybe<bigint_comparison_exp>;
  total_won_revenue?: InputMaybe<numeric_comparison_exp>;
  wins?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_bookings_by_channel_gql". */
export type revtron_reporting_bookings_by_channel_gql_order_by = {
  avg_cycle_times_wins?: InputMaybe<order_by>;
  avg_deal_size_wins?: InputMaybe<order_by>;
  lead_channel?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  total_won_revenue?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_bookings_by_channel_gql" */
export enum revtron_reporting_bookings_by_channel_gql_select_column {
  /** column name */
  avg_cycle_times_wins = "avg_cycle_times_wins",
  /** column name */
  avg_deal_size_wins = "avg_deal_size_wins",
  /** column name */
  lead_channel = "lead_channel",
  /** column name */
  losses = "losses",
  /** column name */
  total_opps = "total_opps",
  /** column name */
  total_won_revenue = "total_won_revenue",
  /** column name */
  wins = "wins",
}

/** Streaming cursor of the table "revtron_reporting_bookings_by_channel_gql" */
export type revtron_reporting_bookings_by_channel_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_bookings_by_channel_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_bookings_by_channel_gql_stream_cursor_value_input =
  {
    avg_cycle_times_wins?: InputMaybe<Scalars["float8"]>;
    avg_deal_size_wins?: InputMaybe<Scalars["numeric"]>;
    lead_channel?: InputMaybe<Scalars["String"]>;
    losses?: InputMaybe<Scalars["bigint"]>;
    total_opps?: InputMaybe<Scalars["bigint"]>;
    total_won_revenue?: InputMaybe<Scalars["numeric"]>;
    wins?: InputMaybe<Scalars["bigint"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_bookings_by_detailed_channel_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_bookings_by_detailed_channel_gql_bool_exp = {
  _and?: InputMaybe<
    Array<revtron_reporting_bookings_by_detailed_channel_gql_bool_exp>
  >;
  _not?: InputMaybe<revtron_reporting_bookings_by_detailed_channel_gql_bool_exp>;
  _or?: InputMaybe<
    Array<revtron_reporting_bookings_by_detailed_channel_gql_bool_exp>
  >;
  avg_cycle_times_wins?: InputMaybe<float8_comparison_exp>;
  avg_deal_size_wins?: InputMaybe<numeric_comparison_exp>;
  lead_channel?: InputMaybe<String_comparison_exp>;
  leadsource?: InputMaybe<String_comparison_exp>;
  losses?: InputMaybe<bigint_comparison_exp>;
  total_opps?: InputMaybe<bigint_comparison_exp>;
  total_won_revenue?: InputMaybe<numeric_comparison_exp>;
  wins?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_bookings_by_detailed_channel_gql". */
export type revtron_reporting_bookings_by_detailed_channel_gql_order_by = {
  avg_cycle_times_wins?: InputMaybe<order_by>;
  avg_deal_size_wins?: InputMaybe<order_by>;
  lead_channel?: InputMaybe<order_by>;
  leadsource?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  total_won_revenue?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_bookings_by_detailed_channel_gql" */
export enum revtron_reporting_bookings_by_detailed_channel_gql_select_column {
  /** column name */
  avg_cycle_times_wins = "avg_cycle_times_wins",
  /** column name */
  avg_deal_size_wins = "avg_deal_size_wins",
  /** column name */
  lead_channel = "lead_channel",
  /** column name */
  leadsource = "leadsource",
  /** column name */
  losses = "losses",
  /** column name */
  total_opps = "total_opps",
  /** column name */
  total_won_revenue = "total_won_revenue",
  /** column name */
  wins = "wins",
}

/** Streaming cursor of the table "revtron_reporting_bookings_by_detailed_channel_gql" */
export type revtron_reporting_bookings_by_detailed_channel_gql_stream_cursor_input =
  {
    /** Stream column input with initial value */
    initial_value: revtron_reporting_bookings_by_detailed_channel_gql_stream_cursor_value_input;
    /** cursor ordering */
    ordering?: InputMaybe<cursor_ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_bookings_by_detailed_channel_gql_stream_cursor_value_input =
  {
    avg_cycle_times_wins?: InputMaybe<Scalars["float8"]>;
    avg_deal_size_wins?: InputMaybe<Scalars["numeric"]>;
    lead_channel?: InputMaybe<Scalars["String"]>;
    leadsource?: InputMaybe<Scalars["String"]>;
    losses?: InputMaybe<Scalars["bigint"]>;
    total_opps?: InputMaybe<Scalars["bigint"]>;
    total_won_revenue?: InputMaybe<Scalars["numeric"]>;
    wins?: InputMaybe<Scalars["bigint"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_bookings_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_bookings_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_bookings_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_bookings_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_bookings_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_bookings_yoy_gql". */
export type revtron_reporting_bookings_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_bookings_yoy_gql" */
export enum revtron_reporting_bookings_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_bookings_yoy_gql" */
export type revtron_reporting_bookings_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_bookings_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_bookings_yoy_gql_stream_cursor_value_input = {
  current_period_revenue?: InputMaybe<Scalars["numeric"]>;
  percent_change?: InputMaybe<Scalars["numeric"]>;
  previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_individuals_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_individuals_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_individuals_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_individuals_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_individuals_gql_bool_exp>>;
  accounts?: InputMaybe<bigint_comparison_exp>;
  contacts?: InputMaybe<bigint_comparison_exp>;
  contacts_per_account?: InputMaybe<numeric_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  leads?: InputMaybe<bigint_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  outbound_opps?: InputMaybe<bigint_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  pipeline_generated?: InputMaybe<numeric_comparison_exp>;
  total_new_biz_opps?: InputMaybe<bigint_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_individuals_gql". */
export type revtron_reporting_individuals_gql_order_by = {
  accounts?: InputMaybe<order_by>;
  contacts?: InputMaybe<order_by>;
  contacts_per_account?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  leads?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  outbound_opps?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  pipeline_generated?: InputMaybe<order_by>;
  total_new_biz_opps?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_individuals_gql" */
export enum revtron_reporting_individuals_gql_select_column {
  /** column name */
  accounts = "accounts",
  /** column name */
  contacts = "contacts",
  /** column name */
  contacts_per_account = "contacts_per_account",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  leads = "leads",
  /** column name */
  name = "name",
  /** column name */
  outbound_opps = "outbound_opps",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  pipeline_generated = "pipeline_generated",
  /** column name */
  total_new_biz_opps = "total_new_biz_opps",
}

/** Streaming cursor of the table "revtron_reporting_individuals_gql" */
export type revtron_reporting_individuals_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_individuals_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_individuals_gql_stream_cursor_value_input = {
  accounts?: InputMaybe<Scalars["bigint"]>;
  contacts?: InputMaybe<Scalars["bigint"]>;
  contacts_per_account?: InputMaybe<Scalars["numeric"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  leads?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  outbound_opps?: InputMaybe<Scalars["bigint"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  pipeline_generated?: InputMaybe<Scalars["numeric"]>;
  total_new_biz_opps?: InputMaybe<Scalars["bigint"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_sales_velocity_details_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_sales_velocity_details_gql_bool_exp = {
  _and?: InputMaybe<
    Array<revtron_reporting_sales_velocity_details_gql_bool_exp>
  >;
  _not?: InputMaybe<revtron_reporting_sales_velocity_details_gql_bool_exp>;
  _or?: InputMaybe<
    Array<revtron_reporting_sales_velocity_details_gql_bool_exp>
  >;
  stat?: InputMaybe<float8_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_sales_velocity_details_gql". */
export type revtron_reporting_sales_velocity_details_gql_order_by = {
  stat?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_sales_velocity_details_gql" */
export enum revtron_reporting_sales_velocity_details_gql_select_column {
  /** column name */
  stat = "stat",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_sales_velocity_details_gql" */
export type revtron_reporting_sales_velocity_details_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_sales_velocity_details_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_sales_velocity_details_gql_stream_cursor_value_input =
  {
    stat?: InputMaybe<Scalars["float8"]>;
    type?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_tof_numbers_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_tof_numbers_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_tof_numbers_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_tof_numbers_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_tof_numbers_yoy_gql_bool_exp>>;
  change?: InputMaybe<bigint_comparison_exp>;
  current_period_opps?: InputMaybe<bigint_comparison_exp>;
  percent_change?: InputMaybe<float8_comparison_exp>;
  previous_period_count?: InputMaybe<bigint_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_tof_numbers_yoy_gql". */
export type revtron_reporting_tof_numbers_yoy_gql_order_by = {
  change?: InputMaybe<order_by>;
  current_period_opps?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_count?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_tof_numbers_yoy_gql" */
export enum revtron_reporting_tof_numbers_yoy_gql_select_column {
  /** column name */
  change = "change",
  /** column name */
  current_period_opps = "current_period_opps",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_count = "previous_period_count",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_tof_numbers_yoy_gql" */
export type revtron_reporting_tof_numbers_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_tof_numbers_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_tof_numbers_yoy_gql_stream_cursor_value_input = {
  change?: InputMaybe<Scalars["bigint"]>;
  current_period_opps?: InputMaybe<Scalars["bigint"]>;
  percent_change?: InputMaybe<Scalars["float8"]>;
  previous_period_count?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_tof_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_tof_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_tof_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_tof_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_tof_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_tof_yoy_gql". */
export type revtron_reporting_tof_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_tof_yoy_gql" */
export enum revtron_reporting_tof_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_tof_yoy_gql" */
export type revtron_reporting_tof_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_tof_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_tof_yoy_gql_stream_cursor_value_input = {
  current_period_revenue?: InputMaybe<Scalars["numeric"]>;
  percent_change?: InputMaybe<Scalars["numeric"]>;
  previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_total_bookings_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_total_bookings_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_total_bookings_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_total_bookings_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_total_bookings_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_total_bookings_yoy_gql". */
export type revtron_reporting_total_bookings_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_total_bookings_yoy_gql" */
export enum revtron_reporting_total_bookings_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_total_bookings_yoy_gql" */
export type revtron_reporting_total_bookings_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_total_bookings_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_total_bookings_yoy_gql_stream_cursor_value_input =
  {
    current_period_revenue?: InputMaybe<Scalars["numeric"]>;
    percent_change?: InputMaybe<Scalars["numeric"]>;
    previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
    type?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_total_tof_numbers_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_total_tof_numbers_yoy_gql_bool_exp = {
  _and?: InputMaybe<
    Array<revtron_reporting_total_tof_numbers_yoy_gql_bool_exp>
  >;
  _not?: InputMaybe<revtron_reporting_total_tof_numbers_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_total_tof_numbers_yoy_gql_bool_exp>>;
  current_period_opps?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_count?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_total_tof_numbers_yoy_gql". */
export type revtron_reporting_total_tof_numbers_yoy_gql_order_by = {
  current_period_opps?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_count?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_total_tof_numbers_yoy_gql" */
export enum revtron_reporting_total_tof_numbers_yoy_gql_select_column {
  /** column name */
  current_period_opps = "current_period_opps",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_count = "previous_period_count",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_total_tof_numbers_yoy_gql" */
export type revtron_reporting_total_tof_numbers_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_total_tof_numbers_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_total_tof_numbers_yoy_gql_stream_cursor_value_input =
  {
    current_period_opps?: InputMaybe<Scalars["numeric"]>;
    percent_change?: InputMaybe<Scalars["numeric"]>;
    previous_period_count?: InputMaybe<Scalars["numeric"]>;
    type?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "revtron_reporting_total_tof_yoy_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_total_tof_yoy_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_total_tof_yoy_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_total_tof_yoy_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_total_tof_yoy_gql_bool_exp>>;
  current_period_revenue?: InputMaybe<numeric_comparison_exp>;
  percent_change?: InputMaybe<numeric_comparison_exp>;
  previous_period_revenue?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_total_tof_yoy_gql". */
export type revtron_reporting_total_tof_yoy_gql_order_by = {
  current_period_revenue?: InputMaybe<order_by>;
  percent_change?: InputMaybe<order_by>;
  previous_period_revenue?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_total_tof_yoy_gql" */
export enum revtron_reporting_total_tof_yoy_gql_select_column {
  /** column name */
  current_period_revenue = "current_period_revenue",
  /** column name */
  percent_change = "percent_change",
  /** column name */
  previous_period_revenue = "previous_period_revenue",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_total_tof_yoy_gql" */
export type revtron_reporting_total_tof_yoy_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_total_tof_yoy_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_total_tof_yoy_gql_stream_cursor_value_input = {
  current_period_revenue?: InputMaybe<Scalars["numeric"]>;
  percent_change?: InputMaybe<Scalars["numeric"]>;
  previous_period_revenue?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_totals_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_totals_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_totals_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_totals_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_totals_gql_bool_exp>>;
  stat?: InputMaybe<numeric_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_totals_gql". */
export type revtron_reporting_totals_gql_order_by = {
  stat?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_totals_gql" */
export enum revtron_reporting_totals_gql_select_column {
  /** column name */
  stat = "stat",
  /** column name */
  type = "type",
}

/** Streaming cursor of the table "revtron_reporting_totals_gql" */
export type revtron_reporting_totals_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_totals_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_totals_gql_stream_cursor_value_input = {
  stat?: InputMaybe<Scalars["numeric"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "revtron_reporting_weighted_gql". All fields are combined with a logical 'AND'. */
export type revtron_reporting_weighted_gql_bool_exp = {
  _and?: InputMaybe<Array<revtron_reporting_weighted_gql_bool_exp>>;
  _not?: InputMaybe<revtron_reporting_weighted_gql_bool_exp>;
  _or?: InputMaybe<Array<revtron_reporting_weighted_gql_bool_exp>>;
  sum?: InputMaybe<float8_comparison_exp>;
};

/** Ordering options when selecting data from "revtron_reporting_weighted_gql". */
export type revtron_reporting_weighted_gql_order_by = {
  sum?: InputMaybe<order_by>;
};

/** select columns of table "revtron_reporting_weighted_gql" */
export enum revtron_reporting_weighted_gql_select_column {
  /** column name */
  sum = "sum",
}

/** Streaming cursor of the table "revtron_reporting_weighted_gql" */
export type revtron_reporting_weighted_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: revtron_reporting_weighted_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type revtron_reporting_weighted_gql_stream_cursor_value_input = {
  sum?: InputMaybe<Scalars["float8"]>;
};

/** Boolean expression to filter rows from the table "running_revenue_gql". All fields are combined with a logical 'AND'. */
export type running_revenue_gql_bool_exp = {
  _and?: InputMaybe<Array<running_revenue_gql_bool_exp>>;
  _not?: InputMaybe<running_revenue_gql_bool_exp>;
  _or?: InputMaybe<Array<running_revenue_gql_bool_exp>>;
  day?: InputMaybe<timestamp_comparison_exp>;
  revenue?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "running_revenue_gql". */
export type running_revenue_gql_order_by = {
  day?: InputMaybe<order_by>;
  revenue?: InputMaybe<order_by>;
};

/** select columns of table "running_revenue_gql" */
export enum running_revenue_gql_select_column {
  /** column name */
  day = "day",
  /** column name */
  revenue = "revenue",
}

/** Streaming cursor of the table "running_revenue_gql" */
export type running_revenue_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: running_revenue_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type running_revenue_gql_stream_cursor_value_input = {
  day?: InputMaybe<Scalars["timestamp"]>;
  revenue?: InputMaybe<Scalars["numeric"]>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type sf_users_append_input = {
  address?: InputMaybe<Scalars["jsonb"]>;
};

/** Boolean expression to filter rows from the table "sf_users". All fields are combined with a logical 'AND'. */
export type sf_users_bool_exp = {
  _and?: InputMaybe<Array<sf_users_bool_exp>>;
  _not?: InputMaybe<sf_users_bool_exp>;
  _or?: InputMaybe<Array<sf_users_bool_exp>>;
  aboutme?: InputMaybe<String_comparison_exp>;
  accountid?: InputMaybe<String_comparison_exp>;
  address?: InputMaybe<jsonb_comparison_exp>;
  alias?: InputMaybe<String_comparison_exp>;
  badgetext?: InputMaybe<String_comparison_exp>;
  bannerphotourl?: InputMaybe<String_comparison_exp>;
  callcenterid?: InputMaybe<String_comparison_exp>;
  city?: InputMaybe<String_comparison_exp>;
  communitynickname?: InputMaybe<String_comparison_exp>;
  companyname?: InputMaybe<String_comparison_exp>;
  contactid?: InputMaybe<String_comparison_exp>;
  country?: InputMaybe<String_comparison_exp>;
  createdbyid?: InputMaybe<String_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  defaultgroupnotificationfrequency?: InputMaybe<String_comparison_exp>;
  delegatedapproverid?: InputMaybe<String_comparison_exp>;
  department?: InputMaybe<String_comparison_exp>;
  digestfrequency?: InputMaybe<String_comparison_exp>;
  division?: InputMaybe<String_comparison_exp>;
  echosign_dev1__echosign_allow_delegated_sending__c?: InputMaybe<Boolean_comparison_exp>;
  echosign_dev1__echosign_email_verified__c?: InputMaybe<Boolean_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  emailencodingkey?: InputMaybe<String_comparison_exp>;
  emailpreferencesautobcc?: InputMaybe<Boolean_comparison_exp>;
  emailpreferencesautobccstayintouch?: InputMaybe<Boolean_comparison_exp>;
  emailpreferencesstayintouchreminder?: InputMaybe<Boolean_comparison_exp>;
  employeenumber?: InputMaybe<String_comparison_exp>;
  extension?: InputMaybe<String_comparison_exp>;
  fax?: InputMaybe<String_comparison_exp>;
  federationidentifier?: InputMaybe<String_comparison_exp>;
  firstname?: InputMaybe<String_comparison_exp>;
  forcesquares__userurl__c?: InputMaybe<String_comparison_exp>;
  forecastenabled?: InputMaybe<Boolean_comparison_exp>;
  fullphotourl?: InputMaybe<String_comparison_exp>;
  geocodeaccuracy?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  individualid?: InputMaybe<String_comparison_exp>;
  isactive?: InputMaybe<Boolean_comparison_exp>;
  isextindicatorvisible?: InputMaybe<Boolean_comparison_exp>;
  isportalenabled?: InputMaybe<Boolean_comparison_exp>;
  isprofilephotoactive?: InputMaybe<Boolean_comparison_exp>;
  languagelocalekey?: InputMaybe<String_comparison_exp>;
  lastlogindate?: InputMaybe<timestamp_comparison_exp>;
  lastmodifiedbyid?: InputMaybe<String_comparison_exp>;
  lastmodifieddate?: InputMaybe<timestamp_comparison_exp>;
  lastname?: InputMaybe<String_comparison_exp>;
  lastpasswordchangedate?: InputMaybe<timestamp_comparison_exp>;
  lastreferenceddate?: InputMaybe<timestamp_comparison_exp>;
  lastvieweddate?: InputMaybe<timestamp_comparison_exp>;
  latitude?: InputMaybe<numeric_comparison_exp>;
  localesidkey?: InputMaybe<String_comparison_exp>;
  longitude?: InputMaybe<numeric_comparison_exp>;
  managerid?: InputMaybe<String_comparison_exp>;
  mediumbannerphotourl?: InputMaybe<String_comparison_exp>;
  mediumphotourl?: InputMaybe<String_comparison_exp>;
  mobilephone?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  numberoffailedlogins?: InputMaybe<Int_comparison_exp>;
  offlinepdatrialexpirationdate?: InputMaybe<timestamp_comparison_exp>;
  offlinetrialexpirationdate?: InputMaybe<timestamp_comparison_exp>;
  outofofficemessage?: InputMaybe<String_comparison_exp>;
  phone?: InputMaybe<String_comparison_exp>;
  pi__can_view_not_assigned_prospects__c?: InputMaybe<Boolean_comparison_exp>;
  pi__pardot_api_key__c?: InputMaybe<String_comparison_exp>;
  pi__pardot_api_version__c?: InputMaybe<String_comparison_exp>;
  pi__pardot_user_id__c?: InputMaybe<String_comparison_exp>;
  pi__pardot_user_key__c?: InputMaybe<String_comparison_exp>;
  pi__pardot_user_role__c?: InputMaybe<String_comparison_exp>;
  portalrole?: InputMaybe<String_comparison_exp>;
  postalcode?: InputMaybe<String_comparison_exp>;
  profileid?: InputMaybe<String_comparison_exp>;
  receivesadmininfoemails?: InputMaybe<Boolean_comparison_exp>;
  receivesinfoemails?: InputMaybe<Boolean_comparison_exp>;
  region__c?: InputMaybe<String_comparison_exp>;
  senderemail?: InputMaybe<String_comparison_exp>;
  sendername?: InputMaybe<String_comparison_exp>;
  signature?: InputMaybe<String_comparison_exp>;
  smallbannerphotourl?: InputMaybe<String_comparison_exp>;
  smallphotourl?: InputMaybe<String_comparison_exp>;
  sort_id?: InputMaybe<Int_comparison_exp>;
  state?: InputMaybe<String_comparison_exp>;
  stayintouchnote?: InputMaybe<String_comparison_exp>;
  stayintouchsignature?: InputMaybe<String_comparison_exp>;
  stayintouchsubject?: InputMaybe<String_comparison_exp>;
  street?: InputMaybe<String_comparison_exp>;
  systemmodstamp?: InputMaybe<timestamp_comparison_exp>;
  timezonesidkey?: InputMaybe<String_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
  username?: InputMaybe<String_comparison_exp>;
  userpermissionsavantgouser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionscallcenterautologin?: InputMaybe<Boolean_comparison_exp>;
  userpermissionschatteranswersuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsinteractionuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsknowledgeuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsmarketinguser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionsofflineuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionssfcontentuser?: InputMaybe<Boolean_comparison_exp>;
  userpermissionssupportuser?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesactivityreminderspopup?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Boolean_comparison_exp>;
  userpreferencescachediagnostics?: InputMaybe<Boolean_comparison_exp>;
  userpreferencescontentemailasandwhen?: InputMaybe<Boolean_comparison_exp>;
  userpreferencescontentnoemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencescreatelexappswtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisableendorsementemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablefollowersemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablelikeemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablementionspostemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablemessageemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisablesharepostemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdismentionscommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesexcludemailappattachments?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesfavoriteswtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshascelebrationbadge?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshides1browserui?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<Boolean_comparison_exp>;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesnativeemailclient?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<Boolean_comparison_exp>;
  userpreferencespathassistantcollapsed?: InputMaybe<Boolean_comparison_exp>;
  userpreferencespreviewcustomtheme?: InputMaybe<Boolean_comparison_exp>;
  userpreferencespreviewlightning?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesremindersoundoff?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessortfeedbycomment?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessrhoverrideactivities?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Boolean_comparison_exp>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Boolean_comparison_exp>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Boolean_comparison_exp>;
  userpreferencesuserdebugmodepref?: InputMaybe<Boolean_comparison_exp>;
  userroleid?: InputMaybe<String_comparison_exp>;
  usertype?: InputMaybe<String_comparison_exp>;
  zoom_app__disable_invitation_email__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__ispmi_enabled__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__login_type__c?: InputMaybe<String_comparison_exp>;
  zoom_app__meeting_password_type__c?: InputMaybe<numeric_comparison_exp>;
  zoom_app__secret_token__c?: InputMaybe<String_comparison_exp>;
  zoom_app__send_email_to_attendee__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__send_ics_in_invitation_email__c?: InputMaybe<Boolean_comparison_exp>;
  zoom_app__webhook_url__c?: InputMaybe<String_comparison_exp>;
  zoom_app__zoom_meeting_password__c?: InputMaybe<String_comparison_exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type sf_users_delete_at_path_input = {
  address?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type sf_users_delete_elem_input = {
  address?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type sf_users_delete_key_input = {
  address?: InputMaybe<Scalars["String"]>;
};

/** input type for incrementing numeric columns in table "sf_users" */
export type sf_users_inc_input = {
  latitude?: InputMaybe<Scalars["numeric"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  zoom_app__meeting_password_type__c?: InputMaybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "sf_users" */
export type sf_users_insert_input = {
  aboutme?: InputMaybe<Scalars["String"]>;
  accountid?: InputMaybe<Scalars["String"]>;
  address?: InputMaybe<Scalars["jsonb"]>;
  alias?: InputMaybe<Scalars["String"]>;
  badgetext?: InputMaybe<Scalars["String"]>;
  bannerphotourl?: InputMaybe<Scalars["String"]>;
  callcenterid?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  communitynickname?: InputMaybe<Scalars["String"]>;
  companyname?: InputMaybe<Scalars["String"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  defaultgroupnotificationfrequency?: InputMaybe<Scalars["String"]>;
  delegatedapproverid?: InputMaybe<Scalars["String"]>;
  department?: InputMaybe<Scalars["String"]>;
  digestfrequency?: InputMaybe<Scalars["String"]>;
  division?: InputMaybe<Scalars["String"]>;
  echosign_dev1__echosign_allow_delegated_sending__c?: InputMaybe<
    Scalars["Boolean"]
  >;
  echosign_dev1__echosign_email_verified__c?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailencodingkey?: InputMaybe<Scalars["String"]>;
  emailpreferencesautobcc?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesautobccstayintouch?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesstayintouchreminder?: InputMaybe<Scalars["Boolean"]>;
  employeenumber?: InputMaybe<Scalars["String"]>;
  extension?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  federationidentifier?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  forcesquares__userurl__c?: InputMaybe<Scalars["String"]>;
  forecastenabled?: InputMaybe<Scalars["Boolean"]>;
  fullphotourl?: InputMaybe<Scalars["String"]>;
  geocodeaccuracy?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  individualid?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  isextindicatorvisible?: InputMaybe<Scalars["Boolean"]>;
  isportalenabled?: InputMaybe<Scalars["Boolean"]>;
  isprofilephotoactive?: InputMaybe<Scalars["Boolean"]>;
  languagelocalekey?: InputMaybe<Scalars["String"]>;
  lastlogindate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastpasswordchangedate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  latitude?: InputMaybe<Scalars["numeric"]>;
  localesidkey?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  managerid?: InputMaybe<Scalars["String"]>;
  mediumbannerphotourl?: InputMaybe<Scalars["String"]>;
  mediumphotourl?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  offlinepdatrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  offlinetrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  outofofficemessage?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  pi__can_view_not_assigned_prospects__c?: InputMaybe<Scalars["Boolean"]>;
  pi__pardot_api_key__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_api_version__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_id__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_key__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_role__c?: InputMaybe<Scalars["String"]>;
  portalrole?: InputMaybe<Scalars["String"]>;
  postalcode?: InputMaybe<Scalars["String"]>;
  profileid?: InputMaybe<Scalars["String"]>;
  receivesadmininfoemails?: InputMaybe<Scalars["Boolean"]>;
  receivesinfoemails?: InputMaybe<Scalars["Boolean"]>;
  region__c?: InputMaybe<Scalars["String"]>;
  senderemail?: InputMaybe<Scalars["String"]>;
  sendername?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<Scalars["String"]>;
  smallbannerphotourl?: InputMaybe<Scalars["String"]>;
  smallphotourl?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  stayintouchnote?: InputMaybe<Scalars["String"]>;
  stayintouchsignature?: InputMaybe<Scalars["String"]>;
  stayintouchsubject?: InputMaybe<Scalars["String"]>;
  street?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  timezonesidkey?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
  userpermissionsavantgouser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionscallcenterautologin?: InputMaybe<Scalars["Boolean"]>;
  userpermissionschatteranswersuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsinteractionuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsknowledgeuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsmarketinguser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsofflineuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssfcontentuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssupportuser?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesactivityreminderspopup?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescachediagnostics?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescontentemailasandwhen?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescontentnoemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescreatelexappswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableendorsementemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesdisablefollowersemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablementionspostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablemessageemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablesharepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdismentionscommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesexcludemailappattachments?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoriteswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshascelebrationbadge?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshides1browserui?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnativeemailclient?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencespathassistantcollapsed?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewcustomtheme?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewlightning?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesremindersoundoff?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessortfeedbycomment?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessrhoverrideactivities?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesuserdebugmodepref?: InputMaybe<Scalars["Boolean"]>;
  userroleid?: InputMaybe<Scalars["String"]>;
  usertype?: InputMaybe<Scalars["String"]>;
  zoom_app__disable_invitation_email__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__ispmi_enabled__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__login_type__c?: InputMaybe<Scalars["String"]>;
  zoom_app__meeting_password_type__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__secret_token__c?: InputMaybe<Scalars["String"]>;
  zoom_app__send_email_to_attendee__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__send_ics_in_invitation_email__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__webhook_url__c?: InputMaybe<Scalars["String"]>;
  zoom_app__zoom_meeting_password__c?: InputMaybe<Scalars["String"]>;
};

/** Ordering options when selecting data from "sf_users". */
export type sf_users_order_by = {
  aboutme?: InputMaybe<order_by>;
  accountid?: InputMaybe<order_by>;
  address?: InputMaybe<order_by>;
  alias?: InputMaybe<order_by>;
  badgetext?: InputMaybe<order_by>;
  bannerphotourl?: InputMaybe<order_by>;
  callcenterid?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  communitynickname?: InputMaybe<order_by>;
  companyname?: InputMaybe<order_by>;
  contactid?: InputMaybe<order_by>;
  country?: InputMaybe<order_by>;
  createdbyid?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  defaultgroupnotificationfrequency?: InputMaybe<order_by>;
  delegatedapproverid?: InputMaybe<order_by>;
  department?: InputMaybe<order_by>;
  digestfrequency?: InputMaybe<order_by>;
  division?: InputMaybe<order_by>;
  echosign_dev1__echosign_allow_delegated_sending__c?: InputMaybe<order_by>;
  echosign_dev1__echosign_email_verified__c?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emailencodingkey?: InputMaybe<order_by>;
  emailpreferencesautobcc?: InputMaybe<order_by>;
  emailpreferencesautobccstayintouch?: InputMaybe<order_by>;
  emailpreferencesstayintouchreminder?: InputMaybe<order_by>;
  employeenumber?: InputMaybe<order_by>;
  extension?: InputMaybe<order_by>;
  fax?: InputMaybe<order_by>;
  federationidentifier?: InputMaybe<order_by>;
  firstname?: InputMaybe<order_by>;
  forcesquares__userurl__c?: InputMaybe<order_by>;
  forecastenabled?: InputMaybe<order_by>;
  fullphotourl?: InputMaybe<order_by>;
  geocodeaccuracy?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  individualid?: InputMaybe<order_by>;
  isactive?: InputMaybe<order_by>;
  isextindicatorvisible?: InputMaybe<order_by>;
  isportalenabled?: InputMaybe<order_by>;
  isprofilephotoactive?: InputMaybe<order_by>;
  languagelocalekey?: InputMaybe<order_by>;
  lastlogindate?: InputMaybe<order_by>;
  lastmodifiedbyid?: InputMaybe<order_by>;
  lastmodifieddate?: InputMaybe<order_by>;
  lastname?: InputMaybe<order_by>;
  lastpasswordchangedate?: InputMaybe<order_by>;
  lastreferenceddate?: InputMaybe<order_by>;
  lastvieweddate?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  localesidkey?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  managerid?: InputMaybe<order_by>;
  mediumbannerphotourl?: InputMaybe<order_by>;
  mediumphotourl?: InputMaybe<order_by>;
  mobilephone?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  numberoffailedlogins?: InputMaybe<order_by>;
  offlinepdatrialexpirationdate?: InputMaybe<order_by>;
  offlinetrialexpirationdate?: InputMaybe<order_by>;
  outofofficemessage?: InputMaybe<order_by>;
  phone?: InputMaybe<order_by>;
  pi__can_view_not_assigned_prospects__c?: InputMaybe<order_by>;
  pi__pardot_api_key__c?: InputMaybe<order_by>;
  pi__pardot_api_version__c?: InputMaybe<order_by>;
  pi__pardot_user_id__c?: InputMaybe<order_by>;
  pi__pardot_user_key__c?: InputMaybe<order_by>;
  pi__pardot_user_role__c?: InputMaybe<order_by>;
  portalrole?: InputMaybe<order_by>;
  postalcode?: InputMaybe<order_by>;
  profileid?: InputMaybe<order_by>;
  receivesadmininfoemails?: InputMaybe<order_by>;
  receivesinfoemails?: InputMaybe<order_by>;
  region__c?: InputMaybe<order_by>;
  senderemail?: InputMaybe<order_by>;
  sendername?: InputMaybe<order_by>;
  signature?: InputMaybe<order_by>;
  smallbannerphotourl?: InputMaybe<order_by>;
  smallphotourl?: InputMaybe<order_by>;
  sort_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  stayintouchnote?: InputMaybe<order_by>;
  stayintouchsignature?: InputMaybe<order_by>;
  stayintouchsubject?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  systemmodstamp?: InputMaybe<order_by>;
  timezonesidkey?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
  username?: InputMaybe<order_by>;
  userpermissionsavantgouser?: InputMaybe<order_by>;
  userpermissionscallcenterautologin?: InputMaybe<order_by>;
  userpermissionschatteranswersuser?: InputMaybe<order_by>;
  userpermissionsinteractionuser?: InputMaybe<order_by>;
  userpermissionsknowledgeuser?: InputMaybe<order_by>;
  userpermissionsmarketinguser?: InputMaybe<order_by>;
  userpermissionsofflineuser?: InputMaybe<order_by>;
  userpermissionssfcontentuser?: InputMaybe<order_by>;
  userpermissionssupportuser?: InputMaybe<order_by>;
  userpreferencesactivityreminderspopup?: InputMaybe<order_by>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<order_by>;
  userpreferencescachediagnostics?: InputMaybe<order_by>;
  userpreferencescontentemailasandwhen?: InputMaybe<order_by>;
  userpreferencescontentnoemail?: InputMaybe<order_by>;
  userpreferencescreatelexappswtshown?: InputMaybe<order_by>;
  userpreferencesdisableallfeedsemail?: InputMaybe<order_by>;
  userpreferencesdisablebookmarkemail?: InputMaybe<order_by>;
  userpreferencesdisablechangecommentemail?: InputMaybe<order_by>;
  userpreferencesdisableendorsementemail?: InputMaybe<order_by>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<order_by>;
  userpreferencesdisablefollowersemail?: InputMaybe<order_by>;
  userpreferencesdisablelatercommentemail?: InputMaybe<order_by>;
  userpreferencesdisablelikeemail?: InputMaybe<order_by>;
  userpreferencesdisablementionspostemail?: InputMaybe<order_by>;
  userpreferencesdisablemessageemail?: InputMaybe<order_by>;
  userpreferencesdisableprofilepostemail?: InputMaybe<order_by>;
  userpreferencesdisablesharepostemail?: InputMaybe<order_by>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<order_by>;
  userpreferencesdismentionscommentemail?: InputMaybe<order_by>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<order_by>;
  userpreferencesenableautosubforfeeds?: InputMaybe<order_by>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<order_by>;
  userpreferencesexcludemailappattachments?: InputMaybe<order_by>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<order_by>;
  userpreferencesfavoriteswtshown?: InputMaybe<order_by>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<order_by>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<order_by>;
  userpreferenceshascelebrationbadge?: InputMaybe<order_by>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<order_by>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<order_by>;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<order_by>;
  userpreferenceshidecsndesktoptask?: InputMaybe<order_by>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<order_by>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<order_by>;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<order_by>;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<order_by>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<order_by>;
  userpreferenceshides1browserui?: InputMaybe<order_by>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<order_by>;
  userpreferenceshidesfxwelcomemat?: InputMaybe<order_by>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<order_by>;
  userpreferenceslightningexperiencepreferred?: InputMaybe<order_by>;
  userpreferencesnativeemailclient?: InputMaybe<order_by>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<order_by>;
  userpreferencespathassistantcollapsed?: InputMaybe<order_by>;
  userpreferencespreviewcustomtheme?: InputMaybe<order_by>;
  userpreferencespreviewlightning?: InputMaybe<order_by>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<order_by>;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<order_by>;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<order_by>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<order_by>;
  userpreferencesremindersoundoff?: InputMaybe<order_by>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowcitytoguestusers?: InputMaybe<order_by>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<order_by>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowemailtoguestusers?: InputMaybe<order_by>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<order_by>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<order_by>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<order_by>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<order_by>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<order_by>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowstatetoguestusers?: InputMaybe<order_by>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<order_by>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowtitletoguestusers?: InputMaybe<order_by>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<order_by>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<order_by>;
  userpreferencessortfeedbycomment?: InputMaybe<order_by>;
  userpreferencessrhoverrideactivities?: InputMaybe<order_by>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<order_by>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<order_by>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<order_by>;
  userpreferencesuserdebugmodepref?: InputMaybe<order_by>;
  userroleid?: InputMaybe<order_by>;
  usertype?: InputMaybe<order_by>;
  zoom_app__disable_invitation_email__c?: InputMaybe<order_by>;
  zoom_app__ispmi_enabled__c?: InputMaybe<order_by>;
  zoom_app__login_type__c?: InputMaybe<order_by>;
  zoom_app__meeting_password_type__c?: InputMaybe<order_by>;
  zoom_app__secret_token__c?: InputMaybe<order_by>;
  zoom_app__send_email_to_attendee__c?: InputMaybe<order_by>;
  zoom_app__send_ics_in_invitation_email__c?: InputMaybe<order_by>;
  zoom_app__webhook_url__c?: InputMaybe<order_by>;
  zoom_app__zoom_meeting_password__c?: InputMaybe<order_by>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type sf_users_prepend_input = {
  address?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "sf_users" */
export enum sf_users_select_column {
  /** column name */
  aboutme = "aboutme",
  /** column name */
  accountid = "accountid",
  /** column name */
  address = "address",
  /** column name */
  alias = "alias",
  /** column name */
  badgetext = "badgetext",
  /** column name */
  bannerphotourl = "bannerphotourl",
  /** column name */
  callcenterid = "callcenterid",
  /** column name */
  city = "city",
  /** column name */
  communitynickname = "communitynickname",
  /** column name */
  companyname = "companyname",
  /** column name */
  contactid = "contactid",
  /** column name */
  country = "country",
  /** column name */
  createdbyid = "createdbyid",
  /** column name */
  createddate = "createddate",
  /** column name */
  defaultgroupnotificationfrequency = "defaultgroupnotificationfrequency",
  /** column name */
  delegatedapproverid = "delegatedapproverid",
  /** column name */
  department = "department",
  /** column name */
  digestfrequency = "digestfrequency",
  /** column name */
  division = "division",
  /** column name */
  echosign_dev1__echosign_allow_delegated_sending__c = "echosign_dev1__echosign_allow_delegated_sending__c",
  /** column name */
  echosign_dev1__echosign_email_verified__c = "echosign_dev1__echosign_email_verified__c",
  /** column name */
  email = "email",
  /** column name */
  emailencodingkey = "emailencodingkey",
  /** column name */
  emailpreferencesautobcc = "emailpreferencesautobcc",
  /** column name */
  emailpreferencesautobccstayintouch = "emailpreferencesautobccstayintouch",
  /** column name */
  emailpreferencesstayintouchreminder = "emailpreferencesstayintouchreminder",
  /** column name */
  employeenumber = "employeenumber",
  /** column name */
  extension = "extension",
  /** column name */
  fax = "fax",
  /** column name */
  federationidentifier = "federationidentifier",
  /** column name */
  firstname = "firstname",
  /** column name */
  forcesquares__userurl__c = "forcesquares__userurl__c",
  /** column name */
  forecastenabled = "forecastenabled",
  /** column name */
  fullphotourl = "fullphotourl",
  /** column name */
  geocodeaccuracy = "geocodeaccuracy",
  /** column name */
  id = "id",
  /** column name */
  individualid = "individualid",
  /** column name */
  isactive = "isactive",
  /** column name */
  isextindicatorvisible = "isextindicatorvisible",
  /** column name */
  isportalenabled = "isportalenabled",
  /** column name */
  isprofilephotoactive = "isprofilephotoactive",
  /** column name */
  languagelocalekey = "languagelocalekey",
  /** column name */
  lastlogindate = "lastlogindate",
  /** column name */
  lastmodifiedbyid = "lastmodifiedbyid",
  /** column name */
  lastmodifieddate = "lastmodifieddate",
  /** column name */
  lastname = "lastname",
  /** column name */
  lastpasswordchangedate = "lastpasswordchangedate",
  /** column name */
  lastreferenceddate = "lastreferenceddate",
  /** column name */
  lastvieweddate = "lastvieweddate",
  /** column name */
  latitude = "latitude",
  /** column name */
  localesidkey = "localesidkey",
  /** column name */
  longitude = "longitude",
  /** column name */
  managerid = "managerid",
  /** column name */
  mediumbannerphotourl = "mediumbannerphotourl",
  /** column name */
  mediumphotourl = "mediumphotourl",
  /** column name */
  mobilephone = "mobilephone",
  /** column name */
  name = "name",
  /** column name */
  numberoffailedlogins = "numberoffailedlogins",
  /** column name */
  offlinepdatrialexpirationdate = "offlinepdatrialexpirationdate",
  /** column name */
  offlinetrialexpirationdate = "offlinetrialexpirationdate",
  /** column name */
  outofofficemessage = "outofofficemessage",
  /** column name */
  phone = "phone",
  /** column name */
  pi__can_view_not_assigned_prospects__c = "pi__can_view_not_assigned_prospects__c",
  /** column name */
  pi__pardot_api_key__c = "pi__pardot_api_key__c",
  /** column name */
  pi__pardot_api_version__c = "pi__pardot_api_version__c",
  /** column name */
  pi__pardot_user_id__c = "pi__pardot_user_id__c",
  /** column name */
  pi__pardot_user_key__c = "pi__pardot_user_key__c",
  /** column name */
  pi__pardot_user_role__c = "pi__pardot_user_role__c",
  /** column name */
  portalrole = "portalrole",
  /** column name */
  postalcode = "postalcode",
  /** column name */
  profileid = "profileid",
  /** column name */
  receivesadmininfoemails = "receivesadmininfoemails",
  /** column name */
  receivesinfoemails = "receivesinfoemails",
  /** column name */
  region__c = "region__c",
  /** column name */
  senderemail = "senderemail",
  /** column name */
  sendername = "sendername",
  /** column name */
  signature = "signature",
  /** column name */
  smallbannerphotourl = "smallbannerphotourl",
  /** column name */
  smallphotourl = "smallphotourl",
  /** column name */
  sort_id = "sort_id",
  /** column name */
  state = "state",
  /** column name */
  stayintouchnote = "stayintouchnote",
  /** column name */
  stayintouchsignature = "stayintouchsignature",
  /** column name */
  stayintouchsubject = "stayintouchsubject",
  /** column name */
  street = "street",
  /** column name */
  systemmodstamp = "systemmodstamp",
  /** column name */
  timezonesidkey = "timezonesidkey",
  /** column name */
  title = "title",
  /** column name */
  username = "username",
  /** column name */
  userpermissionsavantgouser = "userpermissionsavantgouser",
  /** column name */
  userpermissionscallcenterautologin = "userpermissionscallcenterautologin",
  /** column name */
  userpermissionschatteranswersuser = "userpermissionschatteranswersuser",
  /** column name */
  userpermissionsinteractionuser = "userpermissionsinteractionuser",
  /** column name */
  userpermissionsknowledgeuser = "userpermissionsknowledgeuser",
  /** column name */
  userpermissionsmarketinguser = "userpermissionsmarketinguser",
  /** column name */
  userpermissionsofflineuser = "userpermissionsofflineuser",
  /** column name */
  userpermissionssfcontentuser = "userpermissionssfcontentuser",
  /** column name */
  userpermissionssupportuser = "userpermissionssupportuser",
  /** column name */
  userpreferencesactivityreminderspopup = "userpreferencesactivityreminderspopup",
  /** column name */
  userpreferencesapexpagesdevelopermode = "userpreferencesapexpagesdevelopermode",
  /** column name */
  userpreferencescachediagnostics = "userpreferencescachediagnostics",
  /** column name */
  userpreferencescontentemailasandwhen = "userpreferencescontentemailasandwhen",
  /** column name */
  userpreferencescontentnoemail = "userpreferencescontentnoemail",
  /** column name */
  userpreferencescreatelexappswtshown = "userpreferencescreatelexappswtshown",
  /** column name */
  userpreferencesdisableallfeedsemail = "userpreferencesdisableallfeedsemail",
  /** column name */
  userpreferencesdisablebookmarkemail = "userpreferencesdisablebookmarkemail",
  /** column name */
  userpreferencesdisablechangecommentemail = "userpreferencesdisablechangecommentemail",
  /** column name */
  userpreferencesdisableendorsementemail = "userpreferencesdisableendorsementemail",
  /** column name */
  userpreferencesdisablefilesharenotificationsforapi = "userpreferencesdisablefilesharenotificationsforapi",
  /** column name */
  userpreferencesdisablefollowersemail = "userpreferencesdisablefollowersemail",
  /** column name */
  userpreferencesdisablelatercommentemail = "userpreferencesdisablelatercommentemail",
  /** column name */
  userpreferencesdisablelikeemail = "userpreferencesdisablelikeemail",
  /** column name */
  userpreferencesdisablementionspostemail = "userpreferencesdisablementionspostemail",
  /** column name */
  userpreferencesdisablemessageemail = "userpreferencesdisablemessageemail",
  /** column name */
  userpreferencesdisableprofilepostemail = "userpreferencesdisableprofilepostemail",
  /** column name */
  userpreferencesdisablesharepostemail = "userpreferencesdisablesharepostemail",
  /** column name */
  userpreferencesdiscommentafterlikeemail = "userpreferencesdiscommentafterlikeemail",
  /** column name */
  userpreferencesdismentionscommentemail = "userpreferencesdismentionscommentemail",
  /** column name */
  userpreferencesdisprofpostcommentemail = "userpreferencesdisprofpostcommentemail",
  /** column name */
  userpreferencesenableautosubforfeeds = "userpreferencesenableautosubforfeeds",
  /** column name */
  userpreferenceseventreminderscheckboxdefault = "userpreferenceseventreminderscheckboxdefault",
  /** column name */
  userpreferencesexcludemailappattachments = "userpreferencesexcludemailappattachments",
  /** column name */
  userpreferencesfavoritesshowtopfavorites = "userpreferencesfavoritesshowtopfavorites",
  /** column name */
  userpreferencesfavoriteswtshown = "userpreferencesfavoriteswtshown",
  /** column name */
  userpreferencesglobalnavbarwtshown = "userpreferencesglobalnavbarwtshown",
  /** column name */
  userpreferencesglobalnavgridmenuwtshown = "userpreferencesglobalnavgridmenuwtshown",
  /** column name */
  userpreferenceshascelebrationbadge = "userpreferenceshascelebrationbadge",
  /** column name */
  userpreferenceshidebiggerphotocallout = "userpreferenceshidebiggerphotocallout",
  /** column name */
  userpreferenceshidebrowseproductredirectconfirmation = "userpreferenceshidebrowseproductredirectconfirmation",
  /** column name */
  userpreferenceshidechatteronboardingsplash = "userpreferenceshidechatteronboardingsplash",
  /** column name */
  userpreferenceshidecsndesktoptask = "userpreferenceshidecsndesktoptask",
  /** column name */
  userpreferenceshidecsngetchattermobiletask = "userpreferenceshidecsngetchattermobiletask",
  /** column name */
  userpreferenceshideenduseronboardingassistantmodal = "userpreferenceshideenduseronboardingassistantmodal",
  /** column name */
  userpreferenceshideinvoicesredirectconfirmation = "userpreferenceshideinvoicesredirectconfirmation",
  /** column name */
  userpreferenceshidelightningmigrationmodal = "userpreferenceshidelightningmigrationmodal",
  /** column name */
  userpreferenceshideonlinesalesappwelcomemat = "userpreferenceshideonlinesalesappwelcomemat",
  /** column name */
  userpreferenceshides1browserui = "userpreferenceshides1browserui",
  /** column name */
  userpreferenceshidesecondchatteronboardingsplash = "userpreferenceshidesecondchatteronboardingsplash",
  /** column name */
  userpreferenceshidesfxwelcomemat = "userpreferenceshidesfxwelcomemat",
  /** column name */
  userpreferenceshidestatementsredirectconfirmation = "userpreferenceshidestatementsredirectconfirmation",
  /** column name */
  userpreferenceslightningexperiencepreferred = "userpreferenceslightningexperiencepreferred",
  /** column name */
  userpreferencesnativeemailclient = "userpreferencesnativeemailclient",
  /** column name */
  userpreferencesnewlightningreportrunpageenabled = "userpreferencesnewlightningreportrunpageenabled",
  /** column name */
  userpreferencespathassistantcollapsed = "userpreferencespathassistantcollapsed",
  /** column name */
  userpreferencespreviewcustomtheme = "userpreferencespreviewcustomtheme",
  /** column name */
  userpreferencespreviewlightning = "userpreferencespreviewlightning",
  /** column name */
  userpreferencesreceivenonotificationsasapprover = "userpreferencesreceivenonotificationsasapprover",
  /** column name */
  userpreferencesreceivenotificationsasdelegatedapprover = "userpreferencesreceivenotificationsasdelegatedapprover",
  /** column name */
  userpreferencesrecordhomereservedwtshown = "userpreferencesrecordhomereservedwtshown",
  /** column name */
  userpreferencesrecordhomesectioncollapsewtshown = "userpreferencesrecordhomesectioncollapsewtshown",
  /** column name */
  userpreferencesremindersoundoff = "userpreferencesremindersoundoff",
  /** column name */
  userpreferencesshowcitytoexternalusers = "userpreferencesshowcitytoexternalusers",
  /** column name */
  userpreferencesshowcitytoguestusers = "userpreferencesshowcitytoguestusers",
  /** column name */
  userpreferencesshowcountrytoexternalusers = "userpreferencesshowcountrytoexternalusers",
  /** column name */
  userpreferencesshowcountrytoguestusers = "userpreferencesshowcountrytoguestusers",
  /** column name */
  userpreferencesshowemailtoexternalusers = "userpreferencesshowemailtoexternalusers",
  /** column name */
  userpreferencesshowemailtoguestusers = "userpreferencesshowemailtoguestusers",
  /** column name */
  userpreferencesshowfaxtoexternalusers = "userpreferencesshowfaxtoexternalusers",
  /** column name */
  userpreferencesshowfaxtoguestusers = "userpreferencesshowfaxtoguestusers",
  /** column name */
  userpreferencesshowmanagertoexternalusers = "userpreferencesshowmanagertoexternalusers",
  /** column name */
  userpreferencesshowmanagertoguestusers = "userpreferencesshowmanagertoguestusers",
  /** column name */
  userpreferencesshowmobilephonetoexternalusers = "userpreferencesshowmobilephonetoexternalusers",
  /** column name */
  userpreferencesshowmobilephonetoguestusers = "userpreferencesshowmobilephonetoguestusers",
  /** column name */
  userpreferencesshowpostalcodetoexternalusers = "userpreferencesshowpostalcodetoexternalusers",
  /** column name */
  userpreferencesshowpostalcodetoguestusers = "userpreferencesshowpostalcodetoguestusers",
  /** column name */
  userpreferencesshowprofilepictoguestusers = "userpreferencesshowprofilepictoguestusers",
  /** column name */
  userpreferencesshowstatetoexternalusers = "userpreferencesshowstatetoexternalusers",
  /** column name */
  userpreferencesshowstatetoguestusers = "userpreferencesshowstatetoguestusers",
  /** column name */
  userpreferencesshowstreetaddresstoexternalusers = "userpreferencesshowstreetaddresstoexternalusers",
  /** column name */
  userpreferencesshowstreetaddresstoguestusers = "userpreferencesshowstreetaddresstoguestusers",
  /** column name */
  userpreferencesshowtitletoexternalusers = "userpreferencesshowtitletoexternalusers",
  /** column name */
  userpreferencesshowtitletoguestusers = "userpreferencesshowtitletoguestusers",
  /** column name */
  userpreferencesshowworkphonetoexternalusers = "userpreferencesshowworkphonetoexternalusers",
  /** column name */
  userpreferencesshowworkphonetoguestusers = "userpreferencesshowworkphonetoguestusers",
  /** column name */
  userpreferencessortfeedbycomment = "userpreferencessortfeedbycomment",
  /** column name */
  userpreferencessrhoverrideactivities = "userpreferencessrhoverrideactivities",
  /** column name */
  userpreferencessuppresseventsfxreminders = "userpreferencessuppresseventsfxreminders",
  /** column name */
  userpreferencessuppresstasksfxreminders = "userpreferencessuppresstasksfxreminders",
  /** column name */
  userpreferencestaskreminderscheckboxdefault = "userpreferencestaskreminderscheckboxdefault",
  /** column name */
  userpreferencesuserdebugmodepref = "userpreferencesuserdebugmodepref",
  /** column name */
  userroleid = "userroleid",
  /** column name */
  usertype = "usertype",
  /** column name */
  zoom_app__disable_invitation_email__c = "zoom_app__disable_invitation_email__c",
  /** column name */
  zoom_app__ispmi_enabled__c = "zoom_app__ispmi_enabled__c",
  /** column name */
  zoom_app__login_type__c = "zoom_app__login_type__c",
  /** column name */
  zoom_app__meeting_password_type__c = "zoom_app__meeting_password_type__c",
  /** column name */
  zoom_app__secret_token__c = "zoom_app__secret_token__c",
  /** column name */
  zoom_app__send_email_to_attendee__c = "zoom_app__send_email_to_attendee__c",
  /** column name */
  zoom_app__send_ics_in_invitation_email__c = "zoom_app__send_ics_in_invitation_email__c",
  /** column name */
  zoom_app__webhook_url__c = "zoom_app__webhook_url__c",
  /** column name */
  zoom_app__zoom_meeting_password__c = "zoom_app__zoom_meeting_password__c",
}

/** input type for updating data in table "sf_users" */
export type sf_users_set_input = {
  aboutme?: InputMaybe<Scalars["String"]>;
  accountid?: InputMaybe<Scalars["String"]>;
  address?: InputMaybe<Scalars["jsonb"]>;
  alias?: InputMaybe<Scalars["String"]>;
  badgetext?: InputMaybe<Scalars["String"]>;
  bannerphotourl?: InputMaybe<Scalars["String"]>;
  callcenterid?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  communitynickname?: InputMaybe<Scalars["String"]>;
  companyname?: InputMaybe<Scalars["String"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  defaultgroupnotificationfrequency?: InputMaybe<Scalars["String"]>;
  delegatedapproverid?: InputMaybe<Scalars["String"]>;
  department?: InputMaybe<Scalars["String"]>;
  digestfrequency?: InputMaybe<Scalars["String"]>;
  division?: InputMaybe<Scalars["String"]>;
  echosign_dev1__echosign_allow_delegated_sending__c?: InputMaybe<
    Scalars["Boolean"]
  >;
  echosign_dev1__echosign_email_verified__c?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailencodingkey?: InputMaybe<Scalars["String"]>;
  emailpreferencesautobcc?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesautobccstayintouch?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesstayintouchreminder?: InputMaybe<Scalars["Boolean"]>;
  employeenumber?: InputMaybe<Scalars["String"]>;
  extension?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  federationidentifier?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  forcesquares__userurl__c?: InputMaybe<Scalars["String"]>;
  forecastenabled?: InputMaybe<Scalars["Boolean"]>;
  fullphotourl?: InputMaybe<Scalars["String"]>;
  geocodeaccuracy?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  individualid?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  isextindicatorvisible?: InputMaybe<Scalars["Boolean"]>;
  isportalenabled?: InputMaybe<Scalars["Boolean"]>;
  isprofilephotoactive?: InputMaybe<Scalars["Boolean"]>;
  languagelocalekey?: InputMaybe<Scalars["String"]>;
  lastlogindate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastpasswordchangedate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  latitude?: InputMaybe<Scalars["numeric"]>;
  localesidkey?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  managerid?: InputMaybe<Scalars["String"]>;
  mediumbannerphotourl?: InputMaybe<Scalars["String"]>;
  mediumphotourl?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  offlinepdatrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  offlinetrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  outofofficemessage?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  pi__can_view_not_assigned_prospects__c?: InputMaybe<Scalars["Boolean"]>;
  pi__pardot_api_key__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_api_version__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_id__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_key__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_role__c?: InputMaybe<Scalars["String"]>;
  portalrole?: InputMaybe<Scalars["String"]>;
  postalcode?: InputMaybe<Scalars["String"]>;
  profileid?: InputMaybe<Scalars["String"]>;
  receivesadmininfoemails?: InputMaybe<Scalars["Boolean"]>;
  receivesinfoemails?: InputMaybe<Scalars["Boolean"]>;
  region__c?: InputMaybe<Scalars["String"]>;
  senderemail?: InputMaybe<Scalars["String"]>;
  sendername?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<Scalars["String"]>;
  smallbannerphotourl?: InputMaybe<Scalars["String"]>;
  smallphotourl?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  stayintouchnote?: InputMaybe<Scalars["String"]>;
  stayintouchsignature?: InputMaybe<Scalars["String"]>;
  stayintouchsubject?: InputMaybe<Scalars["String"]>;
  street?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  timezonesidkey?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
  userpermissionsavantgouser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionscallcenterautologin?: InputMaybe<Scalars["Boolean"]>;
  userpermissionschatteranswersuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsinteractionuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsknowledgeuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsmarketinguser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsofflineuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssfcontentuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssupportuser?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesactivityreminderspopup?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescachediagnostics?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescontentemailasandwhen?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescontentnoemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescreatelexappswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableendorsementemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesdisablefollowersemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablementionspostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablemessageemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablesharepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdismentionscommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesexcludemailappattachments?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoriteswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshascelebrationbadge?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshides1browserui?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnativeemailclient?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencespathassistantcollapsed?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewcustomtheme?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewlightning?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesremindersoundoff?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessortfeedbycomment?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessrhoverrideactivities?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesuserdebugmodepref?: InputMaybe<Scalars["Boolean"]>;
  userroleid?: InputMaybe<Scalars["String"]>;
  usertype?: InputMaybe<Scalars["String"]>;
  zoom_app__disable_invitation_email__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__ispmi_enabled__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__login_type__c?: InputMaybe<Scalars["String"]>;
  zoom_app__meeting_password_type__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__secret_token__c?: InputMaybe<Scalars["String"]>;
  zoom_app__send_email_to_attendee__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__send_ics_in_invitation_email__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__webhook_url__c?: InputMaybe<Scalars["String"]>;
  zoom_app__zoom_meeting_password__c?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "sf_users" */
export type sf_users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: sf_users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type sf_users_stream_cursor_value_input = {
  aboutme?: InputMaybe<Scalars["String"]>;
  accountid?: InputMaybe<Scalars["String"]>;
  address?: InputMaybe<Scalars["jsonb"]>;
  alias?: InputMaybe<Scalars["String"]>;
  badgetext?: InputMaybe<Scalars["String"]>;
  bannerphotourl?: InputMaybe<Scalars["String"]>;
  callcenterid?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  communitynickname?: InputMaybe<Scalars["String"]>;
  companyname?: InputMaybe<Scalars["String"]>;
  contactid?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  createdbyid?: InputMaybe<Scalars["String"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  defaultgroupnotificationfrequency?: InputMaybe<Scalars["String"]>;
  delegatedapproverid?: InputMaybe<Scalars["String"]>;
  department?: InputMaybe<Scalars["String"]>;
  digestfrequency?: InputMaybe<Scalars["String"]>;
  division?: InputMaybe<Scalars["String"]>;
  echosign_dev1__echosign_allow_delegated_sending__c?: InputMaybe<
    Scalars["Boolean"]
  >;
  echosign_dev1__echosign_email_verified__c?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  emailencodingkey?: InputMaybe<Scalars["String"]>;
  emailpreferencesautobcc?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesautobccstayintouch?: InputMaybe<Scalars["Boolean"]>;
  emailpreferencesstayintouchreminder?: InputMaybe<Scalars["Boolean"]>;
  employeenumber?: InputMaybe<Scalars["String"]>;
  extension?: InputMaybe<Scalars["String"]>;
  fax?: InputMaybe<Scalars["String"]>;
  federationidentifier?: InputMaybe<Scalars["String"]>;
  firstname?: InputMaybe<Scalars["String"]>;
  forcesquares__userurl__c?: InputMaybe<Scalars["String"]>;
  forecastenabled?: InputMaybe<Scalars["Boolean"]>;
  fullphotourl?: InputMaybe<Scalars["String"]>;
  geocodeaccuracy?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  individualid?: InputMaybe<Scalars["String"]>;
  isactive?: InputMaybe<Scalars["Boolean"]>;
  isextindicatorvisible?: InputMaybe<Scalars["Boolean"]>;
  isportalenabled?: InputMaybe<Scalars["Boolean"]>;
  isprofilephotoactive?: InputMaybe<Scalars["Boolean"]>;
  languagelocalekey?: InputMaybe<Scalars["String"]>;
  lastlogindate?: InputMaybe<Scalars["timestamp"]>;
  lastmodifiedbyid?: InputMaybe<Scalars["String"]>;
  lastmodifieddate?: InputMaybe<Scalars["timestamp"]>;
  lastname?: InputMaybe<Scalars["String"]>;
  lastpasswordchangedate?: InputMaybe<Scalars["timestamp"]>;
  lastreferenceddate?: InputMaybe<Scalars["timestamp"]>;
  lastvieweddate?: InputMaybe<Scalars["timestamp"]>;
  latitude?: InputMaybe<Scalars["numeric"]>;
  localesidkey?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["numeric"]>;
  managerid?: InputMaybe<Scalars["String"]>;
  mediumbannerphotourl?: InputMaybe<Scalars["String"]>;
  mediumphotourl?: InputMaybe<Scalars["String"]>;
  mobilephone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberoffailedlogins?: InputMaybe<Scalars["Int"]>;
  offlinepdatrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  offlinetrialexpirationdate?: InputMaybe<Scalars["timestamp"]>;
  outofofficemessage?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  pi__can_view_not_assigned_prospects__c?: InputMaybe<Scalars["Boolean"]>;
  pi__pardot_api_key__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_api_version__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_id__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_key__c?: InputMaybe<Scalars["String"]>;
  pi__pardot_user_role__c?: InputMaybe<Scalars["String"]>;
  portalrole?: InputMaybe<Scalars["String"]>;
  postalcode?: InputMaybe<Scalars["String"]>;
  profileid?: InputMaybe<Scalars["String"]>;
  receivesadmininfoemails?: InputMaybe<Scalars["Boolean"]>;
  receivesinfoemails?: InputMaybe<Scalars["Boolean"]>;
  region__c?: InputMaybe<Scalars["String"]>;
  senderemail?: InputMaybe<Scalars["String"]>;
  sendername?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<Scalars["String"]>;
  smallbannerphotourl?: InputMaybe<Scalars["String"]>;
  smallphotourl?: InputMaybe<Scalars["String"]>;
  sort_id?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  stayintouchnote?: InputMaybe<Scalars["String"]>;
  stayintouchsignature?: InputMaybe<Scalars["String"]>;
  stayintouchsubject?: InputMaybe<Scalars["String"]>;
  street?: InputMaybe<Scalars["String"]>;
  systemmodstamp?: InputMaybe<Scalars["timestamp"]>;
  timezonesidkey?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
  userpermissionsavantgouser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionscallcenterautologin?: InputMaybe<Scalars["Boolean"]>;
  userpermissionschatteranswersuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsinteractionuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsknowledgeuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsmarketinguser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionsofflineuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssfcontentuser?: InputMaybe<Scalars["Boolean"]>;
  userpermissionssupportuser?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesactivityreminderspopup?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesapexpagesdevelopermode?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescachediagnostics?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescontentemailasandwhen?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescontentnoemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencescreatelexappswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableallfeedsemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablebookmarkemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablechangecommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableendorsementemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablefilesharenotificationsforapi?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesdisablefollowersemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelatercommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablelikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablementionspostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablemessageemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisableprofilepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisablesharepostemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdiscommentafterlikeemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdismentionscommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesdisprofpostcommentemail?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesenableautosubforfeeds?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceseventreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesexcludemailappattachments?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoritesshowtopfavorites?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesfavoriteswtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavbarwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesglobalnavgridmenuwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshascelebrationbadge?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebiggerphotocallout?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidebrowseproductredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidechatteronboardingsplash?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsndesktoptask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidecsngetchattermobiletask?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideenduseronboardingassistantmodal?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshideinvoicesredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidelightningmigrationmodal?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshideonlinesalesappwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshides1browserui?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidesecondchatteronboardingsplash?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceshidesfxwelcomemat?: InputMaybe<Scalars["Boolean"]>;
  userpreferenceshidestatementsredirectconfirmation?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferenceslightningexperiencepreferred?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnativeemailclient?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesnewlightningreportrunpageenabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencespathassistantcollapsed?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewcustomtheme?: InputMaybe<Scalars["Boolean"]>;
  userpreferencespreviewlightning?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesreceivenonotificationsasapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesreceivenotificationsasdelegatedapprover?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesrecordhomereservedwtshown?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesrecordhomesectioncollapsewtshown?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesremindersoundoff?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcitytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowcountrytoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowemailtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowfaxtoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmanagertoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowmobilephonetoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowmobilephonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowpostalcodetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowprofilepictoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstatetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowstreetaddresstoexternalusers?: InputMaybe<
    Scalars["Boolean"]
  >;
  userpreferencesshowstreetaddresstoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowtitletoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoexternalusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesshowworkphonetoguestusers?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessortfeedbycomment?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessrhoverrideactivities?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresseventsfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencessuppresstasksfxreminders?: InputMaybe<Scalars["Boolean"]>;
  userpreferencestaskreminderscheckboxdefault?: InputMaybe<Scalars["Boolean"]>;
  userpreferencesuserdebugmodepref?: InputMaybe<Scalars["Boolean"]>;
  userroleid?: InputMaybe<Scalars["String"]>;
  usertype?: InputMaybe<Scalars["String"]>;
  zoom_app__disable_invitation_email__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__ispmi_enabled__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__login_type__c?: InputMaybe<Scalars["String"]>;
  zoom_app__meeting_password_type__c?: InputMaybe<Scalars["numeric"]>;
  zoom_app__secret_token__c?: InputMaybe<Scalars["String"]>;
  zoom_app__send_email_to_attendee__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__send_ics_in_invitation_email__c?: InputMaybe<Scalars["Boolean"]>;
  zoom_app__webhook_url__c?: InputMaybe<Scalars["String"]>;
  zoom_app__zoom_meeting_password__c?: InputMaybe<Scalars["String"]>;
};

export type sf_users_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<sf_users_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<sf_users_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<sf_users_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<sf_users_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<sf_users_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<sf_users_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<sf_users_set_input>;
  where: sf_users_bool_exp;
};

export type task_effort_engagement_mapping_aggregate_bool_exp = {
  count?: InputMaybe<task_effort_engagement_mapping_aggregate_bool_exp_count>;
};

export type task_effort_engagement_mapping_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<task_effort_engagement_mapping_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_aggregate_order_by = {
  avg?: InputMaybe<task_effort_engagement_mapping_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<task_effort_engagement_mapping_max_order_by>;
  min?: InputMaybe<task_effort_engagement_mapping_min_order_by>;
  stddev?: InputMaybe<task_effort_engagement_mapping_stddev_order_by>;
  stddev_pop?: InputMaybe<task_effort_engagement_mapping_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<task_effort_engagement_mapping_stddev_samp_order_by>;
  sum?: InputMaybe<task_effort_engagement_mapping_sum_order_by>;
  var_pop?: InputMaybe<task_effort_engagement_mapping_var_pop_order_by>;
  var_samp?: InputMaybe<task_effort_engagement_mapping_var_samp_order_by>;
  variance?: InputMaybe<task_effort_engagement_mapping_variance_order_by>;
};

/** input type for inserting array relation for remote table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_arr_rel_insert_input = {
  data: Array<task_effort_engagement_mapping_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<task_effort_engagement_mapping_on_conflict>;
};

/** order by avg() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_avg_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "task_effort_engagement_mapping". All fields are combined with a logical 'AND'. */
export type task_effort_engagement_mapping_bool_exp = {
  _and?: InputMaybe<Array<task_effort_engagement_mapping_bool_exp>>;
  _not?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
  _or?: InputMaybe<Array<task_effort_engagement_mapping_bool_exp>>;
  accountid?: InputMaybe<String_comparison_exp>;
  activitydate?: InputMaybe<timestamp_comparison_exp>;
  createddate?: InputMaybe<timestamp_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  task_id?: InputMaybe<String_comparison_exp>;
  whatid?: InputMaybe<String_comparison_exp>;
  whoid?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "task_effort_engagement_mapping" */
export enum task_effort_engagement_mapping_constraint {
  /** unique or primary key constraint on columns "task_id" */
  task_effort_engagement_mapping_pkey = "task_effort_engagement_mapping_pkey",
}

/** input type for incrementing numeric columns in table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_inc_input = {
  task_categorization?: InputMaybe<Scalars["Int"]>;
};

/** input type for inserting data into table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_insert_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by max() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_max_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** order by min() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_min_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_on_conflict = {
  constraint: task_effort_engagement_mapping_constraint;
  update_columns?: Array<task_effort_engagement_mapping_update_column>;
  where?: InputMaybe<task_effort_engagement_mapping_bool_exp>;
};

/** Ordering options when selecting data from "task_effort_engagement_mapping". */
export type task_effort_engagement_mapping_order_by = {
  accountid?: InputMaybe<order_by>;
  activitydate?: InputMaybe<order_by>;
  createddate?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  task_id?: InputMaybe<order_by>;
  whatid?: InputMaybe<order_by>;
  whoid?: InputMaybe<order_by>;
};

/** primary key columns input for table: task_effort_engagement_mapping */
export type task_effort_engagement_mapping_pk_columns_input = {
  task_id: Scalars["String"];
};

/** select columns of table "task_effort_engagement_mapping" */
export enum task_effort_engagement_mapping_select_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  createddate = "createddate",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  subject = "subject",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  task_id = "task_id",
  /** column name */
  whatid = "whatid",
  /** column name */
  whoid = "whoid",
}

/** input type for updating data in table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_set_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by stddev() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stddev_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stddev_pop_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stddev_samp_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: task_effort_engagement_mapping_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type task_effort_engagement_mapping_stream_cursor_value_input = {
  accountid?: InputMaybe<Scalars["String"]>;
  activitydate?: InputMaybe<Scalars["timestamp"]>;
  createddate?: InputMaybe<Scalars["timestamp"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  task_id?: InputMaybe<Scalars["String"]>;
  whatid?: InputMaybe<Scalars["String"]>;
  whoid?: InputMaybe<Scalars["String"]>;
};

/** order by sum() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_sum_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** update columns of table "task_effort_engagement_mapping" */
export enum task_effort_engagement_mapping_update_column {
  /** column name */
  accountid = "accountid",
  /** column name */
  activitydate = "activitydate",
  /** column name */
  createddate = "createddate",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  subject = "subject",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  task_id = "task_id",
  /** column name */
  whatid = "whatid",
  /** column name */
  whoid = "whoid",
}

export type task_effort_engagement_mapping_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<task_effort_engagement_mapping_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<task_effort_engagement_mapping_set_input>;
  where: task_effort_engagement_mapping_bool_exp;
};

/** order by var_pop() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_var_pop_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_var_samp_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "task_effort_engagement_mapping" */
export type task_effort_engagement_mapping_variance_order_by = {
  task_categorization?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "team_activity_gql". All fields are combined with a logical 'AND'. */
export type team_activity_gql_bool_exp = {
  _and?: InputMaybe<Array<team_activity_gql_bool_exp>>;
  _not?: InputMaybe<team_activity_gql_bool_exp>;
  _or?: InputMaybe<Array<team_activity_gql_bool_exp>>;
  calls_actuals?: InputMaybe<numeric_comparison_exp>;
  calls_out?: InputMaybe<numeric_comparison_exp>;
  calls_target?: InputMaybe<numeric_comparison_exp>;
  email_actuals?: InputMaybe<numeric_comparison_exp>;
  email_targets?: InputMaybe<numeric_comparison_exp>;
  emails_sent?: InputMaybe<numeric_comparison_exp>;
  key?: InputMaybe<Int_comparison_exp>;
  meeting_actuals?: InputMaybe<bigint_comparison_exp>;
  meeting_targets?: InputMaybe<float8_comparison_exp>;
  meetings?: InputMaybe<float8_comparison_exp>;
  opportunities?: InputMaybe<float8_comparison_exp>;
  opportunity_actuals?: InputMaybe<bigint_comparison_exp>;
  opportunity_targets?: InputMaybe<float8_comparison_exp>;
  social?: InputMaybe<numeric_comparison_exp>;
  social_actuals?: InputMaybe<numeric_comparison_exp>;
  social_target?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "team_activity_gql". */
export type team_activity_gql_order_by = {
  calls_actuals?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  calls_target?: InputMaybe<order_by>;
  email_actuals?: InputMaybe<order_by>;
  email_targets?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  meeting_actuals?: InputMaybe<order_by>;
  meeting_targets?: InputMaybe<order_by>;
  meetings?: InputMaybe<order_by>;
  opportunities?: InputMaybe<order_by>;
  opportunity_actuals?: InputMaybe<order_by>;
  opportunity_targets?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  social_actuals?: InputMaybe<order_by>;
  social_target?: InputMaybe<order_by>;
};

/** select columns of table "team_activity_gql" */
export enum team_activity_gql_select_column {
  /** column name */
  calls_actuals = "calls_actuals",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  calls_target = "calls_target",
  /** column name */
  email_actuals = "email_actuals",
  /** column name */
  email_targets = "email_targets",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  key = "key",
  /** column name */
  meeting_actuals = "meeting_actuals",
  /** column name */
  meeting_targets = "meeting_targets",
  /** column name */
  meetings = "meetings",
  /** column name */
  opportunities = "opportunities",
  /** column name */
  opportunity_actuals = "opportunity_actuals",
  /** column name */
  opportunity_targets = "opportunity_targets",
  /** column name */
  social = "social",
  /** column name */
  social_actuals = "social_actuals",
  /** column name */
  social_target = "social_target",
}

/** Streaming cursor of the table "team_activity_gql" */
export type team_activity_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: team_activity_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type team_activity_gql_stream_cursor_value_input = {
  calls_actuals?: InputMaybe<Scalars["numeric"]>;
  calls_out?: InputMaybe<Scalars["numeric"]>;
  calls_target?: InputMaybe<Scalars["numeric"]>;
  email_actuals?: InputMaybe<Scalars["numeric"]>;
  email_targets?: InputMaybe<Scalars["numeric"]>;
  emails_sent?: InputMaybe<Scalars["numeric"]>;
  key?: InputMaybe<Scalars["Int"]>;
  meeting_actuals?: InputMaybe<Scalars["bigint"]>;
  meeting_targets?: InputMaybe<Scalars["float8"]>;
  meetings?: InputMaybe<Scalars["float8"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  opportunity_actuals?: InputMaybe<Scalars["bigint"]>;
  opportunity_targets?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["numeric"]>;
  social_actuals?: InputMaybe<Scalars["numeric"]>;
  social_target?: InputMaybe<Scalars["numeric"]>;
};

export type team_members_aggregate_bool_exp = {
  count?: InputMaybe<team_members_aggregate_bool_exp_count>;
};

export type team_members_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<team_members_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<team_members_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "team_members" */
export type team_members_aggregate_order_by = {
  avg?: InputMaybe<team_members_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<team_members_max_order_by>;
  min?: InputMaybe<team_members_min_order_by>;
  stddev?: InputMaybe<team_members_stddev_order_by>;
  stddev_pop?: InputMaybe<team_members_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<team_members_stddev_samp_order_by>;
  sum?: InputMaybe<team_members_sum_order_by>;
  var_pop?: InputMaybe<team_members_var_pop_order_by>;
  var_samp?: InputMaybe<team_members_var_samp_order_by>;
  variance?: InputMaybe<team_members_variance_order_by>;
};

/** input type for inserting array relation for remote table "team_members" */
export type team_members_arr_rel_insert_input = {
  data: Array<team_members_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<team_members_on_conflict>;
};

/** order by avg() on columns of table "team_members" */
export type team_members_avg_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "team_members". All fields are combined with a logical 'AND'. */
export type team_members_bool_exp = {
  _and?: InputMaybe<Array<team_members_bool_exp>>;
  _not?: InputMaybe<team_members_bool_exp>;
  _or?: InputMaybe<Array<team_members_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  team_id?: InputMaybe<bigint_comparison_exp>;
  to_teams?: InputMaybe<teams_bool_exp>;
  to_users?: InputMaybe<users_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "team_members" */
export enum team_members_constraint {
  /** unique or primary key constraint on columns "id" */
  team_members_pkey = "team_members_pkey",
}

/** input type for incrementing numeric columns in table "team_members" */
export type team_members_inc_input = {
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "team_members" */
export type team_members_insert_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
  to_teams?: InputMaybe<teams_obj_rel_insert_input>;
  to_users?: InputMaybe<users_obj_rel_insert_input>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "team_members" */
export type team_members_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "team_members" */
export type team_members_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "team_members" */
export type team_members_obj_rel_insert_input = {
  data: team_members_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<team_members_on_conflict>;
};

/** on_conflict condition type for table "team_members" */
export type team_members_on_conflict = {
  constraint: team_members_constraint;
  update_columns?: Array<team_members_update_column>;
  where?: InputMaybe<team_members_bool_exp>;
};

/** Ordering options when selecting data from "team_members". */
export type team_members_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
  to_teams?: InputMaybe<teams_order_by>;
  to_users?: InputMaybe<users_order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: team_members */
export type team_members_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "team_members" */
export enum team_members_select_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  team_id = "team_id",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  user_id = "user_id",
}

/** input type for updating data in table "team_members" */
export type team_members_set_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
};

/** order by stddev() on columns of table "team_members" */
export type team_members_stddev_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "team_members" */
export type team_members_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "team_members" */
export type team_members_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "team_members" */
export type team_members_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: team_members_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type team_members_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  team_id?: InputMaybe<Scalars["bigint"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
  user_id?: InputMaybe<Scalars["uuid"]>;
};

/** order by sum() on columns of table "team_members" */
export type team_members_sum_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** update columns of table "team_members" */
export enum team_members_update_column {
  /** column name */
  created_at = "created_at",
  /** column name */
  id = "id",
  /** column name */
  team_id = "team_id",
  /** column name */
  updated_at = "updated_at",
  /** column name */
  user_id = "user_id",
}

export type team_members_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<team_members_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<team_members_set_input>;
  where: team_members_bool_exp;
};

/** order by var_pop() on columns of table "team_members" */
export type team_members_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "team_members" */
export type team_members_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "team_members" */
export type team_members_variance_order_by = {
  id?: InputMaybe<order_by>;
  team_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type teams_bool_exp = {
  _and?: InputMaybe<Array<teams_bool_exp>>;
  _not?: InputMaybe<teams_bool_exp>;
  _or?: InputMaybe<Array<teams_bool_exp>>;
  call_target?: InputMaybe<bigint_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  email_target?: InputMaybe<bigint_comparison_exp>;
  id?: InputMaybe<bigint_comparison_exp>;
  is_deleted?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opportunity_target?: InputMaybe<bigint_comparison_exp>;
  social_target?: InputMaybe<bigint_comparison_exp>;
  to_members?: InputMaybe<team_members_bool_exp>;
  to_members_aggregate?: InputMaybe<team_members_aggregate_bool_exp>;
  type?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "teams" */
export enum teams_constraint {
  /** unique or primary key constraint on columns "id" */
  teams_pkey = "teams_pkey",
}

/** input type for incrementing numeric columns in table "teams" */
export type teams_inc_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "teams" */
export type teams_insert_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_deleted?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
  to_members?: InputMaybe<team_members_arr_rel_insert_input>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** input type for inserting object relation for remote table "teams" */
export type teams_obj_rel_insert_input = {
  data: teams_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<teams_on_conflict>;
};

/** on_conflict condition type for table "teams" */
export type teams_on_conflict = {
  constraint: teams_constraint;
  update_columns?: Array<teams_update_column>;
  where?: InputMaybe<teams_bool_exp>;
};

/** Ordering options when selecting data from "teams". */
export type teams_order_by = {
  call_target?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email_target?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_deleted?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  opportunity_target?: InputMaybe<order_by>;
  social_target?: InputMaybe<order_by>;
  to_members_aggregate?: InputMaybe<team_members_aggregate_order_by>;
  type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: teams */
export type teams_pk_columns_input = {
  id: Scalars["bigint"];
};

/** select columns of table "teams" */
export enum teams_select_column {
  /** column name */
  call_target = "call_target",
  /** column name */
  created_at = "created_at",
  /** column name */
  email_target = "email_target",
  /** column name */
  id = "id",
  /** column name */
  is_deleted = "is_deleted",
  /** column name */
  name = "name",
  /** column name */
  opportunity_target = "opportunity_target",
  /** column name */
  social_target = "social_target",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
}

/** input type for updating data in table "teams" */
export type teams_set_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_deleted?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "teams" */
export type teams_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: teams_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type teams_stream_cursor_value_input = {
  call_target?: InputMaybe<Scalars["bigint"]>;
  created_at?: InputMaybe<Scalars["timestamptz"]>;
  email_target?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["bigint"]>;
  is_deleted?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_target?: InputMaybe<Scalars["bigint"]>;
  social_target?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  updated_at?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "teams" */
export enum teams_update_column {
  /** column name */
  call_target = "call_target",
  /** column name */
  created_at = "created_at",
  /** column name */
  email_target = "email_target",
  /** column name */
  id = "id",
  /** column name */
  is_deleted = "is_deleted",
  /** column name */
  name = "name",
  /** column name */
  opportunity_target = "opportunity_target",
  /** column name */
  social_target = "social_target",
  /** column name */
  type = "type",
  /** column name */
  updated_at = "updated_at",
}

export type teams_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<teams_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<teams_set_input>;
  where: teams_bool_exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars["timestamp"]>;
  _gt?: InputMaybe<Scalars["timestamp"]>;
  _gte?: InputMaybe<Scalars["timestamp"]>;
  _in?: InputMaybe<Array<Scalars["timestamp"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["timestamp"]>;
  _lte?: InputMaybe<Scalars["timestamp"]>;
  _neq?: InputMaybe<Scalars["timestamp"]>;
  _nin?: InputMaybe<Array<Scalars["timestamp"]>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars["timestamptz"]>;
  _gt?: InputMaybe<Scalars["timestamptz"]>;
  _gte?: InputMaybe<Scalars["timestamptz"]>;
  _in?: InputMaybe<Array<Scalars["timestamptz"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["timestamptz"]>;
  _lte?: InputMaybe<Scalars["timestamptz"]>;
  _neq?: InputMaybe<Scalars["timestamptz"]>;
  _nin?: InputMaybe<Array<Scalars["timestamptz"]>>;
};

/** Boolean expression to filter rows from the table "user_photo_mapping". All fields are combined with a logical 'AND'. */
export type user_photo_mapping_bool_exp = {
  _and?: InputMaybe<Array<user_photo_mapping_bool_exp>>;
  _not?: InputMaybe<user_photo_mapping_bool_exp>;
  _or?: InputMaybe<Array<user_photo_mapping_bool_exp>>;
  email?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  revtron_role?: InputMaybe<String_comparison_exp>;
};

/** input type for inserting data into table "user_photo_mapping" */
export type user_photo_mapping_insert_input = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  revtron_role?: InputMaybe<Scalars["String"]>;
};

/** Ordering options when selecting data from "user_photo_mapping". */
export type user_photo_mapping_order_by = {
  email?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  revtron_role?: InputMaybe<order_by>;
};

/** select columns of table "user_photo_mapping" */
export enum user_photo_mapping_select_column {
  /** column name */
  email = "email",
  /** column name */
  name = "name",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  revtron_role = "revtron_role",
}

/** input type for updating data in table "user_photo_mapping" */
export type user_photo_mapping_set_input = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  revtron_role?: InputMaybe<Scalars["String"]>;
};

/** Streaming cursor of the table "user_photo_mapping" */
export type user_photo_mapping_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: user_photo_mapping_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type user_photo_mapping_stream_cursor_value_input = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  revtron_role?: InputMaybe<Scalars["String"]>;
};

export type user_photo_mapping_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<user_photo_mapping_set_input>;
  where: user_photo_mapping_bool_exp;
};

export type users_aggregate_bool_exp = {
  bool_and?: InputMaybe<users_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<users_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<users_aggregate_bool_exp_count>;
};

export type users_aggregate_bool_exp_bool_and = {
  arguments: users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<users_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type users_aggregate_bool_exp_bool_or = {
  arguments: users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<users_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type users_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<users_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<users_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "auth.users" */
export type users_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<users_max_order_by>;
  min?: InputMaybe<users_min_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type users_append_input = {
  metadata?: InputMaybe<Scalars["jsonb"]>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type users_arr_rel_insert_input = {
  data: Array<users_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<users_on_conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type users_bool_exp = {
  _and?: InputMaybe<Array<users_bool_exp>>;
  _not?: InputMaybe<users_bool_exp>;
  _or?: InputMaybe<Array<users_bool_exp>>;
  activeMfaType?: InputMaybe<String_comparison_exp>;
  avatarUrl?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  crm_users?: InputMaybe<crm_users_bool_exp>;
  currentChallenge?: InputMaybe<String_comparison_exp>;
  defaultRole?: InputMaybe<String_comparison_exp>;
  defaultRoleByRole?: InputMaybe<authRoles_bool_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  displayName?: InputMaybe<String_comparison_exp>;
  email?: InputMaybe<citext_comparison_exp>;
  emailVerified?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  isAnonymous?: InputMaybe<Boolean_comparison_exp>;
  lastSeen?: InputMaybe<timestamptz_comparison_exp>;
  locale?: InputMaybe<String_comparison_exp>;
  metadata?: InputMaybe<jsonb_comparison_exp>;
  newEmail?: InputMaybe<citext_comparison_exp>;
  otpHash?: InputMaybe<String_comparison_exp>;
  otpHashExpiresAt?: InputMaybe<timestamptz_comparison_exp>;
  otpMethodLastUsed?: InputMaybe<String_comparison_exp>;
  passwordHash?: InputMaybe<String_comparison_exp>;
  phoneNumber?: InputMaybe<String_comparison_exp>;
  phoneNumberVerified?: InputMaybe<Boolean_comparison_exp>;
  refreshTokens?: InputMaybe<authRefreshTokens_bool_exp>;
  refreshTokens_aggregate?: InputMaybe<authRefreshTokens_aggregate_bool_exp>;
  revtron_team?: InputMaybe<team_members_bool_exp>;
  roles?: InputMaybe<authUserRoles_bool_exp>;
  roles_aggregate?: InputMaybe<authUserRoles_aggregate_bool_exp>;
  securityKeys?: InputMaybe<authUserSecurityKeys_bool_exp>;
  securityKeys_aggregate?: InputMaybe<authUserSecurityKeys_aggregate_bool_exp>;
  ticket?: InputMaybe<String_comparison_exp>;
  ticketExpiresAt?: InputMaybe<timestamptz_comparison_exp>;
  totpSecret?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userProviders?: InputMaybe<authUserProviders_bool_exp>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum users_constraint {
  /** unique or primary key constraint on columns "email" */
  users_email_key = "users_email_key",
  /** unique or primary key constraint on columns "phone_number" */
  users_phone_number_key = "users_phone_number_key",
  /** unique or primary key constraint on columns "id" */
  users_pkey = "users_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type users_delete_at_path_input = {
  metadata?: InputMaybe<Array<Scalars["String"]>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type users_delete_elem_input = {
  metadata?: InputMaybe<Scalars["Int"]>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type users_delete_key_input = {
  metadata?: InputMaybe<Scalars["String"]>;
};

/** input type for inserting data into table "auth.users" */
export type users_insert_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  crm_users?: InputMaybe<crm_users_obj_rel_insert_input>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  defaultRoleByRole?: InputMaybe<authRoles_obj_rel_insert_input>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["jsonb"]>;
  newEmail?: InputMaybe<Scalars["citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  refreshTokens?: InputMaybe<authRefreshTokens_arr_rel_insert_input>;
  revtron_team?: InputMaybe<team_members_obj_rel_insert_input>;
  roles?: InputMaybe<authUserRoles_arr_rel_insert_input>;
  securityKeys?: InputMaybe<authUserSecurityKeys_arr_rel_insert_input>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
  userProviders?: InputMaybe<authUserProviders_arr_rel_insert_input>;
};

/** order by max() on columns of table "auth.users" */
export type users_max_order_by = {
  activeMfaType?: InputMaybe<order_by>;
  avatarUrl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  currentChallenge?: InputMaybe<order_by>;
  defaultRole?: InputMaybe<order_by>;
  displayName?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastSeen?: InputMaybe<order_by>;
  locale?: InputMaybe<order_by>;
  newEmail?: InputMaybe<order_by>;
  otpHash?: InputMaybe<order_by>;
  otpHashExpiresAt?: InputMaybe<order_by>;
  otpMethodLastUsed?: InputMaybe<order_by>;
  passwordHash?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  ticket?: InputMaybe<order_by>;
  ticketExpiresAt?: InputMaybe<order_by>;
  totpSecret?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** order by min() on columns of table "auth.users" */
export type users_min_order_by = {
  activeMfaType?: InputMaybe<order_by>;
  avatarUrl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  currentChallenge?: InputMaybe<order_by>;
  defaultRole?: InputMaybe<order_by>;
  displayName?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastSeen?: InputMaybe<order_by>;
  locale?: InputMaybe<order_by>;
  newEmail?: InputMaybe<order_by>;
  otpHash?: InputMaybe<order_by>;
  otpHashExpiresAt?: InputMaybe<order_by>;
  otpMethodLastUsed?: InputMaybe<order_by>;
  passwordHash?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  ticket?: InputMaybe<order_by>;
  ticketExpiresAt?: InputMaybe<order_by>;
  totpSecret?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type users_obj_rel_insert_input = {
  data: users_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<users_on_conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type users_on_conflict = {
  constraint: users_constraint;
  update_columns?: Array<users_update_column>;
  where?: InputMaybe<users_bool_exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type users_order_by = {
  activeMfaType?: InputMaybe<order_by>;
  avatarUrl?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  crm_users?: InputMaybe<crm_users_order_by>;
  currentChallenge?: InputMaybe<order_by>;
  defaultRole?: InputMaybe<order_by>;
  defaultRoleByRole?: InputMaybe<authRoles_order_by>;
  disabled?: InputMaybe<order_by>;
  displayName?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  emailVerified?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isAnonymous?: InputMaybe<order_by>;
  lastSeen?: InputMaybe<order_by>;
  locale?: InputMaybe<order_by>;
  metadata?: InputMaybe<order_by>;
  newEmail?: InputMaybe<order_by>;
  otpHash?: InputMaybe<order_by>;
  otpHashExpiresAt?: InputMaybe<order_by>;
  otpMethodLastUsed?: InputMaybe<order_by>;
  passwordHash?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  phoneNumberVerified?: InputMaybe<order_by>;
  refreshTokens_aggregate?: InputMaybe<authRefreshTokens_aggregate_order_by>;
  revtron_team?: InputMaybe<team_members_order_by>;
  roles_aggregate?: InputMaybe<authUserRoles_aggregate_order_by>;
  securityKeys_aggregate?: InputMaybe<authUserSecurityKeys_aggregate_order_by>;
  ticket?: InputMaybe<order_by>;
  ticketExpiresAt?: InputMaybe<order_by>;
  totpSecret?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userProviders_aggregate?: InputMaybe<authUserProviders_aggregate_order_by>;
};

/** primary key columns input for table: auth.users */
export type users_pk_columns_input = {
  id: Scalars["uuid"];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type users_prepend_input = {
  metadata?: InputMaybe<Scalars["jsonb"]>;
};

/** select columns of table "auth.users" */
export enum users_select_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabled = "disabled",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
}

/** input type for updating data in table "auth.users" */
export type users_set_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["jsonb"]>;
  newEmail?: InputMaybe<Scalars["citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** Streaming cursor of the table "users" */
export type users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type users_stream_cursor_value_input = {
  activeMfaType?: InputMaybe<Scalars["String"]>;
  avatarUrl?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["timestamptz"]>;
  currentChallenge?: InputMaybe<Scalars["String"]>;
  defaultRole?: InputMaybe<Scalars["String"]>;
  disabled?: InputMaybe<Scalars["Boolean"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["citext"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["uuid"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]>;
  lastSeen?: InputMaybe<Scalars["timestamptz"]>;
  locale?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["jsonb"]>;
  newEmail?: InputMaybe<Scalars["citext"]>;
  otpHash?: InputMaybe<Scalars["String"]>;
  otpHashExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  otpMethodLastUsed?: InputMaybe<Scalars["String"]>;
  passwordHash?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  phoneNumberVerified?: InputMaybe<Scalars["Boolean"]>;
  ticket?: InputMaybe<Scalars["String"]>;
  ticketExpiresAt?: InputMaybe<Scalars["timestamptz"]>;
  totpSecret?: InputMaybe<Scalars["String"]>;
  updatedAt?: InputMaybe<Scalars["timestamptz"]>;
};

/** update columns of table "auth.users" */
export enum users_update_column {
  /** column name */
  activeMfaType = "activeMfaType",
  /** column name */
  avatarUrl = "avatarUrl",
  /** column name */
  createdAt = "createdAt",
  /** column name */
  currentChallenge = "currentChallenge",
  /** column name */
  defaultRole = "defaultRole",
  /** column name */
  disabled = "disabled",
  /** column name */
  displayName = "displayName",
  /** column name */
  email = "email",
  /** column name */
  emailVerified = "emailVerified",
  /** column name */
  id = "id",
  /** column name */
  isAnonymous = "isAnonymous",
  /** column name */
  lastSeen = "lastSeen",
  /** column name */
  locale = "locale",
  /** column name */
  metadata = "metadata",
  /** column name */
  newEmail = "newEmail",
  /** column name */
  otpHash = "otpHash",
  /** column name */
  otpHashExpiresAt = "otpHashExpiresAt",
  /** column name */
  otpMethodLastUsed = "otpMethodLastUsed",
  /** column name */
  passwordHash = "passwordHash",
  /** column name */
  phoneNumber = "phoneNumber",
  /** column name */
  phoneNumberVerified = "phoneNumberVerified",
  /** column name */
  ticket = "ticket",
  /** column name */
  ticketExpiresAt = "ticketExpiresAt",
  /** column name */
  totpSecret = "totpSecret",
  /** column name */
  updatedAt = "updatedAt",
}

export type users_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<users_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<users_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<users_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<users_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<users_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<users_set_input>;
  where: users_bool_exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars["uuid"]>;
  _gt?: InputMaybe<Scalars["uuid"]>;
  _gte?: InputMaybe<Scalars["uuid"]>;
  _in?: InputMaybe<Array<Scalars["uuid"]>>;
  _is_null?: InputMaybe<Scalars["Boolean"]>;
  _lt?: InputMaybe<Scalars["uuid"]>;
  _lte?: InputMaybe<Scalars["uuid"]>;
  _neq?: InputMaybe<Scalars["uuid"]>;
  _nin?: InputMaybe<Array<Scalars["uuid"]>>;
};

/** Boolean expression to filter rows from the table "weekly_activity_targets". All fields are combined with a logical 'AND'. */
export type weekly_activity_targets_bool_exp = {
  _and?: InputMaybe<Array<weekly_activity_targets_bool_exp>>;
  _not?: InputMaybe<weekly_activity_targets_bool_exp>;
  _or?: InputMaybe<Array<weekly_activity_targets_bool_exp>>;
  calls?: InputMaybe<bigint_comparison_exp>;
  conversational_touch_points?: InputMaybe<bigint_comparison_exp>;
  email_address?: InputMaybe<String_comparison_exp>;
  emails?: InputMaybe<bigint_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  meetings_held?: InputMaybe<float8_comparison_exp>;
  meetings_scheduled?: InputMaybe<float8_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  new_pipeline_arr?: InputMaybe<bigint_comparison_exp>;
  opportunities?: InputMaybe<float8_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  total_activities?: InputMaybe<bigint_comparison_exp>;
};

/** input type for incrementing numeric columns in table "weekly_activity_targets" */
export type weekly_activity_targets_inc_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

/** input type for inserting data into table "weekly_activity_targets" */
export type weekly_activity_targets_insert_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["String"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

/** Ordering options when selecting data from "weekly_activity_targets". */
export type weekly_activity_targets_order_by = {
  calls?: InputMaybe<order_by>;
  conversational_touch_points?: InputMaybe<order_by>;
  email_address?: InputMaybe<order_by>;
  emails?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  meetings_held?: InputMaybe<order_by>;
  meetings_scheduled?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  new_pipeline_arr?: InputMaybe<order_by>;
  opportunities?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  total_activities?: InputMaybe<order_by>;
};

/** select columns of table "weekly_activity_targets" */
export enum weekly_activity_targets_select_column {
  /** column name */
  calls = "calls",
  /** column name */
  conversational_touch_points = "conversational_touch_points",
  /** column name */
  email_address = "email_address",
  /** column name */
  emails = "emails",
  /** column name */
  id = "id",
  /** column name */
  meetings_held = "meetings_held",
  /** column name */
  meetings_scheduled = "meetings_scheduled",
  /** column name */
  name = "name",
  /** column name */
  new_pipeline_arr = "new_pipeline_arr",
  /** column name */
  opportunities = "opportunities",
  /** column name */
  social = "social",
  /** column name */
  total_activities = "total_activities",
}

/** input type for updating data in table "weekly_activity_targets" */
export type weekly_activity_targets_set_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["String"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

/** Streaming cursor of the table "weekly_activity_targets" */
export type weekly_activity_targets_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_activity_targets_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_activity_targets_stream_cursor_value_input = {
  calls?: InputMaybe<Scalars["bigint"]>;
  conversational_touch_points?: InputMaybe<Scalars["bigint"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  emails?: InputMaybe<Scalars["bigint"]>;
  id?: InputMaybe<Scalars["String"]>;
  meetings_held?: InputMaybe<Scalars["float8"]>;
  meetings_scheduled?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  new_pipeline_arr?: InputMaybe<Scalars["bigint"]>;
  opportunities?: InputMaybe<Scalars["float8"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  total_activities?: InputMaybe<Scalars["bigint"]>;
};

export type weekly_activity_targets_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<weekly_activity_targets_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<weekly_activity_targets_set_input>;
  where: weekly_activity_targets_bool_exp;
};

/** Boolean expression to filter rows from the table "weekly_activity_vs_targets_gql". All fields are combined with a logical 'AND'. */
export type weekly_activity_vs_targets_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_activity_vs_targets_gql_bool_exp>>;
  _not?: InputMaybe<weekly_activity_vs_targets_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_activity_vs_targets_gql_bool_exp>>;
  call_answered?: InputMaybe<bigint_comparison_exp>;
  call_targets?: InputMaybe<bigint_comparison_exp>;
  calls_out?: InputMaybe<bigint_comparison_exp>;
  conversation_targets?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  email_address?: InputMaybe<String_comparison_exp>;
  email_opens?: InputMaybe<bigint_comparison_exp>;
  email_responses?: InputMaybe<bigint_comparison_exp>;
  email_targets?: InputMaybe<bigint_comparison_exp>;
  emails_sent?: InputMaybe<bigint_comparison_exp>;
  engagement_ratio?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  inbound_calls?: InputMaybe<bigint_comparison_exp>;
  meetings_booked?: InputMaybe<Int_comparison_exp>;
  meetings_targets?: InputMaybe<float8_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  name_team_member?: InputMaybe<String_comparison_exp>;
  opportunity_create_count?: InputMaybe<bigint_comparison_exp>;
  opportunity_targets?: InputMaybe<float8_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  pipeline_targets?: InputMaybe<bigint_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  social_targets?: InputMaybe<bigint_comparison_exp>;
  total_activity_targets?: InputMaybe<bigint_comparison_exp>;
  weekly_effort?: InputMaybe<numeric_comparison_exp>;
  weekly_engagement?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_activity_vs_targets_gql". */
export type weekly_activity_vs_targets_gql_order_by = {
  call_answered?: InputMaybe<order_by>;
  call_targets?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  conversation_targets?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  email_address?: InputMaybe<order_by>;
  email_opens?: InputMaybe<order_by>;
  email_responses?: InputMaybe<order_by>;
  email_targets?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  engagement_ratio?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  inbound_calls?: InputMaybe<order_by>;
  meetings_booked?: InputMaybe<order_by>;
  meetings_targets?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  name_team_member?: InputMaybe<order_by>;
  opportunity_create_count?: InputMaybe<order_by>;
  opportunity_targets?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  pipeline_targets?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  social_targets?: InputMaybe<order_by>;
  total_activity_targets?: InputMaybe<order_by>;
  weekly_effort?: InputMaybe<order_by>;
  weekly_engagement?: InputMaybe<order_by>;
};

/** select columns of table "weekly_activity_vs_targets_gql" */
export enum weekly_activity_vs_targets_gql_select_column {
  /** column name */
  call_answered = "call_answered",
  /** column name */
  call_targets = "call_targets",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  conversation_targets = "conversation_targets",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  email = "email",
  /** column name */
  email_address = "email_address",
  /** column name */
  email_opens = "email_opens",
  /** column name */
  email_responses = "email_responses",
  /** column name */
  email_targets = "email_targets",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  engagement_ratio = "engagement_ratio",
  /** column name */
  id = "id",
  /** column name */
  inbound_calls = "inbound_calls",
  /** column name */
  meetings_booked = "meetings_booked",
  /** column name */
  meetings_targets = "meetings_targets",
  /** column name */
  name = "name",
  /** column name */
  name_team_member = "name_team_member",
  /** column name */
  opportunity_create_count = "opportunity_create_count",
  /** column name */
  opportunity_targets = "opportunity_targets",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  pipeline_targets = "pipeline_targets",
  /** column name */
  social = "social",
  /** column name */
  social_targets = "social_targets",
  /** column name */
  total_activity_targets = "total_activity_targets",
  /** column name */
  weekly_effort = "weekly_effort",
  /** column name */
  weekly_engagement = "weekly_engagement",
}

/** Streaming cursor of the table "weekly_activity_vs_targets_gql" */
export type weekly_activity_vs_targets_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_activity_vs_targets_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_activity_vs_targets_gql_stream_cursor_value_input = {
  call_answered?: InputMaybe<Scalars["bigint"]>;
  call_targets?: InputMaybe<Scalars["bigint"]>;
  calls_out?: InputMaybe<Scalars["bigint"]>;
  conversation_targets?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamptz"]>;
  email?: InputMaybe<Scalars["String"]>;
  email_address?: InputMaybe<Scalars["String"]>;
  email_opens?: InputMaybe<Scalars["bigint"]>;
  email_responses?: InputMaybe<Scalars["bigint"]>;
  email_targets?: InputMaybe<Scalars["bigint"]>;
  emails_sent?: InputMaybe<Scalars["bigint"]>;
  engagement_ratio?: InputMaybe<Scalars["numeric"]>;
  id?: InputMaybe<Scalars["String"]>;
  inbound_calls?: InputMaybe<Scalars["bigint"]>;
  meetings_booked?: InputMaybe<Scalars["Int"]>;
  meetings_targets?: InputMaybe<Scalars["float8"]>;
  name?: InputMaybe<Scalars["String"]>;
  name_team_member?: InputMaybe<Scalars["String"]>;
  opportunity_create_count?: InputMaybe<Scalars["bigint"]>;
  opportunity_targets?: InputMaybe<Scalars["float8"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  pipeline_targets?: InputMaybe<Scalars["bigint"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  social_targets?: InputMaybe<Scalars["bigint"]>;
  total_activity_targets?: InputMaybe<Scalars["bigint"]>;
  weekly_effort?: InputMaybe<Scalars["numeric"]>;
  weekly_engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Boolean expression to filter rows from the table "weekly_effort_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type weekly_effort_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_effort_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<weekly_effort_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_effort_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_effort_breakdown_overview_gql". */
export type weekly_effort_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "weekly_effort_breakdown_overview_gql" */
export enum weekly_effort_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "weekly_effort_breakdown_overview_gql" */
export type weekly_effort_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_effort_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_effort_breakdown_overview_gql_stream_cursor_value_input = {
  count?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  meeting_key?: InputMaybe<Scalars["bigint"]>;
  task_categorization?: InputMaybe<Scalars["Int"]>;
  type_category?: InputMaybe<Scalars["String"]>;
  type_detail?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "weekly_engagement_breakdown_overview_gql". All fields are combined with a logical 'AND'. */
export type weekly_engagement_breakdown_overview_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_engagement_breakdown_overview_gql_bool_exp>>;
  _not?: InputMaybe<weekly_engagement_breakdown_overview_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_engagement_breakdown_overview_gql_bool_exp>>;
  count?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  meeting_key?: InputMaybe<bigint_comparison_exp>;
  task_categorization?: InputMaybe<Int_comparison_exp>;
  type_category?: InputMaybe<String_comparison_exp>;
  type_detail?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_engagement_breakdown_overview_gql". */
export type weekly_engagement_breakdown_overview_gql_order_by = {
  count?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  meeting_key?: InputMaybe<order_by>;
  task_categorization?: InputMaybe<order_by>;
  type_category?: InputMaybe<order_by>;
  type_detail?: InputMaybe<order_by>;
};

/** select columns of table "weekly_engagement_breakdown_overview_gql" */
export enum weekly_engagement_breakdown_overview_gql_select_column {
  /** column name */
  count = "count",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  meeting_key = "meeting_key",
  /** column name */
  task_categorization = "task_categorization",
  /** column name */
  type_category = "type_category",
  /** column name */
  type_detail = "type_detail",
}

/** Streaming cursor of the table "weekly_engagement_breakdown_overview_gql" */
export type weekly_engagement_breakdown_overview_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_engagement_breakdown_overview_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_engagement_breakdown_overview_gql_stream_cursor_value_input =
  {
    count?: InputMaybe<Scalars["bigint"]>;
    date_trunc?: InputMaybe<Scalars["timestamp"]>;
    meeting_key?: InputMaybe<Scalars["bigint"]>;
    task_categorization?: InputMaybe<Scalars["Int"]>;
    type_category?: InputMaybe<Scalars["String"]>;
    type_detail?: InputMaybe<Scalars["String"]>;
  };

/** Boolean expression to filter rows from the table "weekly_leaderboard_gql". All fields are combined with a logical 'AND'. */
export type weekly_leaderboard_gql_bool_exp = {
  _and?: InputMaybe<Array<weekly_leaderboard_gql_bool_exp>>;
  _not?: InputMaybe<weekly_leaderboard_gql_bool_exp>;
  _or?: InputMaybe<Array<weekly_leaderboard_gql_bool_exp>>;
  call_answered?: InputMaybe<bigint_comparison_exp>;
  calls_out?: InputMaybe<bigint_comparison_exp>;
  date_trunc?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  email_opens?: InputMaybe<bigint_comparison_exp>;
  email_responses?: InputMaybe<bigint_comparison_exp>;
  emails_sent?: InputMaybe<bigint_comparison_exp>;
  inbound_calls?: InputMaybe<bigint_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  opportunity_create_count?: InputMaybe<bigint_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  social?: InputMaybe<bigint_comparison_exp>;
  weekly_effort?: InputMaybe<numeric_comparison_exp>;
  weekly_engagement?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_leaderboard_gql". */
export type weekly_leaderboard_gql_order_by = {
  call_answered?: InputMaybe<order_by>;
  calls_out?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  email_opens?: InputMaybe<order_by>;
  email_responses?: InputMaybe<order_by>;
  emails_sent?: InputMaybe<order_by>;
  inbound_calls?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  opportunity_create_count?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  photo_url?: InputMaybe<order_by>;
  social?: InputMaybe<order_by>;
  weekly_effort?: InputMaybe<order_by>;
  weekly_engagement?: InputMaybe<order_by>;
};

/** select columns of table "weekly_leaderboard_gql" */
export enum weekly_leaderboard_gql_select_column {
  /** column name */
  call_answered = "call_answered",
  /** column name */
  calls_out = "calls_out",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  email = "email",
  /** column name */
  email_opens = "email_opens",
  /** column name */
  email_responses = "email_responses",
  /** column name */
  emails_sent = "emails_sent",
  /** column name */
  inbound_calls = "inbound_calls",
  /** column name */
  name = "name",
  /** column name */
  opportunity_create_count = "opportunity_create_count",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  photo_url = "photo_url",
  /** column name */
  social = "social",
  /** column name */
  weekly_effort = "weekly_effort",
  /** column name */
  weekly_engagement = "weekly_engagement",
}

/** Streaming cursor of the table "weekly_leaderboard_gql" */
export type weekly_leaderboard_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_leaderboard_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_leaderboard_gql_stream_cursor_value_input = {
  call_answered?: InputMaybe<Scalars["bigint"]>;
  calls_out?: InputMaybe<Scalars["bigint"]>;
  date_trunc?: InputMaybe<Scalars["timestamptz"]>;
  email?: InputMaybe<Scalars["String"]>;
  email_opens?: InputMaybe<Scalars["bigint"]>;
  email_responses?: InputMaybe<Scalars["bigint"]>;
  emails_sent?: InputMaybe<Scalars["bigint"]>;
  inbound_calls?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  opportunity_create_count?: InputMaybe<Scalars["bigint"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  photo_url?: InputMaybe<Scalars["String"]>;
  social?: InputMaybe<Scalars["bigint"]>;
  weekly_effort?: InputMaybe<Scalars["numeric"]>;
  weekly_engagement?: InputMaybe<Scalars["numeric"]>;
};

/** Boolean expression to filter rows from the table "weekly_pipeline_gql_new". All fields are combined with a logical 'AND'. */
export type weekly_pipeline_gql_new_bool_exp = {
  _and?: InputMaybe<Array<weekly_pipeline_gql_new_bool_exp>>;
  _not?: InputMaybe<weekly_pipeline_gql_new_bool_exp>;
  _or?: InputMaybe<Array<weekly_pipeline_gql_new_bool_exp>>;
  amount?: InputMaybe<numeric_comparison_exp>;
  date_trunc?: InputMaybe<timestamp_comparison_exp>;
  lead_source?: InputMaybe<String_comparison_exp>;
  opportunity_id?: InputMaybe<String_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  owner_name?: InputMaybe<String_comparison_exp>;
  stagename?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "weekly_pipeline_gql_new". */
export type weekly_pipeline_gql_new_order_by = {
  amount?: InputMaybe<order_by>;
  date_trunc?: InputMaybe<order_by>;
  lead_source?: InputMaybe<order_by>;
  opportunity_id?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  owner_name?: InputMaybe<order_by>;
  stagename?: InputMaybe<order_by>;
};

/** select columns of table "weekly_pipeline_gql_new" */
export enum weekly_pipeline_gql_new_select_column {
  /** column name */
  amount = "amount",
  /** column name */
  date_trunc = "date_trunc",
  /** column name */
  lead_source = "lead_source",
  /** column name */
  opportunity_id = "opportunity_id",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  owner_name = "owner_name",
  /** column name */
  stagename = "stagename",
}

/** Streaming cursor of the table "weekly_pipeline_gql_new" */
export type weekly_pipeline_gql_new_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weekly_pipeline_gql_new_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weekly_pipeline_gql_new_stream_cursor_value_input = {
  amount?: InputMaybe<Scalars["numeric"]>;
  date_trunc?: InputMaybe<Scalars["timestamp"]>;
  lead_source?: InputMaybe<Scalars["String"]>;
  opportunity_id?: InputMaybe<Scalars["String"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  owner_name?: InputMaybe<Scalars["String"]>;
  stagename?: InputMaybe<Scalars["String"]>;
};

/** Boolean expression to filter rows from the table "weighted_pipeline_ml_gql". All fields are combined with a logical 'AND'. */
export type weighted_pipeline_ml_gql_bool_exp = {
  _and?: InputMaybe<Array<weighted_pipeline_ml_gql_bool_exp>>;
  _not?: InputMaybe<weighted_pipeline_ml_gql_bool_exp>;
  _or?: InputMaybe<Array<weighted_pipeline_ml_gql_bool_exp>>;
  account_id?: InputMaybe<String_comparison_exp>;
  closedate?: InputMaybe<timestamp_comparison_exp>;
  custom_filter_1?: InputMaybe<String_comparison_exp>;
  forecast_category?: InputMaybe<String_comparison_exp>;
  ml_weighted_arr?: InputMaybe<float8_comparison_exp>;
  ml_weighted_arr1?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services?: InputMaybe<float8_comparison_exp>;
  ml_weighted_services1?: InputMaybe<float8_comparison_exp>;
  opportunity_name?: InputMaybe<String_comparison_exp>;
  opportunity_owner?: InputMaybe<String_comparison_exp>;
  region?: InputMaybe<String_comparison_exp>;
  stage?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  weighted_arr?: InputMaybe<float8_comparison_exp>;
  weighted_services?: InputMaybe<float8_comparison_exp>;
};

/** Ordering options when selecting data from "weighted_pipeline_ml_gql". */
export type weighted_pipeline_ml_gql_order_by = {
  account_id?: InputMaybe<order_by>;
  closedate?: InputMaybe<order_by>;
  custom_filter_1?: InputMaybe<order_by>;
  forecast_category?: InputMaybe<order_by>;
  ml_weighted_arr?: InputMaybe<order_by>;
  ml_weighted_arr1?: InputMaybe<order_by>;
  ml_weighted_services?: InputMaybe<order_by>;
  ml_weighted_services1?: InputMaybe<order_by>;
  opportunity_name?: InputMaybe<order_by>;
  opportunity_owner?: InputMaybe<order_by>;
  region?: InputMaybe<order_by>;
  stage?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  weighted_arr?: InputMaybe<order_by>;
  weighted_services?: InputMaybe<order_by>;
};

/** select columns of table "weighted_pipeline_ml_gql" */
export enum weighted_pipeline_ml_gql_select_column {
  /** column name */
  account_id = "account_id",
  /** column name */
  closedate = "closedate",
  /** column name */
  custom_filter_1 = "custom_filter_1",
  /** column name */
  forecast_category = "forecast_category",
  /** column name */
  ml_weighted_arr = "ml_weighted_arr",
  /** column name */
  ml_weighted_arr1 = "ml_weighted_arr1",
  /** column name */
  ml_weighted_services = "ml_weighted_services",
  /** column name */
  ml_weighted_services1 = "ml_weighted_services1",
  /** column name */
  opportunity_name = "opportunity_name",
  /** column name */
  opportunity_owner = "opportunity_owner",
  /** column name */
  region = "region",
  /** column name */
  stage = "stage",
  /** column name */
  type = "type",
  /** column name */
  weighted_arr = "weighted_arr",
  /** column name */
  weighted_services = "weighted_services",
}

/** Streaming cursor of the table "weighted_pipeline_ml_gql" */
export type weighted_pipeline_ml_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: weighted_pipeline_ml_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type weighted_pipeline_ml_gql_stream_cursor_value_input = {
  account_id?: InputMaybe<Scalars["String"]>;
  closedate?: InputMaybe<Scalars["timestamp"]>;
  custom_filter_1?: InputMaybe<Scalars["String"]>;
  forecast_category?: InputMaybe<Scalars["String"]>;
  ml_weighted_arr?: InputMaybe<Scalars["float8"]>;
  ml_weighted_arr1?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services?: InputMaybe<Scalars["float8"]>;
  ml_weighted_services1?: InputMaybe<Scalars["float8"]>;
  opportunity_name?: InputMaybe<Scalars["String"]>;
  opportunity_owner?: InputMaybe<Scalars["String"]>;
  region?: InputMaybe<Scalars["String"]>;
  stage?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  weighted_arr?: InputMaybe<Scalars["float8"]>;
  weighted_services?: InputMaybe<Scalars["float8"]>;
};

/** Boolean expression to filter rows from the table "win_rate_totals". All fields are combined with a logical 'AND'. */
export type win_rate_totals_bool_exp = {
  _and?: InputMaybe<Array<win_rate_totals_bool_exp>>;
  _not?: InputMaybe<win_rate_totals_bool_exp>;
  _or?: InputMaybe<Array<win_rate_totals_bool_exp>>;
  type?: InputMaybe<String_comparison_exp>;
  win_rate?: InputMaybe<numeric_comparison_exp>;
};

/** Ordering options when selecting data from "win_rate_totals". */
export type win_rate_totals_order_by = {
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
};

/** select columns of table "win_rate_totals" */
export enum win_rate_totals_select_column {
  /** column name */
  type = "type",
  /** column name */
  win_rate = "win_rate",
}

/** Streaming cursor of the table "win_rate_totals" */
export type win_rate_totals_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: win_rate_totals_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type win_rate_totals_stream_cursor_value_input = {
  type?: InputMaybe<Scalars["String"]>;
  win_rate?: InputMaybe<Scalars["numeric"]>;
};

export type win_rates_individual_gql_aggregate_bool_exp = {
  avg?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_avg>;
  corr?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_corr>;
  count?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_max>;
  min?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<win_rates_individual_gql_aggregate_bool_exp_var_samp>;
};

export type win_rates_individual_gql_aggregate_bool_exp_avg = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_corr = {
  arguments: win_rates_individual_gql_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_corr_arguments = {
  X: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns;
  Y: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns;
};

export type win_rates_individual_gql_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<win_rates_individual_gql_select_column>>;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: Int_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_covar_samp = {
  arguments: win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments = {
  X: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type win_rates_individual_gql_aggregate_bool_exp_max = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_min = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_stddev_samp = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_sum = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

export type win_rates_individual_gql_aggregate_bool_exp_var_samp = {
  arguments: win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<win_rates_individual_gql_bool_exp>;
  predicate: float8_comparison_exp;
};

/** order by aggregate values of table "win_rates_individual_gql" */
export type win_rates_individual_gql_aggregate_order_by = {
  avg?: InputMaybe<win_rates_individual_gql_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<win_rates_individual_gql_max_order_by>;
  min?: InputMaybe<win_rates_individual_gql_min_order_by>;
  stddev?: InputMaybe<win_rates_individual_gql_stddev_order_by>;
  stddev_pop?: InputMaybe<win_rates_individual_gql_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<win_rates_individual_gql_stddev_samp_order_by>;
  sum?: InputMaybe<win_rates_individual_gql_sum_order_by>;
  var_pop?: InputMaybe<win_rates_individual_gql_var_pop_order_by>;
  var_samp?: InputMaybe<win_rates_individual_gql_var_samp_order_by>;
  variance?: InputMaybe<win_rates_individual_gql_variance_order_by>;
};

/** input type for inserting array relation for remote table "win_rates_individual_gql" */
export type win_rates_individual_gql_arr_rel_insert_input = {
  data: Array<win_rates_individual_gql_insert_input>;
};

/** order by avg() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_avg_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "win_rates_individual_gql". All fields are combined with a logical 'AND'. */
export type win_rates_individual_gql_bool_exp = {
  _and?: InputMaybe<Array<win_rates_individual_gql_bool_exp>>;
  _not?: InputMaybe<win_rates_individual_gql_bool_exp>;
  _or?: InputMaybe<Array<win_rates_individual_gql_bool_exp>>;
  key?: InputMaybe<bigint_comparison_exp>;
  losses?: InputMaybe<bigint_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  ownerid?: InputMaybe<String_comparison_exp>;
  total_opps?: InputMaybe<bigint_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  win_rate?: InputMaybe<float8_comparison_exp>;
  wins?: InputMaybe<bigint_comparison_exp>;
};

/** input type for inserting data into table "win_rates_individual_gql" */
export type win_rates_individual_gql_insert_input = {
  key?: InputMaybe<Scalars["bigint"]>;
  losses?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  total_opps?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  win_rate?: InputMaybe<Scalars["float8"]>;
  wins?: InputMaybe<Scalars["bigint"]>;
};

/** order by max() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_max_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by min() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_min_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "win_rates_individual_gql". */
export type win_rates_individual_gql_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  ownerid?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** select columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column {
  /** column name */
  key = "key",
  /** column name */
  losses = "losses",
  /** column name */
  name = "name",
  /** column name */
  ownerid = "ownerid",
  /** column name */
  total_opps = "total_opps",
  /** column name */
  type = "type",
  /** column name */
  win_rate = "win_rate",
  /** column name */
  wins = "wins",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_avg_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_max_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_min_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_sum_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** select "win_rates_individual_gql_aggregate_bool_exp_var_samp_arguments_columns" columns of table "win_rates_individual_gql" */
export enum win_rates_individual_gql_select_column_win_rates_individual_gql_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  win_rate = "win_rate",
}

/** order by stddev() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_stddev_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_stddev_pop_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_stddev_samp_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "win_rates_individual_gql" */
export type win_rates_individual_gql_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: win_rates_individual_gql_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type win_rates_individual_gql_stream_cursor_value_input = {
  key?: InputMaybe<Scalars["bigint"]>;
  losses?: InputMaybe<Scalars["bigint"]>;
  name?: InputMaybe<Scalars["String"]>;
  ownerid?: InputMaybe<Scalars["String"]>;
  total_opps?: InputMaybe<Scalars["bigint"]>;
  type?: InputMaybe<Scalars["String"]>;
  win_rate?: InputMaybe<Scalars["float8"]>;
  wins?: InputMaybe<Scalars["bigint"]>;
};

/** order by sum() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_sum_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_var_pop_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_var_samp_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "win_rates_individual_gql" */
export type win_rates_individual_gql_variance_order_by = {
  key?: InputMaybe<order_by>;
  losses?: InputMaybe<order_by>;
  total_opps?: InputMaybe<order_by>;
  win_rate?: InputMaybe<order_by>;
  wins?: InputMaybe<order_by>;
};

export type IcpModuleForHarriQueryVariables = Exact<{
  where: account_bool_exp;
  orderBy: account_order_by;
  limit: Scalars["Int"];
}>;

export type IcpModuleForHarriQuery = {
  account: Array<{
    id?: string | null;
    name?: string | null;
    website?: string | null;
    billingcity?: string | null;
    billingstate?: string | null;
    billingcountry?: string | null;
    annualrevenue?: any | null;
    numberofemployees?: number | null;
    account_to_custom_account?: {
      type2__c?: string | null;
      concept_type__c?: string | null;
      franchisee__c?: boolean | null;
      franchise_name__c?: string | null;
      locations__c?: any | null;
      segment__c?: string | null;
      fair_workweek__c?: boolean | null;
      operating_structure_2__c?: string | null;
      account_type__c?: string | null;
    } | null;
    account_module_static?: { predct_proba?: any | null } | null;
  }>;
};

export const IcpModuleForHarriDocument = gql`
  query IcpModuleForHarri(
    $where: account_bool_exp!
    $orderBy: account_order_by!
    $limit: Int!
  ) {
    account(where: $where, order_by: [$orderBy], limit: $limit) {
      id
      name
      website
      billingcity
      billingstate
      billingcountry
      annualrevenue
      numberofemployees
      account_to_custom_account {
        type2__c
        concept_type__c
        franchisee__c
        franchise_name__c
        locations__c
        segment__c
        fair_workweek__c
        operating_structure_2__c
        account_type__c
      }
      account_module_static {
        predct_proba
      }
    }
  }
`;

/**
 * __useIcpModuleForHarriQuery__
 *
 * To run a query within a React component, call `useIcpModuleForHarriQuery` and pass it any options that fit your needs.
 * When your component renders, `useIcpModuleForHarriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIcpModuleForHarriQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIcpModuleForHarriQuery(
  baseOptions: Apollo.QueryHookOptions<
    IcpModuleForHarriQuery,
    IcpModuleForHarriQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IcpModuleForHarriQuery,
    IcpModuleForHarriQueryVariables
  >(IcpModuleForHarriDocument, options);
}
export function useIcpModuleForHarriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IcpModuleForHarriQuery,
    IcpModuleForHarriQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IcpModuleForHarriQuery,
    IcpModuleForHarriQueryVariables
  >(IcpModuleForHarriDocument, options);
}
export type IcpModuleForHarriQueryHookResult = ReturnType<
  typeof useIcpModuleForHarriQuery
>;
export type IcpModuleForHarriLazyQueryHookResult = ReturnType<
  typeof useIcpModuleForHarriLazyQuery
>;
export type IcpModuleForHarriQueryResult = Apollo.QueryResult<
  IcpModuleForHarriQuery,
  IcpModuleForHarriQueryVariables
>;
export function refetchIcpModuleForHarriQuery(
  variables: IcpModuleForHarriQueryVariables
) {
  return { query: IcpModuleForHarriDocument, variables: variables };
}
